/* tslint:disable */
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Cursor: any;
  Date: any;
  DateScalar: any;
  DateTime: any;
  Email: any;
  JSONObject: any;
  JSONType: any;
  NcDate: any;
  URL: any;
};

export type C10NetworkInformation = {
  __typename: 'C10NetworkInformation';
  interfaces: Maybe<C10NetworkInformationInterfaces>;
};

export type C10NetworkInformationInterfaces = {
  __typename: 'C10NetworkInformationInterfaces';
  value: Maybe<Array<C10NetworkInformationValue>>;
  mutable: Maybe<Scalars['Boolean']>;
  readable: Maybe<Scalars['Boolean']>;
};

export type C10NetworkInformationValue = {
  __typename: 'C10NetworkInformationValue';
  status: Maybe<Scalars['Boolean']>;
  cdpstatus: Maybe<Scalars['String']>;
  connectionmode: Maybe<Scalars['String']>;
  connectionspeed: Maybe<Scalars['String']>;
  connectiontype: Maybe<Scalars['String']>;
  dnsalternativeaddress: Maybe<Scalars['String']>;
  dnsdomain: Maybe<Scalars['String']>;
  dnsprimaryaddress: Maybe<Scalars['String']>;
  eapmethod: Maybe<Scalars['String']>;
  ipv4address: Maybe<Scalars['String']>;
  ipv4addresssource: Maybe<Scalars['String']>;
  ipv4gateway: Maybe<Scalars['String']>;
  ipv4subnet: Maybe<Scalars['String']>;
  ipv4vlan: Maybe<Scalars['String']>;
  ipv6addresssource: Maybe<Scalars['String']>;
  ipv6globaladdress: Maybe<Scalars['String']>;
  ipv6linklocaladdress: Maybe<Scalars['String']>;
  ipv6ula: Maybe<Scalars['String']>;
  lldplocationinformation: Maybe<Scalars['String']>;
  lldpneighbors: Maybe<Scalars['String']>;
  lldpstatus: Maybe<Scalars['String']>;
  ntpserver: Maybe<Scalars['String']>;
  provisioningprotocol: Maybe<Scalars['String']>;
  pcportstatus: Maybe<Scalars['String']>;
  interfacename: Maybe<Scalars['String']>;
  vlan: Maybe<Scalars['String']>;
  security: Maybe<Scalars['String']>;
  ssid: Maybe<Scalars['String']>;
  wifistatus: Maybe<Scalars['String']>;
  regulatorydomain: Maybe<Scalars['String']>;
  eaperror: Maybe<Scalars['String']>;
  eaperrorcount: Maybe<Scalars['String']>;
  wifichannel: Maybe<Scalars['String']>;
  micerrorcount: Maybe<Scalars['String']>;
  signalstrength: Maybe<Scalars['String']>;
};

export type C10OutputServiceInformation = {
  __typename: 'C10OutputServiceInformation';
  deviceid: StringValue;
  lineid: Maybe<NumberValue>;
  serveraddr: Maybe<StringValue>;
  status: Maybe<StringValue>;
  linetype: Maybe<StringValue>;
  regtype: Maybe<StringValue>;
  userid: Maybe<StringValue>;
  email: Maybe<StringValue>;
  expiry: Maybe<NumberValue>;
  displayname: Maybe<StringValue>;
  sipport: Maybe<NumberValue>;
  sipaddr: Maybe<StringValue>;
  siptranport: Maybe<StringValue>;
  sipaccountname: Maybe<StringValue>;
  sipdomainname: Maybe<StringValue>;
  sipusername: Maybe<StringValue>;
  srvplatform: Maybe<StringValue>;
  failurereason: Maybe<StringValue>;
  outboundproxy: Maybe<StringValue>;
  outboundproxytransport: Maybe<StringValue>;
  uploadtime: Maybe<StringValue>;
  versioninfo: Maybe<StringValue>;
  eventmonotonictime: Maybe<StringValue>;
  registeredip: Maybe<StringValue>;
  domain: Maybe<StringValue>;
  authtype: Maybe<StringValue>;
  basedn: Maybe<StringValue>;
  defaultgroup: Maybe<StringValue>;
  enablessl: Maybe<BooleanValue>;
  globalserver: Maybe<StringValue>;
  serverport: Maybe<StringValue>;
};

export type StringValue = {
  __typename: 'StringValue';
  constraints: Maybe<Constraints>;
  mutable: Maybe<Scalars['Boolean']>;
  readable: Maybe<Scalars['Boolean']>;
  value: Maybe<Scalars['String']>;
};

export type Constraints = {
  __typename: 'Constraints';
  options: Maybe<Array<Scalars['String']>>;
};

export type NumberValue = {
  __typename: 'NumberValue';
  constraints: Maybe<Constraints>;
  mutable: Maybe<Scalars['Boolean']>;
  readable: Maybe<Scalars['Boolean']>;
  value: Maybe<Scalars['Float']>;
};

export type BooleanValue = {
  __typename: 'BooleanValue';
  constraints: Maybe<Constraints>;
  mutable: Maybe<Scalars['Boolean']>;
  readable: Maybe<Scalars['Boolean']>;
  value: Maybe<Scalars['Boolean']>;
};

export type C10PrimaryDeviceInformation = {
  __typename: 'C10PrimaryDeviceInformation';
  deviceid: Maybe<StringValue>;
  devicesignature: Maybe<StringValue>;
  eventmonotonictime: Maybe<StringValue>;
  featurevariation: Maybe<StringValue>;
  hardwaremodel: Maybe<StringValue>;
  hardwarepn: Maybe<StringValue>;
  hardwarerevision: Maybe<StringValue>;
  hosthardware: Maybe<StringValue>;
  hostos: Maybe<StringValue>;
  hostosbuild: Maybe<StringValue>;
  hostosversion: Maybe<StringValue>;
  macaddress: Maybe<StringValue>;
  manufacturer: Maybe<StringValue>;
  offsetgmt: Maybe<StringValue>;
  originalhardwaremodel: Maybe<StringValue>;
  originalproductfamily: Maybe<StringValue>;
  powersource: Maybe<StringValue>;
  productfamily: Maybe<StringValue>;
  productid: Maybe<StringValue>;
  productname: Maybe<StringValue>;
  proxyagent: Maybe<StringValue>;
  proxyagentid: Maybe<StringValue>;
  proxyagentversion: Maybe<StringValue>;
  reboottype: Maybe<StringValue>;
  regioncode: Maybe<StringValue>;
  serialnumber: Maybe<StringValue>;
  softwarebuild: Maybe<StringValue>;
  softwarerelease: Maybe<StringValue>;
  updaterversion: Maybe<StringValue>;
  uploadtime: Maybe<StringValue>;
  versioninfo: Maybe<StringValue>;
};

export type Poly = {
  __typename: 'poly';
  network_information: Maybe<C10NetworkInformation>;
  service_information: Maybe<Array<C10OutputServiceInformation>>;
  primary_device_information: Maybe<C10PrimaryDeviceInformation>;
  audio: Maybe<Audio>;
  call_control: Maybe<CallControl>;
  device: Maybe<DeviceOutput>;
  general: Maybe<General>;
  software_update: Maybe<SoftwareUpdate>;
  video: Maybe<Video>;
  wireless: Maybe<Wireless>;
};

export type AcceptedInviteResponse = {
  __typename: 'AcceptedInviteResponse';
  invite: Maybe<UserInvite>;
};

export type Accessor = {
  __typename: 'Accessor';
  grants: Array<Grant>;
  id: Scalars['ID'];
  user: Maybe<User>;
};

export type AccessorConnection = {
  __typename: 'AccessorConnection';
  count: Scalars['Int'];
  edges: Array<AccessorEdge>;
  pageInfo: PageInfo;
};

export type AccessorEdge = {
  __typename: 'AccessorEdge';
  cursor: Scalars['Cursor'];
  node: Accessor;
};

export type AccessorFilter = {
  and?: Maybe<Array<AccessorFilter>>;
  not?: Maybe<AccessorInput>;
  or?: Maybe<Array<AccessorFilter>>;
  where?: Maybe<AccessorInput>;
};

export type AccessorInput = {
  permissions?: Maybe<StringFilter>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType?: Maybe<Scalars['String']>;
  roles?: Maybe<RoleInput>;
  tags?: Maybe<StringFilter>;
};

export type AccessorSearchParams = {
  permissions?: Maybe<Array<Scalars['String']>>;
  resourceId?: Maybe<Scalars['ID']>;
  resourceType?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  tagFilters?: Maybe<TagFilters>;
};

export type Action = {
  __typename: 'Action';
  additional: Maybe<Scalars['JSONObject']>;
  created: Scalars['NcDate'];
  duplicated: Scalars['Boolean'];
  group: Maybe<Scalars['String']>;
  handleAfter: Maybe<Scalars['NcDate']>;
  id: Scalars['ID'];
  received: Scalars['NcDate'];
  resourceId: Scalars['String'];
  resourceType: Maybe<Scalars['String']>;
  site: Maybe<Site>;
  tenant: Tenant;
  type: ActionType;
  updated: Scalars['NcDate'];
};

export type ActionConfiguration = {
  __typename: 'ActionConfiguration';
  actionType: ActionType;
  allowedRates: Array<Rate>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  rate: Rate;
};

export type ActionFilter = {
  resourceId?: Maybe<StringFilter>;
  state?: Maybe<StateFilter>;
};

export type ActionInput = {
  additional?: Maybe<Scalars['JSONObject']>;
  group?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  type: ActionTypeInput;
};

export enum ActionState {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type ActionType = {
  __typename: 'ActionType';
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type ActionTypeFilter = {
  integration?: Maybe<StringFilter>;
  type?: Maybe<StringFilter>;
};

export enum ActionTypeInput {
  DeviceCanBeUpdated = 'DEVICE_CAN_BE_UPDATED',
  DeviceOffline = 'DEVICE_OFFLINE',
  LicensesExpiring = 'LICENSES_EXPIRING'
}

export type ActiveCall = {
  __typename: 'ActiveCall';
  dialString: Maybe<Scalars['String']>;
  id: Scalars['String'];
  state: CallState;
};

export type ActiveCalls = {
  __typename: 'ActiveCalls';
  calls: Maybe<Array<ActiveCall>>;
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddRecipient = {
  audienceId: Scalars['ID'];
  email: Scalars['Email'];
};

export type Address = {
  __typename: 'Address';
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  formattedAddress: Maybe<Scalars['String']>;
  geohash: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  postalCode: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  regionCode: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  geohash?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  regionCode?: Maybe<Scalars['String']>;
};

export type Aggregate = {
  __typename: 'Aggregate';
  buckets: Array<Bucket>;
  field: Scalars['String'];
};

export type Aggregation = {
  geohash?: Maybe<GeoHashAggregation>;
  range?: Maybe<RangeAggregation>;
  SUB?: Maybe<Array<Aggregation>>;
  term?: Maybe<Scalars['String']>;
};

export type ApiResponse = {
  __typename: 'APIResponse';
  deviceId: Scalars['String'];
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AttributeValueDto = {
  __typename: 'AttributeValueDTO';
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type AttributeValueDtoInput = {
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Audience = {
  __typename: 'Audience';
  actionConfigurations: Array<ActionConfiguration>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  recipients: Array<Recipient>;
};

export type AudienceFilter = {
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<StringFilter>;
};

export type Audio = {
  __typename: 'Audio';
  acoustic_fence: Maybe<StringValue>;
  anc_timeout: Maybe<StringValue>;
  anti_startle: Maybe<StringValue>;
  audio_quality: Maybe<StringValue>;
  auto_pause_music: Maybe<StringValue>;
  bass: Maybe<StringValue>;
  extended_range: Maybe<StringValue>;
  g616: Maybe<StringValue>;
  hours_on_phone_per_day: Maybe<StringValue>;
  independent_volume_control: Maybe<StringValue>;
  noise_block_ai: Maybe<StringValue>;
  noise_exposure_limit: Maybe<StringValue>;
  stereo: Maybe<StringValue>;
  streaming_audio: Maybe<StringValue>;
  tone_control: Maybe<StringValue>;
  treble: Maybe<StringValue>;
  volume_alerts: Maybe<StringValue>;
  volume_level_indicators: Maybe<StringValue>;
};

export type AudioInput = {
  acoustic_fence?: Maybe<Scalars['String']>;
  anc_timeout?: Maybe<Scalars['String']>;
  anti_startle?: Maybe<Scalars['String']>;
  audio_quality?: Maybe<Scalars['String']>;
  auto_pause_music?: Maybe<Scalars['String']>;
  bass?: Maybe<Scalars['String']>;
  extended_range?: Maybe<Scalars['String']>;
  g616?: Maybe<Scalars['String']>;
  hours_on_phone_per_day?: Maybe<Scalars['String']>;
  independent_volume_control?: Maybe<Scalars['String']>;
  noise_block_ai?: Maybe<Scalars['String']>;
  noise_exposure_limit?: Maybe<Scalars['String']>;
  stereo?: Maybe<Scalars['String']>;
  streaming_audio?: Maybe<Scalars['String']>;
  tone_control?: Maybe<Scalars['String']>;
  treble?: Maybe<Scalars['String']>;
  volume_alerts?: Maybe<Scalars['String']>;
  volume_level_indicators?: Maybe<Scalars['String']>;
};

export type AuditLog = {
  __typename: 'AuditLog';
  apolloClientName: Maybe<Scalars['String']>;
  authorized: Scalars['Boolean'];
  eventDetails: Maybe<Scalars['String']>;
  eventType: Maybe<EventType>;
  id: Scalars['String'];
  loginType: Maybe<LoginType>;
  logTime: Scalars['DateTime'];
  logTimeZone: Maybe<Scalars['String']>;
  publicIpAddress: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type Auth0UserUpdateData = {
  blocked?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  phone_verified?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  verify_email?: Maybe<Scalars['Boolean']>;
};

export type AuthorizationContext = {
  __typename: 'AuthorizationContext';
  authorize: Scalars['Boolean'];
  permissions: Array<Scalars['String']>;
  resource: Maybe<AuthorizationResource>;
};

export type AuthorizationResource = EveryResource | ParamResource | StaticResource | TypeResource;

export enum AuthorizationType {
  Authenticated = 'AUTHENTICATED',
  Public = 'PUBLIC'
}

export type AutoEntitleConfiguration = {
  __typename: 'AutoEntitleConfiguration';
  enabled: Scalars['Boolean'];
  tenantId: Scalars['ID'];
};

export type AvailableOs = {
  __typename: 'AvailableOS';
  version: OsVersion;
};

export type AverageIndicator = {
  __typename: 'AverageIndicator';
  average: Scalars['Float'];
};

export type Bandwidth = {
  __typename: 'Bandwidth';
  downloadMbps: Maybe<Scalars['Float']>;
  endTime: Maybe<Scalars['DateTime']>;
  pingJitterMs: Maybe<Scalars['Float']>;
  pingLatencyMs: Maybe<Scalars['Float']>;
  pingLossPercent: Maybe<Scalars['Float']>;
  uploadMbps: Maybe<Scalars['Float']>;
};

export type BoundedRange = {
  timeEnd: Scalars['Date'];
  timeStart: Scalars['Date'];
};

export type Bucket = {
  aggregates: Array<Aggregate>;
  count: Scalars['Float'];
};

export type CallControl = {
  __typename: 'CallControl';
  active_call_audio: Maybe<StringValue>;
  answer_voice_prompt: Maybe<StringValue>;
  answering_call_alert: Maybe<StringValue>;
  audio_channel_tone: Maybe<StringValue>;
  audio_prompt_volume: Maybe<StringValue>;
  audio_sensing: Maybe<StringValue>;
  auto_answer: Maybe<StringValue>;
  auto_answer_cradle: Maybe<StringValue>;
  auto_connect_mobile: Maybe<StringValue>;
  auto_disconnect_cradle: Maybe<StringValue>;
  auto_mute: Maybe<StringValue>;
  call_announcement: Maybe<StringValue>;
  call_button_lock: Maybe<StringValue>;
  caller_id: Maybe<StringValue>;
  close_conversation_limiting: Maybe<StringValue>;
  computer_audio_bandwidth: Maybe<StringValue>;
  computer_ringtone: Maybe<StringValue>;
  computer_volume: Maybe<StringValue>;
  default_phone_line: Maybe<StringValue>;
  default_ringtone: Maybe<StringValue>;
  desk_phone_audio_bandwidth: Maybe<StringValue>;
  desk_phone_ringtone: Maybe<StringValue>;
  desk_phone_volume: Maybe<StringValue>;
  dialtone: Maybe<StringValue>;
  hd_voice: Maybe<StringValue>;
  increase_qd_headset_volume: Maybe<StringValue>;
  mobile_phone_ringtone: Maybe<StringValue>;
  mobile_phone_volume: Maybe<StringValue>;
  mobile_voice_commands: Maybe<StringValue>;
  mute_alert_type: Maybe<StringValue>;
  mute_alerts: Maybe<StringValue>;
  mute_off_alert: Maybe<StringValue>;
  mute_reminder_mode: Maybe<StringValue>;
  mute_reminder_timing: Maybe<StringValue>;
  mute_reminder_volume: Maybe<StringValue>;
  notification_tones: Maybe<StringValue>;
  online_indicator: Maybe<StringValue>;
  over_air_subscription: Maybe<StringValue>;
  range: Maybe<StringValue>;
  ring_vibration: Maybe<StringValue>;
  rocket_button: Maybe<StringValue>;
  second_incoming_call: Maybe<StringValue>;
  sidetone: Maybe<StringValue>;
  smart_audio_transfer: Maybe<StringValue>;
  wearing_preference: Maybe<StringValue>;
};

export type CallControlInput = {
  active_call_audio?: Maybe<Scalars['String']>;
  answer_voice_prompt?: Maybe<Scalars['String']>;
  answering_call_alert?: Maybe<Scalars['String']>;
  audio_channel_tone?: Maybe<Scalars['String']>;
  audio_prompt_volume?: Maybe<Scalars['String']>;
  audio_sensing?: Maybe<Scalars['String']>;
  auto_answer?: Maybe<Scalars['String']>;
  auto_answer_cradle?: Maybe<Scalars['String']>;
  auto_connect_mobile?: Maybe<Scalars['String']>;
  auto_disconnect_cradle?: Maybe<Scalars['String']>;
  auto_mute?: Maybe<Scalars['String']>;
  call_announcement?: Maybe<Scalars['String']>;
  call_button_lock?: Maybe<Scalars['String']>;
  caller_id?: Maybe<Scalars['String']>;
  close_conversation_limiting?: Maybe<Scalars['String']>;
  computer_audio_bandwidth?: Maybe<Scalars['String']>;
  computer_ringtone?: Maybe<Scalars['String']>;
  computer_volume?: Maybe<Scalars['String']>;
  default_phone_line?: Maybe<Scalars['String']>;
  default_ringtone?: Maybe<Scalars['String']>;
  desk_phone_audio_bandwidth?: Maybe<Scalars['String']>;
  desk_phone_ringtone?: Maybe<Scalars['String']>;
  desk_phone_volume?: Maybe<Scalars['String']>;
  dialtone?: Maybe<Scalars['String']>;
  hd_voice?: Maybe<Scalars['String']>;
  increase_qd_headset_volume?: Maybe<Scalars['String']>;
  mobile_phone_ringtone?: Maybe<Scalars['String']>;
  mobile_phone_volume?: Maybe<Scalars['String']>;
  mobile_voice_commands?: Maybe<Scalars['String']>;
  mute_alert_type?: Maybe<Scalars['String']>;
  mute_alerts?: Maybe<Scalars['String']>;
  mute_off_alert?: Maybe<Scalars['String']>;
  mute_reminder_mode?: Maybe<Scalars['String']>;
  mute_reminder_timing?: Maybe<Scalars['String']>;
  mute_reminder_volume?: Maybe<Scalars['String']>;
  notification_tones?: Maybe<Scalars['String']>;
  online_indicator?: Maybe<Scalars['String']>;
  over_air_subscription?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  ring_vibration?: Maybe<Scalars['String']>;
  rocket_button?: Maybe<Scalars['String']>;
  second_incoming_call?: Maybe<Scalars['String']>;
  sidetone?: Maybe<Scalars['String']>;
  smart_audio_transfer?: Maybe<Scalars['String']>;
  wearing_preference?: Maybe<Scalars['String']>;
};

export type CallControlOptions = {
  waitForStatusResponse?: Maybe<Scalars['Boolean']>;
};

export type CallOptions = {
  bitrate?: Maybe<Scalars['Float']>;
  line?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  type?: Maybe<CallType>;
  waitForStatusResponse?: Maybe<Scalars['Boolean']>;
};

export enum CallState {
  Connected = 'Connected',
  Connecting = 'Connecting',
  Disconnected = 'Disconnected',
  Disconnecting = 'Disconnecting',
  Unknown = 'Unknown'
}

export enum CallStatus {
  InCall = 'IN_CALL',
  NotInCall = 'NOT_IN_CALL',
  Unknown = 'UNKNOWN',
  Unsupported = 'UNSUPPORTED'
}

export enum CallType {
  Auto = 'AUTO',
  Gateway = 'GATEWAY',
  H320 = 'H320',
  H323 = 'H323',
  IsdnVoice = 'ISDN_VOICE',
  Loopback = 'LOOPBACK',
  Pots = 'POTS',
  PotsSpeakerphone = 'POTS_SPEAKERPHONE',
  Sip = 'SIP',
  SipSpeakerphone = 'SIP_SPEAKERPHONE',
  Tel = 'TEL',
  Video = 'VIDEO',
  Voice = 'VOICE',
  VoiceGateway = 'VOICE_GATEWAY',
  VoiceH323 = 'VOICE_H323',
  VoiceSip = 'VOICE_SIP'
}

export type Capabilities = {
  __typename: 'Capabilities';
  com: Maybe<Com>;
};

export type CapabilitiesInput = {
  com?: Maybe<ComInput>;
};

export type Capability = {
  __typename: 'Capability';
  constraints: Maybe<Constraints>;
  id: Scalars['ID'];
  mutable: Maybe<Scalars['Boolean']>;
  readable: Maybe<Scalars['Boolean']>;
};

export type CatalogCategoryConnection = {
  __typename: 'CatalogCategoryConnection';
  edges: Maybe<Array<CatalogCategoryConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type CatalogCategoryConnectionEdge = {
  __typename: 'CatalogCategoryConnectionEdge';
  cursor: Scalars['Cursor'];
  node: HardwareCategory;
};

export type CatalogCategoryConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<CategorySortObject>>;
};

export enum CatalogCategorySortField {
  Name = 'NAME'
}

export enum CatalogComparisonOperator {
  Equal = 'EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type CatalogFamilyConnection = {
  __typename: 'CatalogFamilyConnection';
  edges: Maybe<Array<CatalogFamilyConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type CatalogFamilyConnectionEdge = {
  __typename: 'CatalogFamilyConnectionEdge';
  cursor: Scalars['Cursor'];
  node: HardwareFamily;
};

export type CatalogFamilyConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<FamilySortObject>>;
};

export enum CatalogFamilySortField {
  Name = 'NAME'
}

export type CatalogImageConnection = {
  __typename: 'CatalogImageConnection';
  edges: Maybe<Array<CatalogImageConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type CatalogImageConnectionEdge = {
  __typename: 'CatalogImageConnectionEdge';
  cursor: Scalars['Cursor'];
  node: HardwareImage;
};

export type CatalogImageConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<CatalogImageSortObject>>;
};

export enum CatalogImageSortField {
  Name = 'NAME'
}

export type CatalogImageSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<CatalogImageSortField>;
};

export type CatalogManufacturerConnection = {
  __typename: 'CatalogManufacturerConnection';
  edges: Maybe<Array<CatalogManufacturerConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type CatalogManufacturerConnectionEdge = {
  __typename: 'CatalogManufacturerConnectionEdge';
  cursor: Scalars['Cursor'];
  node: HardwareManufacturer;
};

export type CatalogManufacturerConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<CatalogManufacturerSortObject>>;
};

export enum CatalogManufacturerSortField {
  Name = 'NAME'
}

export type CatalogManufacturerSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<CatalogManufacturerSortField>;
};

export type CatalogModelConnection = {
  __typename: 'CatalogModelConnection';
  edges: Maybe<Array<CatalogModelConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type CatalogModelConnectionEdge = {
  __typename: 'CatalogModelConnectionEdge';
  cursor: Scalars['Cursor'];
  node: HardwareModel;
};

export type CatalogModelConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<CatalogModelSortObject>>;
};

export enum CatalogModelSortField {
  Name = 'NAME'
}

export type CatalogModelSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<CatalogModelSortField>;
};

export type CatalogProductConnection = {
  __typename: 'CatalogProductConnection';
  edges: Maybe<Array<CatalogProductConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type CatalogProductConnectionEdge = {
  __typename: 'CatalogProductConnectionEdge';
  cursor: Scalars['Cursor'];
  node: HardwareProduct;
};

export type CatalogProductConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<ProductSortObject>>;
};

export enum CatalogProductSortField {
  Name = 'NAME'
}

export enum Category {
  Device = 'DEVICE',
  Room = 'ROOM'
}

export type CategoryInput = {
  description?: Maybe<Scalars['String']>;
  hardwareFamilies?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CategorySortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<CatalogCategorySortField>;
};

export type CertificateResponse = {
  __typename: 'CertificateResponse';
  checksum: Maybe<Scalars['String']>;
  deviceId: Scalars['String'];
  error: Maybe<Scalars['String']>;
  expiry: Maybe<Scalars['String']>;
  issuerCN: Maybe<Scalars['String']>;
  sans: Maybe<Scalars['String']>;
  subjectCN: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Chart = {
  __typename: 'Chart';
  invocationId: Scalars['ID'];
  meta: ChartMeta;
  series: Array<Series>;
};

export enum ChartAggregation {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Percentage = 'PERCENTAGE',
  Total = 'TOTAL'
}

export type ChartMeta = InsightChartMeta | MeetingRecordAggregateChartMeta;

export enum ChartType {
  Line = 'LINE',
  Special = 'SPECIAL'
}

export enum CidrComparisonOperator {
  Contain = 'contain',
  ContainedWithin = 'containedWithin',
  ContainedWithinOrEqual = 'containedWithinOrEqual',
  ContainOrContainedWithin = 'containOrContainedWithin',
  ContainOrEqual = 'containOrEqual',
  Equal = 'equal',
  NotEqual = 'notEqual'
}

export type ClaritiTrialConferenceReport = {
  __typename: 'ClaritiTrialConferenceReport';
  conferenceIdentifier: Scalars['ID'];
  conferenceRoomIdentifier: Scalars['String'];
  endTime: Maybe<Scalars['DateTime']>;
  entityTag: Scalars['String'];
  hostName: Scalars['String'];
  id: Scalars['ID'];
  numberOfParticipants: Scalars['Float'];
  participantsDetails: Scalars['String'];
  startTime: Scalars['DateTime'];
  subscriptionReportId: Scalars['ID'];
};

export type ClaritiTrialDeleteSubscriptionReportResponse = {
  __typename: 'ClaritiTrialDeleteSubscriptionReportResponse';
  id: Scalars['ID'];
};

export type ClaritiTrialSubscriptionReport = {
  __typename: 'ClaritiTrialSubscriptionReport';
  aboutToExpireEmailSent: Maybe<Scalars['DateTime']>;
  browserType: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  eulaAcceptanceDate: Maybe<Scalars['DateTime']>;
  eulaAccepted: Scalars['Boolean'];
  expired: Scalars['Boolean'];
  id: Scalars['ID'];
  latestUse: Maybe<Scalars['DateTime']>;
  meetingRoomId: Scalars['String'];
  meetingUrl: Scalars['String'];
  subscriptionDate: Scalars['DateTime'];
  subscriptionExpiredEmailSent: Maybe<Scalars['DateTime']>;
  usageStats: ClaritiTrialUsageStats;
  user: Maybe<ClaritiTrialUserInfo>;
  userAccessorId: Scalars['ID'];
  welcomeEmailSent: Maybe<Scalars['DateTime']>;
};

export type ClaritiTrialSubscriptionReportConnection = {
  __typename: 'ClaritiTrialSubscriptionReportConnection';
  edges: Maybe<Array<ClaritiTrialSubscriptionReportConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type ClaritiTrialSubscriptionReportConnectionEdge = {
  __typename: 'ClaritiTrialSubscriptionReportConnectionEdge';
  cursor: Scalars['Cursor'];
  node: ClaritiTrialSubscriptionReport;
};

export type ClaritiTrialSubscriptionReportConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
};

export type ClaritiTrialUsageStats = {
  __typename: 'ClaritiTrialUsageStats';
  averageNumberOfParticipants: Maybe<Scalars['Float']>;
  conferenceReports: Maybe<Array<ClaritiTrialConferenceReport>>;
  conferencesUsageCounter: Maybe<Scalars['Float']>;
  maxNumberOfParticipants: Maybe<Scalars['Float']>;
  minNumberOfParticipants: Maybe<Scalars['Float']>;
  totalDurationMinutes: Maybe<Scalars['Float']>;
  totalNumberOfParticipants: Maybe<Scalars['Float']>;
};

export type ClaritiTrialUserInfo = {
  __typename: 'ClaritiTrialUserInfo';
  email: Maybe<Scalars['String']>;
  familyName: Maybe<Scalars['String']>;
  givenName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type ClaritiTrialUserSubscription = {
  __typename: 'ClaritiTrialUserSubscription';
  id: Scalars['ID'];
  meetingRoomId: Scalars['String'];
  meetingUrl: Scalars['String'];
};

export type ClearAction = {
  id?: Maybe<Scalars['ID']>;
  resourceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  type: ActionTypeInput;
};

export type Collection = {
  __typename: 'Collection';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  matches: Maybe<CollectionMatches>;
  metadata: Maybe<Scalars['JSONType']>;
  rules: Maybe<Scalars['JSONType']>;
  updatedAt: Scalars['DateTime'];
};

export type CollectionMatches = {
  __typename: 'CollectionMatches';
  matches: Maybe<Array<Collection>>;
  totalCount: Scalars['Float'];
};

export type CollectionRule = {
  __typename: 'CollectionRule';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  modelId: Scalars['String'];
  tenantId: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type CollectiveHealthCheckResponse = {
  __typename: 'CollectiveHealthCheckResponse';
  healthy: Scalars['Boolean'];
};

export type Com = {
  __typename: 'com';
  poly: Maybe<Poly>;
};

export type ComInput = {
  poly?: Maybe<PolyInput>;
};

export enum ComparisonOperator {
  Equal = 'EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type ConfigProfileDto = {
  __typename: 'ConfigProfileDTO';
  attributeValues: Maybe<Array<Maybe<AttributeValueDto>>>;
  businessType: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  profileType: Maybe<Scalars['String']>;
  supportPdms: Maybe<Scalars['Boolean']>;
  supportXma: Maybe<Scalars['Boolean']>;
  tags: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid: Maybe<Scalars['String']>;
};

export type ConfigProfileDtoInput = {
  attributeValues?: Maybe<Array<Maybe<AttributeValueDtoInput>>>;
  businessType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['String']>;
  supportPdms?: Maybe<Scalars['Boolean']>;
  supportXma?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ConfigurationAttribute = {
  __typename: 'ConfigurationAttribute';
  currentValue: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  param2DArray: Maybe<Array<Maybe<Param2DArrayItem>>>;
  paramArray: Maybe<Array<Maybe<ParamArrayItem>>>;
};

export type ConfigurationAttributeInput = {
  currentValue?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  param2DArray?: Maybe<Array<Maybe<Param2DArrayItemInput>>>;
  paramArray?: Maybe<Array<Maybe<ParamArrayItemInput>>>;
};

export type ConnectionParams = {
  after?: Maybe<Scalars['Cursor']>;
  directional?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
};

export type Coordinate = {
  __typename: 'Coordinate';
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
};

export type CountAverageIndicator = {
  __typename: 'CountAverageIndicator';
  average: Scalars['Float'];
  count: Scalars['Int'];
};

export type CountOfTotalIndicator = {
  __typename: 'CountOfTotalIndicator';
  count: Scalars['Int'];
  percentage: Scalars['Float'];
  total: Scalars['Int'];
};

export type CreateProductSoftware = {
  description: Scalars['String'];
  name: Scalars['String'];
  productBuildId: Scalars['String'];
  productId: Scalars['String'];
  publishDate?: Maybe<Scalars['DateTime']>;
  releaseChannel?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type CreateRegisteredDeviceRequest = {
  deviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type CreateRegisteredDeviceResponse = {
  __typename: 'CreateRegisteredDeviceResponse';
  deviceId: Maybe<Scalars['String']>;
  deviceKey: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  idScope: Maybe<Scalars['String']>;
  isEdgeDevice: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type CreateServiceNowInput = {
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  password: Scalars['String'];
  url: Scalars['URL'];
  username: Scalars['String'];
};

export type CreateSubnetRequest = {
  cidr: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  siteId: Scalars['String'];
};

export type CreateSubnetRuleInput = {
  privateCidr?: Maybe<Scalars['String']>;
  publicCidr: Scalars['String'];
  siteId: Scalars['String'];
};

export type CreateTenantInput = {
  name: Scalars['String'];
  type?: Maybe<TenantType>;
};

export type CreateTenantIntegrationResponse = {
  __typename: 'CreateTenantIntegrationResponse';
  integration: Integration;
};

export type CreateWebhook = {
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};





export type DeleteByPidResponse = {
  __typename: 'DeleteByPidResponse';
  affected: Scalars['Float'];
  pid: Scalars['String'];
};

export type DeleteMockRecordsResult = {
  __typename: 'DeleteMockRecordsResult';
  resultCode: DeleteMockRecordsResultStatus;
};

export enum DeleteMockRecordsResultStatus {
  NoMockRecordsFound = 'NO_MOCK_RECORDS_FOUND',
  Success = 'SUCCESS'
}

export type DeleteResponse = {
  __typename: 'DeleteResponse';
  affected: Scalars['Float'];
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
};

export type DeleteResult = {
  __typename: 'DeleteResult';
  id: Scalars['ID'];
};

export type DeleteRoomsResponse = {
  __typename: 'DeleteRoomsResponse';
  error: Maybe<Scalars['String']>;
  id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteSitesResponse = {
  __typename: 'DeleteSitesResponse';
  error: Maybe<Scalars['String']>;
  id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteSubnetRuleInput = {
  ruleId: Scalars['String'];
};

export type DeleteTenantIntegrationResponse = {
  __typename: 'DeleteTenantIntegrationResponse';
  id: Scalars['ID'];
};

export type DeleteTenantResponse = {
  __typename: 'DeleteTenantResponse';
  id: Scalars['ID'];
};

export type DeleteUserResponse = {
  __typename: 'DeleteUserResponse';
  userId: Scalars['ID'];
};

export type Device = {
  __typename: 'Device';
  activeApplicationName: Maybe<Scalars['String']>;
  activeApplicationVersion: Maybe<Scalars['String']>;
  availableOSs: Maybe<Array<AvailableOs>>;
  bandwidth: Maybe<Bandwidth>;
  callStatus: CallStatus;
  connected: Maybe<Scalars['Boolean']>;
  connections: Maybe<Array<Device>>;
  currentOSState: Maybe<OsState>;
  dateRegistered: Maybe<Scalars['DateTime']>;
  entitledUntilDate: Maybe<Scalars['DateTime']>;
  entitlements: Array<Entitlement>;
  entityConnections: EntityConnectionInfo;
  etag: Maybe<Scalars['String']>;
  externalIp: Maybe<Scalars['String']>;
  hardwareFamily: Maybe<Scalars['String']>;
  hardwareModel: Maybe<Scalars['String']>;
  hardwareProduct: Maybe<Scalars['String']>;
  hardwareRevision: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalIp: Maybe<Scalars['String']>;
  lastConfigRequestDate: Maybe<Scalars['DateTime']>;
  lastDetected: Maybe<Scalars['DateTime']>;
  location: Maybe<DeviceLocation>;
  macAddress: Maybe<Scalars['String']>;
  manufacturer: Maybe<Scalars['String']>;
  model: Maybe<HardwareModel>;
  name: Maybe<Scalars['String']>;
  organization: Maybe<Scalars['String']>;
  product: Maybe<HardwareProduct>;
  productId: Maybe<Scalars['String']>;
  provisioningEnabled: Maybe<Scalars['Boolean']>;
  proxyAgent: Maybe<Scalars['String']>;
  proxyAgentId: Maybe<Scalars['String']>;
  proxyAgentVersion: Maybe<Scalars['String']>;
  room: Maybe<Room>;
  serialNumber: Maybe<Scalars['String']>;
  shipment: Maybe<ShipmentModel>;
  shipmentDate: Maybe<Scalars['DateTime']>;
  site: Maybe<Site>;
  softwareBuild: Maybe<Scalars['String']>;
  softwareVersion: Maybe<Scalars['String']>;
  supportsSettings: Maybe<Scalars['Boolean']>;
  supportsSoftwareUpdate: Maybe<Scalars['Boolean']>;
  tags: Array<Scalars['String']>;
  tenant: Maybe<Tenant>;
  tenantId: Maybe<Scalars['String']>;
  usbProductId: Maybe<Scalars['String']>;
  usbVendorId: Maybe<Scalars['String']>;
  user: Maybe<User>;
};


export type DeviceEntityConnectionsArgs = {
  params: ConnectionParams;
};

export type DeviceApiResponse = {
  __typename: 'DeviceAPIResponse';
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeviceBasicData = {
  __typename: 'DeviceBasicData';
  deviceFamily: Maybe<Scalars['String']>;
  deviceId: Maybe<Scalars['String']>;
  deviceName: Maybe<Scalars['String']>;
  groups: Maybe<Array<Maybe<Scalars['String']>>>;
  macAddress: Maybe<Scalars['String']>;
  parentDevId: Maybe<Scalars['String']>;
  serialNum: Maybe<Scalars['String']>;
};

export type DeviceCertificate = {
  certificateKey: Scalars['String'];
  certificatePfx: Scalars['String'];
};

export type DeviceClass = {
  __typename: 'DeviceClass';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeviceClassInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DeviceImportResponse = {
  __typename: 'DeviceImportResponse';
  deviceId: Maybe<Scalars['String']>;
  deviceModel: Maybe<Scalars['String']>;
  deviceReport: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeviceIn = {
  deviceModel: Scalars['String'];
  serial: Scalars['String'];
};

export type DeviceIp = {
  externalIp?: Maybe<Scalars['String']>;
  internalIp?: Maybe<Scalars['String']>;
};

export type DeviceLocation = {
  __typename: 'DeviceLocation';
  coordinate: Maybe<Coordinate>;
  geohash: Maybe<Scalars['String']>;
};

export type DeviceLogsApiResponse = {
  __typename: 'DeviceLogsAPIResponse';
  error: Maybe<Scalars['String']>;
  pcapStopTime: Maybe<Scalars['DateTime']>;
  success: Scalars['Boolean'];
  uploadedOn: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ExportDeviceInventoryResponse = {
  __typename: 'ExportDeviceInventoryResponse';
  success: Scalars['Boolean'];
  error: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  recipientEmail: Maybe<Scalars['String']>;
};

export type DeviceModelData = {
  __typename: 'DeviceModelData';
  countDevices: Scalars['Float'];
  deviceModel: Scalars['String'];
};

export type DeviceOutput = {
  __typename: 'DeviceOutput';
  pid: Maybe<NumberValue>;
  serial_number: Maybe<StringValue>;
  software_version: Maybe<StringValue>;
};

export type DeviceParameterDto = {
  __typename: 'DeviceParameterDTO';
  accessType: Maybe<Scalars['String']>;
  blockToDevice: Maybe<Scalars['Int']>;
  callback: Maybe<Scalars['String']>;
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
  defaultValue: Maybe<Scalars['String']>;
  deviceFamily: Maybe<Scalars['String']>;
  deviceModel: Maybe<Scalars['String']>;
  deviceModelUuid: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  enumName: Maybe<Scalars['String']>;
  enumVal: Maybe<Array<Maybe<EnumVal>>>;
  enumValue: Maybe<Array<Maybe<Scalars['String']>>>;
  friendlyName: Maybe<Scalars['String']>;
  grouping: Maybe<Scalars['String']>;
  groupingOrder: Maybe<Scalars['Int']>;
  help: Maybe<Scalars['String']>;
  featureCategory: Maybe<FeatureCategory>;
  languageKey: Maybe<Scalars['String']>;
  lensConditional: Maybe<Scalars['String']>;
  lensConditionalValue: Maybe<Scalars['String']>;
  lensUserType: Maybe<Scalars['Int']>;
  max: Maybe<Scalars['Int']>;
  min: Maybe<Scalars['Int']>;
  modelName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  numReplace1Max: Maybe<Scalars['Int']>;
  numReplace2Max: Maybe<Scalars['Int']>;
  param2DArray: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
  paramArray: Maybe<Array<Maybe<Scalars['String']>>>;
  paramType: Maybe<Scalars['String']>;
  rebootRequired: Maybe<Scalars['Boolean']>;
  templates: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type DeviceParameterDtoInput = {
  accessType?: Maybe<Scalars['String']>;
  blockToDevice?: Maybe<Scalars['Int']>;
  callback?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  defaultValue?: Maybe<Scalars['String']>;
  deviceFamily?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  deviceModelUuid?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  enumName?: Maybe<Scalars['String']>;
  enumVal?: Maybe<Array<Maybe<EnumValInput>>>;
  enumValue?: Maybe<Array<Maybe<Scalars['String']>>>;
  friendlyName?: Maybe<Scalars['String']>;
  grouping?: Maybe<Scalars['String']>;
  groupingOrder?: Maybe<Scalars['Int']>;
  help?: Maybe<Scalars['String']>;
  featureCategory?: Maybe<FeatureCategory>;
  languageKey?: Maybe<Scalars['String']>;
  lensConditional?: Maybe<Scalars['String']>;
  lensConditionalValue?: Maybe<Scalars['String']>;
  lensUserType?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  modelName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numReplace1Max?: Maybe<Scalars['Int']>;
  numReplace2Max?: Maybe<Scalars['Int']>;
  param2DArray?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
  paramArray?: Maybe<Array<Maybe<Scalars['String']>>>;
  paramType?: Maybe<Scalars['String']>;
  rebootRequired?: Maybe<Scalars['Boolean']>;
  templates?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Devices = {
  devices: Array<DeviceIn>;
};

export type DeviceSort = {
  fields: Array<DeviceSortField>;
};

export enum DeviceSortDirection {
  Asc = 'ASC',
  Ascending = 'Ascending',
  Desc = 'DESC',
  Descending = 'Descending'
}

export type DeviceSortField = {
  direction: DeviceSortDirection;
  name: Scalars['String'];
};

export type DeviceTypeDocument = {
  __typename: 'DeviceTypeDocument';
  metadata: Maybe<DeviceTypeMetadata>;
  models: Maybe<Array<Maybe<DeviceTypeModel>>>;
  name: Maybe<Scalars['String']>;
};

export type DeviceTypeDocumentInput = {
  metadata?: Maybe<DeviceTypeMetadataInput>;
  models?: Maybe<Array<Maybe<DeviceTypeModelInput>>>;
  name?: Maybe<Scalars['String']>;
};

export type DeviceTypeDto = {
  __typename: 'DeviceTypeDTO';
  metadata: Maybe<DeviceTypeMetadataDto>;
  models: Maybe<Array<Maybe<DeviceTypeModelDto>>>;
  name: Maybe<Scalars['String']>;
};

export type DeviceTypeMetadata = {
  __typename: 'DeviceTypeMetadata';
  businessTypes: Maybe<Array<Maybe<Scalars['String']>>>;
  deviceTypeUuid: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  family: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  schemaName: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
  typePatterns: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeviceTypeMetadataDto = {
  __typename: 'DeviceTypeMetadataDTO';
  businessTypes: Maybe<Array<Maybe<Scalars['String']>>>;
  deviceTypeUuid: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  family: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  schemaName: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
  typePatterns: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeviceTypeMetadataInput = {
  businessTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  deviceTypeUuid?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  imageType?: Maybe<Scalars['String']>;
  schemaName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  typePatterns?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeviceTypeModel = {
  __typename: 'DeviceTypeModel';
  code: Maybe<Scalars['String']>;
  displayOrder: Maybe<Scalars['Int']>;
  lensName: Maybe<Scalars['String']>;
  matcherAll: Maybe<Scalars['Boolean']>;
  minSWVersion: Maybe<Scalars['String']>;
  modelPatterns: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  uuid: Maybe<Scalars['String']>;
};

export type DeviceTypeModelDto = {
  __typename: 'DeviceTypeModelDTO';
  code: Maybe<Scalars['String']>;
  displayOrder: Maybe<Scalars['Int']>;
  lensName: Maybe<Scalars['String']>;
  matcherAll: Maybe<Scalars['Boolean']>;
  minSWVersion: Maybe<Scalars['String']>;
  modelPatterns: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  uuid: Maybe<Scalars['String']>;
};

export type DeviceTypeModelInput = {
  code?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  lensName?: Maybe<Scalars['String']>;
  matcherAll?: Maybe<Scalars['Boolean']>;
  minSWVersion?: Maybe<Scalars['String']>;
  modelPatterns?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export enum DfuSupport {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  None = 'None'
}

export enum Direction {
  Asc = 'ASC',
  Ascending = 'Ascending',
  Desc = 'DESC',
  Descending = 'Descending'
}

export type Directive = {
  __typename: 'Directive';
  args: Array<InputValue>;
  description: Maybe<Scalars['String']>;
  locations: Maybe<Array<DirectiveLocation>>;
  name: Maybe<Scalars['String']>;
  onField: Maybe<Scalars['Boolean']>;
  onFragment: Maybe<Scalars['Boolean']>;
  onOperation: Maybe<Scalars['Boolean']>;
};

export enum DirectiveLocation {
  ArgumentDefinition = 'ARGUMENT_DEFINITION',
  Enum = 'ENUM',
  Field = 'FIELD',
  FieldDefinition = 'FIELD_DEFINITION',
  FragmentDefinition = 'FRAGMENT_DEFINITION',
  FragmentSpread = 'FRAGMENT_SPREAD',
  InlineFragment = 'INLINE_FRAGMENT',
  InputFieldDefinition = 'INPUT_FIELD_DEFINITION',
  InputObject = 'INPUT_OBJECT',
  Interface = 'INTERFACE',
  Mutation = 'MUTATION',
  Object = 'OBJECT',
  Query = 'QUERY',
  Scalar = 'SCALAR',
  Schema = 'SCHEMA',
  Union = 'UNION'
}


export type EndpointAuthorization = {
  __typename: 'EndpointAuthorization';
  context: Array<AuthorizationContext>;
  type: AuthorizationType;
};

export enum EndpointType {
  Mutation = 'MUTATION',
  Query = 'QUERY'
}

export type EntitleDeviceResult = {
  __typename: 'EntitleDeviceResult';
  licenseKey: Maybe<Scalars['String']>;
  productSerial: Maybe<Scalars['String']>;
  resultCode: EntitleResultStatus;
  resultErrorMessage: Maybe<Scalars['String']>;
};

export type Entitlement = {
  __typename: 'Entitlement';
  date: Scalars['DateTime'];
  endDate: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  isMockEntitlement: Maybe<Scalars['Boolean']>;
  license: LicenseInfo;
  licenseKey: Scalars['String'];
  productSerial: Scalars['String'];
  tenantId: Scalars['String'];
  userId: Maybe<Scalars['String']>;
};

export type EntitlementConnection = {
  __typename: 'EntitlementConnection';
  edges: Array<Entitlement>;
  pageInfo: PolyPlusPageInfo;
};

export type EntitleResult = {
  __typename: 'EntitleResult';
  licenseKey: Maybe<Scalars['String']>;
  productSerial: Maybe<Scalars['String']>;
  resultCode: EntitleResultStatus;
  resultErrorMessage: Maybe<Scalars['String']>;
};

export enum EntitleResultStatus {
  AllEntitlementsUsed = 'ALL_ENTITLEMENTS_USED',
  AlreadyEntitled = 'ALREADY_ENTITLED',
  ItApiError = 'IT_API_ERROR',
  LicenseActivatedByDifferentTenant = 'LICENSE_ACTIVATED_BY_DIFFERENT_TENANT',
  LicenseExpired = 'LICENSE_EXPIRED',
  LicenseNotActivated = 'LICENSE_NOT_ACTIVATED',
  LicenseNotFound = 'LICENSE_NOT_FOUND',
  NoShipmentFound = 'NO_SHIPMENT_FOUND',
  ProductNotSupportedByLicense = 'PRODUCT_NOT_SUPPORTED_BY_LICENSE',
  ShipmentTooOld = 'SHIPMENT_TOO_OLD',
  Success = 'SUCCESS'
}

export type EntityConnection = {
  __typename: 'EntityConnection';
  connected: Scalars['Boolean'];
  createdOn: Scalars['DateTime'];
  derived: Maybe<Scalars['Boolean']>;
  entityId: Scalars['String'];
  targetEntity: Device;
  targetEntityId: Scalars['String'];
  targetEntityType: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedOn: Scalars['DateTime'];
  via: Maybe<Array<Scalars['String']>>;
};

export type EntityConnectionEdge = {
  __typename: 'EntityConnectionEdge';
  cursor: Scalars['Cursor'];
  node: EntityConnection;
};

export type EntityConnectionInfo = {
  __typename: 'EntityConnectionInfo';
  edges: Maybe<Array<EntityConnectionEdge>>;
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

export type EntityConnectionTransport = {
  __typename: 'EntityConnectionTransport';
  createdOn: Scalars['DateTime'];
  transportProtocol: TransportProtocol;
  type: Scalars['String'];
  updatedOn: Scalars['DateTime'];
};

export enum Enum_8021XeapAuthenticationMethod {
  Peap = 'PEAP',
  Pwd = 'PWD',
  Tls = 'TLS',
  Ttls = 'TTLS'
}

export enum Enum_8021XeapPhaseTwo {
  Gtc = 'GTC',
  Mschapv2 = 'MSCHAPV2',
  None = 'NONE'
}

export enum Enum_AlertUserTone {
  Tone_1 = 'Tone_1',
  Tone_2 = 'Tone_2',
  Tone_3 = 'Tone_3',
  Tone_4 = 'Tone_4'
}

export enum Enum_AlertVideoTone {
  Tone_1 = 'Tone_1',
  Tone_10 = 'Tone_10',
  Tone_2 = 'Tone_2',
  Tone_3 = 'Tone_3',
  Tone_4 = 'Tone_4',
  Tone_5 = 'Tone_5',
  Tone_6 = 'Tone_6',
  Tone_7 = 'Tone_7',
  Tone_8 = 'Tone_8',
  Tone_9 = 'Tone_9'
}

export enum Enum_ApiPort {
  Two3 = 'TWO3',
  Two4 = 'TWO4'
}

export enum Enum_Audio0_10 {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  One0 = 'ONE0',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export enum Enum_AudioInLevel {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  One0 = 'ONE0',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export enum Enum_AudioOutMode {
  Fixed = 'fixed',
  Variable = 'variable'
}

export enum Enum_AudioTransmitLevel {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Neg_1 = 'NEG_1',
  Neg_2 = 'NEG_2',
  Neg_3 = 'NEG_3',
  Neg_4 = 'NEG_4',
  Neg_5 = 'NEG_5',
  Neg_6 = 'NEG_6',
  Nine = 'NINE',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  One2 = 'ONE2',
  One3 = 'ONE3',
  One4 = 'ONE4',
  One5 = 'ONE5',
  One6 = 'ONE6',
  One7 = 'ONE7',
  One8 = 'ONE8',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export enum Enum_AuthenticationAlgorithm {
  Md5 = 'MD5',
  Sha = 'SHA'
}

export enum Enum_AuthType {
  Anonymous = 'anonymous',
  Basic = 'basic',
  Ntlm = 'ntlm'
}

export enum Enum_AutoAnswer {
  DoNotDisturb = 'Do_Not_Disturb',
  No = 'No',
  Yes = 'Yes'
}

export enum Enum_BfcpTransportProtocol {
  PreferTcp = 'Prefer_TCP',
  PreferUdp = 'Prefer_UDP',
  TcpOnly = 'TCP_ONLY',
  UdpOnly = 'UDP_ONLY'
}

export enum Enum_Boolean {
  False = 'False',
  True = 'True'
}

export enum Enum_CalendarReminderTime {
  Five = 'FIVE',
  None = 'None',
  One = 'ONE',
  One0 = 'ONE0',
  One5 = 'ONE5',
  Three0 = 'THREE0'
}

export enum Enum_CameraGroupViewSize {
  Medium = 'Medium',
  Tight = 'Tight',
  Wide = 'Wide'
}

export enum Enum_CameraOrientation {
  Inverted = 'Inverted',
  Normal = 'Normal'
}

export enum Enum_CameraSleepMode {
  FastWakeUp = 'Fast_Wake_Up',
  SaveEnergy = 'Save_Energy'
}

export enum Enum_CameraTrackingMode {
  FrameGroup = 'FrameGroup',
  FrameGroupWithTransition = 'FrameGroupWithTransition',
  FrameSpeaker = 'FrameSpeaker',
  Off = 'Off'
}

export enum Enum_CameraTrackingSpeed {
  Fast = 'Fast',
  Normal = 'Normal',
  Slow = 'Slow'
}

export enum Enum_CameraTypes {
  EagleEyeCubeUsb = 'EagleEyeCubeUSB',
  EagleEyeDirectorIi = 'EagleEyeDirectorII',
  EagleEyeIv12x = 'EagleEyeIV12x',
  EagleEyeIv4x = 'EagleEyeIV4x',
  EagleEyeProducer = 'EagleEyeProducer'
}

export enum Enum_CameraVideoQuality {
  Motion = 'Motion',
  Sharpness = 'Sharpness'
}

export enum Enum_CameraWhiteBalanceMode {
  Atw = 'atw',
  Eight000k = 'EIGHT000k',
  Five120k = 'FIVE120k',
  Five200k = 'FIVE200k',
  Five600k = 'FIVE600k',
  Five800k = 'FIVE800k',
  Four160k = 'FOUR160k',
  Four230k = 'FOUR230k',
  Four640k = 'FOUR640k',
  Four700k = 'FOUR700k',
  Manual = 'Manual',
  Six500k = 'SIX500k',
  Six504k = 'SIX504k',
  Three200k = 'THREE200k',
  Three450k = 'THREE450k',
  Three600k = 'THREE600k',
  Three680k = 'THREE680k',
  Two300k = 'TWO300k',
  Two500k = 'TWO500k',
  Two856k = 'TWO856k'
}

export enum Enum_ContentQualityPreference {
  Both = 'Both',
  Content = 'Content',
  People = 'People'
}

export enum Enum_Country {
  Afghanistan = 'Afghanistan',
  Albania = 'Albania',
  Algeria = 'Algeria',
  AmericanSamoa = 'American_Samoa',
  Andorra = 'Andorra',
  Angola = 'Angola',
  Anguilla = 'Anguilla',
  Antarctica = 'Antarctica',
  Antigua = 'Antigua',
  Argentina = 'Argentina',
  Armenia = 'Armenia',
  Aruba = 'Aruba',
  AscensionIslands = 'Ascension_Islands',
  Australia = 'Australia',
  AustralianExtTerritories = 'Australian_Ext__Territories',
  Austria = 'Austria',
  Azerbaijan = 'Azerbaijan',
  Bahamas = 'Bahamas',
  Bahrain = 'Bahrain',
  Bangladesh = 'Bangladesh',
  Barbados = 'Barbados',
  Barbuda = 'Barbuda',
  Belarus = 'Belarus',
  Belgium = 'Belgium',
  Belize = 'Belize',
  BeninRepublic = 'Benin_Republic',
  Bermuda = 'Bermuda',
  Bhutan = 'Bhutan',
  Bolivia = 'Bolivia',
  BosniaAndHerzegovina = 'Bosnia_and_Herzegovina',
  Botswana = 'Botswana',
  Brazil = 'Brazil',
  BritishIndianOceanTerritory = 'British_Indian_Ocean_Territory',
  BritishVirginIslands = 'British_Virgin_Islands',
  Brunei = 'Brunei',
  Bulgaria = 'Bulgaria',
  BurkinaFaso = 'Burkina_Faso',
  BurmaMyanmar = 'Burma__Myanmar_',
  Burundi = 'Burundi',
  Cambodia = 'Cambodia',
  CameroonUnitedRepublic = 'Cameroon_United_Republic',
  Canada = 'Canada',
  CapeVerdeIsland = 'Cape_Verde_Island',
  CaymanIslands = 'Cayman_Islands',
  CentralAfricanRepublic = 'Central_African_Republic',
  ChadRepublic = 'Chad_Republic',
  Chile = 'Chile',
  China = 'China',
  ChristmasIsland = 'Christmas_Island',
  CocosIslands = 'Cocos_Islands',
  Colombia = 'Colombia',
  Comoros = 'Comoros',
  Congo = 'Congo',
  CongoDemocraticRepublic = 'Congo_Democratic_Republic',
  CookIslands = 'Cook_Islands',
  CostaRica = 'Costa_Rica',
  Croatia = 'Croatia',
  Cuba = 'Cuba',
  Curacao = 'Curacao',
  Cyprus = 'Cyprus',
  CzechRepublic = 'Czech_Republic',
  Denmark = 'Denmark',
  DiegoGarcia = 'Diego_Garcia',
  Djibouti = 'Djibouti',
  Dominica = 'Dominica',
  DominicanRepublic = 'Dominican_Republic',
  EastTimor = 'East_Timor',
  EasterIsland = 'Easter_Island',
  Ecuador = 'Ecuador',
  Egypt = 'Egypt',
  ElSalvador = 'El_Salvador',
  EquatorialGuinea = 'Equatorial_Guinea',
  Eritrea = 'Eritrea',
  Estonia = 'Estonia',
  Ethiopia = 'Ethiopia',
  FaeroeIslands = 'Faeroe_Islands',
  FalklandIslands = 'Falkland_Islands',
  FijiIslands = 'Fiji_Islands',
  Finland = 'Finland',
  France = 'France',
  FrenchAntilles = 'French_Antilles',
  FrenchGuiana = 'French_Guiana',
  FrenchPolynesia = 'French_Polynesia',
  FrenchSouthernAndAntarcticLands = 'French_Southern_and_Antarctic_Lands',
  Gabon = 'Gabon',
  Gambia = 'Gambia',
  Georgia = 'Georgia',
  Germany = 'Germany',
  Ghana = 'Ghana',
  Gibraltar = 'Gibraltar',
  Global = 'Global',
  Greece = 'Greece',
  Greenland = 'Greenland',
  Grenada = 'Grenada',
  Guadeloupe = 'Guadeloupe',
  Guam = 'Guam',
  GuantanamoBay = 'Guantanamo_Bay',
  Guatemala = 'Guatemala',
  Guernsey = 'Guernsey',
  Guinea = 'Guinea',
  GuineaBissau = 'Guinea_Bissau',
  Guyana = 'Guyana',
  Haiti = 'Haiti',
  Honduras = 'Honduras',
  HongKong = 'Hong_Kong',
  Hungary = 'Hungary',
  Iceland = 'Iceland',
  India = 'India',
  Indonesia = 'Indonesia',
  InmarsatAtlanticOceanEast = 'Inmarsat__Atlantic_Ocean_East_',
  InmarsatAtlanticOceanWest = 'Inmarsat__Atlantic_Ocean_West_',
  InmarsatIndianOcean = 'Inmarsat__Indian_Ocean_',
  InmarsatPacificOcean = 'Inmarsat__Pacific_Ocean_',
  InmarsatSnac = 'Inmarsat__SNAC_',
  Iran = 'Iran',
  Iraq = 'Iraq',
  Ireland = 'Ireland',
  Israel = 'Israel',
  Italy = 'Italy',
  IvoryCoast = 'Ivory_Coast',
  Jamaica = 'Jamaica',
  Japan = 'Japan',
  Jersey = 'Jersey',
  Jordan = 'Jordan',
  Kazakhstan = 'Kazakhstan',
  Kenya = 'Kenya',
  Kiribati = 'Kiribati',
  KoreaNorth = 'Korea_North',
  KoreaSouth = 'Korea_South',
  Kosovo = 'Kosovo',
  Kuwait = 'Kuwait',
  Kyrgyzstan = 'Kyrgyzstan',
  Laos = 'Laos',
  Latvia = 'Latvia',
  Lebanon = 'Lebanon',
  Lesotho = 'Lesotho',
  Liberia = 'Liberia',
  Libya = 'Libya',
  Liechtenstein = 'Liechtenstein',
  Lithuania = 'Lithuania',
  Luxembourg = 'Luxembourg',
  Macao = 'Macao',
  Macedonia = 'Macedonia',
  Madagascar = 'Madagascar',
  Malawi = 'Malawi',
  Malaysia = 'Malaysia',
  Maldives = 'Maldives',
  Mali = 'Mali',
  Malta = 'Malta',
  ManIsleOf = 'Man__Isle_of',
  MarianaIslands = 'Mariana_Islands',
  MarshallIslands = 'Marshall_Islands',
  Martinique = 'Martinique',
  Mauritania = 'Mauritania',
  Mauritius = 'Mauritius',
  MayotteIsland = 'Mayotte_Island',
  Mexico = 'Mexico',
  Micronesia = 'Micronesia',
  MidwayIsland = 'Midway_Island',
  Moldova = 'Moldova',
  Monaco = 'Monaco',
  Mongolia = 'Mongolia',
  Montenegro = 'Montenegro',
  Montserrat = 'Montserrat',
  Morocco = 'Morocco',
  Mozambique = 'Mozambique',
  MyanmarBurma = 'Myanmar__Burma_',
  Namibia = 'Namibia',
  Nauru = 'Nauru',
  Nepal = 'Nepal',
  Netherlands = 'Netherlands',
  NetherlandsAntillies = 'Netherlands_Antillies',
  Nevis = 'Nevis',
  NewCaledonia = 'New_Caledonia',
  NewZealand = 'New_Zealand',
  Nicaragua = 'Nicaragua',
  Niger = 'Niger',
  Nigeria = 'Nigeria',
  Niue = 'Niue',
  NorfolkIsland = 'Norfolk_Island',
  Norway = 'Norway',
  Oman = 'Oman',
  Pakistan = 'Pakistan',
  Palau = 'Palau',
  Palestine = 'Palestine',
  Panama = 'Panama',
  PapuaNewGuinea = 'Papua_New_Guinea',
  Paraguay = 'Paraguay',
  Peru = 'Peru',
  Philippines = 'Philippines',
  Pitcairn = 'Pitcairn',
  Poland = 'Poland',
  Portugal = 'Portugal',
  PuertoRico = 'Puerto_Rico',
  Qatar = 'Qatar',
  ReunionIsland = 'Reunion_Island',
  Romania = 'Romania',
  Russia = 'Russia',
  Rwanda = 'Rwanda',
  SanMarino = 'San_Marino',
  SaoTomeAndPrincipe = 'Sao_Tome_and_Principe',
  SaudiArabia = 'Saudi_Arabia',
  Senegal = 'Senegal',
  Serbia = 'Serbia',
  Seychelles = 'Seychelles',
  SierraLeone = 'Sierra_Leone',
  Singapore = 'Singapore',
  Slovakia = 'Slovakia',
  Slovenia = 'Slovenia',
  SolomonIslands = 'Solomon_Islands',
  SomaliaRepublic = 'Somalia_Republic',
  SouthAfrica = 'South_Africa',
  Spain = 'Spain',
  SriLanka = 'Sri_Lanka',
  StHelena = 'St_Helena',
  StKitts = 'St_Kitts',
  StLucia = 'St_Lucia',
  StPierreAndMiquelon = 'St_Pierre_and_Miquelon',
  StVincent = 'St_Vincent',
  Sudan = 'Sudan',
  Suriname = 'Suriname',
  Swaziland = 'Swaziland',
  Sweden = 'Sweden',
  Switzerland = 'Switzerland',
  Syria = 'Syria',
  Taiwan = 'Taiwan',
  Tajikistan = 'Tajikistan',
  Tanzania = 'Tanzania',
  Thailand = 'Thailand',
  Togo = 'Togo',
  Tonga = 'Tonga',
  TrinidadAndTobago = 'Trinidad_and_Tobago',
  Tunisia = 'Tunisia',
  Turkey = 'Turkey',
  Turkmenistan = 'Turkmenistan',
  TurksAndCaicos = 'Turks_and_Caicos',
  Tuvalu = 'Tuvalu',
  Uganda = 'Uganda',
  Ukraine = 'Ukraine',
  UnitedArabEmirates = 'United_Arab_Emirates',
  UnitedKingdom = 'United_Kingdom',
  UnitedStates = 'United_States',
  Uruguay = 'Uruguay',
  UsMinorOutlyingIslands = 'US_Minor_Outlying_Islands',
  UsVirginIslands = 'US_Virgin_Islands',
  Uzbekistan = 'Uzbekistan',
  Vanuatu = 'Vanuatu',
  VaticanCity = 'Vatican_City',
  Venezuela = 'Venezuela',
  Vietnam = 'Vietnam',
  WakeIsland = 'Wake_Island',
  WallisAndFutunaIslands = 'Wallis_And_Futuna_Islands',
  WesternSamoa = 'Western_Samoa',
  Yemen = 'Yemen',
  Zambia = 'Zambia',
  Zanzibar = 'Zanzibar',
  Zimbabwe = 'Zimbabwe'
}

export enum Enum_DateFormat {
  DdMmYyyy = 'dd_mm_yyyy',
  MmDdYyyy = 'mm_dd_yyyy',
  YyyyMmDd = 'yyyy_mm_dd'
}

export enum Enum_DirectoryServerType {
  Ldap = 'LDAP',
  Microsoft = 'Microsoft',
  Off = 'Off',
  PolycomGds = 'Polycom_GDS'
}

export enum Enum_EncryptionEnable {
  Off = 'Off',
  RequiredAll = 'Required_All',
  RequiredVideo = 'Required_Video',
  WhenAvailable = 'When_Available'
}

export enum Enum_EthernetDuplexMode {
  Full = 'Full',
  Half = 'Half'
}

export enum Enum_EthernetPortSpeed {
  One000Mbps = 'ONE000Mbps',
  One00Mbps = 'ONE00Mbps',
  One0Mbps = 'ONE0Mbps'
}

export enum Enum_FailedLoginWindow {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  Off = 'Off',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  One2 = 'ONE2',
  One3 = 'ONE3',
  One4 = 'ONE4',
  One5 = 'ONE5',
  One6 = 'ONE6',
  One7 = 'ONE7',
  One8 = 'ONE8',
  One9 = 'ONE9',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  Two0 = 'TWO0',
  Two1 = 'TWO1',
  Two2 = 'TWO2',
  Two3 = 'TWO3',
  Two4 = 'TWO4'
}

export enum Enum_GabAddressDisplayType {
  Private = 'Private',
  Public = 'Public'
}

export enum Enum_GateKeeperEnable {
  Auto = 'Auto',
  Off = 'Off',
  Specify = 'Specify'
}

export enum Enum_HangUpKeyLongPressFunc {
  None = 'None',
  PowerOff = 'Power_Off',
  Sleep = 'Sleep'
}

export enum Enum_IdleSessionTimeOut {
  Five = 'FIVE',
  Four5 = 'FOUR5',
  Four80 = 'FOUR80',
  One = 'ONE',
  One0 = 'ONE0',
  One20 = 'ONE20',
  One5 = 'ONE5',
  Six0 = 'SIX0',
  Three = 'THREE',
  Three0 = 'THREE0',
  Two0 = 'TWO0',
  Two40 = 'TWO40'
}

export enum Enum_Ipv4NicMode {
  Automatically = 'Automatically',
  Manually = 'Manually'
}

export enum Enum_LockOutAttempts {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  Off = 'Off',
  One0 = 'ONE0',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_LockOutTime_1_480 {
  Five = 'FIVE',
  Four80 = 'FOUR80',
  One = 'ONE',
  One0 = 'ONE0',
  One20 = 'ONE20',
  Six0 = 'SIX0',
  Three = 'THREE',
  Three0 = 'THREE0',
  Two = 'TWO',
  Two0 = 'TWO0',
  Two40 = 'TWO40'
}

export enum Enum_LockOutTime_1_5 {
  Five = 'FIVE',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_LoginMode {
  Adminpassword = 'adminpassword',
  None = 'none',
  Usernamepassword = 'usernamepassword'
}

export enum Enum_LogLevel {
  Critical = 'Critical',
  Debug = 'Debug',
  Error = 'Error',
  Info = 'Info',
  Warning = 'Warning'
}

export enum Enum_LogSpacemonitoringFoldernameOption {
  Custom = 'Custom',
  SystemNameAndTimestamp = 'SystemNameAndTimestamp',
  Timestamp = 'Timestamp'
}

export enum Enum_LogSpacemonitoringThreshold {
  Eight0 = 'EIGHT0',
  Five0 = 'FIVE0',
  Four0 = 'FOUR0',
  Nine0 = 'NINE0',
  Off = 'Off',
  One0 = 'ONE0',
  Seven0 = 'SEVEN0',
  Six0 = 'SIX0',
  Three0 = 'THREE0',
  Two0 = 'TWO0'
}

export enum Enum_MaxBandWidth {
  Eight32 = 'EIGHT32',
  Eight96 = 'EIGHT96',
  Five12 = 'FIVE12',
  Five76 = 'FIVE76',
  Four096 = 'FOUR096',
  Four48 = 'FOUR48',
  Nine60 = 'NINE60',
  One024 = 'ONE024',
  One088 = 'ONE088',
  One152 = 'ONE152',
  One216 = 'ONE216',
  One28 = 'ONE28',
  One280 = 'ONE280',
  One344 = 'ONE344',
  One408 = 'ONE408',
  One472 = 'ONE472',
  One536 = 'ONE536',
  One600 = 'ONE600',
  One664 = 'ONE664',
  One728 = 'ONE728',
  One792 = 'ONE792',
  One856 = 'ONE856',
  One92 = 'ONE92',
  One920 = 'ONE920',
  Seven04 = 'SEVEN04',
  Seven68 = 'SEVEN68',
  Six144 = 'SIX144',
  Six4 = 'SIX4',
  Six40 = 'SIX40',
  Three20 = 'THREE20',
  Three84 = 'THREE84',
  Three840 = 'THREE840',
  Two048 = 'TWO048',
  Two56 = 'TWO56'
}

export enum Enum_MaxSessions {
  Five0 = 'FIVE0',
  Four0 = 'FOUR0',
  Four5 = 'FOUR5',
  One0 = 'ONE0',
  One5 = 'ONE5',
  Three0 = 'THREE0',
  Three5 = 'THREE5',
  Two0 = 'TWO0',
  Two5 = 'TWO5'
}

export enum Enum_MaxTimeInCall {
  EightHours = 'EIGHT_hours',
  FiveHours = 'FIVE_hours',
  FourHours = 'FOUR_hours',
  Four8Hours = 'FOUR8_hours',
  NineHours = 'NINE_hours',
  Off = 'Off',
  OneHour = 'ONE_hour',
  One0Hours = 'ONE0_hours',
  One1Hours = 'ONE1_hours',
  One2Hours = 'ONE2_hours',
  SevenHours = 'SEVEN_hours',
  SixHours = 'SIX_hours',
  ThreeHours = 'THREE_hours',
  TwoHours = 'TWO_hours',
  Two4Hours = 'TWO4_hours'
}

export enum Enum_MinimumTlsVersion {
  Tlsv1 = 'tlsv1',
  Tlsv1_1 = 'tlsv1_1',
  Tlsv1_2 = 'tlsv1_2'
}

export enum Enum_Miracast_ListenChannel {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_Miracast_OperatingChannel {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Four0 = 'FOUR0',
  Four4 = 'FOUR4',
  Four8 = 'FOUR8',
  Nine = 'NINE',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Three6 = 'THREE6',
  Two = 'TWO'
}

export enum Enum_MonitorDisplay_Primary {
  Auto = 'auto',
  Manual = 'manual'
}

export enum Enum_MonitorDisplay_Secondary_Willie {
  Auto = 'auto',
  Off = 'off'
}

export enum Enum_MonitorResolution_Primary {
  One920x1080p_50Hz = 'ONE920x1080p_50Hz',
  One920x1080p_60Hz = 'ONE920x1080p_60Hz',
  Three840x2160p_25Hz = 'THREE840x2160p_25Hz',
  Three840x2160p_30Hz = 'THREE840x2160p_30Hz',
  Three840x2160p_50Hz = 'THREE840x2160p_50Hz',
  Three840x2160p_60Hz = 'THREE840x2160p_60Hz'
}

export enum Enum_MtuMode {
  Default = 'Default',
  Specify = 'Specify'
}

export enum Enum_MtuSize {
  Nine00 = 'NINE00',
  One020 = 'ONE020',
  One140 = 'ONE140',
  One260 = 'ONE260',
  One500 = 'ONE500',
  Seven80 = 'SEVEN80',
  Six60 = 'SIX60'
}

export enum Enum_NatAddressMode {
  Auto = 'Auto',
  Manual = 'Manual',
  Off = 'Off'
}

export enum Enum_NumericKeypadFunction {
  Presets = 'Presets',
  Tones = 'Tones'
}

export enum Enum_PasswordPolicy_1_16_32 {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  Off = 'Off',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  One2 = 'ONE2',
  One3 = 'ONE3',
  One4 = 'ONE4',
  One5 = 'ONE5',
  One6 = 'ONE6',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Three2 = 'THREE2',
  Two = 'TWO'
}

export enum Enum_PasswordPolicy_1_16C {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  Off = 'Off',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  One2 = 'ONE2',
  One3 = 'ONE3',
  One4 = 'ONE4',
  One5 = 'ONE5',
  One6 = 'ONE6',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_PasswordPolicy_1_2_All_C {
  All = 'All',
  Off = 'Off',
  One = 'ONE',
  Two = 'TWO'
}

export enum Enum_PasswordPolicy_1_30 {
  Five = 'FIVE',
  Off = 'Off',
  One = 'ONE',
  One0 = 'ONE0',
  One5 = 'ONE5',
  Three0 = 'THREE0',
  Two0 = 'TWO0'
}

export enum Enum_PasswordPolicy_1_4_All_C {
  All = 'All',
  Four = 'FOUR',
  Off = 'Off',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_PasswordPolicy_1_4_C {
  Four = 'FOUR',
  Off = 'Off',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_PasswordPolicy_1_7_C {
  Five = 'FIVE',
  Four = 'FOUR',
  Off = 'Off',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO'
}

export enum Enum_PasswordPolicy_30_60_90_180C {
  Nine0 = 'NINE0',
  Off = 'Off',
  One00 = 'ONE00',
  One10 = 'ONE10',
  One20 = 'ONE20',
  One30 = 'ONE30',
  One40 = 'ONE40',
  One50 = 'ONE50',
  One60 = 'ONE60',
  One70 = 'ONE70',
  One80 = 'ONE80',
  Six0 = 'SIX0',
  Three0 = 'THREE0'
}

export enum Enum_PasswordPolicy_8_16C_32 {
  Eight = 'EIGHT',
  Nine = 'NINE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  One2 = 'ONE2',
  One3 = 'ONE3',
  One4 = 'ONE4',
  One5 = 'ONE5',
  One6 = 'ONE6',
  Three2 = 'THREE2'
}

export enum Enum_PlaceCallFunc {
  Globaldir = 'globaldir',
  Keypad = 'keypad',
  Recentcalls = 'recentcalls'
}

export enum Enum_PlaybackOption {
  PlaybackToAllLocations = 'Playback_to_All_Locations',
  PlaybackToFarSitesMuteControlledEchoCancelled = 'Playback_to_Far_Sites__Mute_Controlled__Echo_Cancelled'
}

export enum Enum_PoundButtonFunction {
  AtThenPound = 'at_then_pound',
  PoundThenAt = 'pound_then_at'
}

export enum Enum_PowerFrequency {
  Five0 = 'FIVE0',
  Six0 = 'SIX0'
}

export enum Enum_PreferredSpeedIp {
  Five12 = 'FIVE12',
  Four096 = 'FOUR096',
  One024 = 'ONE024',
  One28 = 'ONE28',
  One472 = 'ONE472',
  One920 = 'ONE920',
  Seven68 = 'SEVEN68',
  Six144 = 'SIX144',
  Three072 = 'THREE072',
  Three84 = 'THREE84',
  Three840 = 'THREE840',
  Two048 = 'TWO048',
  Two56 = 'TWO56'
}

export enum Enum_PrivacyAlgorithm {
  CbcDes = 'CBC_DES',
  CfbAes128 = 'CFB_AES128'
}

export enum Enum_QualityProcess {
  Neg_2 = 'NEG_2',
  Neg_4 = 'NEG_4',
  Neg_6 = 'NEG_6',
  Pos_2 = 'POS_2',
  Pos_4 = 'POS_4',
  Pos_6 = 'POS_6',
  Zero = 'ZERO'
}

export enum Enum_RecentCallsMaxNumberToDisplay {
  Five0 = 'FIVE0',
  One00 = 'ONE00',
  Seven5 = 'SEVEN5',
  Two5 = 'TWO5'
}

export enum Enum_ScreenSaverMode {
  Black = 'Black',
  NoSignal = 'NoSignal'
}

export enum Enum_SecondaryNetworkType {
  None = 'None',
  WiFi = 'WiFi'
}

export enum Enum_SerialBaud {
  Five7600 = 'FIVE7600',
  Nine600 = 'NINE600',
  One15200 = 'ONE15200',
  One9200 = 'ONE9200',
  Three8400 = 'THREE8400'
}

export enum Enum_SerialFlowControl {
  Hardware = 'hardware',
  None = 'none'
}

export enum Enum_SerialMode {
  Control = 'Control',
  Off = 'Off'
}

export enum Enum_SerialParity {
  Even = 'even',
  None = 'none',
  Odd = 'odd'
}

export enum Enum_SerialStopBits {
  One = 'ONE',
  Two = 'TWO'
}

export enum Enum_ServerProtocol {
  Tcp = 'TCP',
  Tls = 'TLS',
  Udp = 'UDP'
}

export enum Enum_SipConfigType {
  Auto = 'Auto',
  Specify = 'Specify'
}

export enum Enum_SipRegistrarServerType {
  Microsoft = 'Microsoft',
  StandardSip = 'Standard_SIP',
  Unknown = 'unknown'
}

export enum Enum_SipTransportProtocol {
  Auto = 'Auto',
  Tcp = 'TCP',
  Tls = 'TLS',
  Udp = 'UDP'
}

export enum Enum_SleepTimeOut {
  Four5 = 'FOUR5',
  Four80 = 'FOUR80',
  One = 'ONE',
  One20 = 'ONE20',
  One5 = 'ONE5',
  Six0 = 'SIX0',
  Three = 'THREE',
  Three0 = 'THREE0',
  Two40 = 'TWO40',
  Zero = 'ZERO'
}

export enum Enum_SnmpProtocolVersion {
  V1 = 'v1',
  V2c = 'v2c',
  V3 = 'v3'
}

export enum Enum_SnmpTrapMessageType {
  Inform = 'Inform',
  Trap = 'Trap'
}

export enum Enum_SpaceMonitoringTransferFrequency {
  AutoAtThreshold = 'AutoAtThreshold',
  Manual = 'Manual'
}

export enum Enum_SpeakerVolume {
  Eight = 'EIGHT',
  Eight0 = 'EIGHT0',
  Eight2 = 'EIGHT2',
  Eight4 = 'EIGHT4',
  Eight6 = 'EIGHT6',
  Eight8 = 'EIGHT8',
  Five0 = 'FIVE0',
  Five2 = 'FIVE2',
  Five4 = 'FIVE4',
  Five6 = 'FIVE6',
  Five8 = 'FIVE8',
  Four = 'FOUR',
  Four0 = 'FOUR0',
  Four2 = 'FOUR2',
  Four4 = 'FOUR4',
  Four6 = 'FOUR6',
  Four8 = 'FOUR8',
  Nine0 = 'NINE0',
  Nine2 = 'NINE2',
  Nine4 = 'NINE4',
  Nine6 = 'NINE6',
  Nine8 = 'NINE8',
  One0 = 'ONE0',
  One00 = 'ONE00',
  One2 = 'ONE2',
  One4 = 'ONE4',
  One6 = 'ONE6',
  One8 = 'ONE8',
  Seven0 = 'SEVEN0',
  Seven2 = 'SEVEN2',
  Seven4 = 'SEVEN4',
  Seven6 = 'SEVEN6',
  Seven8 = 'SEVEN8',
  Six = 'SIX',
  Six0 = 'SIX0',
  Six2 = 'SIX2',
  Six4 = 'SIX4',
  Six6 = 'SIX6',
  Six8 = 'SIX8',
  Three0 = 'THREE0',
  Three2 = 'THREE2',
  Three4 = 'THREE4',
  Three6 = 'THREE6',
  Three8 = 'THREE8',
  Two = 'TWO',
  Two0 = 'TWO0',
  Two2 = 'TWO2',
  Two4 = 'TWO4',
  Two6 = 'TWO6',
  Two8 = 'TWO8',
  Zero = 'ZERO'
}

export enum Enum_SslVerificationDepth {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  One0 = 'ONE0',
  One1 = 'ONE1',
  One2 = 'ONE2',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export enum Enum_StarButtonFunction {
  PeriodThenStar = 'period_then_star',
  StarThenPeriod = 'star_then_period'
}

export enum Enum_StatusBarAddress {
  GuestWiFiIpAddress = 'Guest_Wi_Fi_IP_Address',
  H_323Extension = 'H_323_Extension',
  None = 'None',
  PrimaryIpAddress = 'Primary_IP_Address',
  SipAddress = 'SIP_Address'
}

export enum Enum_TimeFormat {
  One2Hour = 'ONE2_Hour',
  Two4Hour = 'TWO4_Hour'
}

export enum Enum_TimeServerMode {
  Auto = 'Auto',
  Manual = 'Manual',
  Off = 'Off'
}

export enum Enum_TimeZone {
  AfricaBangui = 'Africa_Bangui',
  AfricaCasablanca = 'Africa_Casablanca',
  AfricaDarEsSalaam = 'Africa_Dar__es__Salaam',
  AfricaHarare = 'Africa_Harare',
  AfricaNairobi = 'Africa_Nairobi',
  AmericaAdak = 'America_Adak',
  AmericaAnchorage = 'America_Anchorage',
  AmericaCaracas = 'America_Caracas',
  AmericaCordoba = 'America_Cordoba',
  AmericaGodthab = 'America_Godthab',
  AmericaGuatemala = 'America_Guatemala',
  AmericaIndianapolis = 'America_Indianapolis',
  AmericaLaPaz = 'America_La__Paz',
  AmericaLima = 'America_Lima',
  AmericaMazatlan = 'America_Mazatlan',
  AmericaMonterrey = 'America_Monterrey',
  AmericaNoronha = 'America_Noronha',
  AmericaPhoenix = 'America_Phoenix',
  AmericaRegina = 'America_Regina',
  AmericaSantiago = 'America_Santiago',
  AmericaSaoPaulo = 'America_Sao__Paulo',
  AsiaBaghdad = 'Asia_Baghdad',
  AsiaBaku = 'Asia_Baku',
  AsiaBangkok = 'Asia_Bangkok',
  AsiaCalcutta = 'Asia_Calcutta',
  AsiaColombo = 'Asia_Colombo',
  AsiaDhaka = 'Asia_Dhaka',
  AsiaHongKong = 'Asia_Hong__Kong',
  AsiaJerusalem = 'Asia_Jerusalem',
  AsiaKabul = 'Asia_Kabul',
  AsiaKarachi = 'Asia_Karachi',
  AsiaKatmandu = 'Asia_Katmandu',
  AsiaKrasnoyarsk = 'Asia_Krasnoyarsk',
  AsiaKuwait = 'Asia_Kuwait',
  AsiaMagadan = 'Asia_Magadan',
  AsiaMumbai = 'Asia_Mumbai',
  AsiaMuscat = 'Asia_Muscat',
  AsiaNovosibirsk = 'Asia_Novosibirsk',
  AsiaRangoon = 'Asia_Rangoon',
  AsiaSeoul = 'Asia_Seoul',
  AsiaSingapore = 'Asia_Singapore',
  AsiaTaipei = 'Asia_Taipei',
  AsiaUlaanbaatar = 'Asia_Ulaanbaatar',
  AsiaVladivostok = 'Asia_Vladivostok',
  AsiaYakutsk = 'Asia_Yakutsk',
  AsiaYekaterinburg = 'Asia_Yekaterinburg',
  AtlanticAzores = 'Atlantic_Azores',
  AtlanticCapeVerde = 'Atlantic_Cape__Verde',
  AustraliaAdelaide = 'Australia_Adelaide',
  AustraliaBrisbane = 'Australia_Brisbane',
  AustraliaDarwin = 'Australia_Darwin',
  AustraliaHobart = 'Australia_Hobart',
  AustraliaPerth = 'Australia_Perth',
  AustraliaSydney = 'Australia_Sydney',
  Baja = 'BAJA',
  CanadaAtlantic = 'Canada_Atlantic',
  CanadaNewfoundland = 'Canada_Newfoundland',
  Cst = 'CST',
  Egypt = 'Egypt',
  Est = 'EST',
  EtcGmtminus12 = 'Etc_GMTMINUS12',
  EtcGreenwich = 'Etc_Greenwich',
  EuropeAmsterdam = 'Europe_Amsterdam',
  EuropeAthens = 'Europe_Athens',
  EuropeBelgrade = 'Europe_Belgrade',
  EuropeBucharest = 'Europe_Bucharest',
  EuropeHelsinki = 'Europe_Helsinki',
  EuropeLondon = 'Europe_London',
  EuropeMoscow = 'Europe_Moscow',
  EuropeParis = 'Europe_Paris',
  EuropeSofia = 'Europe_Sofia',
  EuropeTirane = 'Europe_Tirane',
  EuropeWarsaw = 'Europe_Warsaw',
  IndianChagos = 'Indian_Chagos',
  IndianKerguelen = 'Indian_Kerguelen',
  Iran = 'Iran',
  Japan = 'Japan',
  Mst = 'MST',
  PacificAuckland = 'Pacific_Auckland',
  PacificFiji = 'Pacific_Fiji',
  PacificGuam = 'Pacific_Guam',
  PacificHonolulu = 'Pacific_Honolulu',
  PacificMidway = 'Pacific_Midway',
  PacificPitcairn = 'Pacific_Pitcairn',
  PacificTongatapu = 'Pacific_Tongatapu',
  Pst = 'PST'
}

export enum Enum_TosType {
  DiffServ = 'DiffServ',
  IpPrecedence = 'IP_Precedence'
}

export enum Enum_TransportProtocol {
  Tcp = 'TCP',
  Udp = 'UDP'
}

export enum Enum_UicontrolWidget {
  Calendar = 'calendar',
  Favorites = 'favorites',
  None = 'none'
}

export enum Enum_UpdateServerType {
  MicrosoftTeamsDeviceManagement = 'microsoft_teams_device_management',
  PolycomSupportServer = 'polycom_support_server',
  ProvServer = 'prov_server',
  UserDefinedServer = 'user_defined_server'
}

export enum Enum_VideoDialPreference {
  H323 = 'h323',
  Sip = 'sip'
}

export enum Enum_Vlan_Priority {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export enum Enum_VoiceDialPreference {
  H323 = 'h323',
  Sip = 'sip'
}

export enum Enum_WirelessSecurity {
  Eight02_1xEap = 'EIGHT02_1xEAP',
  None = 'None',
  Wep = 'WEP',
  WpaPsk = 'WPA_PSK'
}

export type EnumVal = {
  __typename: 'EnumVal';
  friendlyValue: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
  featureCategory: Maybe<FeatureCategory>;
};

export type EnumValInput = {
  friendlyValue?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  featureCategory?: Maybe<FeatureCategory>;
};

export type EnumValue = {
  __typename: 'EnumValue';
  deprecationReason: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Episode = {
  id: Scalars['ID'];
  invocationId: Scalars['ID'];
  tenant: Tenant;
  type: EpisodeType;
};

export type EpisodeConnection = {
  __typename: 'EpisodeConnection';
  count: Scalars['Int'];
  edges: Array<EpisodeEdge>;
  invocationId: Scalars['ID'];
  pageInfo: PageInfo;
};

export type EpisodeEdge = {
  __typename: 'EpisodeEdge';
  cursor: Scalars['Cursor'];
  node: Episode;
};

export enum EpisodeQueryFilter {
  Active = 'ACTIVE',
  All = 'ALL'
}

export enum EpisodeType {
  TopicIndicator = 'TOPIC_INDICATOR'
}

export type EpUpdateImage = {
  __typename: 'EpUpdateImage';
  description: Maybe<Scalars['String']>;
  directory: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  imagePolicyType: Maybe<ImagePolicyType>;
  imageType: Maybe<ImageType>;
  imageVersion: Maybe<Scalars['String']>;
  size: Maybe<Scalars['Int']>;
  status: Maybe<Scalars['String']>;
  swSupportUpdatePath: Maybe<Array<Maybe<SoftwareSupportUpdatePath>>>;
};

export type Equal = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum EventType {
  DisassociateWithResource = 'disassociateWithResource',
  InviteUser = 'inviteUser',
  Login = 'login',
  SwitchRole = 'switchRole'
}

export type EveryResource = {
  __typename: 'EveryResource';
  every: Scalars['Boolean'];
};

export enum ExportConfigType {
  Configfiles = 'CONFIGFILES',
  Device = 'DEVICE',
  Local = 'LOCAL',
  Web = 'WEB'
}

export type ExtendedConfigParam = {
  __typename: 'ExtendedConfigParam';
  categories: Maybe<Array<Maybe<Scalars['String']>>>;
  exportConfigType: Maybe<ExportConfigType>;
  friendlyName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type ExtendedConfigParamsResponse = {
  __typename: 'ExtendedConfigParamsResponse';
  configParams: Maybe<Array<Maybe<ExtendedConfigParam>>>;
  errorMessage: Maybe<Scalars['String']>;
  status: Maybe<Scalars['Boolean']>;
};

export type ExtendedDeviceParameterDto = {
  __typename: 'ExtendedDeviceParameterDTO';
  metadata: Maybe<DeviceParameterDto>;
  name: Maybe<Scalars['String']>;
  policyAttribute: Maybe<ConfigurationAttribute>;
  policyDeploymentScope: Maybe<PolicyDeploymentScope>;
  /** @deprecated Moved to policyAttribute.currentValue! */
  value: Maybe<Scalars['String']>;
};

export type FactoryResetOptions = {
  keepCallDataRecords?: Maybe<Scalars['Boolean']>;
  keepContactDirectory?: Maybe<Scalars['Boolean']>;
  keepSystemLogs?: Maybe<Scalars['Boolean']>;
  keepUserInstalledCertificates?: Maybe<Scalars['Boolean']>;
};

export type FamilySortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<CatalogFamilySortField>;
};

export enum FeatureCategory {
  Beta = 'Beta',
  Preview = 'Preview',
  Released = 'Released',
  Deprecated = 'Deprecated'
}

export enum FeatureSet {
  Basic = 'BASIC',
  Premium = 'PREMIUM'
}

export type Field = {
  __typename: 'Field';
  args: Array<InputValue>;
  deprecationReason: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  name: Scalars['String'];
  type: Type;
};

export type FieldMissingBucket = Bucket & {
  __typename: 'FieldMissingBucket';
  aggregates: Array<Aggregate>;
  count: Scalars['Float'];
  fieldMissing: Scalars['Boolean'];
};

export type Filter = {
  AND?: Maybe<Array<Filter>>;
  beginsWith?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Scalars['String']>>;
  contains?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  field?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  NOT?: Maybe<Array<Filter>>;
  notContains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Filter>>;
  searchTerm?: Maybe<Scalars['String']>;
  within?: Maybe<GeoBox>;
};

export type FirmwareUpdateInfo = {
  __typename: 'FirmwareUpdateInfo';
  isUpdateAvailable: Maybe<Scalars['Boolean']>;
  updateVersion: Maybe<Scalars['String']>;
};

export type FrontDoor = {
  __typename: 'FrontDoor';
  resource: Scalars['JSONObject'];
};

export type General = {
  __typename: 'General';
  battery_charging: Maybe<BooleanValue>;
  battery_level: Maybe<NumberValue>;
  battery_status_alert: Maybe<StringValue>;
  charge_vibration: Maybe<StringValue>;
  is_online: Maybe<BooleanValue>;
  language: Maybe<StringValue>;
  restore_defaults: Maybe<StringValue>;
  sensor_settings_enabled: Maybe<StringValue>;
};

export type GeneralInput = {
  battery_status_alert?: Maybe<Scalars['String']>;
  charge_vibration?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  restore_defaults?: Maybe<Scalars['String']>;
  sensor_settings_enabled?: Maybe<Scalars['String']>;
};

export type GenericUserGroupResponse = {
  __typename: 'GenericUserGroupResponse';
  error: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
};

export type GeoBox = {
  bottomRight: LatLon;
  topLeft: LatLon;
};

export type GeoHashAggregation = {
  field: Scalars['String'];
  precision: Scalars['Float'];
};

export type Geopoint = {
  __typename: 'Geopoint';
  lat: Maybe<Scalars['Float']>;
  lon: Maybe<Scalars['Float']>;
};

export type GetSubnetRulesInput = {
  siteId: Scalars['String'];
};

export type GlobalConfigResponse = {
  __typename: 'GlobalConfigResponse';
  deviceModel: Maybe<Scalars['String']>;
  globalConfigSettings: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Grant = {
  __typename: 'Grant';
  grantType: GrantType;
  permissions: Array<Permission>;
  providedBy: Maybe<Scalars['ID']>;
  resourceId: Scalars['ID'];
  resourceType: Maybe<Scalars['String']>;
  roles: Array<Role>;
  tags: Array<Scalars['String']>;
};

export enum GrantType {
  Inferred = 'INFERRED',
  Standard = 'STANDARD',
  Transitive = 'TRANSITIVE'
}

export enum GrantTypeInput {
  Standard = 'STANDARD',
  Transitive = 'TRANSITIVE'
}

export type GraphEndpoint = {
  __typename: 'GraphEndpoint';
  auth: EndpointAuthorization;
  name: Scalars['String'];
  type: EndpointType;
};

export type GroupApiResponse = {
  __typename: 'GroupAPIResponse';
  error: Maybe<Scalars['String']>;
  groupDoc: Maybe<GroupDto>;
  groupId: Maybe<Scalars['String']>;
  groups: Maybe<GroupDtos>;
  models: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
};

export type GroupConfigResponse = {
  __typename: 'GroupConfigResponse';
  groupConfigSettings: Maybe<Array<Maybe<ModelConfigSettingsResponse>>>;
  groupName: Maybe<Scalars['String']>;
};

export type GroupDto = {
  __typename: 'GroupDto';
  createdAt: Maybe<Scalars['DateTime']>;
  deletedDevices: Maybe<Array<Scalars['String']>>;
  deviceSerials: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
  newDevices: Maybe<Array<Scalars['String']>>;
  policies: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type GroupDtos = {
  __typename: 'GroupDtos';
  groups: Array<GroupDto>;
};

export enum GroupFilter {
  Model = 'MODEL'
}

export type GroupPolicy = {
  __typename: 'GroupPolicy';
  capabilities: Capabilities;
  collectionId: Scalars['String'];
  collectionRule: Maybe<CollectionRule>;
  createdAt: Scalars['DateTime'];
  hardwareModel: Maybe<HardwareModel>;
  id: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['String'];
  settingsCount: Scalars['Float'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type GroupPolicyInput = {
  capabilities?: Maybe<CapabilitiesInput>;
  collectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pathsToRemove?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<Scalars['String']>;
  rule?: Maybe<Rule>;
};

export type Groups = {
  gIds: Array<Scalars['String']>;
};

export type HardwareCategory = {
  __typename: 'HardwareCategory';
  createdAt: Scalars['DateScalar'];
  description: Maybe<Scalars['String']>;
  families: CatalogFamilyConnection;
  hardwareFamilies: Maybe<Array<HardwareFamily>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateScalar'];
};


export type HardwareCategoryFamiliesArgs = {
  params?: Maybe<CatalogFamilyConnectionParams>;
};

export type HardwareFamily = {
  __typename: 'HardwareFamily';
  categories: Maybe<Array<HardwareCategory>>;
  description: Maybe<Scalars['String']>;
  familyCategories: CatalogCategoryConnection;
  familyImages: CatalogImageConnection;
  /** @deprecated This API is no longer supported. Use 'models' instead. */
  hardwareModels: Array<HardwareModel>;
  id: Scalars['ID'];
  models: CatalogModelConnection;
  name: Scalars['String'];
  vendor: Vendor;
  verifyShipmentDate: Scalars['Boolean'];
};


export type HardwareFamilyFamilyCategoriesArgs = {
  params?: Maybe<CatalogCategoryConnectionParams>;
};


export type HardwareFamilyFamilyImagesArgs = {
  entity?: Maybe<HardwareImageEntities>;
  params?: Maybe<CatalogImageConnectionParams>;
};


export type HardwareFamilyModelsArgs = {
  params?: Maybe<CatalogModelConnectionParams>;
};

export type HardwareFamilyImage = {
  __typename: 'HardwareFamilyImage';
  description: Scalars['String'];
  family: HardwareFamily;
  id: Scalars['ID'];
  metadata: ImageMetadata;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareFamilyImageInput = {
  description?: Maybe<Scalars['String']>;
  familyId: Scalars['ID'];
  id: Scalars['ID'];
  metadata?: Maybe<ImageMetadataInput>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareFamilyInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  vendorId: Scalars['ID'];
  verifyShipmentDate?: Maybe<Scalars['Boolean']>;
};

export type HardwareImage = {
  __typename: 'HardwareImage';
  description: Scalars['String'];
  id: Scalars['ID'];
  metadata: ImageMetadata;
  name: Scalars['String'];
  url: Scalars['String'];
};

export enum HardwareImageEntities {
  HardwareFamily = 'HardwareFamily',
  HardwareModel = 'HardwareModel',
  HardwareProduct = 'HardwareProduct',
  Vendor = 'Vendor'
}

export type HardwareManufacturer = {
  __typename: 'HardwareManufacturer';
  description: Maybe<Scalars['String']>;
  /** @deprecated This API is no longer supported. Use 'models' instead. */
  hardwareModels: Array<HardwareModel>;
  id: Scalars['ID'];
  models: CatalogModelConnection;
  name: Scalars['String'];
};


export type HardwareManufacturerModelsArgs = {
  params?: Maybe<CatalogManufacturerConnectionParams>;
};

export type HardwareManufacturerImage = {
  __typename: 'HardwareManufacturerImage';
  description: Scalars['String'];
  id: Scalars['ID'];
  manufacturer: HardwareManufacturer;
  metadata: ImageMetadata;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareManufacturerImageInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manufacturerId: Scalars['ID'];
  metadata?: Maybe<ImageMetadataInput>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareManufacturerInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HardwareModel = {
  __typename: 'HardwareModel';
  aliases: Array<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  deviceClass: DeviceClass;
  hardwareFamily: HardwareFamily;
  hardwareManufacturer: HardwareManufacturer;
  /** @deprecated This API is no longer supported. Use 'modelProducts' instead. */
  hardwareProducts: Array<HardwareProduct>;
  id: Scalars['ID'];
  images: Array<HardwareModelImage>;
  modelImages: CatalogImageConnection;
  modelProducts: CatalogProductConnection;
  modelSkus: SkuConnection;
  name: Scalars['String'];
  skus: Maybe<Array<Sku>>;
  supportsPolicies: Maybe<Scalars['Boolean']>;
  supportsProvisioning: Maybe<Scalars['Boolean']>;
};


export type HardwareModelModelImagesArgs = {
  entity?: Maybe<HardwareImageEntities>;
  params?: Maybe<CatalogImageConnectionParams>;
};


export type HardwareModelModelProductsArgs = {
  params?: Maybe<CatalogProductConnectionParams>;
};


export type HardwareModelModelSkusArgs = {
  params?: Maybe<SkuConnectionParams>;
};

export type HardwareModelImage = {
  __typename: 'HardwareModelImage';
  description: Scalars['String'];
  id: Scalars['ID'];
  metadata: ImageMetadata;
  model: HardwareModel;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareModelImageInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<ImageMetadataInput>;
  modelId: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareModelInput = {
  aliases?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  deviceClassId?: Maybe<Scalars['ID']>;
  familyId: Scalars['ID'];
  id: Scalars['String'];
  manufacturerId: Scalars['ID'];
  name: Scalars['String'];
  selectiveReveal?: Maybe<Scalars['Boolean']>;
  supportsPolicies?: Maybe<Scalars['Boolean']>;
  supportsProvisioning?: Maybe<Scalars['Boolean']>;
};

export type HardwareProduct = {
  __typename: 'HardwareProduct';
  availableProductSoftware: Maybe<ProductSoftware>;
  createdAt: Scalars['DateScalar'];
  hardwareModel: HardwareModel;
  id: Scalars['ID'];
  /** @deprecated This API is no longer supported. Use 'productImages' instead. */
  images: Array<HardwareImage>;
  metadata: Maybe<HardwareProductMetadata>;
  name: Maybe<Scalars['String']>;
  productImages: CatalogImageConnection;
  /** @deprecated This API is no longer supported. Use 'softwareReleases' instead. */
  productSoftwares: Maybe<Array<ProductSoftware>>;
  softwareReleases: Maybe<SoftwareConnection>;
  softwareVersionSortMethod: SoftwareVersionSortMethod;
  updatedAt: Scalars['DateScalar'];
};


export type HardwareProductAvailableProductSoftwareArgs = {
  releaseChannel?: Maybe<Scalars['String']>;
};


export type HardwareProductImagesArgs = {
  entity?: Maybe<HardwareImageEntities>;
};


export type HardwareProductProductImagesArgs = {
  entity?: Maybe<HardwareImageEntities>;
  params?: Maybe<CatalogImageConnectionParams>;
};


export type HardwareProductProductSoftwaresArgs = {
  releaseChannel?: Maybe<Scalars['String']>;
};


export type HardwareProductSoftwareReleasesArgs = {
  params?: Maybe<SoftwareConnectionParams>;
};

export type HardwareProductImage = {
  __typename: 'HardwareProductImage';
  description: Scalars['String'];
  hardwareProduct: HardwareProduct;
  id: Scalars['ID'];
  metadata: ImageMetadata;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type HardwareProductImageInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<ImageMetadataInput>;
  name: Scalars['String'];
  productId: Scalars['ID'];
  url: Scalars['String'];
};

export type HardwareProductInput = {
  id: Scalars['String'];
  metadata?: Maybe<HardwareProductMetadataInput>;
  modelId: Scalars['ID'];
  name: Scalars['String'];
  softwareVersionSortMethod?: Maybe<SoftwareVersionSortMethod>;
};

export type HardwareProductMetadata = {
  __typename: 'HardwareProductMetadata';
  aliases: Maybe<Array<Scalars['String']>>;
  dfuSupport: Maybe<DfuSupport>;
  quickStartUrl: Maybe<Scalars['String']>;
  userGuideUrl: Maybe<Scalars['String']>;
};

export type HardwareProductMetadataInput = {
  aliases?: Maybe<Array<Scalars['String']>>;
  dfuSupport?: Maybe<DfuSupport>;
  quickStartUrl?: Maybe<Scalars['String']>;
  userGuideUrl?: Maybe<Scalars['String']>;
};

export type HardwareVendorImageInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<ImageMetadataInput>;
  name: Scalars['String'];
  url: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type HealthCheckResponse = {
  __typename: 'HealthCheckResponse';
  healthy: Scalars['Boolean'];
};

export type HookTestResult = {
  __typename: 'HookTestResult';
  body: Scalars['String'];
  code: Maybe<Scalars['Int']>;
  message: Maybe<Scalars['String']>;
  statusCode: Maybe<Scalars['Int']>;
  statusMessage: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Identity = {
  __typename: 'Identity';
  connection: Maybe<Scalars['String']>;
  isSocial: Maybe<Scalars['Boolean']>;
  provider: Maybe<Scalars['String']>;
  user_id: Maybe<Scalars['String']>;
};

export type IdFilter = {
  eq?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Scalars['ID']>>;
};

export type ImageMetadata = {
  __typename: 'ImageMetadata';
  height: Scalars['Float'];
  type: Scalars['String'];
  width: Scalars['Float'];
};

export type ImageMetadataInput = {
  height: Scalars['Float'];
  type: Scalars['String'];
  width: Scalars['Float'];
};

export enum ImagePolicyType {
  All = 'ALL',
  List = 'LIST'
}

export enum ImageType {
  Ccx = 'CCX',
  Ec = 'EC',
  Edge = 'EDGE',
  Polyos = 'POLYOS',
  Rove = 'ROVE',
  Ucs = 'UCS',
  Utopia = 'UTOPIA'
}

export type ImportResponse = {
  __typename: 'ImportResponse';
  deviceConfigResult: Maybe<Array<Maybe<DeviceImportResponse>>>;
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  globalConfigResult: Maybe<Array<Maybe<GlobalConfigResponse>>>;
  groupConfigResult: Maybe<Array<Maybe<GroupConfigResponse>>>;
  progress: Maybe<Scalars['String']>;
  siteConfigResult: Maybe<Array<Maybe<SiteConfigResponse>>>;
  siteTopologyResult: Maybe<Array<Maybe<SiteTopologyResponse>>>;
  success: Scalars['Boolean'];
};

export enum Increment {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Indicator = AverageIndicator | CountAverageIndicator | CountOfTotalIndicator;

export enum IndicatorType {
  Average = 'AVERAGE',
  CountAverage = 'COUNT_AVERAGE',
  CountTotal = 'COUNT_TOTAL'
}

export type InputValue = {
  __typename: 'InputValue';
  defaultValue: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Type;
};

export type InsightChartMeta = {
  __typename: 'InsightChartMeta';
  aggType: ChartAggregation;
  childCount: Scalars['Float'];
  increment: Increment;
  otherCount: Scalars['Float'];
  timeScope: TimeScope;
  topic: Scalars['String'];
};

export type InsightSeriesMeta = {
  __typename: 'InsightSeriesMeta';
  locationScope: LocationScope;
  object: Maybe<MetaId>;
  place: Maybe<Scalars['String']>;
  seriesType: SeriesType;
};

export type Integration = {
  __typename: 'Integration';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  detail: Maybe<Microsoft>;
  id: Scalars['ID'];
  integrationType: IntegrationType;
  tenant_id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type IntegrationsFilter = {
  name?: Maybe<StringFilter>;
};

export enum IntegrationType {
  Microsoft = 'MICROSOFT'
}

export enum InventoryView {
  List = 'LIST',
  Map = 'MAP'
}

export type InviteUserResponse = {
  __typename: 'InviteUserResponse';
  invites: Maybe<Array<InviteUsersStatus>>;
};

export type InviteUsersStatus = {
  __typename: 'InviteUsersStatus';
  email: Scalars['String'];
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Ip = {
  __typename: 'IP';
  ip: Scalars['String'];
};



export type KeyBucket = Bucket & {
  __typename: 'KeyBucket';
  aggregates: Array<Aggregate>;
  count: Scalars['Float'];
  key: Scalars['String'];
};

export type LatLon = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export enum LensTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type License = {
  __typename: 'License';
  activationDate: Maybe<Scalars['DateTime']>;
  canceled: Scalars['Boolean'];
  consolidatedKey: Maybe<Scalars['String']>;
  details: Maybe<Scalars['JSONObject']>;
  endDate: Maybe<Scalars['DateTime']>;
  entitlements: Array<Entitlement>;
  expired: Scalars['Boolean'];
  isMockLicense: Maybe<Scalars['Boolean']>;
  licenseKey: Scalars['String'];
  models: Array<Scalars['String']>;
  quantity: Scalars['Float'];
  sku: Scalars['String'];
  tenantId: Maybe<Scalars['String']>;
  type: LicenseType;
  userId: Maybe<Scalars['String']>;
};

export type LicenseAggregations = {
  __typename: 'LicenseAggregations';
  activeLicenseCount: Scalars['Int'];
  availableDeviceCount: Scalars['Int'];
  availableLicenseCount: Scalars['Int'];
  eligibleDeviceCount: Scalars['Int'];
  entitledDeviceCount: Scalars['Int'];
  expiredLicenseCount: Scalars['Int'];
  id: Scalars['ID'];
  ineligibleDeviceCount: Scalars['Int'];
  name: Scalars['String'];
};

export type LicenseAsset = {
  licenseKey: Scalars['String'];
  productSerial: Scalars['String'];
};

export type LicenseAssetForEntitlement = {
  __typename: 'LicenseAssetForEntitlement';
  licenseKey: Scalars['String'];
  productSerial: Scalars['String'];
};

export type LicenseInfo = {
  __typename: 'LicenseInfo';
  activationDate: Maybe<Scalars['DateTime']>;
  consolidatedKey: Maybe<Scalars['String']>;
  details: Maybe<Scalars['JSONObject']>;
  endDate: Maybe<Scalars['DateTime']>;
  entitlements: Array<Entitlement>;
  expired: Scalars['Boolean'];
  isMockLicense: Maybe<Scalars['Boolean']>;
  licenseKey: Scalars['String'];
  quantity: Scalars['Float'];
  sku: Scalars['String'];
  tenantId: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
};

export type LicenseInfoConnection = {
  __typename: 'LicenseInfoConnection';
  edges: Array<LicenseInfo>;
  pageInfo: PolyPlusPageInfo;
};

export enum LicenseSortField {
  ActivationDate = 'ACTIVATION_DATE',
  EndDate = 'END_DATE',
  LicenseKey = 'LICENSE_KEY',
  Quantity = 'QUANTITY',
  UserId = 'USER_ID'
}

export type LicenseSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field: LicenseSortField;
};

export enum LicenseType {
  Clariti = 'CLARITI',
  PolyPlus = 'POLY_PLUS'
}

export enum LicenseTypeInput {
  Clariti = 'CLARITI',
  MockOnly = 'MOCK_ONLY',
  PolyPlus = 'POLY_PLUS'
}

export type Location = {
  __typename: 'Location';
  buildingNumber: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  confidence: Maybe<Scalars['Int']>;
  continentCode: Maybe<Scalars['String']>;
  continentName: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  countryName: Maybe<Scalars['String']>;
  formattedAddress: Maybe<Scalars['String']>;
  geohash: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  provider: Scalars['String'];
  regionCode: Maybe<Scalars['String']>;
  regionName: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};

export enum LocationScope {
  Device = 'DEVICE',
  DeviceType = 'DEVICE_TYPE',
  Family = 'FAMILY',
  Model = 'MODEL',
  ModelVersion = 'MODEL_VERSION',
  Room = 'ROOM',
  RoomMeeting = 'ROOM_MEETING',
  Site = 'SITE',
  Tenant = 'TENANT',
  Version = 'VERSION'
}

export type LogFilter = {
  AND?: Maybe<Array<LogFilter>>;
  beginsWith?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Scalars['String']>>;
  contains?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<LogFilter>>;
  searchTerm?: Maybe<Scalars['String']>;
};

export enum LoginType {
  Api = 'API',
  Unknown = 'UNKNOWN',
  Webui = 'WEBUI'
}

export type LogToFlashApiResponse = {
  __typename: 'LogToFlashAPIResponse';
  error: Maybe<Scalars['String']>;
  requestedValue: Maybe<Scalars['Boolean']>;
  result: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type LookupAssociationsData = {
  capacity?: Maybe<Scalars['Float']>;
  deviceIp?: Maybe<DeviceIp>;
  externalIp?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  internalIp?: Maybe<Scalars['String']>;
  roomid?: Maybe<Scalars['String']>;
  roomname?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  roomuuid?: Maybe<Scalars['String']>;
  roomUUID?: Maybe<Scalars['String']>;
  siteid?: Maybe<Scalars['String']>;
  sitename?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  siteuuid?: Maybe<Scalars['String']>;
  siteUUID?: Maybe<Scalars['String']>;
  tenantid?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantuuid?: Maybe<Scalars['String']>;
  tenantUUID?: Maybe<Scalars['String']>;
  tid?: Maybe<Scalars['String']>;
};

export type MeetingRecord = {
  __typename: 'MeetingRecord';
  answeredInSoftphone: Maybe<Scalars['Boolean']>;
  appName: Maybe<Scalars['String']>;
  callDirection: Maybe<Scalars['String']>;
  callId: Maybe<Scalars['ID']>;
  callRate: Maybe<Scalars['Int']>;
  deviceId: Maybe<Device>;
  dialString: Maybe<Scalars['String']>;
  disconnectInfo: Maybe<Scalars['String']>;
  durationSeconds: Maybe<Scalars['Int']>;
  endTime: Scalars['Date'];
  geoLatitude: Maybe<Scalars['Float']>;
  geoLongitude: Maybe<Scalars['Float']>;
  hardwareModel: Maybe<Scalars['String']>;
  ipAddress: Maybe<Scalars['String']>;
  localSame: Maybe<Scalars['String']>;
  localTag: Maybe<Scalars['String']>;
  localUri: Maybe<Scalars['String']>;
  mac: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  normalizeOffsetGMT: Maybe<Scalars['String']>;
  pluginId: Maybe<Scalars['String']>;
  productFamily: Maybe<Scalars['String']>;
  protocol: Maybe<Scalars['String']>;
  proxyAgent: Maybe<Scalars['String']>;
  proxyAgentid: Maybe<Scalars['String']>;
  proxyAgentVersion: Maybe<Scalars['String']>;
  qoe_audIoprotocolrx: Maybe<Scalars['String']>;
  qoe_audioprotocoltx: Maybe<Scalars['String']>;
  qoe_avgjitterrx: Maybe<Scalars['Int']>;
  qoe_avgjittertx: Maybe<Scalars['Int']>;
  qoe_avglatencyrx: Maybe<Scalars['Int']>;
  qoe_avglatencytx: Maybe<Scalars['Int']>;
  qoe_avgpacketslostrx: Maybe<Scalars['Int']>;
  qoe_avgpacketslosttx: Maybe<Scalars['Int']>;
  qoe_avgpercentpacketlossrx: Maybe<Scalars['Float']>;
  qoe_avgpercentpacketlosstx: Maybe<Scalars['Float']>;
  qoe_maxjitterrx: Maybe<Scalars['Int']>;
  qoe_maxjittertx: Maybe<Scalars['Int']>;
  qoe_maxlatencyrx: Maybe<Scalars['Int']>;
  qoe_maxlatencytx: Maybe<Scalars['Int']>;
  qoe_precedencelevel: Maybe<Scalars['String']>;
  qoe_totalh320errors: Maybe<Scalars['Int']>;
  qoe_videoformatrx: Maybe<Scalars['String']>;
  qoe_videoformattx: Maybe<Scalars['String']>;
  qoe_videoprotocolrx: Maybe<Scalars['String']>;
  qoe_videoprotocoltx: Maybe<Scalars['String']>;
  RecordType: Maybe<MeetingRecordType>;
  relatedDeviceEvent: Maybe<Scalars['String']>;
  remoteName: Maybe<Scalars['String']>;
  remoteParty: Maybe<Scalars['String']>;
  remoteTag: Maybe<Scalars['String']>;
  remoteUri: Maybe<Scalars['String']>;
  resolution: Maybe<Scalars['String']>;
  room: Maybe<Room>;
  site: Maybe<Site>;
  softphoneVersion: Maybe<Scalars['String']>;
  softwareRelease: Maybe<Scalars['String']>;
  startTime: Scalars['Date'];
  tenant: Tenant;
  transferredTo: Maybe<Scalars['String']>;
  user: Maybe<Scalars['String']>;
  userAction: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
  versionInfo: Maybe<Scalars['String']>;
};

export type MeetingRecordAggregateChartMeta = {
  __typename: 'MeetingRecordAggregateChartMeta';
  test: Maybe<Scalars['String']>;
};

export type MeetingRecordAggregateSeriesMeta = {
  __typename: 'MeetingRecordAggregateSeriesMeta';
  test: Maybe<Scalars['String']>;
};

export enum MeetingRecordAggregationField {
  Duration = 'DURATION'
}

export enum MeetingRecordAggregationGroup {
  Device = 'DEVICE',
  ProxyId = 'PROXY_ID',
  User = 'USER'
}

export enum MeetingRecordAggregationMode {
  Sum = 'SUM'
}

export enum MeetingRecordType {
  Cdr = 'CDR',
  Headcount = 'HEADCOUNT',
  Mediashare = 'MEDIASHARE'
}

export type MercatorHealthCheckResponse = {
  __typename: 'MercatorHealthCheckResponse';
  healthy: Scalars['Boolean'];
};

export type MergeEntitiesResponse = {
  __typename: 'MergeEntitiesResponse';
  mergeRequests: MergeEntitiesResult;
};

export type MergeEntitiesResult = {
  __typename: 'MergeEntitiesResult';
  from: Array<MergeEntityRequest>;
  to: Array<MergeEntityRequest>;
};

export enum MergeEntityActionType {
  Accept = 'ACCEPT',
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
  Reject = 'REJECT',
  Request = 'REQUEST',
  RollbackConfirm = 'ROLLBACK_CONFIRM'
}

export type MergeEntityRequest = {
  __typename: 'MergeEntityRequest';
  acceptedAt: Maybe<Scalars['DateTime']>;
  acceptedById: Maybe<Scalars['ID']>;
  cancelledAt: Maybe<Scalars['DateTime']>;
  cancelledById: Maybe<Scalars['ID']>;
  confirmedAt: Maybe<Scalars['DateTime']>;
  confirmedById: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  history: Array<Scalars['JSONObject']>;
  id: Scalars['ID'];
  mergeFromId: Scalars['ID'];
  mergeFromType: Scalars['String'];
  mergeToId: Maybe<Scalars['ID']>;
  mergeToType: Maybe<Scalars['String']>;
  mergeToUserId: Maybe<Scalars['ID']>;
  rejectedAt: Maybe<Scalars['DateTime']>;
  rejectedById: Maybe<Scalars['ID']>;
  requestedAt: Scalars['DateTime'];
  requestedById: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type MergeEntityResponse = {
  __typename: 'MergeEntityResponse';
  mergeRequest: MergeEntityRequest;
};

export type MetadataResponse = {
  __typename: 'MetadataResponse';
  error: Maybe<Scalars['String']>;
  groupId: Scalars['String'];
  models: Maybe<Array<DeviceModelData>>;
  success: Scalars['Boolean'];
};

export type MetaId = Device | Other | Room | Site | Tenant;

export type Microsoft = {
  __typename: 'Microsoft';
  MicrosoftTenantId: Scalars['String'];
  scopes: Array<MicrosoftScopes>;
};

export type MicrosoftInput = {
  MicrosoftTenantId?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<MicrosoftScopes>>;
};

export enum MicrosoftScopes {
  Default = 'DEFAULT',
  DirReadAll = 'DIR_READ_ALL'
}

export type ModelConfigSettingsResponse = {
  __typename: 'ModelConfigSettingsResponse';
  configAttributes: Maybe<Array<Maybe<Scalars['String']>>>;
  deviceModel: Maybe<Scalars['String']>;
};

export type ModelFilter = {
  AND?: Maybe<Array<ModelFilter>>;
  clauses?: Maybe<Array<ProductCompareClause>>;
  OR?: Maybe<Array<ModelFilter>>;
};

export type ModelQuery = {
  filter?: Maybe<ModelFilter>;
  limit?: Maybe<Scalars['Float']>;
};

export enum ModelSearchField {
  Description = 'description',
  Id = 'id',
  Name = 'name',
  SupportsPolicies = 'supportsPolicies',
  SupportsProvisioning = 'supportsProvisioning'
}

export type Mutation = {
  __typename: 'Mutation';
  acceptUserInvite: AcceptedInviteResponse;
  activateLicense: Array<LicenseInfo>;
  activateTenant: TenantResponse;
  addDeviceTag: Array<Scalars['String']>;
  addFamilyImage: HardwareFamilyImage;
  addManufacturerlImage: HardwareManufacturerImage;
  addModelImage: HardwareModelImage;
  addPermissionToRole: Role;
  addProductImage: HardwareProductImage;
  addResourceFile: Maybe<ResourceFileResponse>;
  addTagToGrant: Accessor;
  addTagToRole: Role;
  addVendorImage: VendorImage;
  aliasTenant: TenantResponse;
  associateWithResource: Accessor;
  cancelUserInvite: UserInviteResponse;
  capabilitiesMutate: Maybe<Capabilities>;
  configureAutoEntitle: AutoEntitleConfiguration;
  createClaritiTrialSubscription: ClaritiTrialUserSubscription;
  createConfigurationProfile: Maybe<ConfigProfileDto>;
  createDeviceParameter: Maybe<DeviceParameterDto>;
  createDeviceType: Maybe<DeviceTypeDto>;
  createGroup: GroupApiResponse;
  createPolicy: Maybe<Scalars['String']>;
  createPolicyCapabilities: GroupPolicy;
  createProductSoftware: ProductSoftware;
  createRegisteredEdgeDevice: CreateRegisteredDeviceResponse;
  createSubnet: Maybe<Subnet>;
  createSubnetRule: Maybe<SubnetRule>;
  createTenant: TenantResponse;
  createTenantIntegration: CreateTenantIntegrationResponse;
  createUser: UserResponse;
  deleteClaritiTrialSubscriptionReport: ClaritiTrialDeleteSubscriptionReportResponse;
  deleteConfigurationProfile: Maybe<Scalars['Int']>;
  deleteDeviceClass: DeleteResult;
  deleteDeviceParameter: Maybe<Scalars['Int']>;
  deleteDevices: Maybe<Scalars['Int']>;
  deleteDeviceType: Maybe<Scalars['Int']>;
  deleteFamilyImage: HardwareFamilyImage;
  deleteGroups: GroupApiResponse;
  deleteHardwareCategory: DeleteResult;
  deleteHardwareFamily: DeleteResult;
  deleteHardwareManufacturer: DeleteResult;
  deleteHardwareModel: DeleteResult;
  deleteHardwareProduct: DeleteResult;
  deleteManufacturerlImage: HardwareManufacturerImage;
  deleteMockRecords: DeleteMockRecordsResult;
  deleteModelImage: HardwareModelImage;
  deletePolicies: Maybe<PolicyResponse>;
  deletePoliciesBySiteId: Maybe<PolicyResponse>;
  deletePoliciesCapabilities: Scalars['Boolean'];
  deletePolicyById: Maybe<Scalars['String']>;
  deleteProductImage: HardwareProductImage;
  deleteProductSoftware: DeleteResponse;
  deleteProductSoftwareByPid: DeleteByPidResponse;
  deleteResourceFiles: Maybe<ResourceFileResponse>;
  deleteRooms: Maybe<Array<DeleteRoomsResponse>>;
  deleteSites: Maybe<Array<DeleteSitesResponse>>;
  deleteSku: DeleteResult;
  deleteSubnet: Maybe<Subnet>;
  deleteSubnetRule: Maybe<SubnetRule>;
  deleteTenant: DeleteTenantResponse;
  deleteTenantIntegration: DeleteTenantIntegrationResponse;
  deleteUser: DeleteUserResponse;
  deleteUserGroup: GenericUserGroupResponse;
  deleteVendor: DeleteResult;
  deleteVendorImage: VendorImage;
  destroyRole: Scalars['Boolean'];
  disassociateWithResource: Accessor;
  entitle: Array<EntitleResult>;
  entitleAllDevices: Array<EntitleDeviceResult>;
  entitleAllDevicesForModel: Array<EntitleDeviceResult>;
  entitleDevices: Array<EntitleDeviceResult>;
  exportDeviceInventory: ExportDeviceInventoryResponse;
  factoryReset: DeviceApiResponse;
  generateLicense: LicenseInfo;
  grantPermission: Accessor;
  grantRole: Accessor;
  importDeviceSettings: Maybe<Array<Maybe<DeviceImportResponse>>>;
  importToLens: Maybe<Scalars['Boolean']>;
  insertInGroup: Maybe<Collection>;
  installCertificate: CertificateResponse;
  inviteUser: InviteUserResponse;
  leaveCall: ActiveCalls;
  lookupAssociations: Maybe<Room>;
  manageMergeFromTenantRequest: MergeEntityResponse;
  manageMergeToTenantRequest: MergeEntityResponse;
  mergeInternalTenants: MergeEntityResponse;
  migrationImport: Maybe<Scalars['Boolean']>;
  mutateUserGroupMembership: UserGroup;
  ncAddRecipient: Recipient;
  ncClearAction: Maybe<NotificationCenter>;
  ncConfirmEmail: Scalars['Boolean'];
  ncCreateServiceNowWebhook: ServiceNowWebhook;
  ncCreateTeamsWebhookForTenant: TeamsHook;
  ncDeleteServiceNowWebhook: Tenant;
  ncDeleteTeamsWebhook: Tenant;
  ncDisableAction: ActionConfiguration;
  ncDisableServiceNowWebhook: ServiceNowWebhook;
  ncDisableTeamsWebhook: TeamsHook;
  ncDisableTenant: Audience;
  ncDisableUser: Audience;
  ncEnableAction: ActionConfiguration;
  ncEnableServiceNowWebhook: ServiceNowWebhook;
  ncEnableTeamsWebhook: TeamsHook;
  ncEnableTenant: Audience;
  ncEnableUser: Audience;
  ncLogAction: Maybe<NotificationCenter>;
  ncRemoveRecipient: Audience;
  ncReplaceRecipient: Audience;
  ncRunSchedule: Maybe<Scalars['String']>;
  ncSetFrequency: ActionConfiguration;
  ncTestServiceNowWebhook: HookTestResult;
  ncTestServiceNowWebhookWithParams: HookTestResult;
  ncTestTeamsWebhook: HookTestResult;
  ncUnsubscribe: Scalars['Boolean'];
  ncUpdateServiceNowActionConfiguration: ServiceNowActionConfiguration;
  ncUpdateServiceNowWebhook: ServiceNowWebhook;
  ncUpdateTeamsWebhook: TeamsHook;
  ncUpdateWebhookActionConfiguration: TeamsWebhookActionConfiguration;
  ns_ls_ackInstance: Scalars['Boolean'];
  ns_ls_addEntitlement: Ns_Ls_Entitlement;
  ns_ls_addTenant: Ns_Ls_Tenant;
  ns_ls_addTenantAlias: Ns_Ls_TenantAlias;
  ns_ls_addUser: Ns_Ls_User;
  ns_ls_assignEntitlement: Ns_Ls_Entitlement;
  ns_ls_assignEntitlementValue: Ns_Ls_EntitlementGroupingSet;
  ns_ls_clientRequest: Scalars['String'];
  ns_ls_combineEntitlements: Ns_Ls_Entitlement;
  ns_ls_createAltInstance: Ns_Ls_Instance;
  ns_ls_createAuthToken: Ns_Ls_ClientAuthToken;
  ns_ls_createInstance: Ns_Ls_Instance;
  ns_ls_deleteActiveTokenUser: Scalars['Boolean'];
  ns_ls_deleteAppData: Ns_Ls_AppData;
  ns_ls_deleteAudit: Ns_Ls_AuditEvent;
  ns_ls_deleteAuthToken: Ns_Ls_ClientAuthToken;
  ns_ls_deleteEntitlement: Ns_Ls_Entitlement;
  ns_ls_deleteInstance: Ns_Ls_Instance;
  ns_ls_deleteTenant: Ns_Ls_Tenant;
  ns_ls_deleteTenantAlias: Ns_Ls_TenantAlias;
  ns_ls_deleteUser: Ns_Ls_User;
  ns_ls_expireEntitlement: Ns_Ls_Entitlement;
  ns_ls_extendEntitlement: Ns_Ls_Entitlement;
  ns_ls_generateAlternateLicense: Scalars['String'];
  ns_ls_mergeTenants: Ns_Ls_Tenant;
  ns_ls_performSystemMaint: Scalars['Boolean'];
  ns_ls_processLicenseRequest: Maybe<Scalars['String']>;
  ns_ls_releaseEntitlement: Ns_Ls_Entitlement;
  ns_ls_releaseEntitlementValue: Ns_Ls_EntitlementGroupingSet;
  ns_ls_releaseInstance: Scalars['Boolean'];
  ns_ls_resetInstance: Ns_Ls_Instance;
  ns_ls_searchDeleteAppData: Scalars['Boolean'];
  ns_ls_searchDeleteAudits: Scalars['Boolean'];
  ns_ls_searchDeleteEntitlements: Scalars['Boolean'];
  ns_ls_searchDeleteInstances: Scalars['Boolean'];
  ns_ls_setInstanceEditables: Ns_Ls_Instance;
  ns_ls_setInstanceHostName: Ns_Ls_Instance;
  ns_ls_setInstanceNiceName: Ns_Ls_Instance;
  ns_ls_setInstanceSerialNumber: Ns_Ls_Instance;
  ns_ls_setInstanceVersion: Ns_Ls_Instance;
  ns_ls_splitEntitlement: Ns_Ls_Entitlement;
  ns_ls_startDeepReport: Scalars['Boolean'];
  ns_ls_stopDeepReport: Maybe<Scalars['Boolean']>;
  ns_ls_unassignEntitlement: Ns_Ls_Entitlement;
  ns_ls_updateEntitlement: Ns_Ls_Entitlement;
  ns_ls_updateTenant: Ns_Ls_Tenant;
  ns_ls_updateUser: Ns_Ls_User;
  ns_siebel_createServiceRequest: Maybe<Ns_Siebel_NewServiceRequest>;
  ns_siebel_updateAssetDescription: Maybe<Ns_Siebel_Asset>;
  rebootDevice: DeviceApiResponse;
  rebootDevicesBySiteId: DeviceApiResponse;
  rebootGroup: GroupApiResponse;
  registerAccessor: Accessor;
  registerDevice: RegisterDeviceResponse;
  /** @deprecated Please use registerDevice or registerEndUserDevice */
  registerDeviceDirect: RegisterDeviceResponse;
  registerEndUserDevice: RegisterEndUserDeviceResponse;
  registerMTRDevice: RegisterMtrDeviceResponse;
  rejectUserInvite: UserInviteResponse;
  removeAccessor: Scalars['Boolean'];
  removeDeviceTag: Array<Scalars['String']>;
  removeFromGroup: Maybe<Collection>;
  removePermissionFromRole: Role;
  removeTag: ProductBuild;
  removeTagFromGrant: Accessor;
  removeTagFromRole: Role;
  requestMergeTenant: MergeEntityResponse;
  requestProvisioningSync: DeviceApiResponse;
  requestStartUploadDevicePCAP: DeviceLogsApiResponse;
  requestStopUploadDevicePCAP: DeviceLogsApiResponse;
  requestUploadDeviceLog: DeviceLogsApiResponse;
  requestUploadDeviceScreen: DeviceLogsApiResponse;
  resendUserInvite: UserInviteResponse;
  resendVerifyEmail: ResendVerificationResponse;
  resetServiceRegistry: Scalars['String'];
  revokePermission: Accessor;
  revokeRole: Accessor;
  saveUserGroup: UserGroup;
  setDescription: ProductBuild;
  setDeviceSettingsWithXML: SettingResponse;
  setEntitlementTenant: SetEntitlementTenantResult;
  setGrantableRolesOnRole: Role;
  setGrantType: Grant;
  setIsMockLicenseTenant: TenantResponse;
  setPermissionsOnRole: Role;
  setRoutePath: Route;
  setTag: ProductBuild;
  setTagsOnGrant: Accessor;
  setTagsOnRole: Role;
  setUserMetaData: UserResponse;
  startCall: ActiveCalls;
  suspendUser: UserResponse;
  switchRole: Accessor;
  switchSite: Maybe<Room>;
  syncEntitledUntilDate: Array<SyncEntitledUntilDateResult>;
  syncEntitlements: Scalars['JSONObject'];
  syncLicense: Array<LicenseInfo>;
  syncShipmentDate: Array<SyncShipmentDateResult>;
  toggleLogToFlash: LogToFlashApiResponse;
  uninstallCertificate: ApiResponse;
  unmergeTenant: TenantResponse;
  unregisterDevice: UnregisterDeviceResponse;
  updateConfigurationProfile: Maybe<ConfigProfileDto>;
  updateDevice: Maybe<Device>;
  updateDeviceGroupPriority: Maybe<Scalars['Boolean']>;
  updateDeviceOS: DeviceApiResponse;
  updateDeviceParameter: Maybe<DeviceParameterDto>;
  updateDeviceProvisioningSettings: DeviceApiResponse;
  updateDeviceType: Maybe<DeviceTypeDto>;
  updateFamilyImage: HardwareFamilyImage;
  updateGroup: GroupApiResponse;
  updateManufacturerlImage: HardwareManufacturerImage;
  updateModelImage: HardwareModelImage;
  updatePolicy: Maybe<Policy>;
  updatePolicyCapabilities: GroupPolicy;
  updateProductImage: HardwareProductImage;
  updateProvisioningAccount: Maybe<ProvisioningAccount>;
  updateSubnetRule: Maybe<SubnetRule>;
  updateTenant: TenantResponse;
  updateUser: UserResponse;
  updateVendorImage: VendorImage;
  upsertCollection: Maybe<Collection>;
  upsertDeviceClass: DeviceClass;
  upsertDeviceSettings: SettingResponse;
  upsertHardwareCategory: HardwareCategory;
  upsertHardwareFamily: HardwareFamily;
  upsertHardwareManufacturer: HardwareManufacturer;
  upsertHardwareModel: HardwareModel;
  upsertHardwareProduct: HardwareProduct;
  upsertNormalizedDeviceSettings: NormalizedDeviceSettingsResponse;
  upsertRoom: Maybe<Room>;
  upsertSite: Maybe<Site>;
  upsertSku: Sku;
  upsertVendor: Vendor;
};


export type MutationAcceptUserInviteArgs = {
  code: Scalars['ID'];
};


export type MutationActivateLicenseArgs = {
  licenseKey: Scalars['String'];
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationActivateTenantArgs = {
  activate?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationAddDeviceTagArgs = {
  deviceId: Scalars['String'];
  etag?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};


export type MutationAddFamilyImageArgs = {
  image: HardwareFamilyImageInput;
};


export type MutationAddManufacturerlImageArgs = {
  image: HardwareManufacturerImageInput;
};


export type MutationAddModelImageArgs = {
  image: HardwareModelImageInput;
};


export type MutationAddPermissionToRoleArgs = {
  permission: Scalars['String'];
  role: Scalars['String'];
};


export type MutationAddProductImageArgs = {
  image: HardwareProductImageInput;
};


export type MutationAddResourceFileArgs = {
  file?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize?: Maybe<Scalars['Float']>;
  tenantId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationAddTagToGrantArgs = {
  accessorId: Scalars['String'];
  resourceId: Scalars['String'];
  tag: Scalars['String'];
};


export type MutationAddTagToRoleArgs = {
  role: Scalars['String'];
  tag: Scalars['String'];
};


export type MutationAddVendorImageArgs = {
  image: HardwareVendorImageInput;
};


export type MutationAliasTenantArgs = {
  alias: Scalars['ID'];
  id: Scalars['ID'];
  overwrite?: Maybe<Scalars['Boolean']>;
};


export type MutationAssociateWithResourceArgs = {
  accessorId: Scalars['ID'];
  grantType?: Maybe<GrantTypeInput>;
  resourceId: Scalars['ID'];
  resourceType: Scalars['String'];
};


export type MutationCancelUserInviteArgs = {
  code: Scalars['ID'];
};


export type MutationCapabilitiesMutateArgs = {
  deviceId: Scalars['String'];
  input: CapabilitiesInput;
};


export type MutationConfigureAutoEntitleArgs = {
  enabled: Scalars['Boolean'];
  tenantId: Scalars['String'];
};


export type MutationCreateConfigurationProfileArgs = {
  configProfileDTO?: Maybe<ConfigProfileDtoInput>;
};


export type MutationCreateDeviceParameterArgs = {
  deviceParameterDTO?: Maybe<DeviceParameterDtoInput>;
};


export type MutationCreateDeviceTypeArgs = {
  deviceTypeDocument?: Maybe<DeviceTypeDocumentInput>;
};


export type MutationCreateGroupArgs = {
  createSWPolicy?: Maybe<Scalars['Boolean']>;
  devices?: Maybe<Devices>;
  groupName: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationCreatePolicyArgs = {
  policy?: Maybe<PolicyInput>;
  taskExecuteTime?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationCreatePolicyCapabilitiesArgs = {
  input: GroupPolicyInput;
};


export type MutationCreateProductSoftwareArgs = {
  productSoftware: CreateProductSoftware;
};


export type MutationCreateRegisteredEdgeDeviceArgs = {
  device: CreateRegisteredDeviceRequest;
};


export type MutationCreateSubnetArgs = {
  subnetInput: CreateSubnetRequest;
};


export type MutationCreateSubnetRuleArgs = {
  createSubnetRuleInput: CreateSubnetRuleInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateTenantIntegrationArgs = {
  integration: TenantIntegrationInput;
  tenantId: Scalars['ID'];
};


export type MutationCreateUserArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  tags: Array<Scalars['String']>;
};


export type MutationDeleteClaritiTrialSubscriptionReportArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConfigurationProfileArgs = {
  uuid?: Maybe<Scalars['String']>;
};


export type MutationDeleteDeviceClassArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeviceParameterArgs = {
  deviceModel?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type MutationDeleteDevicesArgs = {
  serials?: Maybe<Array<Maybe<Scalars['String']>>>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationDeleteDeviceTypeArgs = {
  deviceTypeUuid?: Maybe<Scalars['String']>;
};


export type MutationDeleteFamilyImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGroupsArgs = {
  groupIds: Groups;
};


export type MutationDeleteHardwareCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHardwareFamilyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHardwareManufacturerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHardwareModelArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHardwareProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteManufacturerlImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMockRecordsArgs = {
  tenantId: Scalars['String'];
};


export type MutationDeleteModelImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePoliciesArgs = {
  policyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationDeletePoliciesBySiteIdArgs = {
  siteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationDeletePoliciesCapabilitiesArgs = {
  policyIds: Array<Scalars['String']>;
};


export type MutationDeletePolicyByIdArgs = {
  policyId?: Maybe<Scalars['String']>;
};


export type MutationDeleteProductImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductSoftwareArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductSoftwareByPidArgs = {
  pid: Scalars['String'];
};


export type MutationDeleteResourceFilesArgs = {
  fileNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationDeleteRoomsArgs = {
  ids: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type MutationDeleteSitesArgs = {
  deleteRooms?: Maybe<Scalars['Boolean']>;
  ids: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type MutationDeleteSkuArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSubnetArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSubnetRuleArgs = {
  deleteSubnetRuleInput: DeleteSubnetRuleInput;
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTenantIntegrationArgs = {
  integration: TenantIntegrationInput;
  tenantId: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserGroupArgs = {
  id: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationDeleteVendorArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteVendorImageArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyRoleArgs = {
  role: Scalars['String'];
};


export type MutationDisassociateWithResourceArgs = {
  accessorId: Scalars['ID'];
  resourceId: Scalars['ID'];
};


export type MutationEntitleArgs = {
  assets: Array<LicenseAsset>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationEntitleAllDevicesArgs = {
  tenantId: Scalars['String'];
};


export type MutationEntitleAllDevicesForModelArgs = {
  modelId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationEntitleDevicesArgs = {
  modelId: Scalars['String'];
  productSerials: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type MutationExportDeviceInventoryArgs = {
  tenantId: Scalars['String'];
};


export type MutationFactoryResetArgs = {
  deviceId: Scalars['String'];
  options?: Maybe<FactoryResetOptions>;
};


export type MutationGenerateLicenseArgs = {
  quantity?: Maybe<Scalars['Float']>;
  sku?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationGrantPermissionArgs = {
  accessorId: Scalars['ID'];
  grantType?: Maybe<GrantTypeInput>;
  permission: Scalars['String'];
  resourceId: Scalars['ID'];
  resourceType?: Maybe<Scalars['String']>;
};


export type MutationGrantRoleArgs = {
  accessorId: Scalars['ID'];
  grantType?: Maybe<GrantTypeInput>;
  resourceId: Scalars['ID'];
  resourceType?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};


export type MutationImportDeviceSettingsArgs = {
  csv?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationImportToLensArgs = {
  file?: Maybe<Scalars['String']>;
  importType?: Maybe<Scalars['String']>;
  overwriteDeviceRecords?: Maybe<Scalars['Boolean']>;
  tenantId?: Maybe<Scalars['String']>;
  updateExistingDevices?: Maybe<Scalars['Boolean']>;
};


export type MutationInstallCertificateArgs = {
  certificate: DeviceCertificate;
  deviceId: Scalars['String'];
};


export type MutationInviteUserArgs = {
  emails: Array<Scalars['String']>;
  role: Scalars['String'];
  tenant_id: Scalars['ID'];
};


export type MutationLeaveCallArgs = {
  callId: Scalars['String'];
  deviceId: Scalars['String'];
  options?: Maybe<CallControlOptions>;
};


export type MutationLookupAssociationsArgs = {
  fields: LookupAssociationsData;
};


export type MutationManageMergeFromTenantRequestArgs = {
  action: MergeEntityActionType;
  requestId: Scalars['ID'];
};


export type MutationManageMergeToTenantRequestArgs = {
  action: MergeEntityActionType;
  requestId: Scalars['ID'];
  tenantId?: Maybe<Scalars['ID']>;
};


export type MutationMergeInternalTenantsArgs = {
  mergeFromTenantId: Scalars['ID'];
  mergeToTenantId: Scalars['ID'];
};


export type MutationMigrationImportArgs = {
  tenantId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type MutationMutateUserGroupMembershipArgs = {
  groupId: Scalars['String'];
  newUsers: Array<Scalars['String']>;
  removedUsers: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type MutationNcAddRecipientArgs = {
  input: AddRecipient;
};


export type MutationNcClearActionArgs = {
  action: ClearAction;
};


export type MutationNcConfirmEmailArgs = {
  id: Scalars['ID'];
};


export type MutationNcCreateServiceNowWebhookArgs = {
  input: CreateServiceNowInput;
  tenantId: Scalars['ID'];
};


export type MutationNcCreateTeamsWebhookForTenantArgs = {
  input?: Maybe<CreateWebhook>;
  tenantId: Scalars['ID'];
};


export type MutationNcDeleteServiceNowWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationNcDeleteTeamsWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationNcDisableActionArgs = {
  input: ToggleActionNotification;
};


export type MutationNcDisableServiceNowWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationNcDisableTeamsWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationNcDisableTenantArgs = {
  id: Scalars['ID'];
};


export type MutationNcDisableUserArgs = {
  input: UserInput;
};


export type MutationNcEnableActionArgs = {
  input: ToggleActionNotification;
};


export type MutationNcEnableServiceNowWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationNcEnableTeamsWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationNcEnableTenantArgs = {
  id: Scalars['ID'];
};


export type MutationNcEnableUserArgs = {
  input: UserInput;
};


export type MutationNcLogActionArgs = {
  action: ActionInput;
};


export type MutationNcRemoveRecipientArgs = {
  input: RemoveRecipient;
};


export type MutationNcReplaceRecipientArgs = {
  input: ReplaceRecipient;
};


export type MutationNcRunScheduleArgs = {
  name: Scalars['String'];
};


export type MutationNcSetFrequencyArgs = {
  input: SetActionFrequency;
};


export type MutationNcTestServiceNowWebhookArgs = {
  input: NcTestServiceNowWebhook;
};


export type MutationNcTestServiceNowWebhookWithParamsArgs = {
  input: NcTestServiceNowWebhookWithParams;
  tenantId: Scalars['ID'];
};


export type MutationNcTestTeamsWebhookArgs = {
  input: NcTestTeamsWebhook;
};


export type MutationNcUnsubscribeArgs = {
  id: Scalars['ID'];
};


export type MutationNcUpdateServiceNowActionConfigurationArgs = {
  input: NcUpdateServiceNowWebhookAction;
};


export type MutationNcUpdateServiceNowWebhookArgs = {
  id: Scalars['ID'];
  input: UpdateServiceNowWebhook;
};


export type MutationNcUpdateTeamsWebhookArgs = {
  id: Scalars['ID'];
  input: CreateWebhook;
};


export type MutationNcUpdateWebhookActionConfigurationArgs = {
  input: NcUpdateTeamsWebhookAction;
};


export type MutationNs_Ls_AckInstanceArgs = {
  recordId: Scalars['ID'];
  requestValue: Scalars['String'];
};


export type MutationNs_Ls_AddEntitlementArgs = {
  entitlement: Ns_Ls_EntitlementIn;
};


export type MutationNs_Ls_AddTenantArgs = {
  tenant: Ns_Ls_TenantIn;
};


export type MutationNs_Ls_AddTenantAliasArgs = {
  alias: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationNs_Ls_AddUserArgs = {
  userWithPass: Ns_Ls_UserWithPassIn;
};


export type MutationNs_Ls_AssignEntitlementArgs = {
  instanceRecordId: Scalars['ID'];
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_AssignEntitlementValueArgs = {
  groupingId: Scalars['ID'];
  includePending?: Maybe<Scalars['Boolean']>;
  instanceRecordId: Scalars['ID'];
  value: Scalars['Int'];
};


export type MutationNs_Ls_ClientRequestArgs = {
  ath?: Maybe<Scalars['String']>;
  req: Scalars['String'];
};


export type MutationNs_Ls_CombineEntitlementsArgs = {
  recordId: Scalars['ID'];
  toRecordId: Scalars['ID'];
};


export type MutationNs_Ls_CreateAltInstanceArgs = {
  createFromData: Ns_Ls_CreateRestrictiveInstanceDataIn;
};


export type MutationNs_Ls_CreateAuthTokenArgs = {
  tenantId: Scalars['String'];
};


export type MutationNs_Ls_CreateInstanceArgs = {
  b64Request: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationNs_Ls_DeleteActiveTokenUserArgs = {
  sessionToken: Scalars['String'];
};


export type MutationNs_Ls_DeleteAppDataArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_DeleteAuditArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_DeleteAuthTokenArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_DeleteEntitlementArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_DeleteInstanceArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_DeleteTenantArgs = {
  id: Scalars['ID'];
};


export type MutationNs_Ls_DeleteTenantAliasArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_DeleteUserArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_ExpireEntitlementArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_ExtendEntitlementArgs = {
  expireIncrease: Scalars['String'];
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_GenerateAlternateLicenseArgs = {
  ackValue?: Maybe<Scalars['String']>;
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_MergeTenantsArgs = {
  fromTenantId: Scalars['String'];
  toTenantId: Scalars['String'];
};


export type MutationNs_Ls_ProcessLicenseRequestArgs = {
  recordId: Scalars['ID'];
  requestValue: Scalars['String'];
};


export type MutationNs_Ls_ReleaseEntitlementArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_ReleaseEntitlementValueArgs = {
  groupingId: Scalars['ID'];
  includePending?: Maybe<Scalars['Boolean']>;
  instanceRecordId: Scalars['ID'];
  value: Scalars['Int'];
};


export type MutationNs_Ls_ReleaseInstanceArgs = {
  recordId: Scalars['ID'];
  requestValue: Scalars['String'];
};


export type MutationNs_Ls_ResetInstanceArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_SearchDeleteAppDataArgs = {
  appDataSearch?: Maybe<Scalars['String']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationNs_Ls_SearchDeleteAuditsArgs = {
  afterTime?: Maybe<Scalars['String']>;
  beforeTime?: Maybe<Scalars['String']>;
  ofType?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};


export type MutationNs_Ls_SearchDeleteEntitlementsArgs = {
  activationCode?: Maybe<Scalars['String']>;
  assignedToId?: Maybe<Scalars['String']>;
  assignedToTenant?: Maybe<Scalars['Boolean']>;
  beginsAfter?: Maybe<Scalars['String']>;
  beginsBefore?: Maybe<Scalars['String']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  expiresAfter?: Maybe<Scalars['String']>;
  expiresBefore?: Maybe<Scalars['String']>;
  groupingId?: Maybe<Scalars['String']>;
  mappingId1?: Maybe<Scalars['String']>;
  mappingId2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pendingAssignedToId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type MutationNs_Ls_SearchDeleteInstancesArgs = {
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  macsCSV?: Maybe<Scalars['String']>;
  modifiedAfter?: Maybe<Scalars['String']>;
  modifiedBefore?: Maybe<Scalars['String']>;
  niceName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationNs_Ls_SetInstanceEditablesArgs = {
  hostName?: Maybe<Scalars['String']>;
  niceName?: Maybe<Scalars['String']>;
  recordId: Scalars['ID'];
  serialNumber?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};


export type MutationNs_Ls_SetInstanceHostNameArgs = {
  name: Scalars['String'];
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_SetInstanceNiceNameArgs = {
  name: Scalars['String'];
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_SetInstanceSerialNumberArgs = {
  recordId: Scalars['ID'];
  serialNumber: Scalars['String'];
};


export type MutationNs_Ls_SetInstanceVersionArgs = {
  recordId: Scalars['ID'];
  version: Scalars['String'];
};


export type MutationNs_Ls_SplitEntitlementArgs = {
  existingEntitlementRecordId: Scalars['ID'];
  splitCount?: Maybe<Scalars['Int']>;
};


export type MutationNs_Ls_StartDeepReportArgs = {
  afterTime?: Maybe<Scalars['String']>;
  beforeTime?: Maybe<Scalars['String']>;
};


export type MutationNs_Ls_UnassignEntitlementArgs = {
  recordId: Scalars['ID'];
};


export type MutationNs_Ls_UpdateEntitlementArgs = {
  entitlement: Ns_Ls_EntitlementIn;
};


export type MutationNs_Ls_UpdateTenantArgs = {
  tenant: Ns_Ls_TenantIn;
};


export type MutationNs_Ls_UpdateUserArgs = {
  userWithPass: Ns_Ls_UserWithPassIn;
};


export type MutationNs_Siebel_CreateServiceRequestArgs = {
  accountId: Scalars['String'];
  assetId: Scalars['String'];
  contactAccountId: Scalars['String'];
  contactId: Scalars['String'];
  customerIssueDescriptionPLCM: Scalars['String'];
  problemDescription: Scalars['String'];
  problemType: Scalars['String'];
  productId: Scalars['String'];
  softwareVersion: Scalars['String'];
};


export type MutationNs_Siebel_UpdateAssetDescriptionArgs = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationRebootDeviceArgs = {
  deviceId: Scalars['String'];
};


export type MutationRebootDevicesBySiteIdArgs = {
  siteId: Scalars['String'];
};


export type MutationRebootGroupArgs = {
  groupId: Scalars['String'];
};


export type MutationRegisterAccessorArgs = {
  accessorId: Scalars['ID'];
};


export type MutationRegisterDeviceArgs = {
  device: RegisterDeviceRequest;
};


export type MutationRegisterDeviceDirectArgs = {
  device: RegisterDeviceDirectRequest;
};


export type MutationRegisterEndUserDeviceArgs = {
  device?: Maybe<RegisterEndUserDeviceRequest>;
};


export type MutationRegisterMtrDeviceArgs = {
  device: RegisterMtrDeviceRequest;
};


export type MutationRejectUserInviteArgs = {
  code: Scalars['ID'];
};


export type MutationRemoveAccessorArgs = {
  accessorId: Scalars['ID'];
};


export type MutationRemoveDeviceTagArgs = {
  deviceId: Scalars['String'];
  etag?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};


export type MutationRemovePermissionFromRoleArgs = {
  permission: Scalars['String'];
  role: Scalars['String'];
};


export type MutationRemoveTagArgs = {
  build: Scalars['String'];
  category: Scalars['String'];
  tagName: Scalars['String'];
  version: Scalars['String'];
};


export type MutationRemoveTagFromGrantArgs = {
  accessorId: Scalars['String'];
  resourceId: Scalars['String'];
  tag: Scalars['String'];
};


export type MutationRemoveTagFromRoleArgs = {
  role: Scalars['String'];
  tag: Scalars['String'];
};


export type MutationRequestMergeTenantArgs = {
  id: Scalars['ID'];
  toEmail: Scalars['String'];
  toId: Scalars['ID'];
};


export type MutationRequestProvisioningSyncArgs = {
  deviceId: Scalars['String'];
};


export type MutationRequestStartUploadDevicePcapArgs = {
  deviceId: Scalars['String'];
  filter?: Maybe<Scalars['String']>;
  interval?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  timeout?: Maybe<Scalars['Int']>;
};


export type MutationRequestStopUploadDevicePcapArgs = {
  deviceId: Scalars['String'];
};


export type MutationRequestUploadDeviceLogArgs = {
  deviceId: Scalars['String'];
  erase?: Maybe<Scalars['Boolean']>;
};


export type MutationRequestUploadDeviceScreenArgs = {
  deviceId: Scalars['String'];
};


export type MutationResendUserInviteArgs = {
  code: Scalars['ID'];
};


export type MutationResendVerifyEmailArgs = {
  clientId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationRevokePermissionArgs = {
  accessorId: Scalars['ID'];
  permission: Scalars['String'];
  resourceId: Scalars['ID'];
};


export type MutationRevokeRoleArgs = {
  accessorId: Scalars['ID'];
  resourceId: Scalars['ID'];
  role: Scalars['String'];
};


export type MutationSaveUserGroupArgs = {
  body: UserGroupBody;
  tenantId: Scalars['String'];
};


export type MutationSetDescriptionArgs = {
  build: Scalars['String'];
  category: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  version: Scalars['String'];
};


export type MutationSetDeviceSettingsWithXmlArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  settingsXML: Scalars['String'];
};


export type MutationSetEntitlementTenantArgs = {
  productSerial: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationSetGrantableRolesOnRoleArgs = {
  grantableRoles: Array<Scalars['String']>;
  role: Scalars['String'];
};


export type MutationSetGrantTypeArgs = {
  accessorId: Scalars['ID'];
  resourceId: Scalars['ID'];
  resourceType?: Maybe<Scalars['String']>;
  type: GrantTypeInput;
};


export type MutationSetIsMockLicenseTenantArgs = {
  id: Scalars['ID'];
  mockLicenseTenant: Scalars['Boolean'];
};


export type MutationSetPermissionsOnRoleArgs = {
  permissions: Array<Scalars['String']>;
  role: Scalars['String'];
};


export type MutationSetRoutePathArgs = {
  build: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  routeName: Scalars['String'];
  version: Scalars['String'];
};


export type MutationSetTagArgs = {
  build: Scalars['String'];
  category: Scalars['String'];
  tagName: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  version: Scalars['String'];
};


export type MutationSetTagsOnGrantArgs = {
  accessorId: Scalars['String'];
  resourceId: Scalars['String'];
  tags: Array<Scalars['String']>;
};


export type MutationSetTagsOnRoleArgs = {
  role: Scalars['String'];
  tags: Array<Scalars['String']>;
};


export type MutationSetUserMetaDataArgs = {
  input: UserMetaDataInput;
};


export type MutationStartCallArgs = {
  deviceId: Scalars['String'];
  dialString: Scalars['String'];
  options?: Maybe<CallOptions>;
};


export type MutationSuspendUserArgs = {
  id: Scalars['ID'];
  suspend: Scalars['Boolean'];
};


export type MutationSwitchRoleArgs = {
  accessorId: Scalars['ID'];
  grantType?: Maybe<GrantTypeInput>;
  resourceId: Scalars['ID'];
  resourceType?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  tagFilters?: Maybe<TagFilters>;
};


export type MutationSwitchSiteArgs = {
  roomId: Scalars['String'];
  siteId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationSyncEntitledUntilDateArgs = {
  productSerials: Array<Scalars['String']>;
  setToNull?: Maybe<Scalars['Boolean']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationSyncEntitlementsArgs = {
  productSerial: Scalars['String'];
};


export type MutationSyncLicenseArgs = {
  licenseKey: Scalars['String'];
};


export type MutationSyncShipmentDateArgs = {
  productSerials: Array<Scalars['String']>;
};


export type MutationToggleLogToFlashArgs = {
  deviceId: Scalars['String'];
  enableFlash: Scalars['Boolean'];
};


export type MutationUninstallCertificateArgs = {
  deviceId: Scalars['String'];
};


export type MutationUnmergeTenantArgs = {
  id: Scalars['ID'];
};


export type MutationUnregisterDeviceArgs = {
  deviceId: Scalars['String'];
};


export type MutationUpdateConfigurationProfileArgs = {
  configProfileDTO?: Maybe<ConfigProfileDtoInput>;
};


export type MutationUpdateDeviceArgs = {
  fields: UpdateDeviceRequest;
  id: Scalars['String'];
};


export type MutationUpdateDeviceGroupPriorityArgs = {
  groups?: Maybe<Array<Maybe<Scalars['String']>>>;
  serial?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationUpdateDeviceOsArgs = {
  deviceId: Scalars['String'];
};


export type MutationUpdateDeviceParameterArgs = {
  deviceParameterDTO?: Maybe<DeviceParameterDtoInput>;
};


export type MutationUpdateDeviceProvisioningSettingsArgs = {
  deviceId: Scalars['String'];
  settings: ProvisioningSettings;
};


export type MutationUpdateDeviceTypeArgs = {
  deviceTypeDocument?: Maybe<DeviceTypeDocumentInput>;
};


export type MutationUpdateFamilyImageArgs = {
  image: HardwareFamilyImageInput;
};


export type MutationUpdateGroupArgs = {
  createSWPolicy?: Maybe<Scalars['Boolean']>;
  devices?: Maybe<Devices>;
  groupId: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
};


export type MutationUpdateManufacturerlImageArgs = {
  image: HardwareManufacturerImageInput;
};


export type MutationUpdateModelImageArgs = {
  image: HardwareModelImageInput;
};


export type MutationUpdatePolicyArgs = {
  policy?: Maybe<PolicyInput>;
  taskExecuteTime?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type MutationUpdatePolicyCapabilitiesArgs = {
  input: GroupPolicyInput;
};


export type MutationUpdateProductImageArgs = {
  image: HardwareProductImageInput;
};


export type MutationUpdateProvisioningAccountArgs = {
  account?: Maybe<ProvisioningAccountIn>;
  tenantUuid?: Maybe<Scalars['String']>;
};


export type MutationUpdateSubnetRuleArgs = {
  updateSubnetRuleInput: UpdateSubnetRuleInput;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID'];
  input: UpdateTenantInput;
};


export type MutationUpdateUserArgs = {
  data: Auth0UserUpdateData;
  id: Scalars['ID'];
};


export type MutationUpdateVendorImageArgs = {
  image: HardwareVendorImageInput;
};


export type MutationUpsertCollectionArgs = {
  fields: UpsertCollectionRequest;
};


export type MutationUpsertDeviceClassArgs = {
  deviceClass: DeviceClassInput;
};


export type MutationUpsertDeviceSettingsArgs = {
  dryRun?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  settings: PolyOsConfigInput;
};


export type MutationUpsertHardwareCategoryArgs = {
  category: CategoryInput;
};


export type MutationUpsertHardwareFamilyArgs = {
  family: HardwareFamilyInput;
};


export type MutationUpsertHardwareManufacturerArgs = {
  manufacturer: HardwareManufacturerInput;
};


export type MutationUpsertHardwareModelArgs = {
  model: HardwareModelInput;
};


export type MutationUpsertHardwareProductArgs = {
  product: HardwareProductInput;
};


export type MutationUpsertNormalizedDeviceSettingsArgs = {
  id: Scalars['String'];
  settings: Array<NormalizedDeviceSettingInput>;
};


export type MutationUpsertRoomArgs = {
  fields: UpsertRoomRequest;
};


export type MutationUpsertSiteArgs = {
  fields: UpsertSiteRequest;
};


export type MutationUpsertSkuArgs = {
  sku: SkuInput;
};


export type MutationUpsertVendorArgs = {
  vendor: VendorInput;
};


export type NcIntegrationActionConfig = {
  __typename: 'NcIntegrationActionConfig';
  allowedRates: Array<Rate>;
  type: ActionType;
};

export type NcIntegrationConfig = {
  __typename: 'NcIntegrationConfig';
  actionConfigurations: Array<Maybe<NcIntegrationActionConfig>>;
  name: Scalars['String'];
};

export type NcSchedule = {
  __typename: 'NcSchedule';
  cron: Scalars['String'];
  data: Maybe<Scalars['JSONObject']>;
  name: Scalars['String'];
};

export type NcServiceNowQueries = {
  __typename: 'NcServiceNowQueries';
  webhook: Maybe<ServiceNowWebhook>;
};


export type NcServiceNowQueriesWebhookArgs = {
  id: Scalars['ID'];
};

export type NcTeamsQueries = {
  __typename: 'NcTeamsQueries';
  webhook: Maybe<TeamsHook>;
};


export type NcTeamsQueriesWebhookArgs = {
  id: Scalars['ID'];
};

export type NcTestServiceNowWebhook = {
  id: Scalars['ID'];
};

export type NcTestServiceNowWebhookWithParams = {
  password: Scalars['String'];
  url: Scalars['URL'];
  username: Scalars['String'];
};

export type NcTestTeamsWebhook = {
  actionType?: Maybe<ActionTypeInput>;
  id?: Maybe<Scalars['ID']>;
  rate?: Maybe<Rate>;
  url?: Maybe<Scalars['URL']>;
};

export type NcUpdateServiceNowWebhookAction = {
  actionId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  rate?: Maybe<Rate>;
};

export type NcUpdateTeamsWebhook = {
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

export type NcUpdateTeamsWebhookAction = {
  actionId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  rate: Rate;
};

export type Node = {
  id: Scalars['ID'];
  invocationId: Scalars['ID'];
};

export type NormalizedDeviceSetting = {
  __typename: 'NormalizedDeviceSetting';
  name: Scalars['String'];
  value: Maybe<Scalars['String']>;
};

export type NormalizedDeviceSettingInput = {
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type NormalizedDeviceSettingsResponse = {
  __typename: 'NormalizedDeviceSettingsResponse';
  fetchedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  settings: Array<NormalizedDeviceSetting>;
};

export type NotificationCenter = {
  __typename: 'NotificationCenter';
  action: Maybe<Action>;
  actions: Array<Action>;
  actionTypes: Array<ActionType>;
  integrations: Array<NcIntegrationConfig>;
};


export type NotificationCenterActionArgs = {
  id: Scalars['ID'];
};


export type NotificationCenterActionsArgs = {
  filter?: Maybe<ActionFilter>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type NotificationCenterActionTypesArgs = {
  filter?: Maybe<ActionTypeFilter>;
};


export type NotificationCenterIntegrationsArgs = {
  input?: Maybe<IntegrationsFilter>;
};

export type Ns_Ls_AppData = {
  __typename: 'ns_ls_AppData';
  appData: Scalars['String'];
  creationTime: Scalars['String'];
  etag: Scalars['String'];
  instanceId: Scalars['String'];
  lastModifiedTime: Scalars['String'];
  productId: Scalars['String'];
  productVersion: Scalars['String'];
  recordId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type Ns_Ls_AppDataConnection = {
  __typename: 'ns_ls_AppDataConnection';
  edges: Array<Ns_Ls_AppDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_AppDataEdge = {
  __typename: 'ns_ls_AppDataEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_AppData;
};

export type Ns_Ls_AppDataIn = {
  appData?: Maybe<Scalars['String']>;
  creationTime?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  lastModifiedTime?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type Ns_Ls_AppDataList = {
  __typename: 'ns_ls_AppDataList';
  appDatas: Array<Ns_Ls_AppData>;
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Ns_Ls_AppDataListIn = {
  appDatas?: Maybe<Array<Maybe<Ns_Ls_AppDataIn>>>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_AuditEvent = {
  __typename: 'ns_ls_AuditEvent';
  additionalInfo: Scalars['String'];
  creationTime: Scalars['String'];
  entitlementName: Scalars['String'];
  etag: Scalars['String'];
  eventTime: Scalars['String'];
  eventType: Scalars['String'];
  instanceName: Scalars['String'];
  newValue: Scalars['String'];
  onObjectId: Scalars['String'];
  previousValue: Scalars['String'];
  recordId: Scalars['String'];
  tenantId: Scalars['String'];
  userName: Scalars['String'];
};

export type Ns_Ls_AuditEventConnection = {
  __typename: 'ns_ls_AuditEventConnection';
  edges: Array<Ns_Ls_AuditEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_AuditEventCount = {
  __typename: 'ns_ls_AuditEventCount';
  count: Scalars['Int'];
  type: Scalars['String'];
};

export type Ns_Ls_AuditEventCountIn = {
  count?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type Ns_Ls_AuditEventEdge = {
  __typename: 'ns_ls_AuditEventEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_AuditEvent;
};

export type Ns_Ls_AuditEventIn = {
  additionalInfo?: Maybe<Scalars['String']>;
  creationTime?: Maybe<Scalars['String']>;
  entitlementName?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  instanceName?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  onObjectId?: Maybe<Scalars['String']>;
  previousValue?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type Ns_Ls_AuditEventList = {
  __typename: 'ns_ls_AuditEventList';
  events: Array<Ns_Ls_AuditEvent>;
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Ns_Ls_AuditEventListIn = {
  events?: Maybe<Array<Maybe<Ns_Ls_AuditEventIn>>>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum Ns_Ls_AuditEventType {
  AdminAcceptEntitlement = 'ADMIN_ACCEPT_ENTITLEMENT',
  AdminAssignEntitlement = 'ADMIN_ASSIGN_ENTITLEMENT',
  AdminChangeEntitlementValue = 'ADMIN_CHANGE_ENTITLEMENT_VALUE',
  AdminChangeProductVersion = 'ADMIN_CHANGE_PRODUCT_VERSION',
  AdminChangeTenantAccount = 'ADMIN_CHANGE_TENANT_ACCOUNT',
  AdminCombineEntitlement = 'ADMIN_COMBINE_ENTITLEMENT',
  AdminCreateClientAuthToken = 'ADMIN_CREATE_CLIENT_AUTH_TOKEN',
  AdminCreateEntitlement = 'ADMIN_CREATE_ENTITLEMENT',
  AdminCreateInstance = 'ADMIN_CREATE_INSTANCE',
  AdminCreatePolyUser = 'ADMIN_CREATE_POLY_USER',
  AdminCreateProductVersion = 'ADMIN_CREATE_PRODUCT_VERSION',
  AdminCreateTenantAccount = 'ADMIN_CREATE_TENANT_ACCOUNT',
  AdminCreateTenantUser = 'ADMIN_CREATE_TENANT_USER',
  AdminDeleteAppData = 'ADMIN_DELETE_APP_DATA',
  AdminDeleteAuditRecord = 'ADMIN_DELETE_AUDIT_RECORD',
  AdminDeleteClientAuthToken = 'ADMIN_DELETE_CLIENT_AUTH_TOKEN',
  AdminDeleteEntitlement = 'ADMIN_DELETE_ENTITLEMENT',
  AdminDeleteInstance = 'ADMIN_DELETE_INSTANCE',
  AdminDeletePolyUser = 'ADMIN_DELETE_POLY_USER',
  AdminDeleteProductVersion = 'ADMIN_DELETE_PRODUCT_VERSION',
  AdminDeleteTenantAccount = 'ADMIN_DELETE_TENANT_ACCOUNT',
  AdminDeleteTenantUser = 'ADMIN_DELETE_TENANT_USER',
  AdminEditTenantInformation = 'ADMIN_EDIT_TENANT_INFORMATION',
  AdminExpireEntitlement = 'ADMIN_EXPIRE_ENTITLEMENT',
  AdminIncreaseEntitlementExpireValue = 'ADMIN_INCREASE_ENTITLEMENT_EXPIRE_VALUE',
  AdminLogin = 'ADMIN_LOGIN',
  AdminMergeTenantAccount = 'ADMIN_MERGE_TENANT_ACCOUNT',
  AdminModifyPolyUser = 'ADMIN_MODIFY_POLY_USER',
  AdminModifyTenantUser = 'ADMIN_MODIFY_TENANT_USER',
  AdminMoveEntitlementToTenant = 'ADMIN_MOVE_ENTITLEMENT_TO_TENANT',
  AdminPerformAltLicense = 'ADMIN_PERFORM_ALT_LICENSE',
  AdminPerformMaint = 'ADMIN_PERFORM_MAINT',
  AdminReleaseEntitlement = 'ADMIN_RELEASE_ENTITLEMENT',
  AdminResetPolyUserPwd = 'ADMIN_RESET_POLY_USER_PWD',
  AdminResetTenantUserPwd = 'ADMIN_RESET_TENANT_USER_PWD',
  AdminSplitEntitlement = 'ADMIN_SPLIT_ENTITLEMENT',
  AdminUnassignEntitlement = 'ADMIN_UNASSIGN_ENTITLEMENT',
  AuditorLogin = 'AUDITOR_LOGIN',
  InstanceCreationFromRequest = 'INSTANCE_CREATION_FROM_REQUEST',
  IntegrationAddEntitlement = 'INTEGRATION_ADD_ENTITLEMENT',
  IntegrationAddTenantUser = 'INTEGRATION_ADD_TENANT_USER',
  IntegrationChangeEntitlement = 'INTEGRATION_CHANGE_ENTITLEMENT',
  IntegrationChangeProductVersion = 'INTEGRATION_CHANGE_PRODUCT_VERSION',
  IntegrationChangeTenantAccount = 'INTEGRATION_CHANGE_TENANT_ACCOUNT',
  IntegrationCreateProductVersion = 'INTEGRATION_CREATE_PRODUCT_VERSION',
  IntegrationCreateTenantAccount = 'INTEGRATION_CREATE_TENANT_ACCOUNT',
  IntegrationDeleteEntitlement = 'INTEGRATION_DELETE_ENTITLEMENT',
  IntegrationDeleteProductVersion = 'INTEGRATION_DELETE_PRODUCT_VERSION',
  IntegrationDeleteTenantAccount = 'INTEGRATION_DELETE_TENANT_ACCOUNT',
  IntegrationIncreaseEntitlementExpire = 'INTEGRATION_INCREASE_ENTITLEMENT_EXPIRE',
  IntegrationMergeTenantAccount = 'INTEGRATION_MERGE_TENANT_ACCOUNT',
  TenantAdminAcceptEntitlement = 'TENANT_ADMIN_ACCEPT_ENTITLEMENT',
  TenantAdminAssignEntitlement = 'TENANT_ADMIN_ASSIGN_ENTITLEMENT',
  TenantAdminCombineEntitlement = 'TENANT_ADMIN_COMBINE_ENTITLEMENT',
  TenantAdminCreateClientAuthToken = 'TENANT_ADMIN_CREATE_CLIENT_AUTH_TOKEN',
  TenantAdminCreateInstance = 'TENANT_ADMIN_CREATE_INSTANCE',
  TenantAdminDeleteClientAuthToken = 'TENANT_ADMIN_DELETE_CLIENT_AUTH_TOKEN',
  TenantAdminDeleteInstance = 'TENANT_ADMIN_DELETE_INSTANCE',
  TenantAdminDeleteUser = 'TENANT_ADMIN_DELETE_USER',
  TenantAdminLogin = 'TENANT_ADMIN_LOGIN',
  TenantAdminModifyUser = 'TENANT_ADMIN_MODIFY_USER',
  TenantAdminPerformAltLicense = 'TENANT_ADMIN_PERFORM_ALT_LICENSE',
  TenantAdminResetUserPwd = 'TENANT_ADMIN_RESET_USER_PWD',
  TenantAdminSplitEntitlement = 'TENANT_ADMIN_SPLIT_ENTITLEMENT',
  TenantAdminUnassignEntitlement = 'TENANT_ADMIN_UNASSIGN_ENTITLEMENT',
  TenantAuditorLogin = 'TENANT_AUDITOR_LOGIN',
  TenantCreateUser = 'TENANT_CREATE_USER',
  TenantResetUserPwd = 'TENANT_RESET_USER_PWD',
  Unknown = 'UNKNOWN',
  UserSelfResetPwd = 'USER_SELF_RESET_PWD'
}

export type Ns_Ls_ClientAuthToken = {
  __typename: 'ns_ls_ClientAuthToken';
  creationTime: Scalars['String'];
  lastModifiedTime: Scalars['String'];
  lastUsedTime: Scalars['String'];
  recordId: Scalars['String'];
  tenantId: Scalars['String'];
  token: Scalars['String'];
};

export type Ns_Ls_ClientAuthTokenConnection = {
  __typename: 'ns_ls_ClientAuthTokenConnection';
  edges: Array<Ns_Ls_ClientAuthTokenEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_ClientAuthTokenEdge = {
  __typename: 'ns_ls_ClientAuthTokenEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_ClientAuthToken;
};

export type Ns_Ls_ClientAuthTokenIn = {
  creationTime?: Maybe<Scalars['String']>;
  lastModifiedTime?: Maybe<Scalars['String']>;
  lastUsedTime?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Ns_Ls_ClientAuthTokenList = {
  __typename: 'ns_ls_ClientAuthTokenList';
  offset: Scalars['Int'];
  tokens: Array<Ns_Ls_ClientAuthToken>;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_ClientAuthTokenListIn = {
  offset?: Maybe<Scalars['Int']>;
  tokens?: Maybe<Array<Maybe<Ns_Ls_ClientAuthTokenIn>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_CreateRestrictiveInstanceData = {
  __typename: 'ns_ls_CreateRestrictiveInstanceData';
  encodedInstanceId: Scalars['String'];
  fromInstanceData: Ns_Ls_Instance;
};

export type Ns_Ls_CreateRestrictiveInstanceDataIn = {
  encodedInstanceId?: Maybe<Scalars['String']>;
  fromInstanceData?: Maybe<Ns_Ls_InstanceIn>;
};

export type Ns_Ls_DeepReport = {
  __typename: 'ns_ls_DeepReport';
  entitlementsAwaitingRelease: Ns_Ls_EntitlementList;
  instancesWithDuplicateInstanceId: Ns_Ls_InstanceList;
  instancesWithDuplicateMacs: Ns_Ls_InstanceList;
  instancesWithDuplicateSn: Ns_Ls_InstanceList;
  recordsAfterTime: Scalars['String'];
  recordsBeforeTime: Scalars['String'];
  report: Ns_Ls_Report;
  reportEndTime: Scalars['String'];
  reportStartTime: Scalars['String'];
  suspiciousAudits: Ns_Ls_AuditEventList;
  unassignedEntitlements: Ns_Ls_EntitlementList;
};

export type Ns_Ls_DeepReportIn = {
  entitlementsAwaitingRelease?: Maybe<Ns_Ls_EntitlementListIn>;
  instancesWithDuplicateInstanceId?: Maybe<Ns_Ls_InstanceListIn>;
  instancesWithDuplicateMacs?: Maybe<Ns_Ls_InstanceListIn>;
  instancesWithDuplicateSn?: Maybe<Ns_Ls_InstanceListIn>;
  recordsAfterTime?: Maybe<Scalars['String']>;
  recordsBeforeTime?: Maybe<Scalars['String']>;
  report?: Maybe<Ns_Ls_ReportIn>;
  reportEndTime?: Maybe<Scalars['String']>;
  reportStartTime?: Maybe<Scalars['String']>;
  suspiciousAudits?: Maybe<Ns_Ls_AuditEventListIn>;
  unassignedEntitlements?: Maybe<Ns_Ls_EntitlementListIn>;
};

export type Ns_Ls_Entitlement = {
  __typename: 'ns_ls_Entitlement';
  activationCode: Scalars['String'];
  assignedToRecordId: Scalars['String'];
  assignedToTenant: Scalars['Boolean'];
  begins: Scalars['String'];
  creationTime: Scalars['String'];
  etag: Scalars['String'];
  expires: Scalars['String'];
  groupingId: Scalars['String'];
  lastModifiedTime: Scalars['String'];
  mappingId1: Scalars['String'];
  mappingId2: Scalars['String'];
  name: Scalars['String'];
  pendingAssignedToRecordId: Scalars['String'];
  productId: Scalars['String'];
  productVersion: Scalars['String'];
  recordId: Scalars['String'];
  state: Scalars['String'];
  stringValue: Scalars['String'];
  tenantId: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Int'];
  valueType: Scalars['String'];
};

export type Ns_Ls_EntitlementConnection = {
  __typename: 'ns_ls_EntitlementConnection';
  edges: Array<Ns_Ls_EntitlementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_EntitlementEdge = {
  __typename: 'ns_ls_EntitlementEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_Entitlement;
};

export type Ns_Ls_EntitlementGroupingAssignmentSet = {
  __typename: 'ns_ls_EntitlementGroupingAssignmentSet';
  assignedToTenant: Scalars['Boolean'];
  assignedValueSum: Scalars['Int'];
  awaitingReassignEntitlementIds: Array<Scalars['String']>;
  awaitingReassignValueSum: Scalars['Int'];
  awaitingReleaseValueSum: Scalars['Int'];
  entitlementIds: Array<Scalars['String']>;
  groupingId: Scalars['String'];
  orphanedCount: Scalars['Int'];
  orphanedValueSum: Scalars['Int'];
  recordId: Scalars['String'];
  totalAssignedValueSum: Scalars['Int'];
  usedValueSum: Scalars['Int'];
  valueSum: Scalars['Int'];
};

export type Ns_Ls_EntitlementGroupingAssignmentSetIn = {
  assignedToTenant?: Maybe<Scalars['Boolean']>;
  assignedValueSum?: Maybe<Scalars['Int']>;
  awaitingReassignEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  awaitingReassignValueSum?: Maybe<Scalars['Int']>;
  awaitingReleaseValueSum?: Maybe<Scalars['Int']>;
  entitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupingId?: Maybe<Scalars['String']>;
  orphanedCount?: Maybe<Scalars['Int']>;
  orphanedValueSum?: Maybe<Scalars['Int']>;
  recordId?: Maybe<Scalars['String']>;
  totalAssignedValueSum?: Maybe<Scalars['Int']>;
  usedValueSum?: Maybe<Scalars['Int']>;
  valueSum?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_EntitlementGroupings = {
  __typename: 'ns_ls_EntitlementGroupings';
  groupingIds: Array<Scalars['String']>;
  groupingSets: Array<Ns_Ls_EntitlementGroupingSet>;
  tenantEntitlements: Array<Ns_Ls_Entitlement>;
  tenantId: Scalars['String'];
  totalNonTenantCount: Scalars['Int'];
};

export type Ns_Ls_EntitlementGroupingSet = {
  __typename: 'ns_ls_EntitlementGroupingSet';
  assignedToTenant: Scalars['Boolean'];
  assignedValueSum: Scalars['Int'];
  assignmentGroupingSets: Array<Ns_Ls_EntitlementGroupingAssignmentSet>;
  assignmentRecordIds: Array<Scalars['String']>;
  availableValueSum: Scalars['Int'];
  awaitingReassignValueSum: Scalars['Int'];
  awaitingReleaseValueSum: Scalars['Int'];
  entitlements: Array<Ns_Ls_Entitlement>;
  groupingId: Scalars['String'];
  isBoolean: Scalars['Boolean'];
  isUnlimitedBoolean: Scalars['Boolean'];
  normalValueSum: Scalars['Int'];
  orphanedCount: Scalars['Int'];
  orphanedValueSum: Scalars['Int'];
  totalAssignedValueSum: Scalars['Int'];
  usedValueSum: Scalars['Int'];
  valueSum: Scalars['Int'];
};

export type Ns_Ls_EntitlementGroupingSetConnection = {
  __typename: 'ns_ls_EntitlementGroupingSetConnection';
  edges: Array<Ns_Ls_EntitlementGroupingSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_EntitlementGroupingSetEdge = {
  __typename: 'ns_ls_EntitlementGroupingSetEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_EntitlementGroupingSet;
};

export type Ns_Ls_EntitlementGroupingSetIn = {
  assignedToTenant?: Maybe<Scalars['Boolean']>;
  assignedValueSum?: Maybe<Scalars['Int']>;
  assignmentGroupingSets?: Maybe<Array<Maybe<Ns_Ls_EntitlementGroupingAssignmentSetIn>>>;
  assignmentRecordIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  availableValueSum?: Maybe<Scalars['Int']>;
  awaitingReassignValueSum?: Maybe<Scalars['Int']>;
  awaitingReleaseValueSum?: Maybe<Scalars['Int']>;
  entitlements?: Maybe<Array<Maybe<Ns_Ls_EntitlementIn>>>;
  groupingId?: Maybe<Scalars['String']>;
  isBoolean?: Maybe<Scalars['Boolean']>;
  isUnlimitedBoolean?: Maybe<Scalars['Boolean']>;
  normalValueSum?: Maybe<Scalars['Int']>;
  orphanedCount?: Maybe<Scalars['Int']>;
  orphanedValueSum?: Maybe<Scalars['Int']>;
  totalAssignedValueSum?: Maybe<Scalars['Int']>;
  usedValueSum?: Maybe<Scalars['Int']>;
  valueSum?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_EntitlementGroupingsIn = {
  groupingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupingSets?: Maybe<Array<Maybe<Ns_Ls_EntitlementGroupingSetIn>>>;
  tenantEntitlements?: Maybe<Array<Maybe<Ns_Ls_EntitlementIn>>>;
  tenantId?: Maybe<Scalars['String']>;
  totalNonTenantCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_EntitlementIn = {
  activationCode?: Maybe<Scalars['String']>;
  assignedToRecordId?: Maybe<Scalars['String']>;
  assignedToTenant?: Maybe<Scalars['Boolean']>;
  begins?: Maybe<Scalars['String']>;
  creationTime?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['String']>;
  groupingId?: Maybe<Scalars['String']>;
  lastModifiedTime?: Maybe<Scalars['String']>;
  mappingId1?: Maybe<Scalars['String']>;
  mappingId2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pendingAssignedToRecordId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stringValue?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  valueType?: Maybe<Scalars['String']>;
};

export type Ns_Ls_EntitlementList = {
  __typename: 'ns_ls_EntitlementList';
  entitlements: Array<Ns_Ls_Entitlement>;
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Ns_Ls_EntitlementListIn = {
  entitlements?: Maybe<Array<Maybe<Ns_Ls_EntitlementIn>>>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum Ns_Ls_EntitlementState {
  Assigned = 'ASSIGNED',
  AwaitingRelease = 'AWAITING_RELEASE',
  Normal = 'NORMAL',
  Orphaned = 'ORPHANED',
  PendingReleaseAck = 'PENDING_RELEASE_ACK',
  Used = 'USED'
}

export enum Ns_Ls_EntitlementType {
  Normal = 'NORMAL',
  Perpetual = 'PERPETUAL',
  Trial = 'TRIAL'
}

export type Ns_Ls_Instance = {
  __typename: 'ns_ls_Instance';
  creationTime: Scalars['String'];
  entitlements: Array<Scalars['String']>;
  etag: Scalars['String'];
  hasEncodedLicense: Scalars['Boolean'];
  hasInitialEncodedRequest: Scalars['Boolean'];
  hasServerChainToken: Scalars['Boolean'];
  hostname: Scalars['String'];
  instanceId: Scalars['String'];
  lastLicensedTime: Scalars['String'];
  lastLicenseExpires: Scalars['String'];
  lastLicenseHadExpiredEntitlements: Scalars['Boolean'];
  lastModifiedTime: Scalars['String'];
  macs: Array<Scalars['String']>;
  niceName: Scalars['String'];
  pendingEntitlements: Array<Scalars['String']>;
  productId: Scalars['String'];
  productVersion: Scalars['String'];
  recordId: Scalars['String'];
  serialNumber: Scalars['String'];
  tenantId: Scalars['String'];
  useAlternateLicencing: Scalars['Boolean'];
};

export type Ns_Ls_InstanceConnection = {
  __typename: 'ns_ls_InstanceConnection';
  edges: Array<Ns_Ls_InstanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_InstanceEdge = {
  __typename: 'ns_ls_InstanceEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_Instance;
};

export type Ns_Ls_InstanceIn = {
  creationTime?: Maybe<Scalars['String']>;
  entitlements?: Maybe<Array<Maybe<Scalars['String']>>>;
  etag?: Maybe<Scalars['String']>;
  hasEncodedLicense?: Maybe<Scalars['Boolean']>;
  hasInitialEncodedRequest?: Maybe<Scalars['Boolean']>;
  hasServerChainToken?: Maybe<Scalars['Boolean']>;
  hostname?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  lastLicensedTime?: Maybe<Scalars['String']>;
  lastLicenseExpires?: Maybe<Scalars['String']>;
  lastLicenseHadExpiredEntitlements?: Maybe<Scalars['Boolean']>;
  lastModifiedTime?: Maybe<Scalars['String']>;
  macs?: Maybe<Array<Maybe<Scalars['String']>>>;
  niceName?: Maybe<Scalars['String']>;
  pendingEntitlements?: Maybe<Array<Maybe<Scalars['String']>>>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  useAlternateLicencing?: Maybe<Scalars['Boolean']>;
};

export type Ns_Ls_InstanceList = {
  __typename: 'ns_ls_InstanceList';
  instances: Array<Ns_Ls_Instance>;
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Ns_Ls_InstanceListIn = {
  instances?: Maybe<Array<Maybe<Ns_Ls_InstanceIn>>>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_LoginSession = {
  __typename: 'ns_ls_LoginSession';
  sessionToken: Scalars['String'];
  user: Ns_Ls_User;
};

export type Ns_Ls_LoginSessionIn = {
  sessionToken?: Maybe<Scalars['String']>;
  user?: Maybe<Ns_Ls_UserIn>;
};

export enum Ns_Ls_PolyRole {
  NoPolyRole = 'NO_POLY_ROLE',
  PolyAdmin = 'POLY_ADMIN',
  PolyAuditor = 'POLY_AUDITOR',
  PolyIntegration = 'POLY_INTEGRATION',
  PolySuperAdmin = 'POLY_SUPER_ADMIN'
}

export type Ns_Ls_PolyUserRole = {
  __typename: 'ns_ls_PolyUserRole';
  privilegeLevel: Scalars['Int'];
  role: Scalars['String'];
};

export type Ns_Ls_PolyUserRoleIn = {
  privilegeLevel?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
};

export type Ns_Ls_ProductLatestVersion = {
  __typename: 'ns_ls_ProductLatestVersion';
  latestVersion: Scalars['String'];
  productId: Scalars['String'];
};

export type Ns_Ls_ProductLatestVersionIn = {
  latestVersion?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type Ns_Ls_ProductLatestVersionList = {
  __typename: 'ns_ls_ProductLatestVersionList';
  latestVersions: Array<Ns_Ls_ProductLatestVersion>;
};

export type Ns_Ls_ProductLatestVersionListIn = {
  latestVersions?: Maybe<Array<Maybe<Ns_Ls_ProductLatestVersionIn>>>;
};

export type Ns_Ls_ProductList = {
  __typename: 'ns_ls_ProductList';
  productIds: Array<Scalars['String']>;
};

export type Ns_Ls_ProductListIn = {
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Ns_Ls_ProductVersions = {
  __typename: 'ns_ls_ProductVersions';
  productId: Scalars['String'];
  versions: Array<Scalars['String']>;
};

export type Ns_Ls_ProductVersionsIn = {
  productId?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Ns_Ls_Report = {
  __typename: 'ns_ls_Report';
  activeLoggedInSessionCount: Scalars['String'];
  auditEventCounts: Array<Ns_Ls_AuditEventCount>;
  entitlementCount: Scalars['Int'];
  entitlementsOrphaned: Ns_Ls_EntitlementList;
  failedClientAuthCount: Scalars['String'];
  failedServerAuthCount: Scalars['String'];
  instanceCount: Scalars['Int'];
  polyLogins: Scalars['Int'];
  recordsAfterTime: Scalars['String'];
  recordsBeforeTime: Scalars['String'];
  reportTime: Scalars['String'];
  tenantAliasCount: Scalars['Int'];
  tenantCount: Scalars['Int'];
  tenantLogins: Scalars['Int'];
  userCount: Scalars['Int'];
};

export type Ns_Ls_ReportIn = {
  activeLoggedInSessionCount?: Maybe<Scalars['String']>;
  auditEventCounts?: Maybe<Array<Maybe<Ns_Ls_AuditEventCountIn>>>;
  entitlementCount?: Maybe<Scalars['Int']>;
  entitlementsOrphaned?: Maybe<Ns_Ls_EntitlementListIn>;
  failedClientAuthCount?: Maybe<Scalars['String']>;
  failedServerAuthCount?: Maybe<Scalars['String']>;
  instanceCount?: Maybe<Scalars['Int']>;
  polyLogins?: Maybe<Scalars['Int']>;
  recordsAfterTime?: Maybe<Scalars['String']>;
  recordsBeforeTime?: Maybe<Scalars['String']>;
  reportTime?: Maybe<Scalars['String']>;
  tenantAliasCount?: Maybe<Scalars['Int']>;
  tenantCount?: Maybe<Scalars['Int']>;
  tenantLogins?: Maybe<Scalars['Int']>;
  userCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_Role = {
  __typename: 'ns_ls_Role';
  privilegeLevel: Scalars['Int'];
  role: Scalars['String'];
};

export type Ns_Ls_RoleIn = {
  privilegeLevel?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
};

export type Ns_Ls_SoftwareCatalog = {
  __typename: 'ns_ls_SoftwareCatalog';
  productId: Scalars['String'];
  softwareArtifacts: Array<Ns_Ls_SoftwareEntry>;
  version: Scalars['String'];
};

export type Ns_Ls_SoftwareCatalogIn = {
  productId?: Maybe<Scalars['String']>;
  softwareArtifacts?: Maybe<Array<Maybe<Ns_Ls_SoftwareEntryIn>>>;
  version?: Maybe<Scalars['String']>;
};

export type Ns_Ls_SoftwareEntry = {
  __typename: 'ns_ls_SoftwareEntry';
  artifactName: Scalars['String'];
  fileSize: Scalars['String'];
  lastModifiedTime: Scalars['String'];
  url: Scalars['String'];
};

export type Ns_Ls_SoftwareEntryIn = {
  artifactName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['String']>;
  lastModifiedTime?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum Ns_Ls_StandardEntitlementNames {
  AudioDevices = 'AUDIO_DEVICES',
  BurstEnabled = 'BURST_ENABLED',
  ClaritiManagerBaseLicense = 'CLARITI_MANAGER_BASE_LICENSE',
  EasySchedule = 'EASY_SCHEDULE',
  ElasticConcurrentAudioCalls = 'ELASTIC_CONCURRENT_AUDIO_CALLS',
  ElasticConcurrentCalls = 'ELASTIC_CONCURRENT_CALLS',
  ElasticConcurrentP2PCalls = 'ELASTIC_CONCURRENT_P2P_CALLS',
  ElasticConcurrentVmrs = 'ELASTIC_CONCURRENT_VMRS',
  LongTermLicensing = 'LONG_TERM_LICENSING',
  MediaEncryption = 'MEDIA_ENCRYPTION',
  MeetingDirector = 'MEETING_DIRECTOR',
  Otd = 'OTD',
  PerpetualConcurrentAudioCalls = 'PERPETUAL_CONCURRENT_AUDIO_CALLS',
  PerpetualConcurrentCalls = 'PERPETUAL_CONCURRENT_CALLS',
  PerpetualConcurrentP2PCalls = 'PERPETUAL_CONCURRENT_P2P_CALLS',
  PerpetualConcurrentVmrs = 'PERPETUAL_CONCURRENT_VMRS',
  Sdk = 'SDK',
  SubLicServer = 'SUB_LIC_SERVER',
  SubscriptionConcurrentAudioCalls = 'SUBSCRIPTION_CONCURRENT_AUDIO_CALLS',
  SubscriptionConcurrentCalls = 'SUBSCRIPTION_CONCURRENT_CALLS',
  SubscriptionConcurrentP2PCalls = 'SUBSCRIPTION_CONCURRENT_P2P_CALLS',
  SubscriptionConcurrentVmrs = 'SUBSCRIPTION_CONCURRENT_VMRS',
  Unknown = 'UNKNOWN',
  VideoDevices = 'VIDEO_DEVICES'
}

export enum Ns_Ls_StandardEntitlementValueTypes {
  Boolean = 'BOOLEAN',
  Counted = 'COUNTED',
  Unknown = 'UNKNOWN'
}

export enum Ns_Ls_StandardProductIds {
  ClaritiCe = 'CLARITI_CE',
  ClaritiManager = 'CLARITI_MANAGER',
  ClaritiWorkflow = 'CLARITI_WORKFLOW',
  Endpoint = 'ENDPOINT',
  Rm = 'RM',
  SubLicServer = 'SUB_LIC_SERVER',
  Unknown = 'UNKNOWN'
}

export type Ns_Ls_Tenant = {
  __typename: 'ns_ls_Tenant';
  creationTime: Scalars['String'];
  etag: Scalars['String'];
  lastModifiedTime: Scalars['String'];
  recordId: Scalars['String'];
  tenantDomain: Scalars['String'];
  tenantExternalId: Scalars['String'];
  tenantId: Scalars['String'];
  tenantMiscInfo: Scalars['String'];
  tenantName: Scalars['String'];
};

export type Ns_Ls_TenantAlias = {
  __typename: 'ns_ls_TenantAlias';
  aliasId: Scalars['String'];
  creationTime: Scalars['String'];
  etag: Scalars['String'];
  recordId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type Ns_Ls_TenantAliasConnection = {
  __typename: 'ns_ls_TenantAliasConnection';
  edges: Array<Ns_Ls_TenantAliasEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_TenantAliasEdge = {
  __typename: 'ns_ls_TenantAliasEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_TenantAlias;
};

export type Ns_Ls_TenantAliasIn = {
  aliasId?: Maybe<Scalars['String']>;
  creationTime?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type Ns_Ls_TenantAliasList = {
  __typename: 'ns_ls_TenantAliasList';
  aliases: Array<Ns_Ls_TenantAlias>;
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Ns_Ls_TenantAliasListIn = {
  aliases?: Maybe<Array<Maybe<Ns_Ls_TenantAliasIn>>>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_TenantConnection = {
  __typename: 'ns_ls_TenantConnection';
  edges: Array<Ns_Ls_TenantEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_TenantEdge = {
  __typename: 'ns_ls_TenantEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_Tenant;
};

export type Ns_Ls_TenantIn = {
  creationTime?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  lastModifiedTime?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  tenantDomain?: Maybe<Scalars['String']>;
  tenantExternalId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantMiscInfo?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
};

export type Ns_Ls_TenantList = {
  __typename: 'ns_ls_TenantList';
  offset: Scalars['Int'];
  tenants: Array<Ns_Ls_Tenant>;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_TenantListIn = {
  offset?: Maybe<Scalars['Int']>;
  tenants?: Maybe<Array<Maybe<Ns_Ls_TenantIn>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Ns_Ls_User = {
  __typename: 'ns_ls_User';
  creationTime: Scalars['String'];
  etag: Scalars['String'];
  expires: Scalars['String'];
  grantKeys: Array<Scalars['String']>;
  grantValues: Array<Ns_Ls_Role>;
  modifyTime: Scalars['String'];
  polyRole: Ns_Ls_PolyUserRole;
  recordId: Scalars['String'];
  userName: Scalars['String'];
};

export type Ns_Ls_UserConnection = {
  __typename: 'ns_ls_UserConnection';
  edges: Array<Ns_Ls_UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Ns_Ls_UserEdge = {
  __typename: 'ns_ls_UserEdge';
  cursor: Scalars['Cursor'];
  node: Ns_Ls_User;
};

export type Ns_Ls_UserIn = {
  creationTime?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['String']>;
  grantKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  grantValues?: Maybe<Array<Maybe<Ns_Ls_RoleIn>>>;
  modifyTime?: Maybe<Scalars['String']>;
  polyRole?: Maybe<Ns_Ls_PolyUserRoleIn>;
  recordId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type Ns_Ls_UserList = {
  __typename: 'ns_ls_UserList';
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
  users: Array<Ns_Ls_User>;
};

export type Ns_Ls_UserListIn = {
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<Ns_Ls_UserIn>>>;
};

export type Ns_Ls_UserPass = {
  __typename: 'ns_ls_UserPass';
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  recordId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type Ns_Ls_UserPassIn = {
  currentPassword?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export enum Ns_Ls_UserRole {
  LicenseObtainer = 'LICENSE_OBTAINER',
  TenantAdmin = 'TENANT_ADMIN',
  TenantAuditor = 'TENANT_AUDITOR',
  Unknown = 'UNKNOWN'
}

export type Ns_Ls_UserWithPass = {
  __typename: 'ns_ls_UserWithPass';
  password: Scalars['String'];
  user: Ns_Ls_User;
};

export type Ns_Ls_UserWithPassIn = {
  password?: Maybe<Scalars['String']>;
  user?: Maybe<Ns_Ls_UserIn>;
};

export type Ns_Siebel_Asset = {
  __typename: 'ns_siebel_Asset';
  accountPrimaryAddress: Maybe<Scalars['String']>;
  accountPrimaryAddressId: Maybe<Scalars['String']>;
  accountPrimaryAddressLine2: Maybe<Scalars['String']>;
  accountPrimaryCity: Maybe<Scalars['String']>;
  accountPrimaryCountry: Maybe<Scalars['String']>;
  accountPrimaryState: Maybe<Scalars['String']>;
  accountPrimaryZip: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  endUserEmail: Maybe<Scalars['String']>;
  entitlement: Maybe<Ns_Siebel_Entitlement>;
  id: Maybe<Scalars['String']>;
  order: Maybe<Ns_Siebel_Order>;
  ownerAccountId: Maybe<Scalars['String']>;
  productDescription: Maybe<Scalars['String']>;
  productGroup: Maybe<Scalars['String']>;
  productLine: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  productPartNumber: Maybe<Scalars['String']>;
  serial: Maybe<Scalars['String']>;
  warranty: Maybe<Ns_Siebel_Warranty>;
};

export type Ns_Siebel_Contact = {
  __typename: 'ns_siebel_Contact';
  companyNameforIndividual: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  workPhone: Maybe<Scalars['String']>;
};

export type Ns_Siebel_Entitlement = {
  __typename: 'ns_siebel_Entitlement';
  coverage: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['String']>;
  integrationId: Maybe<Scalars['String']>;
  isActive: Maybe<Scalars['Boolean']>;
  partnerName: Maybe<Scalars['String']>;
  partNumber: Maybe<Scalars['String']>;
  product: Maybe<Scalars['String']>;
  serialNumber: Maybe<Scalars['String']>;
  servicePart: Maybe<Scalars['String']>;
  serviceType: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['String']>;
};

export type Ns_Siebel_NewServiceRequest = {
  __typename: 'ns_siebel_NewServiceRequest';
  id: Maybe<Scalars['String']>;
  srNumber: Maybe<Scalars['String']>;
};

export type Ns_Siebel_Order = {
  __typename: 'ns_siebel_Order';
  purchaseDate: Maybe<Scalars['String']>;
  purchaseOrder: Maybe<Scalars['String']>;
  salesOrder: Maybe<Scalars['String']>;
  shipDate: Maybe<Scalars['String']>;
};

export type Ns_Siebel_ServiceRequestWebCenter = {
  __typename: 'ns_siebel_ServiceRequestWebCenter';
  accountId: Maybe<Scalars['String']>;
  assetId: Maybe<Scalars['String']>;
  contactAccountId: Maybe<Scalars['String']>;
  contactId: Maybe<Scalars['String']>;
  customerIssueDescriptionPLCM: Maybe<Scalars['String']>;
  emailCCList: Maybe<Scalars['String']>;
  probDesc: Maybe<Scalars['String']>;
  problemType: Maybe<Scalars['String']>;
  product: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
  productLine: Maybe<Scalars['String']>;
  resolutionCdCustPLCM: Maybe<Scalars['String']>;
  resolutionDescCustPLCM: Maybe<Scalars['String']>;
  serialNumber: Maybe<Scalars['String']>;
  serviceLocationId: Maybe<Scalars['String']>;
  softwareVersion: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
  srNumber: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  version: Maybe<Scalars['String']>;
};

export type Ns_Siebel_ServiceRequestWsPlcm = {
  __typename: 'ns_siebel_ServiceRequestWsPlcm';
  listOfAction: Maybe<Scalars['String']>;
  priority: Maybe<Scalars['String']>;
  srNumber: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  subStatus: Maybe<Scalars['String']>;
};

export type Ns_Siebel_Warranty = {
  __typename: 'ns_siebel_Warranty';
  coverage: Maybe<Scalars['String']>;
  daysLeft: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['String']>;
  hwSupport: Maybe<Scalars['String']>;
  isActive: Maybe<Scalars['Boolean']>;
  phoneSupport: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['String']>;
  swSupport: Maybe<Scalars['String']>;
  warrantyType: Maybe<Scalars['String']>;
};

export type OsState = {
  __typename: 'OSState';
  updateStatus: Maybe<SoftwareUpdateStatus>;
};

export type OsVersion = {
  __typename: 'OSVersion';
  displayName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  version: Maybe<Scalars['String']>;
};

export type Other = {
  __typename: 'Other';
  id: Scalars['ID'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor: Maybe<Scalars['Cursor']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Maybe<Scalars['Cursor']>;
};

export type PageInformation = {
  __typename: 'PageInformation';
  endCursor: Maybe<Scalars['Cursor']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Maybe<Scalars['Cursor']>;
  total: Scalars['Int'];
};

export enum PaginationPagingDirection {
  FirstPage = 'FIRST_PAGE',
  LastPage = 'LAST_PAGE',
  NextPage = 'NEXT_PAGE',
  PreviousPage = 'PREVIOUS_PAGE'
}

export enum PaginationSortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Param2DArrayItem = {
  __typename: 'Param2DArrayItem';
  currentValue: Scalars['String'];
  replace1: Scalars['Int'];
  replace2: Scalars['Int'];
};

export type Param2DArrayItemInput = {
  currentValue: Scalars['String'];
  replace1: Scalars['Int'];
  replace2: Scalars['Int'];
};

export type ParamArrayItem = {
  __typename: 'ParamArrayItem';
  currentValue: Scalars['String'];
  replace1: Scalars['Int'];
};

export type ParamArrayItemInput = {
  currentValue: Scalars['String'];
  replace1: Scalars['Int'];
};

export type ParamResource = {
  __typename: 'ParamResource';
  param: Scalars['String'];
  type: Maybe<Scalars['String']>;
};

export type Permission = {
  __typename: 'Permission';
  groups: Array<PermissionGroup>;
  name: Scalars['String'];
  roles: Array<Role>;
};

export type PermissionGroup = {
  __typename: 'PermissionGroup';
  name: Scalars['String'];
  permissions: Array<Permission>;
};

export type Point = {
  __typename: 'Point';
  x: Scalars['Date'];
  y: Maybe<Scalars['Float']>;
};

export type Policy = {
  __typename: 'Policy';
  configurationAttributes: Maybe<Array<Maybe<ConfigurationAttribute>>>;
  customSwUpdatePath: Maybe<Scalars['String']>;
  customSwSupportUpdatePath: Maybe<Array<Maybe<SoftwareSupportUpdatePath>>>;
  deviceId: Maybe<Scalars['String']>;
  deviceModel: Maybe<Scalars['String']>;
  deviceModelUuid: Maybe<Scalars['String']>;
  deviceType: Maybe<Scalars['String']>;
  groupId: Maybe<Scalars['String']>;
  lastSuccessfullyUpdated: Maybe<Scalars['Boolean']>;
  lastSuccessfullyUpdatedTime: Maybe<Scalars['Float']>;
  modifiedBy: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  policyDeploymentScope: Maybe<PolicyDeploymentScope>;
  policyId: Maybe<Scalars['String']>;
  policyType: Maybe<PolicyType>;
  priority: Maybe<Scalars['String']>;
  siteId: Maybe<Scalars['String']>;
  swSupportUpdatePath: Maybe<Array<Maybe<SoftwareSupportUpdatePath>>>;
  swUpdatePath: Maybe<Scalars['String']>;
  swUpdateSource: Maybe<SwUpdateSource>;
  tenantId: Maybe<Scalars['String']>;
};

export enum PolicyDeploymentScope {
  Device = 'DEVICE',
  DeviceModel = 'DEVICE_MODEL',
  ExternalDevice = 'EXTERNAL_DEVICE',
  Global = 'GLOBAL',
  Group = 'GROUP',
  Site = 'SITE'
}

export type PolicyInput = {
  configurationAttributes?: Maybe<Array<Maybe<ConfigurationAttributeInput>>>;
  customSwUpdatePath?: Maybe<Scalars['String']>;
  customSwSupportUpdatePath?: Maybe<Array<Maybe<SoftwareSupportUpdatePathInput>>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  deviceModelUuid?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  isExecuteImmediately?: Maybe<Scalars['Boolean']>;
  modifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  policyDeploymentScope?: Maybe<PolicyDeploymentScope>;
  policyId?: Maybe<Scalars['String']>;
  policyType?: Maybe<PolicyType>;
  priority?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  swSupportUpdatePath?: Maybe<Array<Maybe<SoftwareSupportUpdatePathInput>>>;
  swUpdatePath?: Maybe<Scalars['String']>;
  swUpdateSource?: Maybe<SwUpdateSource>;
  tenantId?: Maybe<Scalars['String']>;
};

export type PolicyResponse = {
  __typename: 'PolicyResponse';
  ids: Maybe<Scalars['String']>;
};

export enum PolicyType {
  DeviceSettingsUpdate = 'DEVICE_SETTINGS_UPDATE',
  DeviceSwUpdate = 'DEVICE_SW_UPDATE'
}

export type PolyInput = {
  audio?: Maybe<AudioInput>;
  call_control?: Maybe<CallControlInput>;
  general?: Maybe<GeneralInput>;
  software_update?: Maybe<SoftwareUpdateInput>;
  video?: Maybe<VideoInput>;
  wireless?: Maybe<WirelessInput>;
};

export type PolyNotificationConfigurationQueries = {
  __typename: 'PolyNotificationConfigurationQueries';
  audience: Maybe<Audience>;
  audiences: Array<Audience>;
  userAudience: Maybe<Audience>;
};


export type PolyNotificationConfigurationQueriesAudienceArgs = {
  id: Scalars['ID'];
};


export type PolyNotificationConfigurationQueriesAudiencesArgs = {
  filter?: Maybe<AudienceFilter>;
};


export type PolyNotificationConfigurationQueriesUserAudienceArgs = {
  input: UserAudienceInput;
};

export type PolyOsConfig = {
  __typename: 'PolyOSConfig';
  bluetooth: Maybe<PolyOsConfig_Bluetooth>;
  call: Maybe<PolyOsConfig_Call>;
  cloud: Maybe<PolyOsConfig_Cloud>;
  content: Maybe<PolyOsConfig_Content>;
  device: Maybe<PolyOsConfig_Device>;
  dir: Maybe<PolyOsConfig_Dir>;
  exchange: Maybe<PolyOsConfig_Exchange>;
  homeScreen: Maybe<PolyOsConfig_HomeScreen>;
  license: Maybe<PolyOsConfig_License>;
  log: Maybe<PolyOsConfig_Log>;
  mr: Maybe<PolyOsConfig_Mr>;
  net: Maybe<PolyOsConfig_Net>;
  prov: Maybe<PolyOsConfig_Prov>;
  qos: Maybe<PolyOsConfig_Qos>;
  sec: Maybe<PolyOsConfig_Sec>;
  snmp: Maybe<PolyOsConfig_Snmp>;
  upgrade: Maybe<PolyOsConfig_Upgrade>;
  video: Maybe<PolyOsConfig_Video>;
  voice: Maybe<PolyOsConfig_Voice>;
  voIpProt: Maybe<PolyOsConfig_VoIpProt>;
};

export type PolyOsConfig_Bluetooth = {
  __typename: 'PolyOSConfig_bluetooth';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_BluetoothInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_BluetoothMeta = {
  __typename: 'PolyOSConfig_bluetoothMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call = {
  __typename: 'PolyOSConfig_call';
  audioOnly: Maybe<PolyOsConfig_Call_AudioOnly>;
  autoAnswer: Maybe<PolyOsConfig_Call_AutoAnswer>;
  cdr: Maybe<PolyOsConfig_Call_Cdr>;
  conference: Maybe<PolyOsConfig_Call_Conference>;
  displayIconsInCall: Maybe<Scalars['Boolean']>;
  encryption: Maybe<PolyOsConfig_Call_Encryption>;
  escalate2MCU: Maybe<PolyOsConfig_Call_Escalate2Mcu>;
  h239: Maybe<PolyOsConfig_Call_H239>;
  maxTimeInCall: Maybe<Enum_MaxTimeInCall>;
  preferredPlaceACallNav: Maybe<Enum_PlaceCallFunc>;
  preferredSpeed: Maybe<PolyOsConfig_Call_PreferredSpeed>;
  recentcalls: Maybe<PolyOsConfig_Call_Recentcalls>;
  recentCalls: Maybe<PolyOsConfig_Call_RecentCalls>;
  videoDialPreference: Maybe<Array<Enum_VideoDialPreference>>;
  voiceDialPreference: Maybe<Array<Enum_VoiceDialPreference>>;
};

export type PolyOsConfig_Call_AudioOnly = {
  __typename: 'PolyOSConfig_call_audioOnly';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_AudioOnlyInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_AudioOnlyMeta = {
  __typename: 'PolyOSConfig_call_audioOnlyMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_AutoAnswer = {
  __typename: 'PolyOSConfig_call_autoAnswer';
  answerP2PCall: Maybe<Enum_AutoAnswer>;
  micMute: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_AutoAnswerInput = {
  answerP2PCall?: Maybe<Enum_AutoAnswer>;
  micMute?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_AutoAnswerMeta = {
  __typename: 'PolyOSConfig_call_autoAnswerMeta';
  answerP2PCall: Maybe<PropertyMeta>;
  micMute: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_Cdr = {
  __typename: 'PolyOSConfig_call_cdr';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_CdrInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_CdrMeta = {
  __typename: 'PolyOSConfig_call_cdrMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_Conference = {
  __typename: 'PolyOSConfig_call_conference';
  joinLeaveTone: Maybe<PolyOsConfig_Call_Conference_JoinLeaveTone>;
};

export type PolyOsConfig_Call_Conference_JoinLeaveTone = {
  __typename: 'PolyOSConfig_call_conference_joinLeaveTone';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_Conference_JoinLeaveToneInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_Conference_JoinLeaveToneMeta = {
  __typename: 'PolyOSConfig_call_conference_joinLeaveToneMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_ConferenceInput = {
  joinLeaveTone?: Maybe<PolyOsConfig_Call_Conference_JoinLeaveToneInput>;
};

export type PolyOsConfig_Call_ConferenceMeta = {
  __typename: 'PolyOSConfig_call_conferenceMeta';
  joinLeaveTone: Maybe<PolyOsConfig_Call_Conference_JoinLeaveToneMeta>;
};

export type PolyOsConfig_Call_Encryption = {
  __typename: 'PolyOSConfig_call_encryption';
  requireAES: Maybe<Enum_EncryptionEnable>;
};

export type PolyOsConfig_Call_EncryptionInput = {
  requireAES?: Maybe<Enum_EncryptionEnable>;
};

export type PolyOsConfig_Call_EncryptionMeta = {
  __typename: 'PolyOSConfig_call_encryptionMeta';
  requireAES: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_Escalate2Mcu = {
  __typename: 'PolyOSConfig_call_escalate2MCU';
  conferenceId: Maybe<Scalars['Int']>;
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_Escalate2McuInput = {
  conferenceId?: Maybe<Scalars['Int']>;
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_Escalate2McuMeta = {
  __typename: 'PolyOSConfig_call_escalate2MCUMeta';
  conferenceId: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_H239 = {
  __typename: 'PolyOSConfig_call_h239';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_H239Input = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_H239Meta = {
  __typename: 'PolyOSConfig_call_h239Meta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_PreferredSpeed = {
  __typename: 'PolyOSConfig_call_preferredSpeed';
  maxIncoming: Maybe<Enum_PreferredSpeedIp>;
  outgoing: Maybe<Enum_PreferredSpeedIp>;
};

export type PolyOsConfig_Call_PreferredSpeedInput = {
  maxIncoming?: Maybe<Enum_PreferredSpeedIp>;
  outgoing?: Maybe<Enum_PreferredSpeedIp>;
};

export type PolyOsConfig_Call_PreferredSpeedMeta = {
  __typename: 'PolyOSConfig_call_preferredSpeedMeta';
  maxIncoming: Maybe<PropertyMeta>;
  outgoing: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_Recentcalls = {
  __typename: 'PolyOSConfig_call_recentcalls';
  maxNumberToDisplay: Maybe<Enum_RecentCallsMaxNumberToDisplay>;
};

export type PolyOsConfig_Call_RecentCalls = {
  __typename: 'PolyOSConfig_call_recentCalls';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_RecentcallsInput = {
  maxNumberToDisplay?: Maybe<Enum_RecentCallsMaxNumberToDisplay>;
};

export type PolyOsConfig_Call_RecentCallsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Call_RecentcallsMeta = {
  __typename: 'PolyOSConfig_call_recentcallsMeta';
  maxNumberToDisplay: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Call_RecentCallsMeta = {
  __typename: 'PolyOSConfig_call_recentCallsMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_CallInput = {
  audioOnly?: Maybe<PolyOsConfig_Call_AudioOnlyInput>;
  autoAnswer?: Maybe<PolyOsConfig_Call_AutoAnswerInput>;
  cdr?: Maybe<PolyOsConfig_Call_CdrInput>;
  conference?: Maybe<PolyOsConfig_Call_ConferenceInput>;
  displayIconsInCall?: Maybe<Scalars['Boolean']>;
  encryption?: Maybe<PolyOsConfig_Call_EncryptionInput>;
  escalate2MCU?: Maybe<PolyOsConfig_Call_Escalate2McuInput>;
  h239?: Maybe<PolyOsConfig_Call_H239Input>;
  maxTimeInCall?: Maybe<Enum_MaxTimeInCall>;
  preferredPlaceACallNav?: Maybe<Enum_PlaceCallFunc>;
  preferredSpeed?: Maybe<PolyOsConfig_Call_PreferredSpeedInput>;
  recentcalls?: Maybe<PolyOsConfig_Call_RecentcallsInput>;
  recentCalls?: Maybe<PolyOsConfig_Call_RecentCallsInput>;
  videoDialPreference?: Maybe<Array<Enum_VideoDialPreference>>;
  voiceDialPreference?: Maybe<Array<Enum_VoiceDialPreference>>;
};

export type PolyOsConfig_CallMeta = {
  __typename: 'PolyOSConfig_callMeta';
  audioOnly: Maybe<PolyOsConfig_Call_AudioOnlyMeta>;
  autoAnswer: Maybe<PolyOsConfig_Call_AutoAnswerMeta>;
  cdr: Maybe<PolyOsConfig_Call_CdrMeta>;
  conference: Maybe<PolyOsConfig_Call_ConferenceMeta>;
  displayIconsInCall: Maybe<PropertyMeta>;
  encryption: Maybe<PolyOsConfig_Call_EncryptionMeta>;
  escalate2MCU: Maybe<PolyOsConfig_Call_Escalate2McuMeta>;
  h239: Maybe<PolyOsConfig_Call_H239Meta>;
  maxTimeInCall: Maybe<PropertyMeta>;
  preferredPlaceACallNav: Maybe<PropertyMeta>;
  preferredSpeed: Maybe<PolyOsConfig_Call_PreferredSpeedMeta>;
  recentcalls: Maybe<PolyOsConfig_Call_RecentcallsMeta>;
  recentCalls: Maybe<PolyOsConfig_Call_RecentCallsMeta>;
  videoDialPreference: Maybe<Array<PropertyMeta>>;
  voiceDialPreference: Maybe<Array<PropertyMeta>>;
};

export type PolyOsConfig_Cloud = {
  __typename: 'PolyOSConfig_cloud';
  polycom: Maybe<PolyOsConfig_Cloud_Polycom>;
};

export type PolyOsConfig_Cloud_Polycom = {
  __typename: 'PolyOSConfig_cloud_polycom';
  analytics: Maybe<PolyOsConfig_Cloud_Polycom_Analytics>;
};

export type PolyOsConfig_Cloud_Polycom_Analytics = {
  __typename: 'PolyOSConfig_cloud_polycom_analytics';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Cloud_Polycom_AnalyticsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Cloud_Polycom_AnalyticsMeta = {
  __typename: 'PolyOSConfig_cloud_polycom_analyticsMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Cloud_PolycomInput = {
  analytics?: Maybe<PolyOsConfig_Cloud_Polycom_AnalyticsInput>;
};

export type PolyOsConfig_Cloud_PolycomMeta = {
  __typename: 'PolyOSConfig_cloud_polycomMeta';
  analytics: Maybe<PolyOsConfig_Cloud_Polycom_AnalyticsMeta>;
};

export type PolyOsConfig_CloudInput = {
  polycom?: Maybe<PolyOsConfig_Cloud_PolycomInput>;
};

export type PolyOsConfig_CloudMeta = {
  __typename: 'PolyOSConfig_cloudMeta';
  polycom: Maybe<PolyOsConfig_Cloud_PolycomMeta>;
};

export type PolyOsConfig_Content = {
  __typename: 'PolyOSConfig_content';
  airplay: Maybe<PolyOsConfig_Content_Airplay>;
  conference: Maybe<PolyOsConfig_Content_Conference>;
  miracast: Maybe<PolyOsConfig_Content_Miracast>;
};

export type PolyOsConfig_Content_Airplay = {
  __typename: 'PolyOSConfig_content_airplay';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Content_AirplayInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Content_AirplayMeta = {
  __typename: 'PolyOSConfig_content_airplayMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Content_Conference = {
  __typename: 'PolyOSConfig_content_conference';
  autoAdjustBandwidth: Maybe<Scalars['Boolean']>;
  qualityPreference: Maybe<Enum_ContentQualityPreference>;
};

export type PolyOsConfig_Content_ConferenceInput = {
  autoAdjustBandwidth?: Maybe<Scalars['Boolean']>;
  qualityPreference?: Maybe<Enum_ContentQualityPreference>;
};

export type PolyOsConfig_Content_ConferenceMeta = {
  __typename: 'PolyOSConfig_content_conferenceMeta';
  autoAdjustBandwidth: Maybe<PropertyMeta>;
  qualityPreference: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Content_Miracast = {
  __typename: 'PolyOSConfig_content_miracast';
  enable: Maybe<Scalars['Boolean']>;
  listenchannel: Maybe<Enum_Miracast_ListenChannel>;
  operatingchannel: Maybe<Enum_Miracast_OperatingChannel>;
};

export type PolyOsConfig_Content_MiracastInput = {
  enable?: Maybe<Scalars['Boolean']>;
  listenchannel?: Maybe<Enum_Miracast_ListenChannel>;
  operatingchannel?: Maybe<Enum_Miracast_OperatingChannel>;
};

export type PolyOsConfig_Content_MiracastMeta = {
  __typename: 'PolyOSConfig_content_miracastMeta';
  enable: Maybe<PropertyMeta>;
  listenchannel: Maybe<PropertyMeta>;
  operatingchannel: Maybe<PropertyMeta>;
};

export type PolyOsConfig_ContentInput = {
  airplay?: Maybe<PolyOsConfig_Content_AirplayInput>;
  conference?: Maybe<PolyOsConfig_Content_ConferenceInput>;
  miracast?: Maybe<PolyOsConfig_Content_MiracastInput>;
};

export type PolyOsConfig_ContentMeta = {
  __typename: 'PolyOSConfig_contentMeta';
  airplay: Maybe<PolyOsConfig_Content_AirplayMeta>;
  conference: Maybe<PolyOsConfig_Content_ConferenceMeta>;
  miracast: Maybe<PolyOsConfig_Content_MiracastMeta>;
};

export type PolyOsConfig_Device = {
  __typename: 'PolyOSConfig_device';
  local: Maybe<PolyOsConfig_Device_Local>;
  net: Maybe<PolyOsConfig_Device_Net>;
  remoteControl: Maybe<PolyOsConfig_Device_RemoteControl>;
  screenSaver: Maybe<PolyOsConfig_Device_ScreenSaver>;
  serial: Maybe<PolyOsConfig_Device_Serial>;
  sleepTimeout: Maybe<Enum_SleepTimeOut>;
  syslog: Maybe<PolyOsConfig_Device_Syslog>;
  wifi: Maybe<PolyOsConfig_Device_Wifi>;
};

export type PolyOsConfig_Device_Local = {
  __typename: 'PolyOSConfig_device_local';
  autoDaylightSavings: Maybe<PolyOsConfig_Device_Local_AutoDaylightSavings>;
  contact: Maybe<PolyOsConfig_Device_Local_Contact>;
  country: Maybe<Enum_Country>;
  datetime: Maybe<PolyOsConfig_Device_Local_Datetime>;
  deviceName: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  ntpServer: Maybe<PolyOsConfig_Device_Local_NtpServer>;
  roomName: Maybe<Scalars['String']>;
  timezone: Maybe<Enum_TimeZone>;
};

export type PolyOsConfig_Device_Local_AutoDaylightSavings = {
  __typename: 'PolyOSConfig_device_local_autoDaylightSavings';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Local_AutoDaylightSavingsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Local_AutoDaylightSavingsMeta = {
  __typename: 'PolyOSConfig_device_local_autoDaylightSavingsMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Local_Contact = {
  __typename: 'PolyOSConfig_device_local_contact';
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  fax: Maybe<Scalars['String']>;
  organization: Maybe<Scalars['String']>;
  person: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  site: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  techSupport: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Local_ContactInput = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  techSupport?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Local_ContactMeta = {
  __typename: 'PolyOSConfig_device_local_contactMeta';
  city: Maybe<PropertyMeta>;
  country: Maybe<PropertyMeta>;
  email: Maybe<PropertyMeta>;
  fax: Maybe<PropertyMeta>;
  organization: Maybe<PropertyMeta>;
  person: Maybe<PropertyMeta>;
  phone: Maybe<PropertyMeta>;
  site: Maybe<PropertyMeta>;
  state: Maybe<PropertyMeta>;
  techSupport: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Local_Datetime = {
  __typename: 'PolyOSConfig_device_local_datetime';
  date: Maybe<PolyOsConfig_Device_Local_Datetime_Date>;
  time: Maybe<PolyOsConfig_Device_Local_Datetime_Time>;
};

export type PolyOsConfig_Device_Local_Datetime_Date = {
  __typename: 'PolyOSConfig_device_local_datetime_date';
  format: Maybe<Enum_DateFormat>;
};

export type PolyOsConfig_Device_Local_Datetime_DateInput = {
  format?: Maybe<Enum_DateFormat>;
};

export type PolyOsConfig_Device_Local_Datetime_DateMeta = {
  __typename: 'PolyOSConfig_device_local_datetime_dateMeta';
  format: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Local_Datetime_Time = {
  __typename: 'PolyOSConfig_device_local_datetime_time';
  TWO4HourClock: Maybe<Enum_TimeFormat>;
};

export type PolyOsConfig_Device_Local_Datetime_TimeInput = {
  TWO4HourClock?: Maybe<Enum_TimeFormat>;
};

export type PolyOsConfig_Device_Local_Datetime_TimeMeta = {
  __typename: 'PolyOSConfig_device_local_datetime_timeMeta';
  TWO4HourClock: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Local_DatetimeInput = {
  date?: Maybe<PolyOsConfig_Device_Local_Datetime_DateInput>;
  time?: Maybe<PolyOsConfig_Device_Local_Datetime_TimeInput>;
};

export type PolyOsConfig_Device_Local_DatetimeMeta = {
  __typename: 'PolyOSConfig_device_local_datetimeMeta';
  date: Maybe<PolyOsConfig_Device_Local_Datetime_DateMeta>;
  time: Maybe<PolyOsConfig_Device_Local_Datetime_TimeMeta>;
};

export type PolyOsConfig_Device_Local_NtpServer = {
  __typename: 'PolyOSConfig_device_local_ntpServer';
  address: Maybe<Array<Scalars['String']>>;
  mode: Maybe<Enum_TimeServerMode>;
};

export type PolyOsConfig_Device_Local_NtpServerInput = {
  address?: Maybe<Array<Scalars['String']>>;
  mode?: Maybe<Enum_TimeServerMode>;
};

export type PolyOsConfig_Device_Local_NtpServerMeta = {
  __typename: 'PolyOSConfig_device_local_ntpServerMeta';
  address: Maybe<Array<PropertyMeta>>;
  mode: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_LocalInput = {
  autoDaylightSavings?: Maybe<PolyOsConfig_Device_Local_AutoDaylightSavingsInput>;
  contact?: Maybe<PolyOsConfig_Device_Local_ContactInput>;
  country?: Maybe<Enum_Country>;
  datetime?: Maybe<PolyOsConfig_Device_Local_DatetimeInput>;
  deviceName?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  ntpServer?: Maybe<PolyOsConfig_Device_Local_NtpServerInput>;
  roomName?: Maybe<Scalars['String']>;
  timezone?: Maybe<Enum_TimeZone>;
};

export type PolyOsConfig_Device_LocalMeta = {
  __typename: 'PolyOSConfig_device_localMeta';
  autoDaylightSavings: Maybe<PolyOsConfig_Device_Local_AutoDaylightSavingsMeta>;
  contact: Maybe<PolyOsConfig_Device_Local_ContactMeta>;
  country: Maybe<PropertyMeta>;
  datetime: Maybe<PolyOsConfig_Device_Local_DatetimeMeta>;
  deviceName: Maybe<PropertyMeta>;
  language: Maybe<PropertyMeta>;
  ntpServer: Maybe<PolyOsConfig_Device_Local_NtpServerMeta>;
  roomName: Maybe<PropertyMeta>;
  timezone: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net = {
  __typename: 'PolyOSConfig_device_net';
  contentSave: Maybe<PolyOsConfig_Device_Net_ContentSave>;
  dns: Maybe<PolyOsConfig_Device_Net_Dns>;
  domain: Maybe<Scalars['String']>;
  dot1x: Maybe<PolyOsConfig_Device_Net_Dot1x>;
  echo: Maybe<PolyOsConfig_Device_Net_Echo>;
  ethernet: Maybe<PolyOsConfig_Device_Net_Ethernet>;
  hostName: Maybe<Scalars['String']>;
  icmp: Maybe<PolyOsConfig_Device_Net_Icmp>;
  ignoreRedirect: Maybe<Scalars['Boolean']>;
  ipAddress: Maybe<Scalars['String']>;
  ipGateway: Maybe<Scalars['String']>;
  lldp: Maybe<PolyOsConfig_Device_Net_Lldp>;
  mode: Maybe<Enum_Ipv4NicMode>;
  secondaryNetwork: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork>;
  subnetMask: Maybe<Scalars['String']>;
  unreachableTx: Maybe<PolyOsConfig_Device_Net_UnreachableTx>;
  vlan: Maybe<PolyOsConfig_Device_Net_Vlan>;
  vlanid: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Device_Net_ContentSave = {
  __typename: 'PolyOSConfig_device_net_contentSave';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_ContentSaveInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_ContentSaveMeta = {
  __typename: 'PolyOSConfig_device_net_contentSaveMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_Dns = {
  __typename: 'PolyOSConfig_device_net_dns';
  server: Maybe<Array<Scalars['String']>>;
};

export type PolyOsConfig_Device_Net_DnsInput = {
  server?: Maybe<Array<Scalars['String']>>;
};

export type PolyOsConfig_Device_Net_DnsMeta = {
  __typename: 'PolyOSConfig_device_net_dnsMeta';
  server: Maybe<Array<PropertyMeta>>;
};

export type PolyOsConfig_Device_Net_Dot1x = {
  __typename: 'PolyOSConfig_device_net_dot1x';
  enable: Maybe<Scalars['Boolean']>;
  identity: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Net_Dot1xInput = {
  enable?: Maybe<Scalars['Boolean']>;
  identity?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Net_Dot1xMeta = {
  __typename: 'PolyOSConfig_device_net_dot1xMeta';
  enable: Maybe<PropertyMeta>;
  identity: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_Echo = {
  __typename: 'PolyOSConfig_device_net_echo';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_EchoInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_EchoMeta = {
  __typename: 'PolyOSConfig_device_net_echoMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_Ethernet = {
  __typename: 'PolyOSConfig_device_net_ethernet';
  autoNegotiation: Maybe<Scalars['Boolean']>;
  duplexMode: Maybe<Enum_EthernetDuplexMode>;
  portSpeed: Maybe<Enum_EthernetPortSpeed>;
};

export type PolyOsConfig_Device_Net_EthernetInput = {
  autoNegotiation?: Maybe<Scalars['Boolean']>;
  duplexMode?: Maybe<Enum_EthernetDuplexMode>;
  portSpeed?: Maybe<Enum_EthernetPortSpeed>;
};

export type PolyOsConfig_Device_Net_EthernetMeta = {
  __typename: 'PolyOSConfig_device_net_ethernetMeta';
  autoNegotiation: Maybe<PropertyMeta>;
  duplexMode: Maybe<PropertyMeta>;
  portSpeed: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_Icmp = {
  __typename: 'PolyOSConfig_device_net_icmp';
  txRateLimit: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Device_Net_IcmpInput = {
  txRateLimit?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Device_Net_IcmpMeta = {
  __typename: 'PolyOSConfig_device_net_icmpMeta';
  txRateLimit: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_Lldp = {
  __typename: 'PolyOSConfig_device_net_lldp';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_LldpInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_LldpMeta = {
  __typename: 'PolyOSConfig_device_net_lldpMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork';
  contentSave: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_ContentSave>;
  dns: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Dns>;
  ipAddress: Maybe<Scalars['String']>;
  ipGateway: Maybe<Scalars['String']>;
  mode: Maybe<Enum_Ipv4NicMode>;
  subnetMask: Maybe<Scalars['String']>;
  type: Maybe<Enum_SecondaryNetworkType>;
  wifi: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_ContentSave = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_contentSave';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_ContentSaveInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_ContentSaveMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_contentSaveMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Dns = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_dns';
  server: Maybe<Array<Scalars['String']>>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_DnsInput = {
  server?: Maybe<Array<Scalars['String']>>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_DnsMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_dnsMeta';
  server: Maybe<Array<PropertyMeta>>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi';
  dot1xEAP: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Dot1xEap>;
  enableWebservice: Maybe<Scalars['Boolean']>;
  securityType: Maybe<Enum_WirelessSecurity>;
  ssid: Maybe<Scalars['String']>;
  WEP: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Wep>;
  WPA: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Wpa>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Dot1xEap = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi_dot1xEAP';
  identity: Maybe<Scalars['String']>;
  method: Maybe<Enum_8021XeapAuthenticationMethod>;
  password: Maybe<Scalars['String']>;
  phase2Auth: Maybe<Enum_8021XeapPhaseTwo>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Dot1xEapInput = {
  identity?: Maybe<Scalars['String']>;
  method?: Maybe<Enum_8021XeapAuthenticationMethod>;
  password?: Maybe<Scalars['String']>;
  phase2Auth?: Maybe<Enum_8021XeapPhaseTwo>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Dot1xEapMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi_dot1xEAPMeta';
  identity: Maybe<PropertyMeta>;
  method: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  phase2Auth: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Wep = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi_WEP';
  key: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WepInput = {
  key?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WepMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi_WEPMeta';
  key: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Wpa = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi_WPA';
  password: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WpaInput = {
  password?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WpaMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifi_WPAMeta';
  password: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_WifiInput = {
  dot1xEAP?: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Dot1xEapInput>;
  enableWebservice?: Maybe<Scalars['Boolean']>;
  securityType?: Maybe<Enum_WirelessSecurity>;
  ssid?: Maybe<Scalars['String']>;
  WEP?: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WepInput>;
  WPA?: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WpaInput>;
};

export type PolyOsConfig_Device_Net_SecondaryNetwork_WifiMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetwork_wifiMeta';
  dot1xEAP: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_Dot1xEapMeta>;
  enableWebservice: Maybe<PropertyMeta>;
  securityType: Maybe<PropertyMeta>;
  ssid: Maybe<PropertyMeta>;
  WEP: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WepMeta>;
  WPA: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_Wifi_WpaMeta>;
};

export type PolyOsConfig_Device_Net_SecondaryNetworkInput = {
  contentSave?: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_ContentSaveInput>;
  dns?: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_DnsInput>;
  ipAddress?: Maybe<Scalars['String']>;
  ipGateway?: Maybe<Scalars['String']>;
  mode?: Maybe<Enum_Ipv4NicMode>;
  subnetMask?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_SecondaryNetworkType>;
  wifi?: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_WifiInput>;
};

export type PolyOsConfig_Device_Net_SecondaryNetworkMeta = {
  __typename: 'PolyOSConfig_device_net_secondaryNetworkMeta';
  contentSave: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_ContentSaveMeta>;
  dns: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_DnsMeta>;
  ipAddress: Maybe<PropertyMeta>;
  ipGateway: Maybe<PropertyMeta>;
  mode: Maybe<PropertyMeta>;
  subnetMask: Maybe<PropertyMeta>;
  type: Maybe<PropertyMeta>;
  wifi: Maybe<PolyOsConfig_Device_Net_SecondaryNetwork_WifiMeta>;
};

export type PolyOsConfig_Device_Net_UnreachableTx = {
  __typename: 'PolyOSConfig_device_net_unreachableTx';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_UnreachableTxInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_Net_UnreachableTxMeta = {
  __typename: 'PolyOSConfig_device_net_unreachableTxMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Net_Vlan = {
  __typename: 'PolyOSConfig_device_net_vlan';
  audioPriority: Maybe<Enum_Vlan_Priority>;
  controlPriority: Maybe<Enum_Vlan_Priority>;
  enable: Maybe<Scalars['Boolean']>;
  videoPriority: Maybe<Enum_Vlan_Priority>;
};

export type PolyOsConfig_Device_Net_VlanInput = {
  audioPriority?: Maybe<Enum_Vlan_Priority>;
  controlPriority?: Maybe<Enum_Vlan_Priority>;
  enable?: Maybe<Scalars['Boolean']>;
  videoPriority?: Maybe<Enum_Vlan_Priority>;
};

export type PolyOsConfig_Device_Net_VlanMeta = {
  __typename: 'PolyOSConfig_device_net_vlanMeta';
  audioPriority: Maybe<PropertyMeta>;
  controlPriority: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  videoPriority: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_NetInput = {
  contentSave?: Maybe<PolyOsConfig_Device_Net_ContentSaveInput>;
  dns?: Maybe<PolyOsConfig_Device_Net_DnsInput>;
  domain?: Maybe<Scalars['String']>;
  dot1x?: Maybe<PolyOsConfig_Device_Net_Dot1xInput>;
  echo?: Maybe<PolyOsConfig_Device_Net_EchoInput>;
  ethernet?: Maybe<PolyOsConfig_Device_Net_EthernetInput>;
  hostName?: Maybe<Scalars['String']>;
  icmp?: Maybe<PolyOsConfig_Device_Net_IcmpInput>;
  ignoreRedirect?: Maybe<Scalars['Boolean']>;
  ipAddress?: Maybe<Scalars['String']>;
  ipGateway?: Maybe<Scalars['String']>;
  lldp?: Maybe<PolyOsConfig_Device_Net_LldpInput>;
  mode?: Maybe<Enum_Ipv4NicMode>;
  secondaryNetwork?: Maybe<PolyOsConfig_Device_Net_SecondaryNetworkInput>;
  subnetMask?: Maybe<Scalars['String']>;
  unreachableTx?: Maybe<PolyOsConfig_Device_Net_UnreachableTxInput>;
  vlan?: Maybe<PolyOsConfig_Device_Net_VlanInput>;
  vlanid?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Device_NetMeta = {
  __typename: 'PolyOSConfig_device_netMeta';
  contentSave: Maybe<PolyOsConfig_Device_Net_ContentSaveMeta>;
  dns: Maybe<PolyOsConfig_Device_Net_DnsMeta>;
  domain: Maybe<PropertyMeta>;
  dot1x: Maybe<PolyOsConfig_Device_Net_Dot1xMeta>;
  echo: Maybe<PolyOsConfig_Device_Net_EchoMeta>;
  ethernet: Maybe<PolyOsConfig_Device_Net_EthernetMeta>;
  hostName: Maybe<PropertyMeta>;
  icmp: Maybe<PolyOsConfig_Device_Net_IcmpMeta>;
  ignoreRedirect: Maybe<PropertyMeta>;
  ipAddress: Maybe<PropertyMeta>;
  ipGateway: Maybe<PropertyMeta>;
  lldp: Maybe<PolyOsConfig_Device_Net_LldpMeta>;
  mode: Maybe<PropertyMeta>;
  secondaryNetwork: Maybe<PolyOsConfig_Device_Net_SecondaryNetworkMeta>;
  subnetMask: Maybe<PropertyMeta>;
  unreachableTx: Maybe<PolyOsConfig_Device_Net_UnreachableTxMeta>;
  vlan: Maybe<PolyOsConfig_Device_Net_VlanMeta>;
  vlanid: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_RemoteControl = {
  __typename: 'PolyOSConfig_device_remoteControl';
  audioConfirm: Maybe<Scalars['Boolean']>;
  longPressHangup: Maybe<Enum_HangUpKeyLongPressFunc>;
  numKeypadInCall: Maybe<Enum_NumericKeypadFunction>;
  poundButtonFunction: Maybe<Enum_PoundButtonFunction>;
  starButtonFunction: Maybe<Enum_StarButtonFunction>;
};

export type PolyOsConfig_Device_RemoteControlInput = {
  audioConfirm?: Maybe<Scalars['Boolean']>;
  longPressHangup?: Maybe<Enum_HangUpKeyLongPressFunc>;
  numKeypadInCall?: Maybe<Enum_NumericKeypadFunction>;
  poundButtonFunction?: Maybe<Enum_PoundButtonFunction>;
  starButtonFunction?: Maybe<Enum_StarButtonFunction>;
};

export type PolyOsConfig_Device_RemoteControlMeta = {
  __typename: 'PolyOSConfig_device_remoteControlMeta';
  audioConfirm: Maybe<PropertyMeta>;
  longPressHangup: Maybe<PropertyMeta>;
  numKeypadInCall: Maybe<PropertyMeta>;
  poundButtonFunction: Maybe<PropertyMeta>;
  starButtonFunction: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_ScreenSaver = {
  __typename: 'PolyOSConfig_device_screenSaver';
  mode: Maybe<Enum_ScreenSaverMode>;
};

export type PolyOsConfig_Device_ScreenSaverInput = {
  mode?: Maybe<Enum_ScreenSaverMode>;
};

export type PolyOsConfig_Device_ScreenSaverMeta = {
  __typename: 'PolyOSConfig_device_screenSaverMeta';
  mode: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Serial = {
  __typename: 'PolyOSConfig_device_serial';
  baud: Maybe<Enum_SerialBaud>;
  flowControl: Maybe<Enum_SerialFlowControl>;
  mode: Maybe<Enum_SerialMode>;
  parity: Maybe<Enum_SerialParity>;
  stopBits: Maybe<Enum_SerialStopBits>;
};

export type PolyOsConfig_Device_SerialInput = {
  baud?: Maybe<Enum_SerialBaud>;
  flowControl?: Maybe<Enum_SerialFlowControl>;
  mode?: Maybe<Enum_SerialMode>;
  parity?: Maybe<Enum_SerialParity>;
  stopBits?: Maybe<Enum_SerialStopBits>;
};

export type PolyOsConfig_Device_SerialMeta = {
  __typename: 'PolyOSConfig_device_serialMeta';
  baud: Maybe<PropertyMeta>;
  flowControl: Maybe<PropertyMeta>;
  mode: Maybe<PropertyMeta>;
  parity: Maybe<PropertyMeta>;
  stopBits: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Syslog = {
  __typename: 'PolyOSConfig_device_syslog';
  autoTransfer: Maybe<PolyOsConfig_Device_Syslog_AutoTransfer>;
  enable: Maybe<Scalars['Boolean']>;
  level: Maybe<Enum_LogLevel>;
  serverName: Maybe<Scalars['String']>;
  transport: Maybe<Enum_ServerProtocol>;
};

export type PolyOsConfig_Device_Syslog_AutoTransfer = {
  __typename: 'PolyOSConfig_device_syslog_autoTransfer';
  customFolderName: Maybe<Scalars['String']>;
  folderNameOption: Maybe<Enum_LogSpacemonitoringFoldernameOption>;
  frequency: Maybe<Enum_SpaceMonitoringTransferFrequency>;
  threshold: Maybe<Enum_LogSpacemonitoringThreshold>;
};

export type PolyOsConfig_Device_Syslog_AutoTransferInput = {
  customFolderName?: Maybe<Scalars['String']>;
  folderNameOption?: Maybe<Enum_LogSpacemonitoringFoldernameOption>;
  frequency?: Maybe<Enum_SpaceMonitoringTransferFrequency>;
  threshold?: Maybe<Enum_LogSpacemonitoringThreshold>;
};

export type PolyOsConfig_Device_Syslog_AutoTransferMeta = {
  __typename: 'PolyOSConfig_device_syslog_autoTransferMeta';
  customFolderName: Maybe<PropertyMeta>;
  folderNameOption: Maybe<PropertyMeta>;
  frequency: Maybe<PropertyMeta>;
  threshold: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_SyslogInput = {
  autoTransfer?: Maybe<PolyOsConfig_Device_Syslog_AutoTransferInput>;
  enable?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Enum_LogLevel>;
  serverName?: Maybe<Scalars['String']>;
  transport?: Maybe<Enum_ServerProtocol>;
};

export type PolyOsConfig_Device_SyslogMeta = {
  __typename: 'PolyOSConfig_device_syslogMeta';
  autoTransfer: Maybe<PolyOsConfig_Device_Syslog_AutoTransferMeta>;
  enable: Maybe<PropertyMeta>;
  level: Maybe<PropertyMeta>;
  serverName: Maybe<PropertyMeta>;
  transport: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Device_Wifi = {
  __typename: 'PolyOSConfig_device_wifi';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_WifiInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Device_WifiMeta = {
  __typename: 'PolyOSConfig_device_wifiMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_DeviceInput = {
  local?: Maybe<PolyOsConfig_Device_LocalInput>;
  net?: Maybe<PolyOsConfig_Device_NetInput>;
  remoteControl?: Maybe<PolyOsConfig_Device_RemoteControlInput>;
  screenSaver?: Maybe<PolyOsConfig_Device_ScreenSaverInput>;
  serial?: Maybe<PolyOsConfig_Device_SerialInput>;
  sleepTimeout?: Maybe<Enum_SleepTimeOut>;
  syslog?: Maybe<PolyOsConfig_Device_SyslogInput>;
  wifi?: Maybe<PolyOsConfig_Device_WifiInput>;
};

export type PolyOsConfig_DeviceMeta = {
  __typename: 'PolyOSConfig_deviceMeta';
  local: Maybe<PolyOsConfig_Device_LocalMeta>;
  net: Maybe<PolyOsConfig_Device_NetMeta>;
  remoteControl: Maybe<PolyOsConfig_Device_RemoteControlMeta>;
  screenSaver: Maybe<PolyOsConfig_Device_ScreenSaverMeta>;
  serial: Maybe<PolyOsConfig_Device_SerialMeta>;
  sleepTimeout: Maybe<PropertyMeta>;
  syslog: Maybe<PolyOsConfig_Device_SyslogMeta>;
  wifi: Maybe<PolyOsConfig_Device_WifiMeta>;
};

export type PolyOsConfig_Dir = {
  __typename: 'PolyOSConfig_dir';
  gds: Maybe<PolyOsConfig_Dir_Gds>;
  ldap: Maybe<PolyOsConfig_Dir_Ldap>;
  serverType: Maybe<Enum_DirectoryServerType>;
};

export type PolyOsConfig_Dir_Gds = {
  __typename: 'PolyOSConfig_dir_gds';
  auth: Maybe<PolyOsConfig_Dir_Gds_Auth>;
  server: Maybe<PolyOsConfig_Dir_Gds_Server>;
};

export type PolyOsConfig_Dir_Gds_Auth = {
  __typename: 'PolyOSConfig_dir_gds_auth';
  password: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Dir_Gds_AuthInput = {
  password?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Dir_Gds_AuthMeta = {
  __typename: 'PolyOSConfig_dir_gds_authMeta';
  password: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Dir_Gds_Server = {
  __typename: 'PolyOSConfig_dir_gds_server';
  address: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Dir_Gds_ServerInput = {
  address?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Dir_Gds_ServerMeta = {
  __typename: 'PolyOSConfig_dir_gds_serverMeta';
  address: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Dir_GdsInput = {
  auth?: Maybe<PolyOsConfig_Dir_Gds_AuthInput>;
  server?: Maybe<PolyOsConfig_Dir_Gds_ServerInput>;
};

export type PolyOsConfig_Dir_GdsMeta = {
  __typename: 'PolyOSConfig_dir_gdsMeta';
  auth: Maybe<PolyOsConfig_Dir_Gds_AuthMeta>;
  server: Maybe<PolyOsConfig_Dir_Gds_ServerMeta>;
};

export type PolyOsConfig_Dir_Ldap = {
  __typename: 'PolyOSConfig_dir_ldap';
  auth: Maybe<PolyOsConfig_Dir_Ldap_Auth>;
  authType: Maybe<Enum_AuthType>;
  baseDN: Maybe<Scalars['String']>;
  bindDN: Maybe<Scalars['String']>;
  defaultGroupDN: Maybe<Scalars['String']>;
  server: Maybe<PolyOsConfig_Dir_Ldap_Server>;
  useSSL: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Dir_Ldap_Auth = {
  __typename: 'PolyOSConfig_dir_ldap_auth';
  domain: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  useLoginCredentials: Maybe<Scalars['Boolean']>;
  userId: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Dir_Ldap_AuthInput = {
  domain?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  useLoginCredentials?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Dir_Ldap_AuthMeta = {
  __typename: 'PolyOSConfig_dir_ldap_authMeta';
  domain: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  useLoginCredentials: Maybe<PropertyMeta>;
  userId: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Dir_Ldap_Server = {
  __typename: 'PolyOSConfig_dir_ldap_server';
  address: Maybe<Scalars['String']>;
  port: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Dir_Ldap_ServerInput = {
  address?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Dir_Ldap_ServerMeta = {
  __typename: 'PolyOSConfig_dir_ldap_serverMeta';
  address: Maybe<PropertyMeta>;
  port: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Dir_LdapInput = {
  auth?: Maybe<PolyOsConfig_Dir_Ldap_AuthInput>;
  authType?: Maybe<Enum_AuthType>;
  baseDN?: Maybe<Scalars['String']>;
  bindDN?: Maybe<Scalars['String']>;
  defaultGroupDN?: Maybe<Scalars['String']>;
  server?: Maybe<PolyOsConfig_Dir_Ldap_ServerInput>;
  useSSL?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Dir_LdapMeta = {
  __typename: 'PolyOSConfig_dir_ldapMeta';
  auth: Maybe<PolyOsConfig_Dir_Ldap_AuthMeta>;
  authType: Maybe<PropertyMeta>;
  baseDN: Maybe<PropertyMeta>;
  bindDN: Maybe<PropertyMeta>;
  defaultGroupDN: Maybe<PropertyMeta>;
  server: Maybe<PolyOsConfig_Dir_Ldap_ServerMeta>;
  useSSL: Maybe<PropertyMeta>;
};

export type PolyOsConfig_DirInput = {
  gds?: Maybe<PolyOsConfig_Dir_GdsInput>;
  ldap?: Maybe<PolyOsConfig_Dir_LdapInput>;
  serverType?: Maybe<Enum_DirectoryServerType>;
};

export type PolyOsConfig_DirMeta = {
  __typename: 'PolyOSConfig_dirMeta';
  gds: Maybe<PolyOsConfig_Dir_GdsMeta>;
  ldap: Maybe<PolyOsConfig_Dir_LdapMeta>;
  serverType: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Exchange = {
  __typename: 'PolyOSConfig_exchange';
  auth: Maybe<PolyOsConfig_Exchange_Auth>;
  enable: Maybe<Scalars['Boolean']>;
  meeting: Maybe<PolyOsConfig_Exchange_Meeting>;
  server: Maybe<PolyOsConfig_Exchange_Server>;
  showPrivateMeeting: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Exchange_Auth = {
  __typename: 'PolyOSConfig_exchange_auth';
  domain: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  useLoginCredentials: Maybe<Scalars['Boolean']>;
  userName: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Exchange_AuthInput = {
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  useLoginCredentials?: Maybe<Scalars['Boolean']>;
  userName?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Exchange_AuthMeta = {
  __typename: 'PolyOSConfig_exchange_authMeta';
  domain: Maybe<PropertyMeta>;
  email: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  useLoginCredentials: Maybe<PropertyMeta>;
  userName: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Exchange_Meeting = {
  __typename: 'PolyOSConfig_exchange_meeting';
  reminderInterval: Maybe<Enum_CalendarReminderTime>;
  reminderSound: Maybe<PolyOsConfig_Exchange_Meeting_ReminderSound>;
};

export type PolyOsConfig_Exchange_Meeting_ReminderSound = {
  __typename: 'PolyOSConfig_exchange_meeting_reminderSound';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Exchange_Meeting_ReminderSoundInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Exchange_Meeting_ReminderSoundMeta = {
  __typename: 'PolyOSConfig_exchange_meeting_reminderSoundMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Exchange_MeetingInput = {
  reminderInterval?: Maybe<Enum_CalendarReminderTime>;
  reminderSound?: Maybe<PolyOsConfig_Exchange_Meeting_ReminderSoundInput>;
};

export type PolyOsConfig_Exchange_MeetingMeta = {
  __typename: 'PolyOSConfig_exchange_meetingMeta';
  reminderInterval: Maybe<PropertyMeta>;
  reminderSound: Maybe<PolyOsConfig_Exchange_Meeting_ReminderSoundMeta>;
};

export type PolyOsConfig_Exchange_Server = {
  __typename: 'PolyOSConfig_exchange_server';
  url: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Exchange_ServerInput = {
  url?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Exchange_ServerMeta = {
  __typename: 'PolyOSConfig_exchange_serverMeta';
  url: Maybe<PropertyMeta>;
};

export type PolyOsConfig_ExchangeInput = {
  auth?: Maybe<PolyOsConfig_Exchange_AuthInput>;
  enable?: Maybe<Scalars['Boolean']>;
  meeting?: Maybe<PolyOsConfig_Exchange_MeetingInput>;
  server?: Maybe<PolyOsConfig_Exchange_ServerInput>;
  showPrivateMeeting?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_ExchangeMeta = {
  __typename: 'PolyOSConfig_exchangeMeta';
  auth: Maybe<PolyOsConfig_Exchange_AuthMeta>;
  enable: Maybe<PropertyMeta>;
  meeting: Maybe<PolyOsConfig_Exchange_MeetingMeta>;
  server: Maybe<PolyOsConfig_Exchange_ServerMeta>;
  showPrivateMeeting: Maybe<PropertyMeta>;
};

export type PolyOsConfig_HomeScreen = {
  __typename: 'PolyOSConfig_homeScreen';
  addressBar: Maybe<PolyOsConfig_HomeScreen_AddressBar>;
  backgroundImage: Maybe<Scalars['String']>;
  topWidgetType: Maybe<Enum_UicontrolWidget>;
};

export type PolyOsConfig_HomeScreen_AddressBar = {
  __typename: 'PolyOSConfig_homeScreen_addressBar';
  primary: Maybe<Enum_StatusBarAddress>;
  secondary: Maybe<Enum_StatusBarAddress>;
};

export type PolyOsConfig_HomeScreen_AddressBarInput = {
  primary?: Maybe<Enum_StatusBarAddress>;
  secondary?: Maybe<Enum_StatusBarAddress>;
};

export type PolyOsConfig_HomeScreen_AddressBarMeta = {
  __typename: 'PolyOSConfig_homeScreen_addressBarMeta';
  primary: Maybe<PropertyMeta>;
  secondary: Maybe<PropertyMeta>;
};

export type PolyOsConfig_HomeScreenInput = {
  addressBar?: Maybe<PolyOsConfig_HomeScreen_AddressBarInput>;
  backgroundImage?: Maybe<Scalars['String']>;
  topWidgetType?: Maybe<Enum_UicontrolWidget>;
};

export type PolyOsConfig_HomeScreenMeta = {
  __typename: 'PolyOSConfig_homeScreenMeta';
  addressBar: Maybe<PolyOsConfig_HomeScreen_AddressBarMeta>;
  backgroundImage: Maybe<PropertyMeta>;
  topWidgetType: Maybe<PropertyMeta>;
};

export type PolyOsConfig_License = {
  __typename: 'PolyOSConfig_license';
  optionKey: Maybe<Scalars['String']>;
  softupdateKey: Maybe<Scalars['String']>;
};

export type PolyOsConfig_LicenseInput = {
  optionKey?: Maybe<Scalars['String']>;
  softupdateKey?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_LicenseMeta = {
  __typename: 'PolyOSConfig_licenseMeta';
  optionKey: Maybe<PropertyMeta>;
  softupdateKey: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Log = {
  __typename: 'PolyOSConfig_log';
  feature: Maybe<PolyOsConfig_Log_Feature>;
};

export type PolyOsConfig_Log_Feature = {
  __typename: 'PolyOSConfig_log_feature';
  h323Trace: Maybe<PolyOsConfig_Log_Feature_H323Trace>;
  sipTrace: Maybe<PolyOsConfig_Log_Feature_SipTrace>;
};

export type PolyOsConfig_Log_Feature_H323Trace = {
  __typename: 'PolyOSConfig_log_feature_h323Trace';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Log_Feature_H323TraceInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Log_Feature_H323TraceMeta = {
  __typename: 'PolyOSConfig_log_feature_h323TraceMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Log_Feature_SipTrace = {
  __typename: 'PolyOSConfig_log_feature_sipTrace';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Log_Feature_SipTraceInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Log_Feature_SipTraceMeta = {
  __typename: 'PolyOSConfig_log_feature_sipTraceMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Log_FeatureInput = {
  h323Trace?: Maybe<PolyOsConfig_Log_Feature_H323TraceInput>;
  sipTrace?: Maybe<PolyOsConfig_Log_Feature_SipTraceInput>;
};

export type PolyOsConfig_Log_FeatureMeta = {
  __typename: 'PolyOSConfig_log_featureMeta';
  h323Trace: Maybe<PolyOsConfig_Log_Feature_H323TraceMeta>;
  sipTrace: Maybe<PolyOsConfig_Log_Feature_SipTraceMeta>;
};

export type PolyOsConfig_LogInput = {
  feature?: Maybe<PolyOsConfig_Log_FeatureInput>;
};

export type PolyOsConfig_LogMeta = {
  __typename: 'PolyOSConfig_logMeta';
  feature: Maybe<PolyOsConfig_Log_FeatureMeta>;
};

export type PolyOsConfig_Mr = {
  __typename: 'PolyOSConfig_mr';
  primary: Maybe<PolyOsConfig_Mr_Primary>;
};

export type PolyOsConfig_Mr_Primary = {
  __typename: 'PolyOSConfig_mr_primary';
  autoPair: Maybe<PolyOsConfig_Mr_Primary_AutoPair>;
};

export type PolyOsConfig_Mr_Primary_AutoPair = {
  __typename: 'PolyOSConfig_mr_primary_autoPair';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Mr_Primary_AutoPairInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Mr_Primary_AutoPairMeta = {
  __typename: 'PolyOSConfig_mr_primary_autoPairMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Mr_PrimaryInput = {
  autoPair?: Maybe<PolyOsConfig_Mr_Primary_AutoPairInput>;
};

export type PolyOsConfig_Mr_PrimaryMeta = {
  __typename: 'PolyOSConfig_mr_primaryMeta';
  autoPair: Maybe<PolyOsConfig_Mr_Primary_AutoPairMeta>;
};

export type PolyOsConfig_MrInput = {
  primary?: Maybe<PolyOsConfig_Mr_PrimaryInput>;
};

export type PolyOsConfig_MrMeta = {
  __typename: 'PolyOSConfig_mrMeta';
  primary: Maybe<PolyOsConfig_Mr_PrimaryMeta>;
};

export type PolyOsConfig_Net = {
  __typename: 'PolyOSConfig_net';
  firewall: Maybe<PolyOsConfig_Net_Firewall>;
  proxy: Maybe<PolyOsConfig_Net_Proxy>;
};

export type PolyOsConfig_Net_Firewall = {
  __typename: 'PolyOSConfig_net_firewall';
  fixedPorts: Maybe<PolyOsConfig_Net_Firewall_FixedPorts>;
  h460: Maybe<PolyOsConfig_Net_Firewall_H460>;
  nat: Maybe<PolyOsConfig_Net_Firewall_Nat>;
};

export type PolyOsConfig_Net_Firewall_FixedPorts = {
  __typename: 'PolyOSConfig_net_firewall_fixedPorts';
  enable: Maybe<Scalars['Boolean']>;
  tcpStart: Maybe<Scalars['Int']>;
  udpStart: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Net_Firewall_FixedPortsInput = {
  enable?: Maybe<Scalars['Boolean']>;
  tcpStart?: Maybe<Scalars['Int']>;
  udpStart?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Net_Firewall_FixedPortsMeta = {
  __typename: 'PolyOSConfig_net_firewall_fixedPortsMeta';
  enable: Maybe<PropertyMeta>;
  tcpStart: Maybe<PropertyMeta>;
  udpStart: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_Firewall_H460 = {
  __typename: 'PolyOSConfig_net_firewall_h460';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Net_Firewall_H460Input = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Net_Firewall_H460Meta = {
  __typename: 'PolyOSConfig_net_firewall_h460Meta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_Firewall_Nat = {
  __typename: 'PolyOSConfig_net_firewall_nat';
  gabAddressDisplayed: Maybe<Enum_GabAddressDisplayType>;
  h323Compatible: Maybe<Scalars['Boolean']>;
  publicAddress: Maybe<Scalars['String']>;
  useNatAddress: Maybe<Enum_NatAddressMode>;
};

export type PolyOsConfig_Net_Firewall_NatInput = {
  gabAddressDisplayed?: Maybe<Enum_GabAddressDisplayType>;
  h323Compatible?: Maybe<Scalars['Boolean']>;
  publicAddress?: Maybe<Scalars['String']>;
  useNatAddress?: Maybe<Enum_NatAddressMode>;
};

export type PolyOsConfig_Net_Firewall_NatMeta = {
  __typename: 'PolyOSConfig_net_firewall_natMeta';
  gabAddressDisplayed: Maybe<PropertyMeta>;
  h323Compatible: Maybe<PropertyMeta>;
  publicAddress: Maybe<PropertyMeta>;
  useNatAddress: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_FirewallInput = {
  fixedPorts?: Maybe<PolyOsConfig_Net_Firewall_FixedPortsInput>;
  h460?: Maybe<PolyOsConfig_Net_Firewall_H460Input>;
  nat?: Maybe<PolyOsConfig_Net_Firewall_NatInput>;
};

export type PolyOsConfig_Net_FirewallMeta = {
  __typename: 'PolyOSConfig_net_firewallMeta';
  fixedPorts: Maybe<PolyOsConfig_Net_Firewall_FixedPortsMeta>;
  h460: Maybe<PolyOsConfig_Net_Firewall_H460Meta>;
  nat: Maybe<PolyOsConfig_Net_Firewall_NatMeta>;
};

export type PolyOsConfig_Net_Proxy = {
  __typename: 'PolyOSConfig_net_proxy';
  address: Maybe<Scalars['String']>;
  autoconf: Maybe<Scalars['Boolean']>;
  pacfile: Maybe<PolyOsConfig_Net_Proxy_Pacfile>;
  port: Maybe<Scalars['Int']>;
  useSfbCredentials: Maybe<Scalars['Boolean']>;
  webproxy: Maybe<PolyOsConfig_Net_Proxy_Webproxy>;
  wpad: Maybe<PolyOsConfig_Net_Proxy_Wpad>;
};

export type PolyOsConfig_Net_Proxy_Pacfile = {
  __typename: 'PolyOSConfig_net_proxy_pacfile';
  url: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Net_Proxy_PacfileInput = {
  url?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Net_Proxy_PacfileMeta = {
  __typename: 'PolyOSConfig_net_proxy_pacfileMeta';
  url: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_Proxy_Webproxy = {
  __typename: 'PolyOSConfig_net_proxy_webproxy';
  auth: Maybe<PolyOsConfig_Net_Proxy_Webproxy_Auth>;
  blockBasicAuth: Maybe<Scalars['Boolean']>;
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Net_Proxy_Webproxy_Auth = {
  __typename: 'PolyOSConfig_net_proxy_webproxy_auth';
  password: Maybe<Scalars['String']>;
  userName: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Net_Proxy_Webproxy_AuthInput = {
  password?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Net_Proxy_Webproxy_AuthMeta = {
  __typename: 'PolyOSConfig_net_proxy_webproxy_authMeta';
  password: Maybe<PropertyMeta>;
  userName: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_Proxy_WebproxyInput = {
  auth?: Maybe<PolyOsConfig_Net_Proxy_Webproxy_AuthInput>;
  blockBasicAuth?: Maybe<Scalars['Boolean']>;
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Net_Proxy_WebproxyMeta = {
  __typename: 'PolyOSConfig_net_proxy_webproxyMeta';
  auth: Maybe<PolyOsConfig_Net_Proxy_Webproxy_AuthMeta>;
  blockBasicAuth: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_Proxy_Wpad = {
  __typename: 'PolyOSConfig_net_proxy_wpad';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Net_Proxy_WpadInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Net_Proxy_WpadMeta = {
  __typename: 'PolyOSConfig_net_proxy_wpadMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Net_ProxyInput = {
  address?: Maybe<Scalars['String']>;
  autoconf?: Maybe<Scalars['Boolean']>;
  pacfile?: Maybe<PolyOsConfig_Net_Proxy_PacfileInput>;
  port?: Maybe<Scalars['Int']>;
  useSfbCredentials?: Maybe<Scalars['Boolean']>;
  webproxy?: Maybe<PolyOsConfig_Net_Proxy_WebproxyInput>;
  wpad?: Maybe<PolyOsConfig_Net_Proxy_WpadInput>;
};

export type PolyOsConfig_Net_ProxyMeta = {
  __typename: 'PolyOSConfig_net_proxyMeta';
  address: Maybe<PropertyMeta>;
  autoconf: Maybe<PropertyMeta>;
  pacfile: Maybe<PolyOsConfig_Net_Proxy_PacfileMeta>;
  port: Maybe<PropertyMeta>;
  useSfbCredentials: Maybe<PropertyMeta>;
  webproxy: Maybe<PolyOsConfig_Net_Proxy_WebproxyMeta>;
  wpad: Maybe<PolyOsConfig_Net_Proxy_WpadMeta>;
};

export type PolyOsConfig_NetInput = {
  firewall?: Maybe<PolyOsConfig_Net_FirewallInput>;
  proxy?: Maybe<PolyOsConfig_Net_ProxyInput>;
};

export type PolyOsConfig_NetMeta = {
  __typename: 'PolyOSConfig_netMeta';
  firewall: Maybe<PolyOsConfig_Net_FirewallMeta>;
  proxy: Maybe<PolyOsConfig_Net_ProxyMeta>;
};

export type PolyOsConfig_Prov = {
  __typename: 'PolyOSConfig_prov';
  enabled: Maybe<Scalars['Boolean']>;
  heartbeat: Maybe<PolyOsConfig_Prov_Heartbeat>;
  polling: Maybe<PolyOsConfig_Prov_Polling>;
  softupdate: Maybe<PolyOsConfig_Prov_Softupdate>;
};

export type PolyOsConfig_Prov_Heartbeat = {
  __typename: 'PolyOSConfig_prov_heartbeat';
  interval: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Prov_HeartbeatInput = {
  interval?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Prov_HeartbeatMeta = {
  __typename: 'PolyOSConfig_prov_heartbeatMeta';
  interval: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Prov_Polling = {
  __typename: 'PolyOSConfig_prov_polling';
  period: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Prov_PollingInput = {
  period?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Prov_PollingMeta = {
  __typename: 'PolyOSConfig_prov_pollingMeta';
  period: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Prov_Softupdate = {
  __typename: 'PolyOSConfig_prov_softupdate';
  https: Maybe<PolyOsConfig_Prov_Softupdate_Https>;
};

export type PolyOsConfig_Prov_Softupdate_Https = {
  __typename: 'PolyOSConfig_prov_softupdate_https';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Prov_Softupdate_HttpsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Prov_Softupdate_HttpsMeta = {
  __typename: 'PolyOSConfig_prov_softupdate_httpsMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Prov_SoftupdateInput = {
  https?: Maybe<PolyOsConfig_Prov_Softupdate_HttpsInput>;
};

export type PolyOsConfig_Prov_SoftupdateMeta = {
  __typename: 'PolyOSConfig_prov_softupdateMeta';
  https: Maybe<PolyOsConfig_Prov_Softupdate_HttpsMeta>;
};

export type PolyOsConfig_ProvInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  heartbeat?: Maybe<PolyOsConfig_Prov_HeartbeatInput>;
  polling?: Maybe<PolyOsConfig_Prov_PollingInput>;
  softupdate?: Maybe<PolyOsConfig_Prov_SoftupdateInput>;
};

export type PolyOsConfig_ProvMeta = {
  __typename: 'PolyOSConfig_provMeta';
  enabled: Maybe<PropertyMeta>;
  heartbeat: Maybe<PolyOsConfig_Prov_HeartbeatMeta>;
  polling: Maybe<PolyOsConfig_Prov_PollingMeta>;
  softupdate: Maybe<PolyOsConfig_Prov_SoftupdateMeta>;
};

export type PolyOsConfig_Qos = {
  __typename: 'PolyOSConfig_qos';
  diffServ: Maybe<PolyOsConfig_Qos_DiffServ>;
  dynamicBandwidth: Maybe<PolyOsConfig_Qos_DynamicBandwidth>;
  intServ: Maybe<PolyOsConfig_Qos_IntServ>;
  LPR: Maybe<PolyOsConfig_Qos_Lpr>;
  maxRxBandwidth: Maybe<Enum_MaxBandWidth>;
  maxTxBandwidth: Maybe<Enum_MaxBandWidth>;
  mtuMode: Maybe<Enum_MtuMode>;
  mtuSize: Maybe<Enum_MtuSize>;
  rsvp: Maybe<PolyOsConfig_Qos_Rsvp>;
  tosType: Maybe<Enum_TosType>;
};

export type PolyOsConfig_Qos_DiffServ = {
  __typename: 'PolyOSConfig_qos_diffServ';
  audio: Maybe<Scalars['Int']>;
  fecc: Maybe<Scalars['Int']>;
  oam: Maybe<Scalars['Int']>;
  video: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Qos_DiffServInput = {
  audio?: Maybe<Scalars['Int']>;
  fecc?: Maybe<Scalars['Int']>;
  oam?: Maybe<Scalars['Int']>;
  video?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Qos_DiffServMeta = {
  __typename: 'PolyOSConfig_qos_diffServMeta';
  audio: Maybe<PropertyMeta>;
  fecc: Maybe<PropertyMeta>;
  oam: Maybe<PropertyMeta>;
  video: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Qos_DynamicBandwidth = {
  __typename: 'PolyOSConfig_qos_dynamicBandwidth';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Qos_DynamicBandwidthInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Qos_DynamicBandwidthMeta = {
  __typename: 'PolyOSConfig_qos_dynamicBandwidthMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Qos_IntServ = {
  __typename: 'PolyOSConfig_qos_intServ';
  audio: Maybe<Scalars['Int']>;
  fecc: Maybe<Scalars['Int']>;
  oam: Maybe<Scalars['Int']>;
  video: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Qos_IntServInput = {
  audio?: Maybe<Scalars['Int']>;
  fecc?: Maybe<Scalars['Int']>;
  oam?: Maybe<Scalars['Int']>;
  video?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Qos_IntServMeta = {
  __typename: 'PolyOSConfig_qos_intServMeta';
  audio: Maybe<PropertyMeta>;
  fecc: Maybe<PropertyMeta>;
  oam: Maybe<PropertyMeta>;
  video: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Qos_Lpr = {
  __typename: 'PolyOSConfig_qos_LPR';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Qos_LprInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Qos_LprMeta = {
  __typename: 'PolyOSConfig_qos_LPRMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Qos_Rsvp = {
  __typename: 'PolyOSConfig_qos_rsvp';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Qos_RsvpInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Qos_RsvpMeta = {
  __typename: 'PolyOSConfig_qos_rsvpMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_QosInput = {
  diffServ?: Maybe<PolyOsConfig_Qos_DiffServInput>;
  dynamicBandwidth?: Maybe<PolyOsConfig_Qos_DynamicBandwidthInput>;
  intServ?: Maybe<PolyOsConfig_Qos_IntServInput>;
  LPR?: Maybe<PolyOsConfig_Qos_LprInput>;
  maxRxBandwidth?: Maybe<Enum_MaxBandWidth>;
  maxTxBandwidth?: Maybe<Enum_MaxBandWidth>;
  mtuMode?: Maybe<Enum_MtuMode>;
  mtuSize?: Maybe<Enum_MtuSize>;
  rsvp?: Maybe<PolyOsConfig_Qos_RsvpInput>;
  tosType?: Maybe<Enum_TosType>;
};

export type PolyOsConfig_QosMeta = {
  __typename: 'PolyOSConfig_qosMeta';
  diffServ: Maybe<PolyOsConfig_Qos_DiffServMeta>;
  dynamicBandwidth: Maybe<PolyOsConfig_Qos_DynamicBandwidthMeta>;
  intServ: Maybe<PolyOsConfig_Qos_IntServMeta>;
  LPR: Maybe<PolyOsConfig_Qos_LprMeta>;
  maxRxBandwidth: Maybe<PropertyMeta>;
  maxTxBandwidth: Maybe<PropertyMeta>;
  mtuMode: Maybe<PropertyMeta>;
  mtuSize: Maybe<PropertyMeta>;
  rsvp: Maybe<PolyOsConfig_Qos_RsvpMeta>;
  tosType: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec = {
  __typename: 'PolyOSConfig_sec';
  access: Maybe<PolyOsConfig_Sec_Access>;
  auth: Maybe<PolyOsConfig_Sec_Auth>;
  nids: Maybe<PolyOsConfig_Sec_Nids>;
  serialPort: Maybe<PolyOsConfig_Sec_SerialPort>;
  ssh: Maybe<PolyOsConfig_Sec_Ssh>;
  telnet: Maybe<PolyOsConfig_Sec_Telnet>;
  TLS: Maybe<PolyOsConfig_Sec_Tls>;
  usb: Maybe<PolyOsConfig_Sec_Usb>;
  web: Maybe<PolyOsConfig_Sec_Web>;
};

export type PolyOsConfig_Sec_Access = {
  __typename: 'PolyOSConfig_sec_access';
  maxSessions: Maybe<Enum_MaxSessions>;
  room: Maybe<PolyOsConfig_Sec_Access_Room>;
};

export type PolyOsConfig_Sec_Access_Room = {
  __typename: 'PolyOSConfig_sec_access_room';
  accessSettings: Maybe<PolyOsConfig_Sec_Access_Room_AccessSettings>;
  secCode: Maybe<PolyOsConfig_Sec_Access_Room_SecCode>;
};

export type PolyOsConfig_Sec_Access_Room_AccessSettings = {
  __typename: 'PolyOSConfig_sec_access_room_accessSettings';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Access_Room_AccessSettingsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Access_Room_AccessSettingsMeta = {
  __typename: 'PolyOSConfig_sec_access_room_accessSettingsMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Access_Room_SecCode = {
  __typename: 'PolyOSConfig_sec_access_room_secCode';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Access_Room_SecCodeInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Access_Room_SecCodeMeta = {
  __typename: 'PolyOSConfig_sec_access_room_secCodeMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Access_RoomInput = {
  accessSettings?: Maybe<PolyOsConfig_Sec_Access_Room_AccessSettingsInput>;
  secCode?: Maybe<PolyOsConfig_Sec_Access_Room_SecCodeInput>;
};

export type PolyOsConfig_Sec_Access_RoomMeta = {
  __typename: 'PolyOSConfig_sec_access_roomMeta';
  accessSettings: Maybe<PolyOsConfig_Sec_Access_Room_AccessSettingsMeta>;
  secCode: Maybe<PolyOsConfig_Sec_Access_Room_SecCodeMeta>;
};

export type PolyOsConfig_Sec_AccessInput = {
  maxSessions?: Maybe<Enum_MaxSessions>;
  room?: Maybe<PolyOsConfig_Sec_Access_RoomInput>;
};

export type PolyOsConfig_Sec_AccessMeta = {
  __typename: 'PolyOSConfig_sec_accessMeta';
  maxSessions: Maybe<PropertyMeta>;
  room: Maybe<PolyOsConfig_Sec_Access_RoomMeta>;
};

export type PolyOsConfig_Sec_Auth = {
  __typename: 'PolyOSConfig_sec_auth';
  accountLockout: Maybe<PolyOsConfig_Sec_Auth_AccountLockout>;
  admin: Maybe<PolyOsConfig_Sec_Auth_Admin>;
  external: Maybe<PolyOsConfig_Sec_Auth_External>;
  portLockout: Maybe<PolyOsConfig_Sec_Auth_PortLockout>;
  remote: Maybe<PolyOsConfig_Sec_Auth_Remote>;
  snmp: Maybe<PolyOsConfig_Sec_Auth_Snmp>;
};

export type PolyOsConfig_Sec_Auth_AccountLockout = {
  __typename: 'PolyOSConfig_sec_auth_accountLockout';
  admin: Maybe<PolyOsConfig_Sec_Auth_AccountLockout_Admin>;
};

export type PolyOsConfig_Sec_Auth_AccountLockout_Admin = {
  __typename: 'PolyOSConfig_sec_auth_accountLockout_admin';
  failedLoginWindow: Maybe<Enum_FailedLoginWindow>;
  lockoutAttempts: Maybe<Enum_LockOutAttempts>;
  lockoutTime: Maybe<Enum_LockOutTime_1_5>;
};

export type PolyOsConfig_Sec_Auth_AccountLockout_AdminInput = {
  failedLoginWindow?: Maybe<Enum_FailedLoginWindow>;
  lockoutAttempts?: Maybe<Enum_LockOutAttempts>;
  lockoutTime?: Maybe<Enum_LockOutTime_1_5>;
};

export type PolyOsConfig_Sec_Auth_AccountLockout_AdminMeta = {
  __typename: 'PolyOSConfig_sec_auth_accountLockout_adminMeta';
  failedLoginWindow: Maybe<PropertyMeta>;
  lockoutAttempts: Maybe<PropertyMeta>;
  lockoutTime: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_AccountLockoutInput = {
  admin?: Maybe<PolyOsConfig_Sec_Auth_AccountLockout_AdminInput>;
};

export type PolyOsConfig_Sec_Auth_AccountLockoutMeta = {
  __typename: 'PolyOSConfig_sec_auth_accountLockoutMeta';
  admin: Maybe<PolyOsConfig_Sec_Auth_AccountLockout_AdminMeta>;
};

export type PolyOsConfig_Sec_Auth_Admin = {
  __typename: 'PolyOSConfig_sec_auth_admin';
  id: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  room: Maybe<PolyOsConfig_Sec_Auth_Admin_Room>;
  useRoomPassword: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Auth_Admin_Room = {
  __typename: 'PolyOSConfig_sec_auth_admin_room';
  password: Maybe<PolyOsConfig_Sec_Auth_Admin_Room_Password>;
};

export type PolyOsConfig_Sec_Auth_Admin_Room_Password = {
  __typename: 'PolyOSConfig_sec_auth_admin_room_password';
  canContainIdOrReverse: Maybe<Scalars['Boolean']>;
  expirationWarning: Maybe<Enum_PasswordPolicy_1_7_C>;
  lowercaseCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  maxAge: Maybe<Enum_PasswordPolicy_30_60_90_180C>;
  maxRepeatedChars: Maybe<Enum_PasswordPolicy_1_4_C>;
  minAge: Maybe<Enum_PasswordPolicy_1_30>;
  minChangedChars: Maybe<Enum_PasswordPolicy_1_4_All_C>;
  minLength: Maybe<Enum_PasswordPolicy_1_16_32>;
  numCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  rejectPrevPassword: Maybe<Enum_PasswordPolicy_1_16C>;
  specialCharCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  uppercaseCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  value: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Sec_Auth_Admin_Room_PasswordInput = {
  canContainIdOrReverse?: Maybe<Scalars['Boolean']>;
  expirationWarning?: Maybe<Enum_PasswordPolicy_1_7_C>;
  lowercaseCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  maxAge?: Maybe<Enum_PasswordPolicy_30_60_90_180C>;
  maxRepeatedChars?: Maybe<Enum_PasswordPolicy_1_4_C>;
  minAge?: Maybe<Enum_PasswordPolicy_1_30>;
  minChangedChars?: Maybe<Enum_PasswordPolicy_1_4_All_C>;
  minLength?: Maybe<Enum_PasswordPolicy_1_16_32>;
  numCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  rejectPrevPassword?: Maybe<Enum_PasswordPolicy_1_16C>;
  specialCharCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  uppercaseCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  value?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Sec_Auth_Admin_Room_PasswordMeta = {
  __typename: 'PolyOSConfig_sec_auth_admin_room_passwordMeta';
  canContainIdOrReverse: Maybe<PropertyMeta>;
  expirationWarning: Maybe<PropertyMeta>;
  lowercaseCount: Maybe<PropertyMeta>;
  maxAge: Maybe<PropertyMeta>;
  maxRepeatedChars: Maybe<PropertyMeta>;
  minAge: Maybe<PropertyMeta>;
  minChangedChars: Maybe<PropertyMeta>;
  minLength: Maybe<PropertyMeta>;
  numCount: Maybe<PropertyMeta>;
  rejectPrevPassword: Maybe<PropertyMeta>;
  specialCharCount: Maybe<PropertyMeta>;
  uppercaseCount: Maybe<PropertyMeta>;
  value: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_Admin_RoomInput = {
  password?: Maybe<PolyOsConfig_Sec_Auth_Admin_Room_PasswordInput>;
};

export type PolyOsConfig_Sec_Auth_Admin_RoomMeta = {
  __typename: 'PolyOSConfig_sec_auth_admin_roomMeta';
  password: Maybe<PolyOsConfig_Sec_Auth_Admin_Room_PasswordMeta>;
};

export type PolyOsConfig_Sec_Auth_AdminInput = {
  id?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  room?: Maybe<PolyOsConfig_Sec_Auth_Admin_RoomInput>;
  useRoomPassword?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Auth_AdminMeta = {
  __typename: 'PolyOSConfig_sec_auth_adminMeta';
  id: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  room: Maybe<PolyOsConfig_Sec_Auth_Admin_RoomMeta>;
  useRoomPassword: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_External = {
  __typename: 'PolyOSConfig_sec_auth_external';
  AD: Maybe<PolyOsConfig_Sec_Auth_External_Ad>;
};

export type PolyOsConfig_Sec_Auth_External_Ad = {
  __typename: 'PolyOSConfig_sec_auth_external_AD';
  adminGroup: Maybe<Scalars['String']>;
  enable: Maybe<Scalars['Boolean']>;
  server: Maybe<PolyOsConfig_Sec_Auth_External_Ad_Server>;
  userGroup: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Sec_Auth_External_Ad_Server = {
  __typename: 'PolyOSConfig_sec_auth_external_AD_server';
  address: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Sec_Auth_External_Ad_ServerInput = {
  address?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Sec_Auth_External_Ad_ServerMeta = {
  __typename: 'PolyOSConfig_sec_auth_external_AD_serverMeta';
  address: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_External_AdInput = {
  adminGroup?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  server?: Maybe<PolyOsConfig_Sec_Auth_External_Ad_ServerInput>;
  userGroup?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Sec_Auth_External_AdMeta = {
  __typename: 'PolyOSConfig_sec_auth_external_ADMeta';
  adminGroup: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  server: Maybe<PolyOsConfig_Sec_Auth_External_Ad_ServerMeta>;
  userGroup: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_ExternalInput = {
  AD?: Maybe<PolyOsConfig_Sec_Auth_External_AdInput>;
};

export type PolyOsConfig_Sec_Auth_ExternalMeta = {
  __typename: 'PolyOSConfig_sec_auth_externalMeta';
  AD: Maybe<PolyOsConfig_Sec_Auth_External_AdMeta>;
};

export type PolyOsConfig_Sec_Auth_PortLockout = {
  __typename: 'PolyOSConfig_sec_auth_portLockout';
  failedLoginWindow: Maybe<Enum_FailedLoginWindow>;
  lockoutAttempts: Maybe<Enum_LockOutAttempts>;
  lockoutTime: Maybe<Enum_LockOutTime_1_480>;
  ssh: Maybe<PolyOsConfig_Sec_Auth_PortLockout_Ssh>;
};

export type PolyOsConfig_Sec_Auth_PortLockout_Ssh = {
  __typename: 'PolyOSConfig_sec_auth_portLockout_ssh';
  failedLoginWindow: Maybe<Enum_FailedLoginWindow>;
  lockoutAttempts: Maybe<Enum_LockOutAttempts>;
  lockoutTime: Maybe<Enum_LockOutTime_1_480>;
};

export type PolyOsConfig_Sec_Auth_PortLockout_SshInput = {
  failedLoginWindow?: Maybe<Enum_FailedLoginWindow>;
  lockoutAttempts?: Maybe<Enum_LockOutAttempts>;
  lockoutTime?: Maybe<Enum_LockOutTime_1_480>;
};

export type PolyOsConfig_Sec_Auth_PortLockout_SshMeta = {
  __typename: 'PolyOSConfig_sec_auth_portLockout_sshMeta';
  failedLoginWindow: Maybe<PropertyMeta>;
  lockoutAttempts: Maybe<PropertyMeta>;
  lockoutTime: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_PortLockoutInput = {
  failedLoginWindow?: Maybe<Enum_FailedLoginWindow>;
  lockoutAttempts?: Maybe<Enum_LockOutAttempts>;
  lockoutTime?: Maybe<Enum_LockOutTime_1_480>;
  ssh?: Maybe<PolyOsConfig_Sec_Auth_PortLockout_SshInput>;
};

export type PolyOsConfig_Sec_Auth_PortLockoutMeta = {
  __typename: 'PolyOSConfig_sec_auth_portLockoutMeta';
  failedLoginWindow: Maybe<PropertyMeta>;
  lockoutAttempts: Maybe<PropertyMeta>;
  lockoutTime: Maybe<PropertyMeta>;
  ssh: Maybe<PolyOsConfig_Sec_Auth_PortLockout_SshMeta>;
};

export type PolyOsConfig_Sec_Auth_Remote = {
  __typename: 'PolyOSConfig_sec_auth_remote';
  password: Maybe<PolyOsConfig_Sec_Auth_Remote_Password>;
};

export type PolyOsConfig_Sec_Auth_Remote_Password = {
  __typename: 'PolyOSConfig_sec_auth_remote_password';
  canContainIdOrReverse: Maybe<Scalars['Boolean']>;
  expirationWarning: Maybe<Enum_PasswordPolicy_1_7_C>;
  lowercaseCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  maxAge: Maybe<Enum_PasswordPolicy_30_60_90_180C>;
  maxRepeatedChars: Maybe<Enum_PasswordPolicy_1_4_C>;
  minAge: Maybe<Enum_PasswordPolicy_1_30>;
  minChangedChars: Maybe<Enum_PasswordPolicy_1_4_All_C>;
  minLength: Maybe<Enum_PasswordPolicy_1_16_32>;
  numCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  rejectPrevPassword: Maybe<Enum_PasswordPolicy_1_16C>;
  specialCharCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  uppercaseCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
};

export type PolyOsConfig_Sec_Auth_Remote_PasswordInput = {
  canContainIdOrReverse?: Maybe<Scalars['Boolean']>;
  expirationWarning?: Maybe<Enum_PasswordPolicy_1_7_C>;
  lowercaseCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  maxAge?: Maybe<Enum_PasswordPolicy_30_60_90_180C>;
  maxRepeatedChars?: Maybe<Enum_PasswordPolicy_1_4_C>;
  minAge?: Maybe<Enum_PasswordPolicy_1_30>;
  minChangedChars?: Maybe<Enum_PasswordPolicy_1_4_All_C>;
  minLength?: Maybe<Enum_PasswordPolicy_1_16_32>;
  numCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  rejectPrevPassword?: Maybe<Enum_PasswordPolicy_1_16C>;
  specialCharCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  uppercaseCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
};

export type PolyOsConfig_Sec_Auth_Remote_PasswordMeta = {
  __typename: 'PolyOSConfig_sec_auth_remote_passwordMeta';
  canContainIdOrReverse: Maybe<PropertyMeta>;
  expirationWarning: Maybe<PropertyMeta>;
  lowercaseCount: Maybe<PropertyMeta>;
  maxAge: Maybe<PropertyMeta>;
  maxRepeatedChars: Maybe<PropertyMeta>;
  minAge: Maybe<PropertyMeta>;
  minChangedChars: Maybe<PropertyMeta>;
  minLength: Maybe<PropertyMeta>;
  numCount: Maybe<PropertyMeta>;
  rejectPrevPassword: Maybe<PropertyMeta>;
  specialCharCount: Maybe<PropertyMeta>;
  uppercaseCount: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_RemoteInput = {
  password?: Maybe<PolyOsConfig_Sec_Auth_Remote_PasswordInput>;
};

export type PolyOsConfig_Sec_Auth_RemoteMeta = {
  __typename: 'PolyOSConfig_sec_auth_remoteMeta';
  password: Maybe<PolyOsConfig_Sec_Auth_Remote_PasswordMeta>;
};

export type PolyOsConfig_Sec_Auth_Snmp = {
  __typename: 'PolyOSConfig_sec_auth_snmp';
  password: Maybe<PolyOsConfig_Sec_Auth_Snmp_Password>;
};

export type PolyOsConfig_Sec_Auth_Snmp_Password = {
  __typename: 'PolyOSConfig_sec_auth_snmp_password';
  canContainIdOrReverse: Maybe<Scalars['Boolean']>;
  lowercaseCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  maxRepeatedChars: Maybe<Enum_PasswordPolicy_1_4_C>;
  minAge: Maybe<Enum_PasswordPolicy_1_30>;
  minLength: Maybe<Enum_PasswordPolicy_8_16C_32>;
  numCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  rejectPrevPassword: Maybe<Enum_PasswordPolicy_1_16C>;
  specialCharCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  uppercaseCount: Maybe<Enum_PasswordPolicy_1_2_All_C>;
};

export type PolyOsConfig_Sec_Auth_Snmp_PasswordInput = {
  canContainIdOrReverse?: Maybe<Scalars['Boolean']>;
  lowercaseCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  maxRepeatedChars?: Maybe<Enum_PasswordPolicy_1_4_C>;
  minAge?: Maybe<Enum_PasswordPolicy_1_30>;
  minLength?: Maybe<Enum_PasswordPolicy_8_16C_32>;
  numCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  rejectPrevPassword?: Maybe<Enum_PasswordPolicy_1_16C>;
  specialCharCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
  uppercaseCount?: Maybe<Enum_PasswordPolicy_1_2_All_C>;
};

export type PolyOsConfig_Sec_Auth_Snmp_PasswordMeta = {
  __typename: 'PolyOSConfig_sec_auth_snmp_passwordMeta';
  canContainIdOrReverse: Maybe<PropertyMeta>;
  lowercaseCount: Maybe<PropertyMeta>;
  maxRepeatedChars: Maybe<PropertyMeta>;
  minAge: Maybe<PropertyMeta>;
  minLength: Maybe<PropertyMeta>;
  numCount: Maybe<PropertyMeta>;
  rejectPrevPassword: Maybe<PropertyMeta>;
  specialCharCount: Maybe<PropertyMeta>;
  uppercaseCount: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Auth_SnmpInput = {
  password?: Maybe<PolyOsConfig_Sec_Auth_Snmp_PasswordInput>;
};

export type PolyOsConfig_Sec_Auth_SnmpMeta = {
  __typename: 'PolyOSConfig_sec_auth_snmpMeta';
  password: Maybe<PolyOsConfig_Sec_Auth_Snmp_PasswordMeta>;
};

export type PolyOsConfig_Sec_AuthInput = {
  accountLockout?: Maybe<PolyOsConfig_Sec_Auth_AccountLockoutInput>;
  admin?: Maybe<PolyOsConfig_Sec_Auth_AdminInput>;
  external?: Maybe<PolyOsConfig_Sec_Auth_ExternalInput>;
  portLockout?: Maybe<PolyOsConfig_Sec_Auth_PortLockoutInput>;
  remote?: Maybe<PolyOsConfig_Sec_Auth_RemoteInput>;
  snmp?: Maybe<PolyOsConfig_Sec_Auth_SnmpInput>;
};

export type PolyOsConfig_Sec_AuthMeta = {
  __typename: 'PolyOSConfig_sec_authMeta';
  accountLockout: Maybe<PolyOsConfig_Sec_Auth_AccountLockoutMeta>;
  admin: Maybe<PolyOsConfig_Sec_Auth_AdminMeta>;
  external: Maybe<PolyOsConfig_Sec_Auth_ExternalMeta>;
  portLockout: Maybe<PolyOsConfig_Sec_Auth_PortLockoutMeta>;
  remote: Maybe<PolyOsConfig_Sec_Auth_RemoteMeta>;
  snmp: Maybe<PolyOsConfig_Sec_Auth_SnmpMeta>;
};

export type PolyOsConfig_Sec_Nids = {
  __typename: 'PolyOSConfig_sec_nids';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_NidsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_NidsMeta = {
  __typename: 'PolyOSConfig_sec_nidsMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_SerialPort = {
  __typename: 'PolyOSConfig_sec_serialPort';
  login: Maybe<PolyOsConfig_Sec_SerialPort_Login>;
};

export type PolyOsConfig_Sec_SerialPort_Login = {
  __typename: 'PolyOSConfig_sec_serialPort_login';
  mode: Maybe<Enum_LoginMode>;
};

export type PolyOsConfig_Sec_SerialPort_LoginInput = {
  mode?: Maybe<Enum_LoginMode>;
};

export type PolyOsConfig_Sec_SerialPort_LoginMeta = {
  __typename: 'PolyOSConfig_sec_serialPort_loginMeta';
  mode: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_SerialPortInput = {
  login?: Maybe<PolyOsConfig_Sec_SerialPort_LoginInput>;
};

export type PolyOsConfig_Sec_SerialPortMeta = {
  __typename: 'PolyOSConfig_sec_serialPortMeta';
  login: Maybe<PolyOsConfig_Sec_SerialPort_LoginMeta>;
};

export type PolyOsConfig_Sec_Ssh = {
  __typename: 'PolyOSConfig_sec_ssh';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_SshInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_SshMeta = {
  __typename: 'PolyOSConfig_sec_sshMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Telnet = {
  __typename: 'PolyOSConfig_sec_telnet';
  apiPort: Maybe<Enum_ApiPort>;
  apiPortIdleTimeout: Maybe<PolyOsConfig_Sec_Telnet_ApiPortIdleTimeout>;
  diagPortIdleTimeout: Maybe<PolyOsConfig_Sec_Telnet_DiagPortIdleTimeout>;
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Telnet_ApiPortIdleTimeout = {
  __typename: 'PolyOSConfig_sec_telnet_apiPortIdleTimeout';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Telnet_ApiPortIdleTimeoutInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Telnet_ApiPortIdleTimeoutMeta = {
  __typename: 'PolyOSConfig_sec_telnet_apiPortIdleTimeoutMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Telnet_DiagPortIdleTimeout = {
  __typename: 'PolyOSConfig_sec_telnet_diagPortIdleTimeout';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Telnet_DiagPortIdleTimeoutInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Telnet_DiagPortIdleTimeoutMeta = {
  __typename: 'PolyOSConfig_sec_telnet_diagPortIdleTimeoutMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_TelnetInput = {
  apiPort?: Maybe<Enum_ApiPort>;
  apiPortIdleTimeout?: Maybe<PolyOsConfig_Sec_Telnet_ApiPortIdleTimeoutInput>;
  diagPortIdleTimeout?: Maybe<PolyOsConfig_Sec_Telnet_DiagPortIdleTimeoutInput>;
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_TelnetMeta = {
  __typename: 'PolyOSConfig_sec_telnetMeta';
  apiPort: Maybe<PropertyMeta>;
  apiPortIdleTimeout: Maybe<PolyOsConfig_Sec_Telnet_ApiPortIdleTimeoutMeta>;
  diagPortIdleTimeout: Maybe<PolyOsConfig_Sec_Telnet_DiagPortIdleTimeoutMeta>;
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Tls = {
  __typename: 'PolyOSConfig_sec_TLS';
  cert: Maybe<PolyOsConfig_Sec_Tls_Cert>;
  customCaCert: Maybe<Array<Scalars['String']>>;
  FIPS: Maybe<PolyOsConfig_Sec_Tls_Fips>;
  minimumVersion: Maybe<Enum_MinimumTlsVersion>;
  revocation: Maybe<PolyOsConfig_Sec_Tls_Revocation>;
};

export type PolyOsConfig_Sec_Tls_Cert = {
  __typename: 'PolyOSConfig_sec_TLS_cert';
  sslVerificationDepth: Maybe<Enum_SslVerificationDepth>;
  validatePeer: Maybe<PolyOsConfig_Sec_Tls_Cert_ValidatePeer>;
};

export type PolyOsConfig_Sec_Tls_Cert_ValidatePeer = {
  __typename: 'PolyOSConfig_sec_TLS_cert_validatePeer';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_Cert_ValidatePeerInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_Cert_ValidatePeerMeta = {
  __typename: 'PolyOSConfig_sec_TLS_cert_validatePeerMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Tls_CertInput = {
  sslVerificationDepth?: Maybe<Enum_SslVerificationDepth>;
  validatePeer?: Maybe<PolyOsConfig_Sec_Tls_Cert_ValidatePeerInput>;
};

export type PolyOsConfig_Sec_Tls_CertMeta = {
  __typename: 'PolyOSConfig_sec_TLS_certMeta';
  sslVerificationDepth: Maybe<PropertyMeta>;
  validatePeer: Maybe<PolyOsConfig_Sec_Tls_Cert_ValidatePeerMeta>;
};

export type PolyOsConfig_Sec_Tls_Fips = {
  __typename: 'PolyOSConfig_sec_TLS_FIPS';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_FipsInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_FipsMeta = {
  __typename: 'PolyOSConfig_sec_TLS_FIPSMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Tls_Revocation = {
  __typename: 'PolyOSConfig_sec_TLS_revocation';
  crl: Maybe<Array<Scalars['String']>>;
  looseRevocation: Maybe<PolyOsConfig_Sec_Tls_Revocation_LooseRevocation>;
  ocsp: Maybe<PolyOsConfig_Sec_Tls_Revocation_Ocsp>;
};

export type PolyOsConfig_Sec_Tls_Revocation_LooseRevocation = {
  __typename: 'PolyOSConfig_sec_TLS_revocation_looseRevocation';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_Revocation_LooseRevocationInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_Revocation_LooseRevocationMeta = {
  __typename: 'PolyOSConfig_sec_TLS_revocation_looseRevocationMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Tls_Revocation_Ocsp = {
  __typename: 'PolyOSConfig_sec_TLS_revocation_ocsp';
  enable: Maybe<Scalars['Boolean']>;
  responderAddress: Maybe<Scalars['String']>;
  useResponderInCert: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_Revocation_OcspInput = {
  enable?: Maybe<Scalars['Boolean']>;
  responderAddress?: Maybe<Scalars['String']>;
  useResponderInCert?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_Tls_Revocation_OcspMeta = {
  __typename: 'PolyOSConfig_sec_TLS_revocation_ocspMeta';
  enable: Maybe<PropertyMeta>;
  responderAddress: Maybe<PropertyMeta>;
  useResponderInCert: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Tls_RevocationInput = {
  crl?: Maybe<Array<Scalars['String']>>;
  looseRevocation?: Maybe<PolyOsConfig_Sec_Tls_Revocation_LooseRevocationInput>;
  ocsp?: Maybe<PolyOsConfig_Sec_Tls_Revocation_OcspInput>;
};

export type PolyOsConfig_Sec_Tls_RevocationMeta = {
  __typename: 'PolyOSConfig_sec_TLS_revocationMeta';
  crl: Maybe<Array<PropertyMeta>>;
  looseRevocation: Maybe<PolyOsConfig_Sec_Tls_Revocation_LooseRevocationMeta>;
  ocsp: Maybe<PolyOsConfig_Sec_Tls_Revocation_OcspMeta>;
};

export type PolyOsConfig_Sec_TlsInput = {
  cert?: Maybe<PolyOsConfig_Sec_Tls_CertInput>;
  customCaCert?: Maybe<Array<Scalars['String']>>;
  FIPS?: Maybe<PolyOsConfig_Sec_Tls_FipsInput>;
  minimumVersion?: Maybe<Enum_MinimumTlsVersion>;
  revocation?: Maybe<PolyOsConfig_Sec_Tls_RevocationInput>;
};

export type PolyOsConfig_Sec_TlsMeta = {
  __typename: 'PolyOSConfig_sec_TLSMeta';
  cert: Maybe<PolyOsConfig_Sec_Tls_CertMeta>;
  customCaCert: Maybe<Array<PropertyMeta>>;
  FIPS: Maybe<PolyOsConfig_Sec_Tls_FipsMeta>;
  minimumVersion: Maybe<PropertyMeta>;
  revocation: Maybe<PolyOsConfig_Sec_Tls_RevocationMeta>;
};

export type PolyOsConfig_Sec_Usb = {
  __typename: 'PolyOSConfig_sec_usb';
  disableAll: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_UsbInput = {
  disableAll?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Sec_UsbMeta = {
  __typename: 'PolyOSConfig_sec_usbMeta';
  disableAll: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Sec_Web = {
  __typename: 'PolyOSConfig_sec_web';
  enable: Maybe<Scalars['Boolean']>;
  httpsOnly: Maybe<Scalars['Boolean']>;
  idleSessionTimeout: Maybe<Enum_IdleSessionTimeOut>;
  port: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Sec_WebInput = {
  enable?: Maybe<Scalars['Boolean']>;
  httpsOnly?: Maybe<Scalars['Boolean']>;
  idleSessionTimeout?: Maybe<Enum_IdleSessionTimeOut>;
  port?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Sec_WebMeta = {
  __typename: 'PolyOSConfig_sec_webMeta';
  enable: Maybe<PropertyMeta>;
  httpsOnly: Maybe<PropertyMeta>;
  idleSessionTimeout: Maybe<PropertyMeta>;
  port: Maybe<PropertyMeta>;
};

export type PolyOsConfig_SecInput = {
  access?: Maybe<PolyOsConfig_Sec_AccessInput>;
  auth?: Maybe<PolyOsConfig_Sec_AuthInput>;
  nids?: Maybe<PolyOsConfig_Sec_NidsInput>;
  serialPort?: Maybe<PolyOsConfig_Sec_SerialPortInput>;
  ssh?: Maybe<PolyOsConfig_Sec_SshInput>;
  telnet?: Maybe<PolyOsConfig_Sec_TelnetInput>;
  TLS?: Maybe<PolyOsConfig_Sec_TlsInput>;
  usb?: Maybe<PolyOsConfig_Sec_UsbInput>;
  web?: Maybe<PolyOsConfig_Sec_WebInput>;
};

export type PolyOsConfig_SecMeta = {
  __typename: 'PolyOSConfig_secMeta';
  access: Maybe<PolyOsConfig_Sec_AccessMeta>;
  auth: Maybe<PolyOsConfig_Sec_AuthMeta>;
  nids: Maybe<PolyOsConfig_Sec_NidsMeta>;
  serialPort: Maybe<PolyOsConfig_Sec_SerialPortMeta>;
  ssh: Maybe<PolyOsConfig_Sec_SshMeta>;
  telnet: Maybe<PolyOsConfig_Sec_TelnetMeta>;
  TLS: Maybe<PolyOsConfig_Sec_TlsMeta>;
  usb: Maybe<PolyOsConfig_Sec_UsbMeta>;
  web: Maybe<PolyOsConfig_Sec_WebMeta>;
};

export type PolyOsConfig_Snmp = {
  __typename: 'PolyOSConfig_snmp';
  auth: Maybe<PolyOsConfig_Snmp_Auth>;
  community: Maybe<Scalars['String']>;
  contactName: Maybe<Scalars['String']>;
  enable: Maybe<Scalars['Boolean']>;
  engineID: Maybe<Scalars['String']>;
  listeningPort: Maybe<Scalars['Int']>;
  locationName: Maybe<Scalars['String']>;
  notification: Maybe<PolyOsConfig_Snmp_Notification>;
  privacyAlgorithm: Maybe<Enum_PrivacyAlgorithm>;
  privacyPassword: Maybe<Scalars['String']>;
  systemDesc: Maybe<Scalars['String']>;
  transport: Maybe<Enum_TransportProtocol>;
  trapTarget: Maybe<Array<PolyOsConfig_Snmp_TrapTarget>>;
  version1: Maybe<PolyOsConfig_Snmp_Version1>;
  version2: Maybe<PolyOsConfig_Snmp_Version2>;
  version3: Maybe<PolyOsConfig_Snmp_Version3>;
};

export type PolyOsConfig_Snmp_Auth = {
  __typename: 'PolyOSConfig_snmp_auth';
  algorithm: Maybe<Enum_AuthenticationAlgorithm>;
  password: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Snmp_AuthInput = {
  algorithm?: Maybe<Enum_AuthenticationAlgorithm>;
  password?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Snmp_AuthMeta = {
  __typename: 'PolyOSConfig_snmp_authMeta';
  algorithm: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  userId: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Snmp_Notification = {
  __typename: 'PolyOSConfig_snmp_notification';
  enabled: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_NotificationInput = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_NotificationMeta = {
  __typename: 'PolyOSConfig_snmp_notificationMeta';
  enabled: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Snmp_TrapTarget = {
  __typename: 'PolyOSConfig_snmp_trapTarget';
  address: Maybe<Scalars['String']>;
  enable: Maybe<Scalars['Boolean']>;
  messageType: Maybe<Enum_SnmpTrapMessageType>;
  port: Maybe<Scalars['String']>;
  protocolVersion: Maybe<Enum_SnmpProtocolVersion>;
};

export type PolyOsConfig_Snmp_TrapTargetInput = {
  address?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  messageType?: Maybe<Enum_SnmpTrapMessageType>;
  port?: Maybe<Scalars['String']>;
  protocolVersion?: Maybe<Enum_SnmpProtocolVersion>;
};

export type PolyOsConfig_Snmp_TrapTargetMeta = {
  __typename: 'PolyOSConfig_snmp_trapTargetMeta';
  address: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  messageType: Maybe<PropertyMeta>;
  port: Maybe<PropertyMeta>;
  protocolVersion: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Snmp_Version1 = {
  __typename: 'PolyOSConfig_snmp_version1';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_Version1Input = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_Version1Meta = {
  __typename: 'PolyOSConfig_snmp_version1Meta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Snmp_Version2 = {
  __typename: 'PolyOSConfig_snmp_version2';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_Version2Input = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_Version2Meta = {
  __typename: 'PolyOSConfig_snmp_version2Meta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Snmp_Version3 = {
  __typename: 'PolyOSConfig_snmp_version3';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_Version3Input = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Snmp_Version3Meta = {
  __typename: 'PolyOSConfig_snmp_version3Meta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_SnmpInput = {
  auth?: Maybe<PolyOsConfig_Snmp_AuthInput>;
  community?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  engineID?: Maybe<Scalars['String']>;
  listeningPort?: Maybe<Scalars['Int']>;
  locationName?: Maybe<Scalars['String']>;
  notification?: Maybe<PolyOsConfig_Snmp_NotificationInput>;
  privacyAlgorithm?: Maybe<Enum_PrivacyAlgorithm>;
  privacyPassword?: Maybe<Scalars['String']>;
  systemDesc?: Maybe<Scalars['String']>;
  transport?: Maybe<Enum_TransportProtocol>;
  trapTarget?: Maybe<Array<PolyOsConfig_Snmp_TrapTargetInput>>;
  version1?: Maybe<PolyOsConfig_Snmp_Version1Input>;
  version2?: Maybe<PolyOsConfig_Snmp_Version2Input>;
  version3?: Maybe<PolyOsConfig_Snmp_Version3Input>;
};

export type PolyOsConfig_SnmpMeta = {
  __typename: 'PolyOSConfig_snmpMeta';
  auth: Maybe<PolyOsConfig_Snmp_AuthMeta>;
  community: Maybe<PropertyMeta>;
  contactName: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  engineID: Maybe<PropertyMeta>;
  listeningPort: Maybe<PropertyMeta>;
  locationName: Maybe<PropertyMeta>;
  notification: Maybe<PolyOsConfig_Snmp_NotificationMeta>;
  privacyAlgorithm: Maybe<PropertyMeta>;
  privacyPassword: Maybe<PropertyMeta>;
  systemDesc: Maybe<PropertyMeta>;
  transport: Maybe<PropertyMeta>;
  trapTarget: Maybe<Array<PolyOsConfig_Snmp_TrapTargetMeta>>;
  version1: Maybe<PolyOsConfig_Snmp_Version1Meta>;
  version2: Maybe<PolyOsConfig_Snmp_Version2Meta>;
  version3: Maybe<PolyOsConfig_Snmp_Version3Meta>;
};

export type PolyOsConfig_Upgrade = {
  __typename: 'PolyOSConfig_upgrade';
  auto: Maybe<PolyOsConfig_Upgrade_Auto>;
};

export type PolyOsConfig_Upgrade_Auto = {
  __typename: 'PolyOSConfig_upgrade_auto';
  backwardCompatible: Maybe<Scalars['Boolean']>;
  enable: Maybe<Scalars['Boolean']>;
  polling: Maybe<PolyOsConfig_Upgrade_Auto_Polling>;
  server: Maybe<PolyOsConfig_Upgrade_Auto_Server>;
  timeFrame: Maybe<PolyOsConfig_Upgrade_Auto_TimeFrame>;
};

export type PolyOsConfig_Upgrade_Auto_Polling = {
  __typename: 'PolyOSConfig_upgrade_auto_polling';
  interval: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Upgrade_Auto_PollingInput = {
  interval?: Maybe<Scalars['Int']>;
};

export type PolyOsConfig_Upgrade_Auto_PollingMeta = {
  __typename: 'PolyOSConfig_upgrade_auto_pollingMeta';
  interval: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Upgrade_Auto_Server = {
  __typename: 'PolyOSConfig_upgrade_auto_server';
  address: Maybe<Scalars['String']>;
  type: Maybe<Enum_UpdateServerType>;
};

export type PolyOsConfig_Upgrade_Auto_ServerInput = {
  address?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_UpdateServerType>;
};

export type PolyOsConfig_Upgrade_Auto_ServerMeta = {
  __typename: 'PolyOSConfig_upgrade_auto_serverMeta';
  address: Maybe<PropertyMeta>;
  type: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Upgrade_Auto_TimeFrame = {
  __typename: 'PolyOSConfig_upgrade_auto_timeFrame';
  enable: Maybe<Scalars['Boolean']>;
  startTime: Maybe<Scalars['String']>;
  stopTime: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Upgrade_Auto_TimeFrameInput = {
  enable?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['String']>;
  stopTime?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Upgrade_Auto_TimeFrameMeta = {
  __typename: 'PolyOSConfig_upgrade_auto_timeFrameMeta';
  enable: Maybe<PropertyMeta>;
  startTime: Maybe<PropertyMeta>;
  stopTime: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Upgrade_AutoInput = {
  backwardCompatible?: Maybe<Scalars['Boolean']>;
  enable?: Maybe<Scalars['Boolean']>;
  polling?: Maybe<PolyOsConfig_Upgrade_Auto_PollingInput>;
  server?: Maybe<PolyOsConfig_Upgrade_Auto_ServerInput>;
  timeFrame?: Maybe<PolyOsConfig_Upgrade_Auto_TimeFrameInput>;
};

export type PolyOsConfig_Upgrade_AutoMeta = {
  __typename: 'PolyOSConfig_upgrade_autoMeta';
  backwardCompatible: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  polling: Maybe<PolyOsConfig_Upgrade_Auto_PollingMeta>;
  server: Maybe<PolyOsConfig_Upgrade_Auto_ServerMeta>;
  timeFrame: Maybe<PolyOsConfig_Upgrade_Auto_TimeFrameMeta>;
};

export type PolyOsConfig_UpgradeInput = {
  auto?: Maybe<PolyOsConfig_Upgrade_AutoInput>;
};

export type PolyOsConfig_UpgradeMeta = {
  __typename: 'PolyOSConfig_upgradeMeta';
  auto: Maybe<PolyOsConfig_Upgrade_AutoMeta>;
};

export type PolyOsConfig_Video = {
  __typename: 'PolyOSConfig_video';
  camera: Maybe<PolyOsConfig_Video_Camera>;
  content: Maybe<PolyOsConfig_Video_Content>;
  layout: Maybe<PolyOsConfig_Video_Layout>;
  monitor: Maybe<PolyOsConfig_Video_Monitor>;
};

export type PolyOsConfig_Video_Camera = {
  __typename: 'PolyOSConfig_video_camera';
  autoUpdate: Maybe<PolyOsConfig_Video_Camera_AutoUpdate>;
  backlightCompensation: Maybe<Enum_Boolean>;
  brightness: Maybe<Scalars['Int']>;
  farControlNearCamera: Maybe<Scalars['Boolean']>;
  groupViewSize: Maybe<Enum_CameraGroupViewSize>;
  name: Maybe<Scalars['String']>;
  orientation: Maybe<Enum_CameraOrientation>;
  powerFrequency: Maybe<Enum_PowerFrequency>;
  preset: Maybe<PolyOsConfig_Video_Camera_Preset>;
  roomViewPIP: Maybe<Enum_Boolean>;
  saturation: Maybe<Scalars['Int']>;
  sharpness: Maybe<Scalars['Int']>;
  skinEnhancement: Maybe<Enum_Boolean>;
  sleepMode: Maybe<Enum_CameraSleepMode>;
  trackingMode: Maybe<Enum_CameraTrackingMode>;
  trackingSpeed: Maybe<Enum_CameraTrackingSpeed>;
  value: Maybe<Array<PolyOsConfig_Video_Camera_Value>>;
  videoQuality: Maybe<Enum_CameraVideoQuality>;
  whiteBalanceMode: Maybe<Enum_CameraWhiteBalanceMode>;
  wideDynamicRange: Maybe<Enum_Boolean>;
};

export type PolyOsConfig_Video_Camera_AutoUpdate = {
  __typename: 'PolyOSConfig_video_camera_autoUpdate';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_Camera_AutoUpdateInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_Camera_AutoUpdateMeta = {
  __typename: 'PolyOSConfig_video_camera_autoUpdateMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Camera_Preset = {
  __typename: 'PolyOSConfig_video_camera_preset';
  snapshot: Maybe<PolyOsConfig_Video_Camera_Preset_Snapshot>;
};

export type PolyOsConfig_Video_Camera_Preset_Snapshot = {
  __typename: 'PolyOSConfig_video_camera_preset_snapshot';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_Camera_Preset_SnapshotInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_Camera_Preset_SnapshotMeta = {
  __typename: 'PolyOSConfig_video_camera_preset_snapshotMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Camera_PresetInput = {
  snapshot?: Maybe<PolyOsConfig_Video_Camera_Preset_SnapshotInput>;
};

export type PolyOsConfig_Video_Camera_PresetMeta = {
  __typename: 'PolyOSConfig_video_camera_presetMeta';
  snapshot: Maybe<PolyOsConfig_Video_Camera_Preset_SnapshotMeta>;
};

export type PolyOsConfig_Video_Camera_Value = {
  __typename: 'PolyOSConfig_video_camera_value';
  backlightCompensation: Maybe<Enum_Boolean>;
  brightness: Maybe<Scalars['Int']>;
  groupViewSize: Maybe<Enum_CameraGroupViewSize>;
  name: Maybe<Scalars['String']>;
  orientation: Maybe<Enum_CameraOrientation>;
  roomViewPIP: Maybe<Enum_Boolean>;
  saturation: Maybe<Scalars['Int']>;
  sharpness: Maybe<Scalars['Int']>;
  skinEnhancement: Maybe<Enum_Boolean>;
  trackingMode: Maybe<Enum_CameraTrackingMode>;
  trackingSpeed: Maybe<Enum_CameraTrackingSpeed>;
  type: Maybe<Enum_CameraTypes>;
  videoQuality: Maybe<Enum_CameraVideoQuality>;
  whiteBalanceMode: Maybe<Enum_CameraWhiteBalanceMode>;
  wideDynamicRange: Maybe<Enum_Boolean>;
};

export type PolyOsConfig_Video_Camera_ValueInput = {
  backlightCompensation?: Maybe<Enum_Boolean>;
  brightness?: Maybe<Scalars['Int']>;
  groupViewSize?: Maybe<Enum_CameraGroupViewSize>;
  name?: Maybe<Scalars['String']>;
  orientation?: Maybe<Enum_CameraOrientation>;
  roomViewPIP?: Maybe<Enum_Boolean>;
  saturation?: Maybe<Scalars['Int']>;
  sharpness?: Maybe<Scalars['Int']>;
  skinEnhancement?: Maybe<Enum_Boolean>;
  trackingMode?: Maybe<Enum_CameraTrackingMode>;
  trackingSpeed?: Maybe<Enum_CameraTrackingSpeed>;
  type?: Maybe<Enum_CameraTypes>;
  videoQuality?: Maybe<Enum_CameraVideoQuality>;
  whiteBalanceMode?: Maybe<Enum_CameraWhiteBalanceMode>;
  wideDynamicRange?: Maybe<Enum_Boolean>;
};

export type PolyOsConfig_Video_Camera_ValueMeta = {
  __typename: 'PolyOSConfig_video_camera_valueMeta';
  backlightCompensation: Maybe<PropertyMeta>;
  brightness: Maybe<PropertyMeta>;
  groupViewSize: Maybe<PropertyMeta>;
  name: Maybe<PropertyMeta>;
  orientation: Maybe<PropertyMeta>;
  roomViewPIP: Maybe<PropertyMeta>;
  saturation: Maybe<PropertyMeta>;
  sharpness: Maybe<PropertyMeta>;
  skinEnhancement: Maybe<PropertyMeta>;
  trackingMode: Maybe<PropertyMeta>;
  trackingSpeed: Maybe<PropertyMeta>;
  type: Maybe<PropertyMeta>;
  videoQuality: Maybe<PropertyMeta>;
  whiteBalanceMode: Maybe<PropertyMeta>;
  wideDynamicRange: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_CameraInput = {
  autoUpdate?: Maybe<PolyOsConfig_Video_Camera_AutoUpdateInput>;
  backlightCompensation?: Maybe<Enum_Boolean>;
  brightness?: Maybe<Scalars['Int']>;
  farControlNearCamera?: Maybe<Scalars['Boolean']>;
  groupViewSize?: Maybe<Enum_CameraGroupViewSize>;
  name?: Maybe<Scalars['String']>;
  orientation?: Maybe<Enum_CameraOrientation>;
  powerFrequency?: Maybe<Enum_PowerFrequency>;
  preset?: Maybe<PolyOsConfig_Video_Camera_PresetInput>;
  roomViewPIP?: Maybe<Enum_Boolean>;
  saturation?: Maybe<Scalars['Int']>;
  sharpness?: Maybe<Scalars['Int']>;
  skinEnhancement?: Maybe<Enum_Boolean>;
  sleepMode?: Maybe<Enum_CameraSleepMode>;
  trackingMode?: Maybe<Enum_CameraTrackingMode>;
  trackingSpeed?: Maybe<Enum_CameraTrackingSpeed>;
  value?: Maybe<Array<PolyOsConfig_Video_Camera_ValueInput>>;
  videoQuality?: Maybe<Enum_CameraVideoQuality>;
  whiteBalanceMode?: Maybe<Enum_CameraWhiteBalanceMode>;
  wideDynamicRange?: Maybe<Enum_Boolean>;
};

export type PolyOsConfig_Video_CameraMeta = {
  __typename: 'PolyOSConfig_video_cameraMeta';
  autoUpdate: Maybe<PolyOsConfig_Video_Camera_AutoUpdateMeta>;
  backlightCompensation: Maybe<PropertyMeta>;
  brightness: Maybe<PropertyMeta>;
  farControlNearCamera: Maybe<PropertyMeta>;
  groupViewSize: Maybe<PropertyMeta>;
  name: Maybe<PropertyMeta>;
  orientation: Maybe<PropertyMeta>;
  powerFrequency: Maybe<PropertyMeta>;
  preset: Maybe<PolyOsConfig_Video_Camera_PresetMeta>;
  roomViewPIP: Maybe<PropertyMeta>;
  saturation: Maybe<PropertyMeta>;
  sharpness: Maybe<PropertyMeta>;
  skinEnhancement: Maybe<PropertyMeta>;
  sleepMode: Maybe<PropertyMeta>;
  trackingMode: Maybe<PropertyMeta>;
  trackingSpeed: Maybe<PropertyMeta>;
  value: Maybe<Array<PolyOsConfig_Video_Camera_ValueMeta>>;
  videoQuality: Maybe<PropertyMeta>;
  whiteBalanceMode: Maybe<PropertyMeta>;
  wideDynamicRange: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Content = {
  __typename: 'PolyOSConfig_video_content';
  name: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Video_ContentInput = {
  name?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_Video_ContentMeta = {
  __typename: 'PolyOSConfig_video_contentMeta';
  name: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Layout = {
  __typename: 'PolyOSConfig_video_layout';
  contentMirror: Maybe<Scalars['Boolean']>;
  selfviewPIP: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_LayoutInput = {
  contentMirror?: Maybe<Scalars['Boolean']>;
  selfviewPIP?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_LayoutMeta = {
  __typename: 'PolyOSConfig_video_layoutMeta';
  contentMirror: Maybe<PropertyMeta>;
  selfviewPIP: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Monitor = {
  __typename: 'PolyOSConfig_video_monitor';
  cec: Maybe<PolyOsConfig_Video_Monitor_Cec>;
  ONE: Maybe<PolyOsConfig_Video_Monitor_1>;
  TWO: Maybe<PolyOsConfig_Video_Monitor_2>;
};

export type PolyOsConfig_Video_Monitor_1 = {
  __typename: 'PolyOSConfig_video_monitor_1';
  display: Maybe<Enum_MonitorDisplay_Primary>;
  resolution: Maybe<Enum_MonitorResolution_Primary>;
};

export type PolyOsConfig_Video_Monitor_1Input = {
  display?: Maybe<Enum_MonitorDisplay_Primary>;
  resolution?: Maybe<Enum_MonitorResolution_Primary>;
};

export type PolyOsConfig_Video_Monitor_1Meta = {
  __typename: 'PolyOSConfig_video_monitor_1Meta';
  display: Maybe<PropertyMeta>;
  resolution: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Monitor_2 = {
  __typename: 'PolyOSConfig_video_monitor_2';
  display: Maybe<Enum_MonitorDisplay_Secondary_Willie>;
};

export type PolyOsConfig_Video_Monitor_2Input = {
  display?: Maybe<Enum_MonitorDisplay_Secondary_Willie>;
};

export type PolyOsConfig_Video_Monitor_2Meta = {
  __typename: 'PolyOSConfig_video_monitor_2Meta';
  display: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_Monitor_Cec = {
  __typename: 'PolyOSConfig_video_monitor_cec';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_Monitor_CecInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Video_Monitor_CecMeta = {
  __typename: 'PolyOSConfig_video_monitor_cecMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Video_MonitorInput = {
  cec?: Maybe<PolyOsConfig_Video_Monitor_CecInput>;
  ONE?: Maybe<PolyOsConfig_Video_Monitor_1Input>;
  TWO?: Maybe<PolyOsConfig_Video_Monitor_2Input>;
};

export type PolyOsConfig_Video_MonitorMeta = {
  __typename: 'PolyOSConfig_video_monitorMeta';
  cec: Maybe<PolyOsConfig_Video_Monitor_CecMeta>;
  ONE: Maybe<PolyOsConfig_Video_Monitor_1Meta>;
  TWO: Maybe<PolyOsConfig_Video_Monitor_2Meta>;
};

export type PolyOsConfig_VideoInput = {
  camera?: Maybe<PolyOsConfig_Video_CameraInput>;
  content?: Maybe<PolyOsConfig_Video_ContentInput>;
  layout?: Maybe<PolyOsConfig_Video_LayoutInput>;
  monitor?: Maybe<PolyOsConfig_Video_MonitorInput>;
};

export type PolyOsConfig_VideoMeta = {
  __typename: 'PolyOSConfig_videoMeta';
  camera: Maybe<PolyOsConfig_Video_CameraMeta>;
  content: Maybe<PolyOsConfig_Video_ContentMeta>;
  layout: Maybe<PolyOsConfig_Video_LayoutMeta>;
  monitor: Maybe<PolyOsConfig_Video_MonitorMeta>;
};

export type PolyOsConfig_Voice = {
  __typename: 'PolyOSConfig_voice';
  acousticFence: Maybe<PolyOsConfig_Voice_AcousticFence>;
  alertTone: Maybe<Enum_AlertUserTone>;
  in: Maybe<PolyOsConfig_Voice_In>;
  liveMusicMode: Maybe<PolyOsConfig_Voice_LiveMusicMode>;
  muteInSleep: Maybe<Scalars['Boolean']>;
  muteReminder: Maybe<PolyOsConfig_Voice_MuteReminder>;
  noiseSuppression: Maybe<PolyOsConfig_Voice_NoiseSuppression>;
  out: Maybe<PolyOsConfig_Voice_Out>;
  ringTone: Maybe<Enum_AlertVideoTone>;
  stereo: Maybe<PolyOsConfig_Voice_Stereo>;
  toneControl: Maybe<PolyOsConfig_Voice_ToneControl>;
  volume: Maybe<PolyOsConfig_Voice_Volume>;
};

export type PolyOsConfig_Voice_AcousticFence = {
  __typename: 'PolyOSConfig_voice_acousticFence';
  enable: Maybe<Scalars['Boolean']>;
  radius: Maybe<Enum_Audio0_10>;
};

export type PolyOsConfig_Voice_AcousticFenceInput = {
  enable?: Maybe<Scalars['Boolean']>;
  radius?: Maybe<Enum_Audio0_10>;
};

export type PolyOsConfig_Voice_AcousticFenceMeta = {
  __typename: 'PolyOSConfig_voice_acousticFenceMeta';
  enable: Maybe<PropertyMeta>;
  radius: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_In = {
  __typename: 'PolyOSConfig_voice_in';
  hdmi: Maybe<PolyOsConfig_Voice_In_Hdmi>;
  THREEp5: Maybe<PolyOsConfig_Voice_In_3p5>;
};

export type PolyOsConfig_Voice_In_3p5 = {
  __typename: 'PolyOSConfig_voice_in_3p5';
  level: Maybe<Enum_AudioInLevel>;
  playbackOption: Maybe<Enum_PlaybackOption>;
};

export type PolyOsConfig_Voice_In_3p5Input = {
  level?: Maybe<Enum_AudioInLevel>;
  playbackOption?: Maybe<Enum_PlaybackOption>;
};

export type PolyOsConfig_Voice_In_3p5Meta = {
  __typename: 'PolyOSConfig_voice_in_3p5Meta';
  level: Maybe<PropertyMeta>;
  playbackOption: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_In_Hdmi = {
  __typename: 'PolyOSConfig_voice_in_hdmi';
  level: Maybe<Enum_AudioInLevel>;
};

export type PolyOsConfig_Voice_In_HdmiInput = {
  level?: Maybe<Enum_AudioInLevel>;
};

export type PolyOsConfig_Voice_In_HdmiMeta = {
  __typename: 'PolyOSConfig_voice_in_hdmiMeta';
  level: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_InInput = {
  hdmi?: Maybe<PolyOsConfig_Voice_In_HdmiInput>;
  THREEp5?: Maybe<PolyOsConfig_Voice_In_3p5Input>;
};

export type PolyOsConfig_Voice_InMeta = {
  __typename: 'PolyOSConfig_voice_inMeta';
  hdmi: Maybe<PolyOsConfig_Voice_In_HdmiMeta>;
  THREEp5: Maybe<PolyOsConfig_Voice_In_3p5Meta>;
};

export type PolyOsConfig_Voice_LiveMusicMode = {
  __typename: 'PolyOSConfig_voice_liveMusicMode';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_LiveMusicModeInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_LiveMusicModeMeta = {
  __typename: 'PolyOSConfig_voice_liveMusicModeMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_MuteReminder = {
  __typename: 'PolyOSConfig_voice_muteReminder';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_MuteReminderInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_MuteReminderMeta = {
  __typename: 'PolyOSConfig_voice_muteReminderMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_NoiseSuppression = {
  __typename: 'PolyOSConfig_voice_noiseSuppression';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_NoiseSuppressionInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_NoiseSuppressionMeta = {
  __typename: 'PolyOSConfig_voice_noiseSuppressionMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_Out = {
  __typename: 'PolyOSConfig_voice_out';
  line: Maybe<PolyOsConfig_Voice_Out_Line>;
};

export type PolyOsConfig_Voice_Out_Line = {
  __typename: 'PolyOSConfig_voice_out_line';
  mode: Maybe<Enum_AudioOutMode>;
};

export type PolyOsConfig_Voice_Out_LineInput = {
  mode?: Maybe<Enum_AudioOutMode>;
};

export type PolyOsConfig_Voice_Out_LineMeta = {
  __typename: 'PolyOSConfig_voice_out_lineMeta';
  mode: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_OutInput = {
  line?: Maybe<PolyOsConfig_Voice_Out_LineInput>;
};

export type PolyOsConfig_Voice_OutMeta = {
  __typename: 'PolyOSConfig_voice_outMeta';
  line: Maybe<PolyOsConfig_Voice_Out_LineMeta>;
};

export type PolyOsConfig_Voice_Stereo = {
  __typename: 'PolyOSConfig_voice_stereo';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_StereoInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_Voice_StereoMeta = {
  __typename: 'PolyOSConfig_voice_stereoMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_ToneControl = {
  __typename: 'PolyOSConfig_voice_toneControl';
  bass: Maybe<Enum_QualityProcess>;
  treble: Maybe<Enum_QualityProcess>;
};

export type PolyOsConfig_Voice_ToneControlInput = {
  bass?: Maybe<Enum_QualityProcess>;
  treble?: Maybe<Enum_QualityProcess>;
};

export type PolyOsConfig_Voice_ToneControlMeta = {
  __typename: 'PolyOSConfig_voice_toneControlMeta';
  bass: Maybe<PropertyMeta>;
  treble: Maybe<PropertyMeta>;
};

export type PolyOsConfig_Voice_Volume = {
  __typename: 'PolyOSConfig_voice_volume';
  soundEffects: Maybe<Enum_Audio0_10>;
  speaker: Maybe<Enum_SpeakerVolume>;
  transmitLevel: Maybe<Enum_AudioTransmitLevel>;
};

export type PolyOsConfig_Voice_VolumeInput = {
  soundEffects?: Maybe<Enum_Audio0_10>;
  speaker?: Maybe<Enum_SpeakerVolume>;
  transmitLevel?: Maybe<Enum_AudioTransmitLevel>;
};

export type PolyOsConfig_Voice_VolumeMeta = {
  __typename: 'PolyOSConfig_voice_volumeMeta';
  soundEffects: Maybe<PropertyMeta>;
  speaker: Maybe<PropertyMeta>;
  transmitLevel: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoiceInput = {
  acousticFence?: Maybe<PolyOsConfig_Voice_AcousticFenceInput>;
  alertTone?: Maybe<Enum_AlertUserTone>;
  in?: Maybe<PolyOsConfig_Voice_InInput>;
  liveMusicMode?: Maybe<PolyOsConfig_Voice_LiveMusicModeInput>;
  muteInSleep?: Maybe<Scalars['Boolean']>;
  muteReminder?: Maybe<PolyOsConfig_Voice_MuteReminderInput>;
  noiseSuppression?: Maybe<PolyOsConfig_Voice_NoiseSuppressionInput>;
  out?: Maybe<PolyOsConfig_Voice_OutInput>;
  ringTone?: Maybe<Enum_AlertVideoTone>;
  stereo?: Maybe<PolyOsConfig_Voice_StereoInput>;
  toneControl?: Maybe<PolyOsConfig_Voice_ToneControlInput>;
  volume?: Maybe<PolyOsConfig_Voice_VolumeInput>;
};

export type PolyOsConfig_VoiceMeta = {
  __typename: 'PolyOSConfig_voiceMeta';
  acousticFence: Maybe<PolyOsConfig_Voice_AcousticFenceMeta>;
  alertTone: Maybe<PropertyMeta>;
  in: Maybe<PolyOsConfig_Voice_InMeta>;
  liveMusicMode: Maybe<PolyOsConfig_Voice_LiveMusicModeMeta>;
  muteInSleep: Maybe<PropertyMeta>;
  muteReminder: Maybe<PolyOsConfig_Voice_MuteReminderMeta>;
  noiseSuppression: Maybe<PolyOsConfig_Voice_NoiseSuppressionMeta>;
  out: Maybe<PolyOsConfig_Voice_OutMeta>;
  ringTone: Maybe<PropertyMeta>;
  stereo: Maybe<PolyOsConfig_Voice_StereoMeta>;
  toneControl: Maybe<PolyOsConfig_Voice_ToneControlMeta>;
  volume: Maybe<PolyOsConfig_Voice_VolumeMeta>;
};

export type PolyOsConfig_VoIpProt = {
  __typename: 'PolyOSConfig_voIpProt';
  H323: Maybe<PolyOsConfig_VoIpProt_H323>;
  SIP: Maybe<PolyOsConfig_VoIpProt_Sip>;
};

export type PolyOsConfig_VoIpProt_H323 = {
  __typename: 'PolyOSConfig_voIpProt_H323';
  e164: Maybe<Scalars['String']>;
  enable: Maybe<Scalars['Boolean']>;
  gk: Maybe<PolyOsConfig_VoIpProt_H323_Gk>;
  name: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_H323_Gk = {
  __typename: 'PolyOSConfig_voIpProt_H323_gk';
  auth: Maybe<PolyOsConfig_VoIpProt_H323_Gk_Auth>;
  ipAddress: Maybe<Scalars['String']>;
  mode: Maybe<Enum_GateKeeperEnable>;
};

export type PolyOsConfig_VoIpProt_H323_Gk_Auth = {
  __typename: 'PolyOSConfig_voIpProt_H323_gk_auth';
  enable: Maybe<Scalars['Boolean']>;
  password: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_H323_Gk_AuthInput = {
  enable?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_H323_Gk_AuthMeta = {
  __typename: 'PolyOSConfig_voIpProt_H323_gk_authMeta';
  enable: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  userId: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoIpProt_H323_GkInput = {
  auth?: Maybe<PolyOsConfig_VoIpProt_H323_Gk_AuthInput>;
  ipAddress?: Maybe<Scalars['String']>;
  mode?: Maybe<Enum_GateKeeperEnable>;
};

export type PolyOsConfig_VoIpProt_H323_GkMeta = {
  __typename: 'PolyOSConfig_voIpProt_H323_gkMeta';
  auth: Maybe<PolyOsConfig_VoIpProt_H323_Gk_AuthMeta>;
  ipAddress: Maybe<PropertyMeta>;
  mode: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoIpProt_H323Input = {
  e164?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  gk?: Maybe<PolyOsConfig_VoIpProt_H323_GkInput>;
  name?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_H323Meta = {
  __typename: 'PolyOSConfig_voIpProt_H323Meta';
  e164: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  gk: Maybe<PolyOsConfig_VoIpProt_H323_GkMeta>;
  name: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoIpProt_Sip = {
  __typename: 'PolyOSConfig_voIpProt_SIP';
  auth: Maybe<PolyOsConfig_VoIpProt_Sip_Auth>;
  bfcpTransportPreference: Maybe<Enum_BfcpTransportProtocol>;
  enable: Maybe<Scalars['Boolean']>;
  forceConnectionReuse: Maybe<Scalars['Boolean']>;
  proxyServer: Maybe<Scalars['String']>;
  registrarServer: Maybe<Scalars['String']>;
  registrarServerType: Maybe<Enum_SipRegistrarServerType>;
  sbcKeepAlive: Maybe<PolyOsConfig_VoIpProt_Sip_SbcKeepAlive>;
  serverType: Maybe<Enum_SipConfigType>;
  transport: Maybe<Enum_SipTransportProtocol>;
  userName: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_Sip_Auth = {
  __typename: 'PolyOSConfig_voIpProt_SIP_auth';
  domain: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  useLoginCredentials: Maybe<Scalars['Boolean']>;
  userId: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_Sip_AuthInput = {
  domain?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  useLoginCredentials?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_Sip_AuthMeta = {
  __typename: 'PolyOSConfig_voIpProt_SIP_authMeta';
  domain: Maybe<PropertyMeta>;
  password: Maybe<PropertyMeta>;
  useLoginCredentials: Maybe<PropertyMeta>;
  userId: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoIpProt_Sip_SbcKeepAlive = {
  __typename: 'PolyOSConfig_voIpProt_SIP_sbcKeepAlive';
  enable: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_VoIpProt_Sip_SbcKeepAliveInput = {
  enable?: Maybe<Scalars['Boolean']>;
};

export type PolyOsConfig_VoIpProt_Sip_SbcKeepAliveMeta = {
  __typename: 'PolyOSConfig_voIpProt_SIP_sbcKeepAliveMeta';
  enable: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoIpProt_SipInput = {
  auth?: Maybe<PolyOsConfig_VoIpProt_Sip_AuthInput>;
  bfcpTransportPreference?: Maybe<Enum_BfcpTransportProtocol>;
  enable?: Maybe<Scalars['Boolean']>;
  forceConnectionReuse?: Maybe<Scalars['Boolean']>;
  proxyServer?: Maybe<Scalars['String']>;
  registrarServer?: Maybe<Scalars['String']>;
  registrarServerType?: Maybe<Enum_SipRegistrarServerType>;
  sbcKeepAlive?: Maybe<PolyOsConfig_VoIpProt_Sip_SbcKeepAliveInput>;
  serverType?: Maybe<Enum_SipConfigType>;
  transport?: Maybe<Enum_SipTransportProtocol>;
  userName?: Maybe<Scalars['String']>;
};

export type PolyOsConfig_VoIpProt_SipMeta = {
  __typename: 'PolyOSConfig_voIpProt_SIPMeta';
  auth: Maybe<PolyOsConfig_VoIpProt_Sip_AuthMeta>;
  bfcpTransportPreference: Maybe<PropertyMeta>;
  enable: Maybe<PropertyMeta>;
  forceConnectionReuse: Maybe<PropertyMeta>;
  proxyServer: Maybe<PropertyMeta>;
  registrarServer: Maybe<PropertyMeta>;
  registrarServerType: Maybe<PropertyMeta>;
  sbcKeepAlive: Maybe<PolyOsConfig_VoIpProt_Sip_SbcKeepAliveMeta>;
  serverType: Maybe<PropertyMeta>;
  transport: Maybe<PropertyMeta>;
  userName: Maybe<PropertyMeta>;
};

export type PolyOsConfig_VoIpProtInput = {
  H323?: Maybe<PolyOsConfig_VoIpProt_H323Input>;
  SIP?: Maybe<PolyOsConfig_VoIpProt_SipInput>;
};

export type PolyOsConfig_VoIpProtMeta = {
  __typename: 'PolyOSConfig_voIpProtMeta';
  H323: Maybe<PolyOsConfig_VoIpProt_H323Meta>;
  SIP: Maybe<PolyOsConfig_VoIpProt_SipMeta>;
};

export type PolyOsConfigInput = {
  bluetooth?: Maybe<PolyOsConfig_BluetoothInput>;
  call?: Maybe<PolyOsConfig_CallInput>;
  cloud?: Maybe<PolyOsConfig_CloudInput>;
  content?: Maybe<PolyOsConfig_ContentInput>;
  device?: Maybe<PolyOsConfig_DeviceInput>;
  dir?: Maybe<PolyOsConfig_DirInput>;
  exchange?: Maybe<PolyOsConfig_ExchangeInput>;
  homeScreen?: Maybe<PolyOsConfig_HomeScreenInput>;
  license?: Maybe<PolyOsConfig_LicenseInput>;
  log?: Maybe<PolyOsConfig_LogInput>;
  mr?: Maybe<PolyOsConfig_MrInput>;
  net?: Maybe<PolyOsConfig_NetInput>;
  prov?: Maybe<PolyOsConfig_ProvInput>;
  qos?: Maybe<PolyOsConfig_QosInput>;
  sec?: Maybe<PolyOsConfig_SecInput>;
  snmp?: Maybe<PolyOsConfig_SnmpInput>;
  upgrade?: Maybe<PolyOsConfig_UpgradeInput>;
  video?: Maybe<PolyOsConfig_VideoInput>;
  voice?: Maybe<PolyOsConfig_VoiceInput>;
  voIpProt?: Maybe<PolyOsConfig_VoIpProtInput>;
};

export type PolyOsConfigMeta = {
  __typename: 'PolyOSConfigMeta';
  bluetooth: Maybe<PolyOsConfig_BluetoothMeta>;
  call: Maybe<PolyOsConfig_CallMeta>;
  cloud: Maybe<PolyOsConfig_CloudMeta>;
  content: Maybe<PolyOsConfig_ContentMeta>;
  device: Maybe<PolyOsConfig_DeviceMeta>;
  dir: Maybe<PolyOsConfig_DirMeta>;
  exchange: Maybe<PolyOsConfig_ExchangeMeta>;
  homeScreen: Maybe<PolyOsConfig_HomeScreenMeta>;
  license: Maybe<PolyOsConfig_LicenseMeta>;
  log: Maybe<PolyOsConfig_LogMeta>;
  mr: Maybe<PolyOsConfig_MrMeta>;
  net: Maybe<PolyOsConfig_NetMeta>;
  prov: Maybe<PolyOsConfig_ProvMeta>;
  qos: Maybe<PolyOsConfig_QosMeta>;
  sec: Maybe<PolyOsConfig_SecMeta>;
  snmp: Maybe<PolyOsConfig_SnmpMeta>;
  upgrade: Maybe<PolyOsConfig_UpgradeMeta>;
  video: Maybe<PolyOsConfig_VideoMeta>;
  voice: Maybe<PolyOsConfig_VoiceMeta>;
  voIpProt: Maybe<PolyOsConfig_VoIpProtMeta>;
};

export type PolyPlusPageInfo = {
  __typename: 'PolyPlusPageInfo';
  hasNextPage: Scalars['Boolean'];
  nextToken: Maybe<Scalars['String']>;
};

export type ProductBuild = {
  __typename: 'ProductBuild';
  applications: Array<ProductBuildApplication>;
  archiveUrl: Maybe<Scalars['String']>;
  build: Scalars['String'];
  category: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** @deprecated Use category field */
  product: Scalars['String'];
  rules: Maybe<ProductBuildRules>;
  storagePath: Scalars['String'];
  tags: Array<ProductBuildTag>;
  url: Scalars['String'];
  version: Scalars['String'];
};

export type ProductBuildApplication = {
  __typename: 'ProductBuildApplication';
  models: Maybe<Array<ProductBuildModel>>;
  name: Scalars['String'];
  path: Scalars['String'];
  releaseInfo: Maybe<Scalars['JSONObject']>;
};

export type ProductBuildDetails = {
  __typename: 'ProductBuildDetails';
  archiveUrl: Maybe<Scalars['String']>;
  rules: Maybe<Scalars['JSONObject']>;
};

export type ProductBuildModel = {
  __typename: 'ProductBuildModel';
  name: Scalars['String'];
  versions: Array<Scalars['String']>;
};

export type ProductBuildRules = {
  __typename: 'ProductBuildRules';
  document: Maybe<Scalars['JSONObject']>;
  hasComponentFilesExtracted: Maybe<Scalars['Boolean']>;
  releaseDate: Maybe<Scalars['String']>;
  releaseNotes: Maybe<Scalars['String']>;
};

export type ProductBuildTag = {
  __typename: 'ProductBuildTag';
  name: Scalars['String'];
  value: Maybe<Scalars['String']>;
};

export type ProductBuildTagInput = {
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ProductCategory = {
  __typename: 'ProductCategory';
  name: Scalars['String'];
  versions: Maybe<Array<ProductCategoryVersion>>;
};

export type ProductCategoryVersion = {
  __typename: 'ProductCategoryVersion';
  builds: Maybe<Array<ProductBuild>>;
  category: Scalars['String'];
  /** @deprecated Use category field */
  product: Scalars['String'];
  version: Scalars['String'];
};

export type ProductCompareClause = {
  comparisonOperator: CatalogComparisonOperator;
  field: ModelSearchField;
  value?: Maybe<Scalars['String']>;
};

export type ProductSoftware = {
  __typename: 'ProductSoftware';
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  product: Maybe<HardwareProduct>;
  productBuild: Maybe<ProductBuild>;
  publishDate: Maybe<Scalars['DateTime']>;
  releaseChannel: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
};

export enum ProductSoftwareField {
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Pid = 'pid',
  ProductBuildId = 'productBuildId',
  ProductId = 'productId',
  ReleaseChannel = 'releaseChannel',
  Version = 'version'
}

export type ProductSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<CatalogProductSortField>;
};

export type PropertyMeta = {
  __typename: 'PropertyMeta';
  isEditable: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isSecure: Scalars['Boolean'];
};

export type ProspectorHealthCheckResponse = {
  __typename: 'ProspectorHealthCheckResponse';
  healthy: Scalars['Boolean'];
};

export type ProvisioningAccount = {
  __typename: 'ProvisioningAccount';
  description: Maybe<Scalars['String']>;
  downloadPath: Maybe<Scalars['String']>;
  isDisabled: Maybe<Scalars['Boolean']>;
  password: Maybe<Scalars['String']>;
  provisioningUri: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  username: Maybe<Scalars['String']>;
  uuid: Maybe<Scalars['String']>;
};

export type ProvisioningAccountIn = {
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ProvisioningSettings = {
  enabled: Scalars['Boolean'];
};

export type Query = {
  __typename: 'Query';
  accessLogUrl: DeviceLogsApiResponse;
  accessor: Maybe<Accessor>;
  /** @deprecated Superceded by 'searchAccessors' query */
  accessors: Array<Accessor>;
  accessPCAPUrl: DeviceLogsApiResponse;
  accessScreenUrl: DeviceLogsApiResponse;
  activeCalls: ActiveCalls;
  autoEntitleConfiguration: AutoEntitleConfiguration;
  availableProductSoftwareByPid: Maybe<ProductSoftware>;
  capabilities: Array<Capability>;
  capabilitiesQuery: Maybe<Capabilities>;
  capabilitiesSuperset: Array<Capability>;
  catalogCategories: CatalogCategoryConnection;
  catalogFamilies: CatalogFamilyConnection;
  catalogManufacturers: CatalogManufacturerConnection;
  catalogModels: CatalogModelConnection;
  catalogProducts: CatalogProductConnection;
  catalogSkus: SkuConnection;
  catalogVendors: VendorConnection;
  cdrAggregates: Chart;
  charts: Maybe<Chart>;
  collection: Maybe<Collection>;
  collectionMatches: Maybe<CollectionMatches>;
  collections: Array<Collection>;
  countDevices: Scalars['Int'];
  describeCertificate: CertificateResponse;
  details: TopicIndicatorDetail;
  device: Device;
  deviceAggregations: Array<Aggregate>;
  deviceClasses: Array<DeviceClass>;
  deviceConnections: Array<EntityConnection>;
  devicePolicyCapabilities: ResolvedCapabilities;
  devices: Array<Device>;
  devicesByGroup: Maybe<Array<Collection>>;
  /** @deprecated Superceded by searchTerm filter in devices() API */
  deviceSearch: Array<Device>;
  deviceSettings: SettingResponse;
  deviceSettingsAsXML: SettingXmlResponse;
  entitlements: EntitlementConnection;
  entityConnection: EntityConnection;
  entityConnectionTransport: EntityConnectionTransport;
  entityConnectionTransports: Array<EntityConnectionTransport>;
  episodes: EpisodeConnection;
  exportDeviceSettings: Maybe<Scalars['String']>;
  findProductBuilds: Array<ProductBuild>;
  firmwareUpdateInfo: FirmwareUpdateInfo;
  frontDoor: FrontDoor;
  gatewayId: Scalars['String'];
  getAllConfigurationProfiles: Maybe<Array<Maybe<ConfigProfileDto>>>;
  getAllDeviceParameters: Maybe<Array<Maybe<DeviceParameterDto>>>;
  getAllDeviceTypes: Maybe<Array<Maybe<DeviceTypeDto>>>;
  getAllGroups: GroupApiResponse;
  getAllResourceFiles: Maybe<Array<Maybe<ResourceFileDto>>>;
  getAuditLogs: Array<AuditLog>;
  getAutoCreatedPolicies: Maybe<Array<Maybe<Policy>>>;
  getClaritiTrialSubscription: Maybe<ClaritiTrialUserSubscription>;
  getClaritiTrialSubscriptionReports: ClaritiTrialSubscriptionReportConnection;
  getConfigProfile: Maybe<ConfigProfileDto>;
  getConfiguration: Maybe<TenantManagementConfiguration>;
  getDevice: Maybe<DeviceBasicData>;
  getDeviceParametersExtended: Maybe<Array<Maybe<ExtendedDeviceParameterDto>>>;
  getEntityConnectionsTreeForEntity: Array<EntityConnection>;
  getEpUpdateImages: Maybe<Array<Maybe<EpUpdateImage>>>;
  getExtendedConfigParams: Maybe<ExtendedConfigParamsResponse>;
  getGroupMetadata: MetadataResponse;
  getImportReport: Maybe<ImportResponse>;
  getMyIp: Ip;
  getPolicies: Maybe<Array<Maybe<Policy>>>;
  getPolicyById: Maybe<Policy>;
  getProvisioningAccounts: Maybe<Array<Maybe<ProvisioningAccount>>>;
  getRoom: Maybe<Room>;
  getSite: Maybe<Site>;
  getSubnet: Maybe<Subnet>;
  getSubnetRules: Maybe<Array<SubnetRule>>;
  getSubnetRuleValidity: Maybe<SubnetRuleValidityResponse>;
  getSubnets: Maybe<Array<Subnet>>;
  getSwUpdatePolicy: Maybe<Policy>;
  getUploadedFiles: UploadedFileList;
  getUserGroup: UserGroup;
  getUserIdForDeviceId: Maybe<Scalars['String']>;
  /** @deprecated This API is no longer supported. Use 'catalogCategories' instead. */
  hardwareCategories: Array<HardwareCategory>;
  /** @deprecated This API is no longer supported. Use 'catalogFamilies' instead. */
  hardwareFamilies: Array<HardwareFamily>;
  hardwareFamily: HardwareFamily;
  hardwareManufacturer: HardwareManufacturer;
  /** @deprecated This API is no longer supported. Use 'catalogManufacturers' instead. */
  hardwareManufacturers: Array<HardwareManufacturer>;
  hardwareModel: HardwareModel;
  /** @deprecated This API is no longer supported. Use 'catalogModels' instead. */
  hardwareModels: Array<HardwareModel>;
  hardwareProduct: HardwareProduct;
  /** @deprecated This API is no longer supported. Use 'catalogProducts' instead. */
  hardwareProducts: Array<HardwareProduct>;
  healthCheckBlackhole: HealthCheckResponse;
  healthCheckCollective: CollectiveHealthCheckResponse;
  healthCheckMercator: MercatorHealthCheckResponse;
  healthCheckProspector: ProspectorHealthCheckResponse;
  license: License;
  licenseAggregationsByModel: Array<LicenseAggregations>;
  licenseAssetsForEntitlement: Array<LicenseAssetForEntitlement>;
  licenseCount: Scalars['Int'];
  licenses: Array<License>;
  licensesExpiring: LicenseInfoConnection;
  locations: Array<Location>;
  logToFlashStatus: LogToFlashApiResponse;
  mergeEntityRequests: MergeEntitiesResponse;
  myCdrAggregates: Chart;
  ncPoly: PolyNotificationConfigurationQueries;
  ncServiceNow: NcServiceNowQueries;
  ncTeams: NcTeamsQueries;
  node: Maybe<Node>;
  normalizedDeviceSettings: NormalizedDeviceSettingsResponse;
  notificationCenter: Maybe<NotificationCenter>;
  ns_ls_getActiveTokenUser: Maybe<Ns_Ls_User>;
  ns_ls_getAllTenants: Ns_Ls_TenantConnection;
  ns_ls_getAppData: Maybe<Ns_Ls_AppData>;
  ns_ls_getAudit: Maybe<Ns_Ls_AuditEvent>;
  ns_ls_getAuditReport: Ns_Ls_Report;
  ns_ls_getClientAuthToken: Maybe<Ns_Ls_ClientAuthToken>;
  ns_ls_getDeepReport: Maybe<Ns_Ls_DeepReport>;
  ns_ls_getEntitlement: Maybe<Ns_Ls_Entitlement>;
  ns_ls_getEntitlementsByGroupingView: Maybe<Ns_Ls_EntitlementGroupings>;
  ns_ls_getInitialLicenseRequest: Maybe<Scalars['String']>;
  ns_ls_getInstance: Maybe<Ns_Ls_Instance>;
  ns_ls_getLastLicense: Maybe<Scalars['String']>;
  ns_ls_getLatestProductVersion: Maybe<Ns_Ls_ProductVersions>;
  ns_ls_getLatestProductVersions: Maybe<Ns_Ls_ProductLatestVersionList>;
  ns_ls_getProductIds: Maybe<Ns_Ls_ProductList>;
  ns_ls_getProductVersions: Maybe<Ns_Ls_ProductVersions>;
  ns_ls_getSoftwareCatalog: Maybe<Ns_Ls_SoftwareCatalog>;
  ns_ls_getTenant: Maybe<Ns_Ls_Tenant>;
  ns_ls_getTenantAlias: Maybe<Ns_Ls_TenantAlias>;
  ns_ls_getUser: Maybe<Ns_Ls_User>;
  ns_ls_isDeepReportRunning: Maybe<Scalars['Boolean']>;
  ns_ls_searchAppData: Ns_Ls_AppDataConnection;
  ns_ls_searchAudits: Ns_Ls_AuditEventConnection;
  ns_ls_searchClientAuthTokens: Ns_Ls_ClientAuthTokenConnection;
  ns_ls_searchEntitlementGroupingSets: Ns_Ls_EntitlementGroupingSetConnection;
  ns_ls_searchEntitlements: Ns_Ls_EntitlementConnection;
  ns_ls_searchInstanceByInstId: Maybe<Ns_Ls_Instance>;
  ns_ls_searchInstances: Ns_Ls_InstanceConnection;
  ns_ls_searchTenantAliases: Ns_Ls_TenantAliasList;
  ns_ls_searchTenants: Ns_Ls_TenantConnection;
  ns_ls_searchUsers: Ns_Ls_UserConnection;
  ns_ls_statusCheck: Scalars['Boolean'];
  ns_siebel_findContact: Maybe<Array<Maybe<Ns_Siebel_Contact>>>;
  ns_siebel_getAssetById: Ns_Siebel_Asset;
  ns_siebel_getAssetsBySerial: Array<Ns_Siebel_Asset>;
  ns_siebel_getEntitlementByIntegrationId: Maybe<Ns_Siebel_Entitlement>;
  ns_siebel_getEntitlementBySerial: Maybe<Ns_Siebel_Entitlement>;
  ns_siebel_getServiceRequestById: Maybe<Ns_Siebel_ServiceRequestWsPlcm>;
  ns_siebel_getServiceRequestBySrNumber: Array<Ns_Siebel_ServiceRequestWsPlcm>;
  ns_siebel_getServiceRequestsByAssetId: Array<Ns_Siebel_ServiceRequestWebCenter>;
  permission: Maybe<Permission>;
  permissionGroup: Maybe<PermissionGroup>;
  permissionGroups: Array<PermissionGroup>;
  permissions: Array<Permission>;
  policiesCapabilities: Array<GroupPolicy>;
  policyCapabilities: ResolvedCapabilities;
  polyPlusEnabled: Scalars['Boolean'];
  postalLookup: Array<Location>;
  productBuild: Maybe<ProductBuild>;
  productBuildById: Maybe<ProductBuild>;
  productCategories: Array<ProductCategory>;
  productCategory: Maybe<ProductCategory>;
  productCategoryVersion: Maybe<ProductCategoryVersion>;
  productSoftware: ProductSoftware;
  /** @deprecated This API is no longer supported. Use 'softwareReleasesByPid' instead. */
  productSoftwareByPid: Array<ProductSoftware>;
  /** @deprecated This API is no longer supported. Use 'softwareReleasesByPid' instead. */
  productSoftwares: Maybe<Array<ProductSoftware>>;
  readGroup: GroupApiResponse;
  resolveSwUpdateForPolicy: Maybe<SwUpdateDetails>;
  resolveTenant: Maybe<Tenant>;
  role: Maybe<Role>;
  roles: Array<Role>;
  room: Maybe<Room>;
  roomData: Maybe<RoomConnectionObject>;
  route: Maybe<Route>;
  routes: Array<Route>;
  ruleMatches: Maybe<Array<Collection>>;
  searchAccessors: AccessorConnection;
  service: Maybe<Service>;
  services: Array<Service>;
  shipments: ShipmentModelConnection;
  site: Maybe<Site>;
  siteData: SiteConnectionObject;
  /** @deprecated This query is deprecated. Use the `siteData` field on the `tenant` query instead or `siteData` query directly */
  sites: Array<Site>;
  sku: Sku;
  /** @deprecated This API is no longer supported. Use 'catalogSkus' instead. */
  skus: Array<Sku>;
  softwareReleasesByPid: SoftwareConnection;
  startExportDeviceConfigs: Maybe<ExtendedConfigParamsResponse>;
  supergraph: Supergraph;
  tenant: Tenant;
  tenantCount: Scalars['Float'];
  tenantEvents: Array<TenantEvent>;
  tenantIntegrations: Array<TenantIntegrationsResponse>;
  tenants: Array<Tenant>;
  topicIndicators: TopicIndicatorConnection;
  topics: Array<Topic>;
  transportProtocol: TransportProtocol;
  transportProtocols: Array<TransportProtocol>;
  user: UserResponse;
  userConnections: Array<EntityConnection>;
  userGroupsForTenant: Array<UserGroup>;
  userInvites: UserInvitesResponse;
  userInvitesByTenant: UserInvitesResponse;
  users: UserConnection;
  vendor: Vendor;
  /** @deprecated This API is no longer supported. Use 'catalogVendors' instead. */
  vendors: Array<Vendor>;
  verifyLicenseKey: VerifyLicenseKeyResult;
};


export type QueryAccessLogUrlArgs = {
  deviceId: Scalars['String'];
};


export type QueryAccessorArgs = {
  accessorId?: Maybe<Scalars['ID']>;
};


export type QueryAccessorsArgs = {
  params: AccessorSearchParams;
};


export type QueryAccessPcapUrlArgs = {
  deviceId: Scalars['String'];
};


export type QueryAccessScreenUrlArgs = {
  deviceId: Scalars['String'];
};


export type QueryActiveCallsArgs = {
  deviceId: Scalars['String'];
};


export type QueryAutoEntitleConfigurationArgs = {
  tenantId: Scalars['String'];
};


export type QueryAvailableProductSoftwareByPidArgs = {
  pid: Scalars['ID'];
  releaseChannel?: Maybe<Scalars['String']>;
};


export type QueryCapabilitiesArgs = {
  deviceId: Scalars['String'];
};


export type QueryCapabilitiesQueryArgs = {
  deviceId: Scalars['String'];
};


export type QueryCapabilitiesSupersetArgs = {
  propertyPath: Scalars['String'];
  propertyValue: Scalars['String'];
};


export type QueryCatalogCategoriesArgs = {
  params?: Maybe<CatalogCategoryConnectionParams>;
};


export type QueryCatalogFamiliesArgs = {
  params?: Maybe<CatalogFamilyConnectionParams>;
};


export type QueryCatalogManufacturersArgs = {
  params?: Maybe<CatalogManufacturerConnectionParams>;
};


export type QueryCatalogModelsArgs = {
  params?: Maybe<CatalogModelConnectionParams>;
};


export type QueryCatalogProductsArgs = {
  params?: Maybe<CatalogProductConnectionParams>;
};


export type QueryCatalogSkusArgs = {
  params?: Maybe<SkuConnectionParams>;
};


export type QueryCatalogVendorsArgs = {
  params?: Maybe<VendorConnectionParams>;
};


export type QueryCdrAggregatesArgs = {
  field?: Maybe<MeetingRecordAggregationField>;
  groupBy: MeetingRecordAggregationGroup;
  increment: Increment;
  input?: Maybe<QueryMeetingRecordAggregationInput>;
  mode?: Maybe<MeetingRecordAggregationMode>;
  tenantId: Array<Scalars['String']>;
  timeRange: TimeRange;
  user?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type QueryChartsArgs = {
  id: Scalars['ID'];
  locationScope: LocationScope;
  tenantId: Array<Scalars['String']>;
  timeScope: TimeScope;
  timeStart: Scalars['Date'];
  topic: Scalars['ID'];
};


export type QueryCollectionArgs = {
  id: Scalars['String'];
};


export type QueryCollectionMatchesArgs = {
  id: Scalars['String'];
};


export type QueryCollectionsArgs = {
  collectionId?: Maybe<Scalars['String']>;
};


export type QueryCountDevicesArgs = {
  filter?: Maybe<Filter>;
};


export type QueryDescribeCertificateArgs = {
  deviceId: Scalars['String'];
};


export type QueryDetailsArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  locationScope?: Maybe<LocationScope>;
  tenantId: Array<Scalars['String']>;
};


export type QueryDeviceArgs = {
  id: Scalars['String'];
};


export type QueryDeviceAggregationsArgs = {
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  filter?: Maybe<Filter>;
};


export type QueryDeviceConnectionsArgs = {
  deviceId: Scalars['ID'];
};


export type QueryDevicePolicyCapabilitiesArgs = {
  deviceId: Scalars['String'];
  productId?: Maybe<Scalars['String']>;
};


export type QueryDevicesArgs = {
  filter?: Maybe<Filter>;
  from?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<DeviceSort>;
};


export type QueryDeviceSearchArgs = {
  from?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  sort?: Maybe<DeviceSort>;
};


export type QueryDeviceSettingsArgs = {
  disableError?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  includeNonEditableFields?: Maybe<Scalars['Boolean']>;
  waitForDevice?: Maybe<Scalars['Boolean']>;
};


export type QueryDeviceSettingsAsXmlArgs = {
  id: Scalars['String'];
  includeNonEditableFields?: Maybe<Scalars['Boolean']>;
  waitForDevice?: Maybe<Scalars['Boolean']>;
};


export type QueryEntitlementsArgs = {
  includeExpired?: Maybe<Scalars['Boolean']>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Float']>;
  productSerials?: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['String'];
};


export type QueryEntityConnectionArgs = {
  entityId: Scalars['ID'];
  targetEntityId: Scalars['ID'];
  type: Scalars['ID'];
};


export type QueryEntityConnectionTransportArgs = {
  type: Scalars['ID'];
};


export type QueryEpisodesArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  input?: Maybe<QueryEpisodesInput>;
  tenantId: Array<Scalars['String']>;
};


export type QueryExportDeviceSettingsArgs = {
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryFindProductBuildsArgs = {
  build?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<ProductBuildTagInput>>;
  version?: Maybe<Scalars['String']>;
};


export type QueryFirmwareUpdateInfoArgs = {
  id: Scalars['String'];
};


export type QueryGetAllDeviceParametersArgs = {
  deviceModel?: Maybe<Scalars['String']>;
};


export type QueryGetAllGroupsArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetAllResourceFilesArgs = {
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetAuditLogsArgs = {
  filter?: Maybe<LogFilter>;
  from?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Sort>;
  tenantId: Scalars['String'];
};


export type QueryGetAutoCreatedPoliciesArgs = {
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetClaritiTrialSubscriptionReportsArgs = {
  params: ClaritiTrialSubscriptionReportConnectionParams;
};


export type QueryGetConfigProfileArgs = {
  uuid?: Maybe<Scalars['String']>;
};


export type QueryGetDeviceArgs = {
  serial?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetDeviceParametersExtendedArgs = {
  deviceId?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  sendOnlyChanged?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetEntityConnectionsTreeForEntityArgs = {
  entityId: Scalars['ID'];
  targetEntityId: Scalars['ID'];
  type: Scalars['ID'];
};


export type QueryGetEpUpdateImagesArgs = {
  deviceModel?: Maybe<Scalars['String']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
};


export type QueryGetExtendedConfigParamsArgs = {
  deviceId?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetGroupMetadataArgs = {
  filter?: Maybe<GroupFilter>;
  groupId: Scalars['String'];
};


export type QueryGetImportReportArgs = {
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetPoliciesArgs = {
  deviceId?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  policyScope?: Maybe<PolicyDeploymentScope>;
  siteId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetPolicyByIdArgs = {
  policyId?: Maybe<Scalars['String']>;
};


export type QueryGetProvisioningAccountsArgs = {
  tenantUuid?: Maybe<Scalars['String']>;
};


export type QueryGetRoomArgs = {
  id: Scalars['String'];
};


export type QueryGetSiteArgs = {
  id: Scalars['String'];
};


export type QueryGetSubnetArgs = {
  id: Scalars['String'];
};


export type QueryGetSubnetRulesArgs = {
  getSubnetRulesInput: GetSubnetRulesInput;
};


export type QueryGetSubnetRuleValidityArgs = {
  subnetRuleValidityInput: SubnetRuleValidityInput;
};


export type QueryGetSubnetsArgs = {
  subnetFilter?: Maybe<SubnetFilter>;
};


export type QueryGetSwUpdatePolicyArgs = {
  deviceId?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryGetUploadedFilesArgs = {
  deviceId: Scalars['String'];
};


export type QueryGetUserGroupArgs = {
  id: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetUserIdForDeviceIdArgs = {
  deviceId: Scalars['ID'];
};


export type QueryHardwareFamilyArgs = {
  id: Scalars['ID'];
};


export type QueryHardwareManufacturerArgs = {
  id: Scalars['ID'];
};


export type QueryHardwareModelArgs = {
  id: Scalars['ID'];
};


export type QueryHardwareModelsArgs = {
  query?: Maybe<ModelQuery>;
};


export type QueryHardwareProductArgs = {
  id: Scalars['ID'];
};


export type QueryLicenseArgs = {
  licenseKey: Scalars['String'];
};


export type QueryLicenseAggregationsByModelArgs = {
  licenseKey?: Maybe<Scalars['String']>;
  modelId?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};


export type QueryLicenseAssetsForEntitlementArgs = {
  modelId?: Maybe<Scalars['String']>;
  productSerials?: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['String'];
};


export type QueryLicenseCountArgs = {
  canceled?: Maybe<Scalars['Boolean']>;
  expiresByDate?: Maybe<Scalars['DateTime']>;
  searchTerm?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type?: Maybe<LicenseTypeInput>;
};


export type QueryLicensesArgs = {
  canceled?: Maybe<Scalars['Boolean']>;
  expiresByDate?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  sort?: Maybe<LicenseSortObject>;
  tenantId: Scalars['String'];
  type?: Maybe<LicenseTypeInput>;
};


export type QueryLicensesExpiringArgs = {
  expirationDate?: Maybe<Scalars['String']>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Float']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryLocationsArgs = {
  ip?: Maybe<Scalars['ID']>;
};


export type QueryLogToFlashStatusArgs = {
  deviceId: Scalars['String'];
};


export type QueryMergeEntityRequestsArgs = {
  entityId?: Maybe<Scalars['String']>;
};


export type QueryMyCdrAggregatesArgs = {
  field?: Maybe<MeetingRecordAggregationField>;
  groupBy: MeetingRecordAggregationGroup;
  increment: Increment;
  input?: Maybe<QueryMeetingRecordAggregationInput>;
  mode?: Maybe<MeetingRecordAggregationMode>;
  tenantId: Array<Scalars['String']>;
  timeRange: TimeRange;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
  tenantId: Array<Scalars['String']>;
};


export type QueryNormalizedDeviceSettingsArgs = {
  id: Scalars['String'];
  settings?: Maybe<Array<Scalars['String']>>;
};


export type QueryNs_Ls_GetActiveTokenUserArgs = {
  sessionToken: Scalars['String'];
};


export type QueryNs_Ls_GetAllTenantsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryNs_Ls_GetAppDataArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetAuditArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetAuditReportArgs = {
  afterTime?: Maybe<Scalars['String']>;
  beforeTime?: Maybe<Scalars['String']>;
  resetStats?: Maybe<Scalars['Boolean']>;
};


export type QueryNs_Ls_GetClientAuthTokenArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetEntitlementArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetEntitlementsByGroupingViewArgs = {
  tenantId: Scalars['String'];
};


export type QueryNs_Ls_GetInitialLicenseRequestArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetInstanceArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetLastLicenseArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetLatestProductVersionArgs = {
  productId: Scalars['String'];
};


export type QueryNs_Ls_GetProductVersionsArgs = {
  productId: Scalars['String'];
};


export type QueryNs_Ls_GetSoftwareCatalogArgs = {
  productId: Scalars['String'];
  version: Scalars['String'];
};


export type QueryNs_Ls_GetTenantArgs = {
  id: Scalars['String'];
};


export type QueryNs_Ls_GetTenantAliasArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_GetUserArgs = {
  recordId: Scalars['ID'];
};


export type QueryNs_Ls_SearchAppDataArgs = {
  after?: Maybe<Scalars['Cursor']>;
  appDataSearch?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['Cursor']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  instanceId?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  sortDescending?: Maybe<Scalars['Boolean']>;
  sortField?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchAuditsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  afterTime?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['Cursor']>;
  beforeTime?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  ofType?: Maybe<Scalars['String']>;
  sortDescending?: Maybe<Scalars['Boolean']>;
  sortField?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchClientAuthTokensArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  modifiedAfter?: Maybe<Scalars['String']>;
  modifiedBefore?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchEntitlementGroupingSetsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  assignedToTenant?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  groupingId?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchEntitlementsArgs = {
  activationCode?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['Cursor']>;
  assignedToId?: Maybe<Scalars['String']>;
  assignedToTenant?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['Cursor']>;
  beginsAfter?: Maybe<Scalars['String']>;
  beginsBefore?: Maybe<Scalars['String']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  expiresAfter?: Maybe<Scalars['String']>;
  expiresBefore?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  groupingId?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  mappingId1?: Maybe<Scalars['String']>;
  mappingId2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pendingAssignedToId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  sortDescending?: Maybe<Scalars['Boolean']>;
  sortField?: Maybe<Scalars['String']>;
  stateMax?: Maybe<Scalars['String']>;
  stateMin?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchInstanceByInstIdArgs = {
  instanceId: Scalars['String'];
};


export type QueryNs_Ls_SearchInstancesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  macsCSV?: Maybe<Scalars['String']>;
  modifiedAfter?: Maybe<Scalars['String']>;
  modifiedBefore?: Maybe<Scalars['String']>;
  niceName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVersion?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sortDescending?: Maybe<Scalars['Boolean']>;
  sortField?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchTenantAliasesArgs = {
  tenantIdOrAlias: Scalars['String'];
};


export type QueryNs_Ls_SearchTenantsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  modifiedAfter?: Maybe<Scalars['String']>;
  modifiedBefore?: Maybe<Scalars['String']>;
  sortDescending?: Maybe<Scalars['Boolean']>;
  sortField?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
};


export type QueryNs_Ls_SearchUsersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  createdAfter?: Maybe<Scalars['String']>;
  createdBefore?: Maybe<Scalars['String']>;
  expiresAfter?: Maybe<Scalars['String']>;
  expiresBefore?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  modifiedAfter?: Maybe<Scalars['String']>;
  modifiedBefore?: Maybe<Scalars['String']>;
  sortDescending?: Maybe<Scalars['Boolean']>;
  sortField?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};


export type QueryNs_Siebel_FindContactArgs = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};


export type QueryNs_Siebel_GetAssetByIdArgs = {
  id: Scalars['String'];
};


export type QueryNs_Siebel_GetAssetsBySerialArgs = {
  serial: Scalars['String'];
};


export type QueryNs_Siebel_GetEntitlementByIntegrationIdArgs = {
  id: Scalars['String'];
};


export type QueryNs_Siebel_GetEntitlementBySerialArgs = {
  serial: Scalars['String'];
};


export type QueryNs_Siebel_GetServiceRequestByIdArgs = {
  id: Scalars['String'];
};


export type QueryNs_Siebel_GetServiceRequestBySrNumberArgs = {
  srNumber: Scalars['String'];
};


export type QueryNs_Siebel_GetServiceRequestsByAssetIdArgs = {
  assetId: Scalars['String'];
};


export type QueryPermissionArgs = {
  name: Scalars['String'];
};


export type QueryPermissionGroupArgs = {
  name: Scalars['String'];
};


export type QueryPoliciesCapabilitiesArgs = {
  rules: Rule;
};


export type QueryPolicyCapabilitiesArgs = {
  collectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  rules?: Maybe<Rule>;
};


export type QueryPolyPlusEnabledArgs = {
  tenantId: Scalars['String'];
};


export type QueryPostalLookupArgs = {
  countryCode?: Maybe<Scalars['String']>;
  q: Scalars['ID'];
};


export type QueryProductBuildArgs = {
  build: Scalars['String'];
  category: Scalars['String'];
  version: Scalars['String'];
};


export type QueryProductBuildByIdArgs = {
  id: Scalars['String'];
};


export type QueryProductCategoryArgs = {
  name: Scalars['String'];
};


export type QueryProductCategoryVersionArgs = {
  category: Scalars['String'];
  version: Scalars['String'];
};


export type QueryProductSoftwareArgs = {
  id: Scalars['ID'];
};


export type QueryProductSoftwareByPidArgs = {
  pid: Scalars['ID'];
  releaseChannel?: Maybe<Scalars['String']>;
};


export type QueryProductSoftwaresArgs = {
  query?: Maybe<SoftwareQuery>;
};


export type QueryReadGroupArgs = {
  groupId: Scalars['String'];
};


export type QueryResolveSwUpdateForPolicyArgs = {
  deviceId?: Maybe<Scalars['String']>;
  deviceProductId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryResolveTenantArgs = {
  id: Scalars['ID'];
};


export type QueryRoleArgs = {
  name: Scalars['String'];
};


export type QueryRolesArgs = {
  tags?: Maybe<Array<Scalars['String']>>;
};


export type QueryRoomArgs = {
  id: Scalars['String'];
};


export type QueryRoomDataArgs = {
  params?: Maybe<RoomConnectionParams>;
  tenantId: Scalars['String'];
};


export type QueryRouteArgs = {
  name: Scalars['String'];
};


export type QueryRuleMatchesArgs = {
  rules: Scalars['JSONType'];
};


export type QuerySearchAccessorsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<AccessorFilter>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryServiceArgs = {
  name: Scalars['String'];
};


export type QueryShipmentsArgs = {
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Float']>;
  productSerials: Array<Scalars['String']>;
};


export type QuerySiteArgs = {
  id: Scalars['String'];
};


export type QuerySiteDataArgs = {
  params?: Maybe<SiteConnectionParams>;
  tenantId: Scalars['String'];
};


export type QuerySitesArgs = {
  tenantId?: Maybe<Scalars['String']>;
};


export type QuerySkuArgs = {
  id: Scalars['ID'];
};


export type QuerySoftwareReleasesByPidArgs = {
  params?: Maybe<SoftwareConnectionParams>;
  pid: Scalars['ID'];
};


export type QueryStartExportDeviceConfigsArgs = {
  deviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type QueryTenantArgs = {
  id: Scalars['ID'];
};


export type QueryTenantEventsArgs = {
  marker: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};


export type QueryTenantIntegrationsArgs = {
  integration?: Maybe<TenantIntegrationInput>;
  tenantId: Scalars['ID'];
};


export type QueryTenantsArgs = {
  from?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  namePrefix?: Maybe<Scalars['String']>;
  sort?: Maybe<TenantSort>;
  tenantType?: Maybe<TenantType>;
};


export type QueryTopicIndicatorsArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  input?: Maybe<QueryTopicIndicatorInput>;
  tenantId: Array<Scalars['String']>;
};


export type QueryTopicsArgs = {
  category?: Maybe<Category>;
  topicId?: Maybe<Array<Scalars['Int']>>;
  topicName?: Maybe<Array<Scalars['String']>>;
};


export type QueryTransportProtocolArgs = {
  type: Scalars['ID'];
};


export type QueryUserArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUserConnectionsArgs = {
  userId: Scalars['ID'];
};


export type QueryUserGroupsForTenantArgs = {
  tenantId: Scalars['String'];
};


export type QueryUserInvitesByTenantArgs = {
  tenant_id?: Maybe<Scalars['ID']>;
};


export type QueryUsersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  params: UserSearchParams;
};


export type QueryVendorArgs = {
  id: Scalars['ID'];
};


export type QueryVerifyLicenseKeyArgs = {
  licenseKey: Scalars['String'];
};

export type QueryEpisodesInput = {
  type: EpisodeType;
};

export type QueryMeetingRecordAggregationInput = {
  deviceId?: Maybe<Scalars['ID']>;
  proxyId?: Maybe<Scalars['ID']>;
};

export type QueryMeetingRecordInput = {
  answeredInSoftphone?: Maybe<Scalars['Boolean']>;
  appName?: Maybe<Scalars['String']>;
  callDirection?: Maybe<Scalars['String']>;
  callRate?: Maybe<Scalars['Int']>;
  deviceId?: Maybe<Scalars['ID']>;
  disconnectInfo?: Maybe<Scalars['String']>;
  hardwareModel?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  mac?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productFamily?: Maybe<Scalars['String']>;
  protocol?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['ID']>;
  searchTerms?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['ID']>;
  softphoneVersion?: Maybe<Scalars['String']>;
  softwareRelease?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type QueryTopicIndicatorInput = {
  category?: Maybe<Category>;
  device?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  episodeActivity?: Maybe<EpisodeQueryFilter>;
  family?: Maybe<Scalars['String']>;
  locationScope?: Maybe<LocationScope>;
  model?: Maybe<Array<Maybe<Scalars['String']>>>;
  recurringEventId?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  threshold?: Maybe<Scalars['Float']>;
  timePeriodStart?: Maybe<Scalars['Date']>;
  timeScope?: Maybe<TimeScope>;
  topic?: Maybe<Array<Maybe<Scalars['ID']>>>;
  version?: Maybe<Scalars['String']>;
};

export type QueryTopicIndicatorObject = {
  __typename: 'QueryTopicIndicatorObject';
  device: Maybe<Scalars['String']>;
  deviceType: Maybe<Scalars['String']>;
  family: Maybe<Scalars['String']>;
  locationScope: LocationScope;
  model: Maybe<Scalars['String']>;
  recurringEventId: Maybe<Scalars['String']>;
  room: Maybe<Scalars['String']>;
  site: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  threshold: Maybe<Scalars['Float']>;
  timePeriodStart: Maybe<Scalars['Date']>;
  timeScope: TimeScope;
  topic: Array<Scalars['ID']>;
  version: Maybe<Scalars['String']>;
};

export type Range = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type RangeAggregation = {
  field: Scalars['String'];
  ranges: Array<Range>;
};

export type RangeBucket = Bucket & {
  __typename: 'RangeBucket';
  aggregates: Array<Aggregate>;
  count: Scalars['Float'];
  from: Scalars['Float'];
  key: Scalars['String'];
  to: Scalars['Float'];
};

export enum Rate {
  Daily = 'DAILY',
  Immediate = 'IMMEDIATE',
  Interval_12H = 'INTERVAL_12H',
  Interval_15M = 'INTERVAL_15M',
  Interval_1H = 'INTERVAL_1H',
  Interval_2H = 'INTERVAL_2H',
  Interval_30M = 'INTERVAL_30M',
  Interval_4H = 'INTERVAL_4H',
  Interval_6H = 'INTERVAL_6H',
  Weekly = 'WEEKLY'
}

export type Recipient = {
  __typename: 'Recipient';
  confirmed: Scalars['Boolean'];
  email: Scalars['Email'];
  id: Scalars['ID'];
  invite_date: Maybe<Scalars['String']>;
};

export type RegisterDeviceAddress = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  geohash?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type RegisterDeviceDirectRequest = {
  allowTenantSwitching?: Maybe<Scalars['Boolean']>;
  deviceId: Scalars['String'];
  deviceName?: Maybe<Scalars['String']>;
  floorName?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  siteAddress?: Maybe<RegisterDeviceAddress>;
  siteName?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type RegisterDeviceRequest = {
  deviceName?: Maybe<Scalars['String']>;
  floorName?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  registrationCode: Scalars['String'];
  roomName?: Maybe<Scalars['String']>;
  siteAddress?: Maybe<RegisterDeviceAddress>;
  siteName?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type RegisterDeviceResponse = {
  __typename: 'RegisterDeviceResponse';
  deviceId: Maybe<Scalars['String']>;
  deviceName: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RegisterEndUserDeviceRequest = {
  deviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type RegisterEndUserDeviceResponse = {
  __typename: 'RegisterEndUserDeviceResponse';
  deviceId: Maybe<Scalars['String']>;
  deviceKey: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  idScope: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RegisterMtrDeviceRequest = {
  deviceId?: Maybe<Scalars['String']>;
  sipMailbox: Scalars['String'];
  tenantId: Scalars['String'];
  token: Scalars['String'];
};

export type RegisterMtrDeviceResponse = {
  __typename: 'RegisterMTRDeviceResponse';
  deviceId: Maybe<Scalars['String']>;
  deviceKey: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  idScope: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RelativeRange = {
  increment: Increment;
  value: Scalars['Int'];
};

export type RemoveRecipient = {
  audienceId: Scalars['ID'];
  recipientId: Scalars['ID'];
};

export type ReplaceRecipient = {
  audienceId: Scalars['ID'];
  currentRecipientId: Scalars['ID'];
  email: Scalars['Email'];
};

export type ResendVerificationResponse = {
  __typename: 'ResendVerificationResponse';
  userId: Scalars['ID'];
};

export type ResolvedCapabilities = {
  __typename: 'ResolvedCapabilities';
  capabilities: Capabilities;
  deviceId: Maybe<Scalars['String']>;
  sources: Array<GroupPolicy>;
};

export type ResourceFileDto = {
  __typename: 'ResourceFileDTO';
  fileName: Maybe<Scalars['String']>;
  fileSize: Maybe<Scalars['Float']>;
  tenantId: Maybe<Scalars['String']>;
  uploadedBy: Maybe<Scalars['String']>;
  uploadedTime: Maybe<Scalars['String']>;
};

export type ResourceFileResponse = {
  __typename: 'ResourceFileResponse';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Maybe<Scalars['Boolean']>;
};

export type Role = {
  __typename: 'Role';
  grantableRoles: Array<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  tags: Array<Scalars['String']>;
};

export type RoleInput = {
  names?: Maybe<StringFilter>;
  tags?: Maybe<StringFilter>;
};

export type Room = {
  __typename: 'Room';
  capacity: Maybe<Scalars['Int']>;
  deviceCount: Scalars['Int'];
  devices: Maybe<Array<Device>>;
  devicesOnlinePercentage: Scalars['Int'];
  floor: Maybe<Scalars['String']>;
  /** @deprecated The getRoomDataForTenant query is deprecated. Use the `roomData` field instead. */
  getRoomDataForTenant: Maybe<RoomConnection>;
  id: Scalars['ID'];
  name: Scalars['String'];
  site: Site;
};


export type RoomGetRoomDataForTenantArgs = {
  after?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};

export type RoomConnection = {
  __typename: 'RoomConnection';
  count: Scalars['Int'];
  edges: Array<RoomEdge>;
  pageInfo: PageInfo;
};

export type RoomConnectionEdge = {
  __typename: 'RoomConnectionEdge';
  cursor: Scalars['Cursor'];
  node: Room;
};

export type RoomConnectionObject = {
  __typename: 'RoomConnectionObject';
  edges: Maybe<Array<RoomConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type RoomConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<Array<RoomFilterObject>>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<RoomSortObject>>;
};

export type RoomEdge = {
  __typename: 'RoomEdge';
  cursor: Scalars['Cursor'];
  node: Room;
};

export enum RoomFilterField {
  Name = 'NAME'
}

export type RoomFilterObject = {
  comparisonOperator: SiteAndRoomComparisonOperator;
  field: RoomFilterField;
  value: Scalars['String'];
};

export enum RoomSortField {
  RoomCapacity = 'ROOM_CAPACITY',
  RoomName = 'ROOM_NAME',
  SiteName = 'SITE_NAME',
  UnassignedRoomNameFirst = 'UNASSIGNED_ROOM_NAME_FIRST',
  UnassignedSiteNameFirst = 'UNASSIGNED_SITE_NAME_FIRST'
}

export type RoomSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<RoomSortField>;
};

export type Route = {
  __typename: 'Route';
  details: Scalars['JSONObject'];
  forwardingpath: Maybe<Scalars['String']>;
  hostnames: Array<Scalars['String']>;
  name: Scalars['String'];
  patterns: Array<Scalars['String']>;
  productBuild: Maybe<ProductBuild>;
  urls: Array<Scalars['String']>;
};

export type Rule = {
  and?: Maybe<Array<Rule>>;
  equal?: Maybe<Equal>;
  not?: Maybe<Rule>;
  or?: Maybe<Array<Rule>>;
};

export type Schema = {
  __typename: 'Schema';
  directives: Array<Directive>;
  mutationType: Maybe<Type>;
  queryType: Type;
  subscriptionType: Maybe<Type>;
  types: Array<Type>;
};

export type Series = {
  __typename: 'Series';
  data: Maybe<Array<Point>>;
  meta: SeriesMeta;
  name: Scalars['String'];
};

export type SeriesMeta = InsightSeriesMeta | MeetingRecordAggregateSeriesMeta;

export enum SeriesType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type Service = {
  __typename: 'Service';
  authHash: Scalars['String'];
  endpoints: Array<GraphEndpoint>;
  instanceCount: Scalars['Int'];
  instances: Array<ServiceInstance>;
  name: Scalars['String'];
  sdlHash: Scalars['String'];
  status: ServiceStatus;
};

export type ServiceInstance = {
  __typename: 'ServiceInstance';
  authHash: Scalars['String'];
  endpoints: Array<GraphEndpoint>;
  error: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sdlHash: Scalars['String'];
  serviceUrl: Scalars['String'];
  timeout: Maybe<Scalars['Int']>;
};

export type ServiceNowActionConfiguration = {
  __typename: 'ServiceNowActionConfiguration';
  actionType: ActionType;
  allowedRates: Array<Rate>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  rate: Rate;
};

export type ServiceNowWebhook = {
  __typename: 'ServiceNowWebhook';
  actionConfigurations: Array<ServiceNowActionConfiguration>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  last_error_body: Maybe<Scalars['String']>;
  last_error_message: Maybe<Scalars['String']>;
  last_error_status_code: Maybe<Scalars['String']>;
  last_error_time: Maybe<Scalars['String']>;
  name: Scalars['String'];
  succeeding_since: Maybe<Scalars['String']>;
  url: Scalars['URL'];
  username: Scalars['String'];
};

export enum ServiceStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Initializing = 'INITIALIZING'
}

export type SetActionFrequency = {
  actionId: Scalars['ID'];
  rate: Rate;
};

export type SetEntitlementTenantResult = {
  __typename: 'SetEntitlementTenantResult';
  resultCode: SetEntitlementTenantResultStatus;
};

export enum SetEntitlementTenantResultStatus {
  EntitlementNotFound = 'ENTITLEMENT_NOT_FOUND',
  Success = 'SUCCESS',
  TenantAlreadySet = 'TENANT_ALREADY_SET',
  UnknownError = 'UNKNOWN_ERROR'
}

export type SettingResponse = {
  __typename: 'SettingResponse';
  fetchedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meta: Maybe<PolyOsConfigMeta>;
  settings: Maybe<PolyOsConfig>;
};

export type SettingXmlResponse = {
  __typename: 'SettingXMLResponse';
  fetchedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  settings: Maybe<Scalars['String']>;
};

export type ShipmentModel = {
  __typename: 'ShipmentModel';
  details: Maybe<Scalars['JSONObject']>;
  productSerial: Scalars['String'];
  shipDate: Scalars['DateTime'];
};

export type ShipmentModelConnection = {
  __typename: 'ShipmentModelConnection';
  edges: Array<ShipmentModel>;
  pageInfo: PolyPlusPageInfo;
};

export type Site = {
  __typename: 'Site';
  address: Maybe<Address>;
  deviceCount: Scalars['Int'];
  devices: Maybe<Array<Device>>;
  devicesOnlinePercentage: Scalars['Int'];
  /** @deprecated Use query siteData or tenant field resolver siteData to get paginated list of sites */
  getSiteDataForTenant: Maybe<SiteConnection>;
  id: Scalars['ID'];
  name: Scalars['String'];
  roomCount: Scalars['Float'];
  roomData: Maybe<RoomConnectionObject>;
  rooms: Array<Room>;
  subnetRules: Maybe<Array<SubnetRule>>;
  subnets: Maybe<Array<Subnet>>;
  tenant: Maybe<Tenant>;
};


export type SiteGetSiteDataForTenantArgs = {
  after?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};


export type SiteRoomDataArgs = {
  params?: Maybe<RoomConnectionParams>;
};

export enum SiteAndRoomComparisonOperator {
  CaseInsensitiveContains = 'CASE_INSENSITIVE_CONTAINS'
}

export type SiteConfigResponse = {
  __typename: 'SiteConfigResponse';
  siteConfigError: Maybe<Scalars['String']>;
  siteConfigSettings: Maybe<Array<Maybe<ModelConfigSettingsResponse>>>;
  siteName: Maybe<Scalars['String']>;
};

export type SiteConnection = {
  __typename: 'SiteConnection';
  count: Scalars['Int'];
  edges: Array<SiteEdge>;
  pageInfo: PageInfo;
};

export type SiteConnectionEdge = {
  __typename: 'SiteConnectionEdge';
  cursor: Scalars['Cursor'];
  node: Site;
};

export type SiteConnectionObject = {
  __typename: 'SiteConnectionObject';
  edges: Maybe<Array<SiteConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type SiteConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<Array<SiteFilterObject>>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<SiteSortObject>>;
};

export type SiteEdge = {
  __typename: 'SiteEdge';
  cursor: Scalars['Cursor'];
  node: Site;
};

export enum SiteFilterField {
  Name = 'NAME'
}

export type SiteFilterObject = {
  comparisonOperator: SiteAndRoomComparisonOperator;
  field: SiteFilterField;
  value: Scalars['String'];
};

export enum SiteSortField {
  Name = 'NAME',
  RoomCount = 'ROOM_COUNT',
  UnassignedFirst = 'UNASSIGNED_FIRST'
}

export type SiteSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<SiteSortField>;
};

export type SiteTopologyResponse = {
  __typename: 'SiteTopologyResponse';
  siteName: Maybe<Scalars['String']>;
  siteTopologyErrors: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Sku = {
  __typename: 'Sku';
  createdAt: Scalars['DateScalar'];
  hardwareModels: Maybe<Array<HardwareModel>>;
  id: Scalars['ID'];
  skuModels: CatalogModelConnection;
  supportDurationYears: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateScalar'];
};


export type SkuSkuModelsArgs = {
  params?: Maybe<CatalogModelConnectionParams>;
};

export type SkuConnection = {
  __typename: 'SkuConnection';
  edges: Maybe<Array<SkuConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type SkuConnectionEdge = {
  __typename: 'SkuConnectionEdge';
  cursor: Scalars['Cursor'];
  node: Sku;
};

export type SkuConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<SkuSortObject>>;
};

export type SkuInput = {
  hardwareModels?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  supportDurationYears?: Maybe<Scalars['Float']>;
};

export enum SkuSortField {
  Id = 'ID',
  SupportDurationYears = 'SUPPORT_DURATION_YEARS'
}

export type SkuSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<SkuSortField>;
};

export type SoftwareCompareClause = {
  comparisonOperator: ComparisonOperator;
  field: ProductSoftwareField;
  value?: Maybe<Scalars['String']>;
};

export type SoftwareConnection = {
  __typename: 'SoftwareConnection';
  edges: Maybe<Array<SoftwareConnectionEdge>>;
  pageInfo: Maybe<PageInformation>;
  total: Maybe<Scalars['Int']>;
};

export type SoftwareConnectionEdge = {
  __typename: 'SoftwareConnectionEdge';
  cursor: Scalars['Cursor'];
  node: ProductSoftware;
};

export type SoftwareConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  filter?: Maybe<Array<SoftwareReleaseCompareClause>>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<SoftwareSortObject>>;
};

export type SoftwareFilter = {
  AND?: Maybe<Array<SoftwareFilter>>;
  clauses?: Maybe<Array<SoftwareCompareClause>>;
  OR?: Maybe<Array<SoftwareFilter>>;
};

export type SoftwareQuery = {
  filter?: Maybe<SoftwareFilter>;
  limit?: Maybe<Scalars['Float']>;
  sortField?: Maybe<SortField>;
};

export type SoftwareReleaseCompareClause = {
  comparisonOperator: ComparisonOperator;
  field: SoftwareReleaseFilterField;
  value?: Maybe<Scalars['String']>;
};

export enum SoftwareReleaseFilterField {
  Name = 'name',
  ReleaseChannel = 'releaseChannel',
  Version = 'version'
}

export enum SoftwareReleaseSortField {
  Name = 'name',
  Version = 'version'
}

export type SoftwareSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field: SoftwareReleaseSortField;
};

export type SoftwareSupportUpdatePath = {
  __typename: 'SoftwareSupportUpdatePath';
  deviceModel: Maybe<Scalars['String']>;
  swPath: Maybe<Scalars['String']>;
};

export type SoftwareSupportUpdatePathInput = {
  deviceModel?: Maybe<Scalars['String']>;
  swPath?: Maybe<Scalars['String']>;
};

export type SoftwareUpdate = {
  __typename: 'SoftwareUpdate';
  archive_url: Maybe<StringValue>;
  base_url: Maybe<StringValue>;
  policy: Maybe<SoftwareUpdatePolicy>;
  rules_json: Maybe<StringValue>;
};

export type SoftwareUpdateInput = {
  policy?: Maybe<SoftwareUpdatePolicyInput>;
};

export type SoftwareUpdatePolicy = {
  __typename: 'SoftwareUpdatePolicy';
  use_latest: Maybe<BooleanValue>;
  version: Maybe<StringValue>;
};

export type SoftwareUpdatePolicyInput = {
  use_latest?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export enum SoftwareUpdateStageOptions {
  AuthError = 'AUTH_ERROR',
  AuthRestart = 'AUTH_RESTART',
  Authenticating = 'AUTHENTICATING',
  CheckingVersion = 'CHECKING_VERSION',
  Cleanup = 'CLEANUP',
  ConnectingToRepo = 'CONNECTING_TO_REPO',
  ContinueRestart = 'CONTINUE_RESTART',
  DownloadCfgFailed = 'DOWNLOAD_CFG_FAILED',
  DownloadPackageFailed = 'DOWNLOAD_PACKAGE_FAILED',
  DownloadedCfg = 'DOWNLOADED_CFG',
  DownloadingCfg = 'DOWNLOADING_CFG',
  DownloadingPackage = 'DOWNLOADING_PACKAGE',
  ErrorIncompatible = 'ERROR_INCOMPATIBLE',
  ErrorTimedout = 'ERROR_TIMEDOUT',
  ErrorUpdateDb = 'ERROR_UPDATE_DB',
  ErrorUsbNotcompatible = 'ERROR_USB_NOTCOMPATIBLE',
  HttpsCert = 'HTTPS_CERT',
  Installing = 'INSTALLING',
  InternalError = 'INTERNAL_ERROR',
  NeedUpgradedKey = 'NEED_UPGRADED_KEY',
  ReadyWaiting = 'READY_WAITING',
  Rebooting = 'REBOOTING',
  ShowSplash = 'SHOW_SPLASH',
  Stageunknown = 'STAGEUNKNOWN',
  Started = 'STARTED'
}

export type SoftwareUpdateStatus = {
  __typename: 'SoftwareUpdateStatus';
  maxTime: Maybe<Scalars['Float']>;
  percentage: Maybe<Scalars['Float']>;
  percentageComplete: Maybe<Scalars['Float']>;
  progressState: Maybe<Scalars['String']>;
  softUpdateStage: Maybe<SoftwareUpdateStageOptions>;
  softUpdateStatus: Maybe<SoftwareUpdateStatusOptions>;
};

export enum SoftwareUpdateStatusOptions {
  Blocked = 'BLOCKED',
  Disconnect = 'DISCONNECT',
  NoUpdate = 'NO_UPDATE',
  UpdateComplete = 'UPDATE_COMPLETE',
  UpdateFailed = 'UPDATE_FAILED',
  Updating = 'UPDATING'
}

export enum SoftwareVersionSortMethod {
  PublishDate = 'publishDate',
  Version = 'version'
}

export type Sort = {
  fields: Array<SortBy>;
};

export type SortBy = {
  direction: Direction;
  name: Scalars['String'];
};

export enum SortField {
  PublishDate = 'publishDate',
  Version = 'version'
}

export type StateFilter = {
  eq?: Maybe<ActionState>;
};

export type StaticResource = {
  __typename: 'StaticResource';
  id: Scalars['String'];
  type: Maybe<Scalars['String']>;
};

export type StringFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type Subnet = {
  __typename: 'Subnet';
  cidr: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  site: Site;
  siteId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SubnetFilter = {
  cidr?: Maybe<Scalars['String']>;
  cidrComparisonOperator?: Maybe<CidrComparisonOperator>;
  tenantId?: Maybe<Scalars['String']>;
};

export type SubnetRule = {
  __typename: 'SubnetRule';
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  privateCidr: Maybe<Scalars['String']>;
  publicCidr: Scalars['String'];
  site: Site;
  siteId: Scalars['String'];
};

export type SubnetRuleValidityInput = {
  privateCidr?: Maybe<Scalars['String']>;
  publicCidr: Scalars['String'];
  ruleId?: Maybe<Scalars['String']>;
  siteId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type SubnetRuleValidityResponse = {
  __typename: 'SubnetRuleValidityResponse';
  result: SubnetRuleValidityResult;
  ruleId: Maybe<Scalars['String']>;
  siteId: Maybe<Scalars['String']>;
  siteName: Maybe<Scalars['String']>;
};

export enum SubnetRuleValidityResult {
  Duplicate = 'Duplicate',
  Overlap = 'Overlap',
  Valid = 'Valid'
}

export type Supergraph = {
  __typename: 'Supergraph';
  hash: Scalars['String'];
  inputSdls: Array<Scalars['String']>;
};

export type SwUpdateDetails = {
  __typename: 'SwUpdateDetails';
  policy: Maybe<Policy>;
  productBuild: Maybe<ProductBuildDetails>;
};

export enum SwUpdateSource {
  CustomUrl = 'CUSTOM_URL',
  StandardUrl = 'STANDARD_URL'
}

export type SyncEntitledUntilDateResult = {
  __typename: 'SyncEntitledUntilDateResult';
  entitledUntilDate: Maybe<Scalars['String']>;
  productSerial: Scalars['String'];
  tenantId: Maybe<Scalars['String']>;
};

export type SyncShipmentDateResult = {
  __typename: 'SyncShipmentDateResult';
  productSerial: Scalars['String'];
  shipmentDate: Maybe<Scalars['String']>;
};

export type TagFilters = {
  withoutTags?: Maybe<Array<Scalars['String']>>;
  withTags?: Maybe<Array<Scalars['String']>>;
};

export type TeamsHook = {
  __typename: 'TeamsHook';
  actionConfigurations: Array<TeamsWebhookActionConfiguration>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Maybe<Scalars['URL']>;
};

export type TeamsWebhookActionConfiguration = {
  __typename: 'TeamsWebhookActionConfiguration';
  actionType: ActionType;
  allowedRates: Array<Rate>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  rate: Rate;
};

export type Tenant = {
  __typename: 'Tenant';
  aliases: Array<Scalars['String']>;
  audience: Maybe<Audience>;
  createdAt: Scalars['DateTime'];
  deactivatedAt: Maybe<Scalars['DateTime']>;
  deviceCount: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  memberCount: Maybe<Scalars['Int']>;
  mergedAt: Maybe<Scalars['DateTime']>;
  mergedToId: Maybe<Scalars['ID']>;
  mockLicenseTenant: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
  roomData: RoomConnectionObject;
  rooms: Maybe<RoomConnection>;
  serviceNowWebhooks: Array<ServiceNowWebhook>;
  siteData: SiteConnectionObject;
  sites: Maybe<SiteConnection>;
  teamsWebhooks: Array<TeamsHook>;
  type: TenantType;
  updatedAt: Scalars['DateTime'];
};


export type TenantDeviceCountArgs = {
  filter?: Maybe<Filter>;
};


export type TenantRoomDataArgs = {
  params?: Maybe<RoomConnectionParams>;
};


export type TenantRoomsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
};


export type TenantSiteDataArgs = {
  params?: Maybe<SiteConnectionParams>;
};


export type TenantSitesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
};

export type TenantEvent = {
  __typename: 'TenantEvent';
  accessorId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  tenant: TenantSnapshot;
  type: TenantEventType;
};

export enum TenantEventType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Merge = 'MERGE',
  Unmerge = 'UNMERGE',
  Update = 'UPDATE'
}

export type TenantIntegrationInput = {
  detail: MicrosoftInput;
  integrationType: IntegrationType;
};

export type TenantIntegrationsResponse = {
  __typename: 'TenantIntegrationsResponse';
  detail: Maybe<Microsoft>;
  id: Scalars['String'];
  integrationType: IntegrationType;
};

export type TenantManagementConfiguration = {
  __typename: 'TenantManagementConfiguration';
  tenantSyncPeriod: Maybe<Scalars['Int']>;
};

export type TenantResponse = {
  __typename: 'TenantResponse';
  tenant: Tenant;
};

export type TenantSnapshot = {
  __typename: 'TenantSnapshot';
  aliases: Maybe<Array<Scalars['String']>>;
  createdAt: Maybe<Scalars['DateTime']>;
  deactivatedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  internalTenant: Maybe<Scalars['Boolean']>;
  mergedAt: Maybe<Scalars['DateTime']>;
  mergedToId: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<TenantType>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type TenantSort = {
  fields?: Maybe<Array<TenantSortField>>;
};

export enum TenantSortDirection {
  Asc = 'ASC',
  Ascending = 'ASCENDING',
  Desc = 'DESC',
  Descending = 'DESCENDING'
}

export type TenantSortField = {
  direction: TenantSortDirection;
  name: Scalars['String'];
};

export enum TenantType {
  Distributor = 'DISTRIBUTOR',
  Enterprise = 'ENTERPRISE',
  ServiceProvider = 'SERVICE_PROVIDER'
}

export type TimeRange = {
  boundedRange?: Maybe<BoundedRange>;
  relativeRange?: Maybe<RelativeRange>;
};

export enum TimeScope {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ToggleActionNotification = {
  actionId: Scalars['ID'];
  audienceId: Scalars['ID'];
};

export type Topic = Node & {
  __typename: 'Topic';
  category: Category;
  featureSet: FeatureSet;
  higherIsBetter: Scalars['Boolean'];
  id: Scalars['ID'];
  indicatorDescription: Scalars['String'];
  invocationId: Scalars['ID'];
  name: Scalars['String'];
  type: IndicatorType;
  validLocationScopes: Array<Maybe<LocationScope>>;
  validTimeScopes: Array<Maybe<TimeScope>>;
};

export type TopicIndicator = Episode & Node & {
  __typename: 'TopicIndicator';
  allDetails: Maybe<Array<TopicIndicatorDetail>>;
  chartData: Maybe<Chart>;
  deleted: Maybe<Scalars['Int']>;
  device: Maybe<Device>;
  deviceType: Maybe<Scalars['String']>;
  family: Maybe<Scalars['String']>;
  geolocation: Maybe<Geopoint>;
  globalAverage: Scalars['Float'];
  globalPercentile: Scalars['Float'];
  id: Scalars['ID'];
  indicator: Indicator;
  invocationId: Scalars['ID'];
  locationScope: LocationScope;
  model: Maybe<Scalars['String']>;
  modelVersion: Maybe<Scalars['String']>;
  notability: Scalars['Float'];
  population: Maybe<Scalars['Int']>;
  previous: Maybe<Indicator>;
  previousGlobalPercentile: Maybe<Scalars['Float']>;
  previousTenantPercentile: Maybe<Scalars['Float']>;
  recommendedDetail: Maybe<TopicIndicatorDetail>;
  recurringEventId: Maybe<Scalars['String']>;
  room: Maybe<Room>;
  site: Maybe<Site>;
  tenant: Tenant;
  tenantAverage: Scalars['Float'];
  tenantPercentile: Scalars['Float'];
  timePeriodEnd: Maybe<Scalars['Date']>;
  timePeriodStart: Maybe<Scalars['Date']>;
  timeScope: TimeScope;
  topic: Topic;
  trendingUpward: Scalars['Boolean'];
  type: EpisodeType;
  version: Maybe<Scalars['String']>;
};

export type TopicIndicatorConnection = {
  __typename: 'TopicIndicatorConnection';
  count: Scalars['Int'];
  edges: Array<TopicIndicatorEdge>;
  invocationId: Scalars['ID'];
  pageInfo: PageInfo;
};

export type TopicIndicatorDetail = {
  __typename: 'TopicIndicatorDetail';
  connection: TopicIndicatorConnection;
  id: Scalars['ID'];
  invocationId: Scalars['ID'];
  locationScope: LocationScope;
  parentId: Scalars['ID'];
  query: QueryTopicIndicatorObject;
};

export type TopicIndicatorEdge = {
  __typename: 'TopicIndicatorEdge';
  cursor: Scalars['Cursor'];
  node: TopicIndicator;
};

export type TransportProtocol = {
  __typename: 'TransportProtocol';
  createdOn: Scalars['DateTime'];
  type: Scalars['String'];
  updatedOn: Scalars['DateTime'];
};

export type Type = {
  __typename: 'Type';
  description: Maybe<Scalars['String']>;
  enumValues: Maybe<Array<EnumValue>>;
  fields: Maybe<Array<Field>>;
  inputFields: Maybe<Array<InputValue>>;
  interfaces: Maybe<Array<Type>>;
  kind: TypeKind;
  name: Maybe<Scalars['String']>;
  ofType: Maybe<Type>;
  possibleTypes: Maybe<Array<Type>>;
};


export type TypeEnumValuesArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>;
};


export type TypeFieldsArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>;
};

export enum TypeKind {
  Enum = 'ENUM',
  InputObject = 'INPUT_OBJECT',
  Interface = 'INTERFACE',
  List = 'LIST',
  NonNull = 'NON_NULL',
  Object = 'OBJECT',
  Scalar = 'SCALAR',
  Union = 'UNION'
}

export type TypeResource = {
  __typename: 'TypeResource';
  type: Scalars['String'];
};

export type UnregisterDeviceResponse = {
  __typename: 'UnregisterDeviceResponse';
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateDeviceRequest = {
  name?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  roomUUID?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  siteUUID?: Maybe<Scalars['String']>;
};

export type UpdateServiceNowWebhook = {
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
  username?: Maybe<Scalars['String']>;
};

export type UpdateSubnetRuleInput = {
  privateCidr?: Maybe<Scalars['String']>;
  publicCidr: Scalars['String'];
  ruleId: Scalars['String'];
};

export type UpdateTenantInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<TenantType>;
};

export type UploadedFileInfo = {
  __typename: 'UploadedFileInfo';
  type: Maybe<Scalars['String']>;
  uploadedOn: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type UploadedFileList = {
  __typename: 'UploadedFileList';
  error: Maybe<Scalars['String']>;
  files: Maybe<Array<UploadedFileInfo>>;
  success: Scalars['Boolean'];
};

export type UpsertCollectionRequest = {
  id?: Maybe<Scalars['String']>;
  metadataString?: Maybe<Scalars['String']>;
  rulesString?: Maybe<Scalars['String']>;
};

export type UpsertRoomRequest = {
  capacity?: Maybe<Scalars['Int']>;
  floor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siteAlias?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type UpsertSiteRequest = {
  address?: Maybe<AddressInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};


export type User = {
  __typename: 'User';
  blocked: Maybe<Scalars['Boolean']>;
  connections: Maybe<Array<Device>>;
  created_at: Maybe<Scalars['String']>;
  email: Scalars['String'];
  email_verified: Maybe<Scalars['Boolean']>;
  family_name: Maybe<Scalars['String']>;
  given_name: Maybe<Scalars['String']>;
  groups: Maybe<UserGroup>;
  identities: Maybe<Array<Maybe<Identity>>>;
  last_ip: Maybe<Scalars['String']>;
  last_login: Maybe<Scalars['String']>;
  logins_count: Maybe<Scalars['Float']>;
  multifactor: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  nickname: Maybe<Scalars['String']>;
  phone_number: Maybe<Scalars['String']>;
  phone_verified: Maybe<Scalars['Boolean']>;
  picture: Scalars['String'];
  updated_at: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
  user_metadata: Maybe<UserMetadata>;
  username: Maybe<Scalars['String']>;
};

export type UserAudienceInput = {
  tenantId: Scalars['ID'];
  user_id: Scalars['String'];
};

export type UserConnection = {
  __typename: 'UserConnection';
  count: Scalars['Int'];
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename: 'UserEdge';
  cursor: Scalars['Cursor'];
  node: User;
};

export type UserGroup = {
  __typename: 'UserGroup';
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  policies: Maybe<Array<GroupPolicy>>;
  source: UserGroupSourceType;
  updatedAt: Scalars['DateTime'];
  users: Array<UserResponse>;
};

export type UserGroupBody = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  users: Array<Scalars['String']>;
};

export enum UserGroupSourceType {
  ActiveDirectory = 'ACTIVE_DIRECTORY',
  Lens = 'LENS'
}

export type UserInput = {
  tenantId: Scalars['ID'];
  user_id: Scalars['String'];
};

export type UserInvite = {
  __typename: 'UserInvite';
  accepted_at: Maybe<Scalars['DateTime']>;
  accepted_by_accessor_id: Maybe<Scalars['ID']>;
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  invited_by_accessor_id: Scalars['ID'];
  invited_by_email: Maybe<Scalars['String']>;
  role_name: Scalars['String'];
  tenant_id: Scalars['ID'];
  tenant_name: Scalars['String'];
};

export type UserInviteResponse = {
  __typename: 'UserInviteResponse';
  invite: UserInvite;
};

export type UserInvitesResponse = {
  __typename: 'UserInvitesResponse';
  invites: Array<UserInvite>;
};

export type UserMetadata = {
  __typename: 'UserMetadata';
  info: Maybe<UserMetaDataInfo>;
};

export type UserMetaDataInfo = {
  __typename: 'UserMetaDataInfo';
  acceptedToS: Maybe<Scalars['DateTime']>;
  ackAdblockWarning: Maybe<Scalars['DateTime']>;
  defaultInventoryView: Maybe<InventoryView>;
  lastTenantId: Maybe<Scalars['String']>;
  subnetInstructions: Maybe<Scalars['DateTime']>;
  theme: Maybe<LensTheme>;
};

export type UserMetaDataInput = {
  acceptedToS?: Maybe<Scalars['DateTime']>;
  ackAdblockWarning?: Maybe<Scalars['DateTime']>;
  defaultInventoryView?: Maybe<InventoryView>;
  lastTenantId?: Maybe<Scalars['String']>;
  subnetInstructions?: Maybe<Scalars['DateTime']>;
  theme?: Maybe<LensTheme>;
};

export type UserResponse = {
  __typename: 'UserResponse';
  user: Maybe<User>;
};

export type UserSearchGrant = {
  resourceId: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']>>;
};

export type UserSearchParams = {
  blocked?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  grants?: Maybe<Array<UserSearchGrant>>;
  searchTerm?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  sortByDirection?: Maybe<Scalars['String']>;
};

export type Vendor = {
  __typename: 'Vendor';
  description: Maybe<Scalars['String']>;
  families: CatalogFamilyConnection;
  /** @deprecated This API is no longer supported. Use 'families' instead. */
  hardwareFamilies: Array<HardwareFamily>;
  id: Scalars['ID'];
  /** @deprecated This API is no longer supported. Use 'vendorImages' instead. */
  images: Array<VendorImage>;
  name: Scalars['String'];
  vendorImages: CatalogImageConnection;
};


export type VendorFamiliesArgs = {
  params?: Maybe<CatalogFamilyConnectionParams>;
};


export type VendorVendorImagesArgs = {
  params?: Maybe<CatalogImageConnectionParams>;
};

export type VendorConnection = {
  __typename: 'VendorConnection';
  edges: Maybe<Array<VendorConnectionEdge>>;
  pageInfo: PageInformation;
  total: Scalars['Int'];
};

export type VendorConnectionEdge = {
  __typename: 'VendorConnectionEdge';
  cursor: Scalars['Cursor'];
  node: Vendor;
};

export type VendorConnectionParams = {
  cursor?: Maybe<Scalars['Cursor']>;
  limit?: Maybe<Scalars['Int']>;
  paging?: Maybe<PaginationPagingDirection>;
  sort?: Maybe<Array<VendorSortObject>>;
};

export type VendorImage = {
  __typename: 'VendorImage';
  description: Scalars['String'];
  id: Scalars['ID'];
  metadata: ImageMetadata;
  name: Scalars['String'];
  url: Scalars['String'];
  vendor: Vendor;
};

export type VendorInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum VendorSortField {
  Name = 'NAME'
}

export type VendorSortObject = {
  direction?: Maybe<PaginationSortingDirection>;
  field?: Maybe<VendorSortField>;
};

export enum VerifyLicenseKeyError {
  LicenseKeyExpired = 'LICENSE_KEY_EXPIRED',
  LicenseKeyNotFound = 'LICENSE_KEY_NOT_FOUND',
  LicenseKeyUsed = 'LICENSE_KEY_USED'
}

export type VerifyLicenseKeyResult = {
  __typename: 'VerifyLicenseKeyResult';
  availableLicenses: Maybe<Array<License>>;
  error: Maybe<VerifyLicenseKeyError>;
  success: Scalars['Boolean'];
};

export type Video = {
  __typename: 'Video';
  anti_flicker: Maybe<StringValue>;
  back_light_compensation: Maybe<StringValue>;
  brightness: Maybe<StringValue>;
  camera_movement: Maybe<StringValue>;
  color: Maybe<StringValue>;
  contrast: Maybe<StringValue>;
  exposure: Maybe<StringValue>;
  exposure_auto_enabled: Maybe<BooleanValue>;
  focus: Maybe<StringValue>;
  focus_auto_enabled: Maybe<BooleanValue>;
  frame_size: Maybe<StringValue>;
  gain: Maybe<StringValue>;
  gamma: Maybe<StringValue>;
  hue: Maybe<StringValue>;
  iris: Maybe<StringValue>;
  max_zoom: Maybe<StringValue>;
  onscreen_display: Maybe<StringValue>;
  pan: Maybe<StringValue>;
  participant_count: Maybe<StringValue>;
  roll: Maybe<StringValue>;
  saturation: Maybe<StringValue>;
  sharpness: Maybe<StringValue>;
  skin_enhancement: Maybe<StringValue>;
  tilt: Maybe<StringValue>;
  tracking_mode: Maybe<StringValue>;
  tracking_speed: Maybe<StringValue>;
  white_balance: Maybe<StringValue>;
  white_balance_auto_enabled: Maybe<BooleanValue>;
  wide_dynamic_range: Maybe<StringValue>;
  zoom: Maybe<StringValue>;
};

export type VideoInput = {
  anti_flicker?: Maybe<Scalars['String']>;
  back_light_compensation?: Maybe<Scalars['String']>;
  brightness?: Maybe<Scalars['String']>;
  camera_movement?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  contrast?: Maybe<Scalars['String']>;
  exposure?: Maybe<Scalars['String']>;
  exposure_auto_enabled?: Maybe<Scalars['Boolean']>;
  focus?: Maybe<Scalars['String']>;
  focus_auto_enabled?: Maybe<Scalars['Boolean']>;
  frame_size?: Maybe<Scalars['String']>;
  gain?: Maybe<Scalars['String']>;
  gamma?: Maybe<Scalars['String']>;
  hue?: Maybe<Scalars['String']>;
  iris?: Maybe<Scalars['String']>;
  max_zoom?: Maybe<Scalars['String']>;
  onscreen_display?: Maybe<Scalars['String']>;
  pan?: Maybe<Scalars['String']>;
  participant_count?: Maybe<Scalars['String']>;
  roll?: Maybe<Scalars['String']>;
  saturation?: Maybe<Scalars['String']>;
  sharpness?: Maybe<Scalars['String']>;
  skin_enhancement?: Maybe<Scalars['String']>;
  tilt?: Maybe<Scalars['String']>;
  tracking_mode?: Maybe<Scalars['String']>;
  tracking_speed?: Maybe<Scalars['String']>;
  white_balance?: Maybe<Scalars['String']>;
  white_balance_auto_enabled?: Maybe<Scalars['Boolean']>;
  wide_dynamic_range?: Maybe<Scalars['String']>;
  zoom?: Maybe<Scalars['String']>;
};

export type Webhook = {
  __typename: 'Webhook';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  method: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['URL'];
};

export type Wireless = {
  __typename: 'Wireless';
  bluetooth: Maybe<StringValue>;
  bluetooth_streaming: Maybe<StringValue>;
  clear_trusted_devices: Maybe<StringValue>;
  connection_indication: Maybe<StringValue>;
  exclusive_connection: Maybe<StringValue>;
  secure_bluetooth: Maybe<StringValue>;
};

export type WirelessInput = {
  bluetooth?: Maybe<Scalars['String']>;
  bluetooth_streaming?: Maybe<Scalars['String']>;
  clear_trusted_devices?: Maybe<Scalars['String']>;
  connection_indication?: Maybe<Scalars['String']>;
  exclusive_connection?: Maybe<Scalars['String']>;
  secure_bluetooth?: Maybe<Scalars['String']>;
};
